// src/i18n/index.js
// Use dynamic imports to avoid MIME type issues with JSON files
const messages_en = {
  "aboutEmployerScore.backToRankings": "Back to Companies",
  "aboutEmployerScore.breadcrumb.current": "Employer score",
  "aboutEmployerScore.breadcrumb.parent": "Companies",
  "aboutEmployerScore.intro": "The JobCrawls Employer Score rates employers on a letter-grade scale, from A down to E, derived from patterns we can measure consistently across job listings. It is meant to highlight employers who communicate clearly, structure compensation fairly, and advertise flexible, candidate-friendly roles, not to replace your own interviews and diligence.",
  "aboutEmployerScore.limits.changes": "Weights and signals may evolve as we improve detection; we aim to keep the methodology directionally stable.",
  "aboutEmployerScore.limits.listings": "Scores reflect what employers publish in listings we index — not internal HR policies we cannot see.",
  "aboutEmployerScore.limits.notEndorsement": "A higher score is not an endorsement, guarantee of quality, or legal/financial advice.",
  "aboutEmployerScore.limits.title": "Important limitations",
  "aboutEmployerScore.pillar.benefits.body": "We count how many distinct benefits and perks (health cover, pension top-ups, equipment budgets, and similar) employers mention across their listings, plus vacation time above Finland's statutory minimum.",
  "aboutEmployerScore.pillar.benefits.title": "Benefits & perks",
  "aboutEmployerScore.pillar.flex.body": "Remote and hybrid options are scored from how consistently employers advertise flexible work models across their open roles.",
  "aboutEmployerScore.pillar.flex.title": "Flexibility (remote / hybrid)",
  "aboutEmployerScore.pillar.growth.body": "When listings include seniority structure and career progression cues, we interpret that as stronger internal growth paths.",
  "aboutEmployerScore.pillar.growth.title": "Growth signals",
  "aboutEmployerScore.pillar.pay.body": "When we have enough listings with structured salary ranges, we score how competitive the typical band is against the Finnish market.",
  "aboutEmployerScore.pillar.pay.title": "Pay (posted salary bands)",
  "aboutEmployerScore.pillar.stability.body": "We look at hiring continuity over time — employers that maintain steady, non-spiky hiring patterns score higher than those with chaotic posting behavior.",
  "aboutEmployerScore.pillar.stability.title": "Hiring stability",
  "aboutEmployerScore.pillar.transparency.body": "We track how often listings disclose a real, non-estimated salary instead of a vague \"competitive salary\" line, and how often they document a recruitment-process timeline candidates can expect.",
  "aboutEmployerScore.pillar.transparency.title": "Transparency",
  "aboutEmployerScore.pillars.title": "What goes into the score",
  "aboutEmployerScore.tierExplainer": "We show a grade rather than an exact number on purpose: employers close together shouldn't look more different than the underlying signal actually supports. Grades, from strongest to weakest: A, B, C, D, E.",
  "aboutEmployerScore.title": "How the Employer Score works",
  "apiKeys.settings.alreadyConnectedBody": "You already created a connection key. We only show the full key once, so if you need to see it again, for example to set up another device, generate a fresh one below. Your existing connection keeps working either way.",
  "apiKeys.settings.alreadyConnectedHeading": "You're already connected",
  "apiKeys.settings.authHeaderLabel": "Authorization header value",
  "apiKeys.settings.autoKeyLabel": "AI agent",
  "apiKeys.settings.breadcrumbSeeker": "AI agent search",
  "apiKeys.settings.claudeCodeBody": "If your Claude account doesn't have Request headers yet, or you prefer the terminal, run this instead:",
  "apiKeys.settings.claudeCodeHeading": "Or use Claude Code",
  "apiKeys.settings.claudeHeading": "Connect Claude",
  "apiKeys.settings.claudeStep1": "Open Claude and go to Customize, then Connectors (in a Team or Enterprise workspace, use Organization settings instead of Customize), then Add custom connector.",
  "apiKeys.settings.claudeStep2": "Paste the server URL below into the connector's URL field.",
  "apiKeys.settings.claudeStep3": "Set Authentication to None.",
  "apiKeys.settings.claudeStep4": "Under Request headers, add a header named Authorization with the value below. Anthropic is still rolling this option out, so it may not appear in every account yet. If you don't see it, use Claude Code instead.",
  "apiKeys.settings.claudeStep5": "Save, then try asking Claude something like \"Find remote software engineering jobs in Helsinki.\"",
  "apiKeys.settings.claudeStep5Generic": "Save, then try asking Claude to use one of the tools this connector exposes.",
  "apiKeys.settings.copiedButton": "Copied",
  "apiKeys.settings.copyButton": "Copy",
  "apiKeys.settings.createButton": "Create key",
  "apiKeys.settings.createHeading": "Create a new key",
  "apiKeys.settings.createdLabel": "Created {date}",
  "apiKeys.settings.creatingButton": "Creating…",
  "apiKeys.settings.doneButton": "Done",
  "apiKeys.settings.emptyState": "You haven't created any keys yet.",
  "apiKeys.settings.existingHeading": "Your keys",
  "apiKeys.settings.generateNewButton": "Generate a new key",
  "apiKeys.settings.generatingButton": "Generating…",
  "apiKeys.settings.labelFieldLabel": "Name this key",
  "apiKeys.settings.labelFieldPlaceholder": "e.g. Claude Desktop",
  "apiKeys.settings.lastUsedLabel": "Last used {date}",
  "apiKeys.settings.manageKeysToggle": "Manage keys",
  "apiKeys.settings.neverUsedLabel": "Never used",
  "apiKeys.settings.newKeyHeading": "Your new key",
  "apiKeys.settings.newKeyWarning": "Copy this now. You won't be able to see it again.",
  "apiKeys.settings.noEmployerAccess": "Your account has no employer access yet. Write to {email} and we'll set you up.",
  "apiKeys.settings.otherAgentsBody": "Most agents that support MCP over HTTP will ask for a server URL and let you add a custom request header. Use the same server URL and Authorization header above. ChatGPT's connector settings don't support this kind of key yet, so it isn't available there for now.",
  "apiKeys.settings.otherAgentsHeading": "Other AI agents",
  "apiKeys.settings.revokeButton": "Revoke",
  "apiKeys.settings.revokeConfirm": "Revoke this key? Anything using it will stop working immediately.",
  "apiKeys.settings.revokedLabel": "Revoked {date}",
  "apiKeys.settings.serverUrlLabel": "Server URL",
  "apiKeys.settings.setupHint": "Create a key below, then follow the step-by-step setup guide that appears with it.",
  "apiKeys.settings.subtitleEmployer": "Connect Claude or another MCP client to manage {companyName}’s jobs and careers page.",
  "apiKeys.settings.subtitleInternal": "Connect Claude or another MCP client to JobCrawls' internal data tools.",
  "apiKeys.settings.subtitleSeeker": "Connect JobCrawls to Claude or another AI agent so it can search real job openings in Finland for you.",
  "apiKeys.settings.title": "API keys",
  "apiKeys.settings.titleSeeker": "JobCrawls search in your AI agent",
  "applyAutofill.applyManually": "Apply on the employer's site instead",
  "applyAutofill.coverLetterLabel": "Cover letter (optional)",
  "applyAutofill.email": "Email",
  "applyAutofill.failedGeneric": "We couldn't finish submitting this application automatically.",
  "applyAutofill.firstName": "First name",
  "applyAutofill.lastName": "Last name",
  "applyAutofill.no": "No",
  "applyAutofill.nothingSentYet": "Nothing has been sent to the employer yet.",
  "applyAutofill.pageTitle": "Review your application",
  "applyAutofill.phone": "Phone",
  "applyAutofill.polling": "Submitting your application now, this can take a minute…",
  "applyAutofill.preparing": "Preparing your application…",
  "applyAutofill.regenerate": "Regenerate",
  "applyAutofill.resumeAttached": "resume.pdf will be attached",
  "applyAutofill.submitTo": "Submit to {company}",
  "applyAutofill.submitting": "Submitting…",
  "applyAutofill.success": "Application submitted.",
  "applyAutofill.viewInTracker": "View in your tracker",
  "applyAutofill.yes": "Yes",
  "auth.signInPrompt.closeLabel": "Close",
  "auth.signInPrompt.description": "Create a free account to save jobs, sync progress, and pick up your search on any device.",
  "auth.signInPrompt.primaryAction": "Create account",
  "auth.signInPrompt.secondaryAction": "Maybe later",
  "auth.signInPrompt.title": "Sign in to save jobs",
  "autocomplete.filters": "Filter matches",
  "autocomplete.noMatches": "No filter matches found",
  "autocomplete.scrollHint": "Scroll for more",
  "backoffice.architecture": "Architecture",
  "backoffice.dashboard": "Dashboard",
  "backoffice.dataExplorer.nav": "Data explorer",
  "backoffice.dataExplorer.title": "Data explorer",
  "backoffice.emailAlerts.nav": "Email alerts",
  "backoffice.hub.nav": "All tools",
  "backoffice.hub.open": "Open",
  "backoffice.hub.subtitle": "Choose a tool to open. Access is restricted to authorized accounts.",
  "backoffice.hub.title": "Backoffice",
  "backoffice.jobDataExplorer.nav": "Job data API",
  "backoffice.mcpKeys.nav": "API keys",
  "backoffice.nav.jumpToTool": "Jump to backoffice tool",
  "backoffice.nav.jumpToToolPlaceholder": "Select a tool…",
  "backoffice.testing": "Testing",
  "backoffice.title": "Backoffice",
  "backoffice.userAgents.description": "Single-screen monitoring: map-centered, auto-refreshes last 1m on load. Adjust lookback and filters, then drill into the table.",
  "backoffice.userAgents.hours": "Look back",
  "backoffice.userAgents.mapboxTokenMissing": "Map view requires a Mapbox access token (PUBLIC_ENV__MAPBOX_ACCESS_TOKEN).",
  "backoffice.userAgents.nav": "User agents",
  "backoffice.userAgents.noData": "No user agent entries in this time range.",
  "backoffice.userAgents.run": "Refresh",
  "backoffice.userAgents.title": "Crawl & traffic dashboard",
  "bestCompanies.breadcrumb.current": "Employers",
  "bestCompanies.breadcrumb.hub": "Companies",
  "bestCompanies.dimension.backToHub": "← All employer rankings",
  "bestCompanies.dimension.empty": "No employers found for this filter yet. Check back after the next index run.",
  "bestCompanies.dimension.introPrefix": "Most active hiring first. Each employer also carries its",
  "bestCompanies.dimension.introSuffix": ", computed from salary transparency, remote flexibility, hiring stability and benefits in listings aimed at the Finnish job market (including many remote roles). Not reviews.",
  "bestCompanies.dimension.scoreName": "JobCrawls Employer Score",
  "bestCompanies.dimension.title": "Employers hiring in {label}",
  "bestCompanies.hub.agenciesHidden": "Agencies hidden",
  "bestCompanies.hub.azHeading": "All employers A to Z",
  "bestCompanies.hub.browseAzChip": "All employers A to Z",
  "bestCompanies.hub.browseCity": "Employers by city",
  "bestCompanies.hub.browseLabel": "Browse",
  "bestCompanies.hub.chip.all": "All",
  "bestCompanies.hub.chip.growing": "Growing",
  "bestCompanies.hub.chip.hiringMyRole": "Hiring my role",
  "bestCompanies.hub.chip.nearHelsinki": "Near Helsinki",
  "bestCompanies.hub.chip.pays5k": "Pays €5k+",
  "bestCompanies.hub.clearSearch": "Clear search",
  "bestCompanies.hub.filteredCount": "{count, plural, one {# employer matches} other {# employers match}}",
  "bestCompanies.hub.heroLede": "Pay bands, remote share, hiring pace and trend for every employer we crawl. Follow one and we check their careers page daily and tell you when a role appears.",
  "bestCompanies.hub.hiringNowCount": "· {count} hiring now",
  "bestCompanies.hub.loadingMoreMatches": "finding more matches…",
  "bestCompanies.hub.matchCount": "{count, plural, one {# match} other {# matches}}",
  "bestCompanies.hub.moreWaysToBrowse": "More ways to browse",
  "bestCompanies.hub.networkWorthyFilter": "Rarely posts publicly",
  "bestCompanies.hub.noMatches": "No companies match your filters. Try clearing a filter or searching a different name.",
  "bestCompanies.hub.overallEmpty": "Employers aren't available right now. Try again later.",
  "bestCompanies.hub.remoteFriendlyFilter": "Remote-friendly",
  "bestCompanies.hub.resultsCount": "{count, plural, one {# employer} other {# employers}}",
  "bestCompanies.hub.searchPlaceholder": "Search employers by name, industry or role…",
  "bestCompanies.hub.showMore": "Show more",
  "bestCompanies.hub.showingCount": "Showing {shown}",
  "bestCompanies.hub.showingOfTotal": "Showing {shown} of {total}",
  "bestCompanies.hub.sort.hiring": "Hiring pace",
  "bestCompanies.hub.sort.pay": "Pay",
  "bestCompanies.hub.sort.score": "Employer score",
  "bestCompanies.hub.sortLabel": "Sort by",
  "bestCompanies.hub.title": "Employers in Finland",
  "bestCompanies.hub.watchlistStrip.following": "Following <b>{count}</b>",
  "bestCompanies.hub.watchlistStrip.newThisWeek": "<b>{count} new</b> roles this week",
  "bestCompanies.hub.watchlistStrip.open": "Open in My Jobs →",
  "bestCompanies.row.hiringPace": "~{count} new roles/mo",
  "bestCompanies.row.medianPrefix": "Median",
  "bestCompanies.row.networkWorthy": "Worth networking with",
  "bestCompanies.row.perMonth": "{range}/mo",
  "bestCompanies.row.remoteHybridPercent": "{percent}% remote/hybrid",
  "bestCompanies.row.remotePercent": "{percent}% remote",
  "bestCompaniesCard.employees": "{range} employees",
  "bestCompaniesCard.hiresLabel": "Hires",
  "bestCompaniesCard.noOpenRoles": "no open roles right now",
  "bestCompaniesCard.noPayBands": "No posted pay bands",
  "bestCompaniesCard.openRoles": "{count, plural, one {# open role} other {# open roles}}",
  "bestCompaniesCard.pace": "~{count} / mo",
  "bestCompaniesCard.payBandRange": "€{min}–{max}<small>/mo</small>",
  "bestCompaniesCard.payBandSingle": "€{amount}<small>/mo</small>",
  "bestCompaniesCard.rarelyPostsPublicly": "Rarely posts publicly",
  "bestCompaniesCard.remoteOrHybridPercent": "{percent}% remote or hybrid",
  "bestCompaniesCard.remotePercent": "{percent}% remote",
  "bestCompaniesCard.scoreCaption": "Employer score",
  "bestCompaniesCard.trendDeclining": "Declining ↘",
  "bestCompaniesCard.trendGrowing": "Growing ↗",
  "bestCompaniesCard.trendStable": "Stable",
  "breadcrumb.benefits": "Benefits",
  "breadcrumb.company": "Company",
  "breadcrumb.educationLevel": "Education",
  "breadcrumb.industry": "Industry",
  "breadcrumb.isDriversLicenseRequired": "Driver's License",
  "breadcrumb.isOpenApplication": "Open Application",
  "breadcrumb.jobType": "Job Type",
  "breadcrumb.jobs": "Jobs",
  "breadcrumb.language": "Language",
  "breadcrumb.level": "Level",
  "breadcrumb.location": "Location",
  "breadcrumb.navigation": "Breadcrumb navigation",
  "breadcrumb.peopleManagementTier": "Management",
  "breadcrumb.remote": "Remote",
  "breadcrumb.skillsAndTechnologies": "Skills/Tech",
  "checklist.field.addTrigger": "Add checklist",
  "checklist.field.placeholder": "Add a task and press Enter…",
  "checklist.field.progressTrigger": "{done}/{total} done",
  "checklist.field.remove": "Remove task {text}",
  "collectiveAgreements.aiTranslatedBadge": "AI-translated",
  "collectiveAgreements.bindingLegend": "What \"unresolved\" means:",
  "collectiveAgreements.bindingLegendBody": "the Confirmation Board didn't name that agreement in any of the annual reviews we have on file — that's a genuine gap in the record, not a \"no.\"",
  "collectiveAgreements.bindingNo": "Not binding",
  "collectiveAgreements.bindingUnknown": "Unknown",
  "collectiveAgreements.bindingYes": "Binding",
  "collectiveAgreements.breadcrumb.current": "Collective Agreements",
  "collectiveAgreements.decisionNoPrefix": "Decision no.",
  "collectiveAgreements.editorialStandardsLinkLabel": "editorial standards",
  "collectiveAgreements.eyebrow": "Reference · Finlex & Ministry of Social Affairs and Health",
  "collectiveAgreements.filterLabel": "Filter collective agreements by name",
  "collectiveAgreements.filterPlaceholder": "Search by agreement name…",
  "collectiveAgreements.intro": "A työehtosopimus sets the minimum pay and terms for a job — which one applies depends on the employer's industry and the kind of role. We link job ads to our best guess automatically; this is the full source list, so you can check that guess yourself.",
  "collectiveAgreements.noResults": "No agreements match your search.",
  "collectiveAgreements.pdfFi": "PDF (Finnish)",
  "collectiveAgreements.pdfSv": "PDF (Swedish)",
  "collectiveAgreements.resultsCount": "Showing {shown} of {total} agreements — {binding} confirmed generally binding",
  "collectiveAgreements.scopeHeading": "Scope of application",
  "collectiveAgreements.scopeUnavailable": "No scope-of-application text is available for this agreement.",
  "collectiveAgreements.sourceLanguageDisclaimer": "Agreement names and scope text below are shown in English/Swedish where an AI translation is available, and in the original Finnish otherwise: Finlex publishes no official translation of them. These translations are unofficial and may contain errors; the original Finnish wording from Finlex is authoritative. Other text on this page may also be machine-translated; see our {editorialStandardsLink}.",
  "collectiveAgreements.stat.binding": "Confirmed binding",
  "collectiveAgreements.stat.total": "Agreements on file",
  "collectiveAgreements.stat.unresolved": "Status unresolved",
  "collectiveAgreements.title": "Finnish collective agreements",
  "collectiveAgreements.viewOnFinlex": "Finlex",
  "company.bulkFollow.cta": "{count, plural, one {Follow this company} other {Follow all {count}}}",
  "company.bulkFollow.followedToast": "{count, plural, one {Following 1 company. Watchlist updated} other {Following {count} companies. Watchlist updated}}",
  "company.follow.createAccount": "Create account",
  "company.follow.cta": "Follow",
  "company.follow.emailPrompt.enabled": "You're set — new roles from companies you follow will be in your job-alert emails.",
  "company.follow.emailPrompt.failed": "Couldn't turn on email updates — you can enable them any time from the Alerts page.",
  "company.follow.emailPrompt.offer": "Following {company} — want an email when they post new roles?",
  "company.follow.emailPrompt.pendingConfirmation": "Almost there — confirm your email in your inbox to activate updates.",
  "company.follow.emailPrompt.turnOn": "Turn on",
  "company.follow.followedToast": "Following. Watchlist updated",
  "company.follow.following": "Following",
  "company.follow.followingCheck": "Following ✓",
  "company.follow.undo": "Undo",
  "company.follow.unfollow": "Unfollow",
  "company.follow.unfollowedToast": "Unfollowed. You won’t be notified of their new roles",
  "company.follow.viewWatchlist": "View →",
  "company.logoAlt": "{company} logo",
  "company.logoAltGeneric": "Employer logo",
  "companyChart.caption.averaging": "averaging {avg} jobs per month",
  "companyChart.caption.hiringDeclining": "{companyName}'s hiring is declining",
  "companyChart.caption.hiringGrowing": "{companyName}'s hiring is growing",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}'s hiring is rapidly declining",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}'s hiring is rapidly growing",
  "companyChart.caption.hiringStable": "{companyName}'s hiring is stable",
  "companyChart.caption.levelDistributionDouble": "{companyName} hires mostly at the {level1} and {level2} levels.",
  "companyChart.caption.levelDistributionSingle": "{companyName} hires mostly at the {level} level.",
  "companyChart.caption.levelDistributionTriple": "{companyName} hires mostly at the {level1}, {level2}, and {level3} levels.",
  "companyChart.caption.locationDistributionDouble": "{companyName} hires mostly in {location1} and {location2}.",
  "companyChart.caption.locationDistributionSingle": "{companyName} hires mostly in {location}.",
  "companyChart.caption.locationDistributionTriple": "{companyName} hires mostly in {location1}, {location2}, and {location3}.",
  "companyChart.caption.margin": "and a profit margin of {margin}",
  "companyChart.caption.marginOnly": "{companyName} had a profit margin of {margin} in 2024",
  "companyChart.caption.profitable": "{companyName} was profitable in 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} hires mostly hybrid positions.",
  "companyChart.caption.remotenessOnsite": "{companyName} hires mostly onsite positions.",
  "companyChart.caption.remotenessRemote": "{companyName} hires mostly remote positions.",
  "companyChart.caption.revenue": "{companyName} had revenue of {revenue} in 2024",
  "companyChart.caption.revenueWith": "with revenue of {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} hires mostly {role1} and {role2} roles.",
  "companyChart.caption.roleDistributionSingle": "{companyName} hires mostly {role} roles.",
  "companyChart.caption.roleDistributionTriple": "{companyName} hires mostly {role1}, {role2}, and {role3} roles.",
  "companyChart.caption.unprofitable": "{companyName} was unprofitable in 2024",
  "companyChart.caption.workforceRate": "({rate}% of their workforce)",
  "companyChart.financialOverview": "Financial Overview (2024)",
  "companyChart.insufficientData": "Limited data available - trends require at least 3 months of data",
  "companyChart.monthlyHiringTrends": "Monthly Hiring Trends",
  "companyChart.moreCategories": "+{count} more",
  "companyChart.profit": "Profit",
  "companyChart.profitMargin": "Profit Margin",
  "companyChart.revenue": "Revenue",
  "companyChart.trend.declining": "Declining",
  "companyChart.trend.growing": "Growing",
  "companyChart.trend.insufficientData": "Limited Data",
  "companyChart.trend.rapidlyDeclining": "Rapidly Declining",
  "companyChart.trend.rapidlyGrowing": "Rapidly Growing",
  "companyChart.trend.stable": "Stable",
  "companyChart.trendDescription.declining": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.growing": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.rapidlyDeclining": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.rapidlyGrowing": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.simpleDeclining": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.simpleGrowing": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.simpleStable": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.stable": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyGroupingToggle.label": "Group jobs by company",
  "companyHeader.jobCount": "{count, plural, one {# open position} other {# open positions}}",
  "companyHeader.locationCount": "{count, plural, one {# location} other {# locations}}",
  "companyInsight.bodyNoLocations": "appears in {count, plural, one {# indexed job posting} other {# indexed job postings}} in JobCrawls' Finland dataset since {sinceDate}. This reflects historical index data, not a live count of open vacancies.",
  "companyInsight.bodyWithLocations": "appears in {count, plural, one {# indexed job posting} other {# indexed job postings}} in JobCrawls' Finland dataset since {sinceDate}. In that historical index, the strongest location signals for this employer are {locationList}.",
  "companyInsight.englishRequirement": "{percent}% of those indexed postings mention English as a requirement.",
  "companyInsight.locationSegment": "{location} ({count, plural, one {# indexed posting} other {# indexed postings}})",
  "companyProfile.commonBenefits.heading": "Common benefits",
  "companyProfile.communityInsights.consTitle": "Common complaints",
  "companyProfile.communityInsights.heading": "What people say online",
  "companyProfile.communityInsights.prosTitle": "What people like",
  "companyProfile.communityInsights.sentimentInsufficient": "Not enough data",
  "companyProfile.communityInsights.sentimentMixed": "Mixed",
  "companyProfile.communityInsights.sentimentNegative": "Mostly negative",
  "companyProfile.communityInsights.sentimentPositive": "Mostly positive",
  "companyProfile.communityInsights.sourcesTitle": "Sources",
  "companyProfile.communityInsights.subtitle": "Summarized from public Reddit, Suomi24, and forum discussion",
  "companyProfile.companyFacts.benefitsLabel": "Benefits",
  "companyProfile.companyFacts.contactLabel": "Contact",
  "companyProfile.companyFacts.corporateHistoryLabel": "Ownership",
  "companyProfile.companyFacts.heading": "Good to know",
  "companyProfile.companyFacts.officeLocationsLabel": "Offices",
  "companyProfile.companyFacts.remotePolicyLabel": "Remote work",
  "companyProfile.companyFacts.teamLabel": "Team",
  "companyProfile.companyFacts.teamLinkText": "Meet the team",
  "companyProfile.companyFacts.valuesLabel": "Values",
  "companyProfile.ownedBrands.heading": "Owned brands",
  "companyProfile.siteSources.sourceLabel": "Source",
  "cookie.consent.accept": "Accept analytics",
  "cookie.consent.analyticsBody": "Helps us spot searches that return no results and pages people get stuck on, so we can fix them. Optional, and never used for ads.",
  "cookie.consent.analyticsTitle": "Analytics",
  "cookie.consent.banner": "We use essential cookies to run JobCrawls. With your OK, we also use privacy-friendly analytics — it helps us spot searches that come up empty and pages people get stuck on, so we can fix them faster. Never for ads. You can change your mind anytime.",
  "cookie.consent.cancel": "Cancel",
  "cookie.consent.manage": "Manage preferences",
  "cookie.consent.modalTitle": "Cookie preferences",
  "cookie.consent.necessaryNote": "Essential cookies (session, preferences, security) are always used so the site works.",
  "cookie.consent.nudge": "You can turn on privacy-friendly analytics anytime — it helps us catch broken searches faster.",
  "cookie.consent.privacyLink": "Privacy Policy",
  "cookie.consent.reject": "Reject non-essential",
  "cookie.consent.save": "Save choices",
  "cookie.consent.title": "Cookies and privacy",
  "dashboard.actions": "Actions",
  "dashboard.addComment": "Add Comment",
  "dashboard.addComment.placeholder": "Add a comment...",
  "dashboard.addCompany.cancel": "Cancel",
  "dashboard.addCompany.close": "Close",
  "dashboard.addCompany.doCrawl": "Enable crawling (doCrawl = TRUE)",
  "dashboard.addCompany.errorName": "Company name is required.",
  "dashboard.addCompany.fieldAts": "ATS",
  "dashboard.addCompany.fieldCareers": "Careers / jobs page URL",
  "dashboard.addCompany.fieldEnqueue": "Enqueue URL",
  "dashboard.addCompany.fieldLogo": "Logo URL",
  "dashboard.addCompany.fieldName": "Company name",
  "dashboard.addCompany.fieldWebsite": "Website",
  "dashboard.addCompany.hintId": "The company ID in the database is the exact company name (trimmed). If a row with the same name already exists, creation will fail.",
  "dashboard.addCompany.open": "Add company",
  "dashboard.addCompany.placeholderName": "e.g. Acme Oy",
  "dashboard.addCompany.saving": "Creating…",
  "dashboard.addCompany.submit": "Create company",
  "dashboard.addCompany.title": "Add company",
  "dashboard.adding": "Adding...",
  "dashboard.address": "Address",
  "dashboard.all": "All",
  "dashboard.allAts": "All ATS",
  "dashboard.allCompanies": "All Companies",
  "dashboard.allStatus": "All Status",
  "dashboard.ats": "ATS",
  "dashboard.atsSystem": "ATS System",
  "dashboard.businessId": "Business ID",
  "dashboard.cancelEdit": "Cancel",
  "dashboard.careersUrl": "Careers URL",
  "dashboard.charts.closeBackdrop": "Close",
  "dashboard.charts.closeButton": "Close charts",
  "dashboard.charts.modalTitle": "Crawl activity charts",
  "dashboard.charts.toolbarDisabledHint": "Load crawl export data first",
  "dashboard.charts.toolbarHint": "Open crawl activity charts",
  "dashboard.charts.toolbarLabel": "Charts",
  "dashboard.check": "Mark as checked",
  "dashboard.clearDlq": "Clear DLQ",
  "dashboard.clearFilters": "Clear Filters",
  "dashboard.clearLogoFailures": "Clear Logo Failures ({count})",
  "dashboard.comments": "Comments",
  "dashboard.companiesHeader": "Companies ({count} of {total})",
  "dashboard.companyAttributes": "Company attributes",
  "dashboard.companyBasic": "Company Basic",
  "dashboard.companyBasic.short": "Basic Info",
  "dashboard.companyBusiness": "Business Info",
  "dashboard.companyContact": "Contact",
  "dashboard.companyCrawl": "Crawl Settings",
  "dashboard.companyCrawlRecordsPerPageLabel": "Rows per page",
  "dashboard.companyCrawlRecordsShowing": "Showing {from}-{to} of {total}",
  "dashboard.companyFinancial": "Financial",
  "dashboard.companyId": "Company ID",
  "dashboard.companyIndustry": "Industry",
  "dashboard.companyInformation": "Company Information",
  "dashboard.companyLocation": "Location",
  "dashboard.companyModal.close": "Close company window",
  "dashboard.companyModal.closeBackdrop": "Close",
  "dashboard.companyModal.subtitle": "{crawls} crawls · {ok} successful · {jobs} sent to processor",
  "dashboard.companyModal.tabCrawls": "Crawl runs",
  "dashboard.companyModal.tabSettings": "Company & crawl settings",
  "dashboard.companyName": "Company Name",
  "dashboard.companyRegistry": "Registry",
  "dashboard.companyRow.jobs": "jobs",
  "dashboard.companyRow.openBadge": "Open",
  "dashboard.companyRow.paginationWarningShort": "Pagination ⚠ {n}",
  "dashboard.companySocial": "Social Media",
  "dashboard.companyUrl": "Company URL",
  "dashboard.coordinates": "Coordinates",
  "dashboard.crawlActions.companyColumnHint": "HTML · Live · Trace · Logs",
  "dashboard.crawlActions.flatActionsColumnHint": "Live · HTML",
  "dashboard.crawlActions.flatLogsColumnHint": "⋯ menu",
  "dashboard.crawlActions.flatTraceColumnHint": "Modal",
  "dashboard.crawlActions.legendHtml": "Eye — HTML: snapshot from S3 as crawled (plus live extracted JSON when the row has a URL).",
  "dashboard.crawlActions.legendLive": "Arrow out — Live site: open the public job page on JobCrawls (detail rows with an object ID only).",
  "dashboard.crawlActions.legendLogs": "⋯ — CloudWatch: jump to crawler, processor, enrich, Algolia, etc. (filters use this crawl id or job URL).",
  "dashboard.crawlActions.legendRecrawlDetail": "Arrows — Recrawl page: enqueue one detail crawl for this URL (not the whole company list).",
  "dashboard.crawlActions.legendTitle": "What the row buttons do",
  "dashboard.crawlActions.legendTrace": "Magnifying glass — Trace: one modal with Raw/Final/Enriched status, DynamoDB & AWS console links.",
  "dashboard.crawlActions.liveJobAria": "Open public job listing on JobCrawls",
  "dashboard.crawlActions.liveJobTooltip": "Open this job’s public listing page on JobCrawls (same URL visitors see when the job is indexed).",
  "dashboard.crawlActions.logsMenuAria": "CloudWatch pipeline logs menu for this crawl",
  "dashboard.crawlActions.logsMenuTooltip": "CloudWatch log links: exact crawl stream when available, then filtered views for crawler (crawlId), processor, enrich, Algolia, maintainer, and processor by URL.",
  "dashboard.crawlActions.recrawlDetailAria": "Recrawl this job page (detail crawl only)",
  "dashboard.crawlActions.recrawlDetailTooltip": "Queue a crawl of this job page only (detail). Does not re-run full company list pages — use company “Recrawl” for that.",
  "dashboard.crawlActions.traceAria": "Open full pipeline trace for this job URL",
  "dashboard.crawlActions.traceTooltip": "Open pipeline trace: RawJobs / FinalJobs / Enriched summaries, object IDs, and links to DynamoDB & CloudWatch for this job URL.",
  "dashboard.crawlActions.viewHtmlAria": "View stored HTML snapshot for this crawl",
  "dashboard.crawlActions.viewHtmlTooltip": "Open the HTML snapshot stored for this crawl (S3). Shows rendered or raw markup and live DynamoDB job JSON beside it.",
  "dashboard.crawlDataLoadedNoCompanies": "Crawl data loaded ({count} records), but company data hasn't been loaded in this browser yet — so nothing is grouped below. Load companies to see it.",
  "dashboard.crawlDlq": "Crawl DLQ",
  "dashboard.crawlExportWindow": "Loaded crawl records from {from} to {to} (maintainer export window).",
  "dashboard.crawlFailIconTooltip": "This crawl run failed or returned an HTTP error — open CloudWatch / pipeline logs for this crawlId.",
  "dashboard.crawlHistory.hideOlder": "Hide {n} older crawl(s)",
  "dashboard.crawlHistory.hint": "Newest run is in the row above. Each older run has its own crawlId and CloudWatch links.",
  "dashboard.crawlHistory.showOlder": "Show {n} older crawl(s) — time, logs, HTML",
  "dashboard.crawlHourlyChart.ariaDuration": "Hourly chart of average page time and total crawl minutes",
  "dashboard.crawlHourlyChart.ariaPages": "Hourly chart of listing and job page fetches, saved jobs, listing links, and unsaved job pages",
  "dashboard.crawlHourlyChart.avgSecPhrase": "avg {seconds} s per page that reported timing",
  "dashboard.crawlHourlyChart.axisAvgSec": "Avg s / page",
  "dashboard.crawlHourlyChart.axisExtracted": "Job-related counts / hr",
  "dashboard.crawlHourlyChart.axisPageFetches": "Page fetches / hr",
  "dashboard.crawlHourlyChart.axisTotalMin": "Total min / hr",
  "dashboard.crawlHourlyChart.collapsedEmpty": "No rows in loaded window",
  "dashboard.crawlHourlyChart.collapsedSummary": "{hours} hours · {fetches} page fetches",
  "dashboard.crawlHourlyChart.durationHms": "{hours}h {minutes}m {seconds}s total (sum of per-page timings)",
  "dashboard.crawlHourlyChart.durationMs": "{minutes}m {seconds}s total (sum of per-page timings)",
  "dashboard.crawlHourlyChart.durationSecOnly": "{seconds}s total (sum of per-page timings)",
  "dashboard.crawlHourlyChart.durationZero": "0s total",
  "dashboard.crawlHourlyChart.empty": "No crawl rows in the loaded window — refresh crawl data after a maintainer export.",
  "dashboard.crawlHourlyChart.helpCollapsibleLabel": "Explanation & window totals",
  "dashboard.crawlHourlyChart.hoverAllFetches": "All page fetches",
  "dashboard.crawlHourlyChart.hoverAllFetchesValue": "{total} ({ok} ok / {fail} failed)",
  "dashboard.crawlHourlyChart.hoverAvgPageTime": "Avg page time (timed rows)",
  "dashboard.crawlHourlyChart.hoverAvgSecValue": "{seconds} s (n = {n})",
  "dashboard.crawlHourlyChart.hoverDetailJobsCounted": "From single job pages (postings seen)",
  "dashboard.crawlHourlyChart.hoverDetailNotSaved": "Single job pages we did not save",
  "dashboard.crawlHourlyChart.hoverFoundOtherPages": "Found on other page types",
  "dashboard.crawlHourlyChart.hoverHourWindow": "{start} – {end}",
  "dashboard.crawlHourlyChart.hoverJobPages": "Job (detail) pages",
  "dashboard.crawlHourlyChart.hoverJobPagesValue": "{ok} ok / {fail} failed",
  "dashboard.crawlHourlyChart.hoverJobsFound": "“Found” total (everything added up)",
  "dashboard.crawlHourlyChart.hoverListPages": "List pages",
  "dashboard.crawlHourlyChart.hoverListPagesValue": "{ok} ok / {fail} failed",
  "dashboard.crawlHourlyChart.hoverListUrlsEnqueued": "From listing pages (job links counted)",
  "dashboard.crawlHourlyChart.hoverNoTimingSamples": "—",
  "dashboard.crawlHourlyChart.hoverPipeline": "Saved to pipeline",
  "dashboard.crawlHourlyChart.hoverPipelineBreakdown": "{total} (Työmarkkinatori {tm}, other {other})",
  "dashboard.crawlHourlyChart.hoverTotalReportedTime": "Total reported crawl time",
  "dashboard.crawlHourlyChart.noTiming": "no per-page duration recorded in this export",
  "dashboard.crawlHourlyChart.panelDuration": "Crawl duration",
  "dashboard.crawlHourlyChart.panelPages": "Fetches and job counts by hour",
  "dashboard.crawlHourlyChart.plainGuide1": "“Found” is often huge because every job link on a careers listing page is counted. Those links are only “we queued this URL” — not a saved job yet.",
  "dashboard.crawlHourlyChart.plainGuide2": "“Extracted” means we actually saved that job to raw storage from a single job page. Listing rows never add to extracted (by design).",
  "dashboard.crawlHourlyChart.plainGuide3": "On the chart, use the checkboxes: the dashed purple line = links counted on list pages; the dashed brown line = job pages we visited but did not save; the solid gold line = saved to the pipeline. Hover the graph for one hour’s numbers.",
  "dashboard.crawlHourlyChart.plainGuideTitle": "In plain terms",
  "dashboard.crawlHourlyChart.subtitle": "Top chart: pages we fetched and job counts per hour. Bottom chart: how long crawls took. Time axis matches your exported crawl window (often about a week).",
  "dashboard.crawlHourlyChart.title": "Crawl activity by hour (local time)",
  "dashboard.crawlHourlyChart.totalDetailSkipped": "Job pages visited but not saved",
  "dashboard.crawlHourlyChart.totalExtracted": "Jobs saved to raw (“extracted”)",
  "dashboard.crawlHourlyChart.totalFoundRaw": "“Found” (all rows added up)",
  "dashboard.crawlHourlyChart.totalJobPages": "Single job pages crawled",
  "dashboard.crawlHourlyChart.totalJobPagesValue": "{total} ({ok} succeeded, {fail} failed)",
  "dashboard.crawlHourlyChart.totalListLinks": "Of that, links counted on listing pages",
  "dashboard.crawlHourlyChart.totalListPages": "Listing pages crawled",
  "dashboard.crawlHourlyChart.totalListPagesValue": "{total} ({ok} succeeded, {fail} failed)",
  "dashboard.crawlHourlyChart.totalTiming": "Crawler-reported time",
  "dashboard.crawlHourlyChart.totalsTitle": "Totals for the time range above",
  "dashboard.crawlKey": "Crawl Key",
  "dashboard.crawlMetricsExplainer.crawls": "Crawls — one log row each time we open a listing page or a single job page.",
  "dashboard.crawlMetricsExplainer.extracted": "Extracted — jobs we actually saved from a job page. Listing pages don’t add here.",
  "dashboard.crawlMetricsExplainer.found": "Found — mostly “how many job links we counted on listing pages,” plus what we saw on job pages. Big numbers here are normal.",
  "dashboard.crawlMetricsExplainer.foundVsExtracted": "For a fuller picture, use the hourly chart below: it labels the purple, brown, and gold lines to match this story.",
  "dashboard.crawlMetricsExplainer.successFailed": "Success / failed — did that page load and finish without a crawl error?",
  "dashboard.crawlMetricsExplainer.title": "What these numbers mean",
  "dashboard.crawlMetricsExplainer.triggerAria": "What these crawl summary numbers mean",
  "dashboard.crawlOkIconTooltip": "This crawl run succeeded (HTTP OK, no crawler failure).",
  "dashboard.crawlOutliersFilter.all": "All crawl rows",
  "dashboard.crawlOutliersFilter.any": "Crawled but not sent",
  "dashboard.crawlOutliersFilter.hint": "Uses IndexedDB export fields only. List-page rows are hidden when this is not “All”. Combine with flat “Job / list pages” tabs.",
  "dashboard.crawlOutliersFilter.label": "Pipeline / index outliers (detail crawls)",
  "dashboard.crawlOutliersFilter.notSent": "Crawled OK but jobsExtracted = 0 (not skipped)",
  "dashboard.crawlRecords": "Crawl Records",
  "dashboard.crawlStatistics": "Crawl Statistics",
  "dashboard.crawlType": "Crawl Type",
  "dashboard.crawlingInformation": "Crawling Information",
  "dashboard.deleteComment": "Delete comment",
  "dashboard.deleteCompany": "Delete",
  "dashboard.deleteCompany.confirm": "Delete \"{name}\" from the Companies table (DynamoDB)? This cannot be undone. Local dashboard rows for this company will be removed.",
  "dashboard.deleteCompany.done": "Company \"{name}\" was deleted.",
  "dashboard.deleteCompany.failed": "Failed to delete company: {message}",
  "dashboard.deleteCompany.modalTooltip": "Remove this company from the Companies table (DynamoDB)",
  "dashboard.deleteCompany.rowTooltip": "Delete company from DynamoDB and remove from local dashboard",
  "dashboard.deleteCompany.virtualBlocked": "The Työmarkkinatori aggregate row is not a Companies table record. It cannot be deleted here.",
  "dashboard.detailPages": "Detail Pages",
  "dashboard.details": "Details",
  "dashboard.dlqEmpty": "DLQ is empty - no failed messages",
  "dashboard.dlqMessageCount": "{count} {count, plural, one {message} other {messages}} in DLQ",
  "dashboard.dlqViewer": "Dead Letter Queue Viewer",
  "dashboard.duration": "Duration",
  "dashboard.editCompany": "Edit",
  "dashboard.enqueueUrlPattern": "Enqueue URL Pattern",
  "dashboard.error": "Error",
  "dashboard.failed": "Failed",
  "dashboard.failedToLoadCompanySettings": "Failed to load company settings: {error}",
  "dashboard.filterByField": "Filter by Field",
  "dashboard.filterValue": "Filter value... (use __NOT_EMPTY__ for non-empty)",
  "dashboard.flatView.noCrawlRows": "No crawl rows to show in flat view. Load crawl export data first.",
  "dashboard.flatViews.colActions": "Actions",
  "dashboard.flatViews.colActionsTooltip": "Live listing on the site, HTML snapshot from S3 when available.",
  "dashboard.flatViews.colCompany": "Company",
  "dashboard.flatViews.colCompanyTooltip": "Company name stored on the crawl record.",
  "dashboard.flatViews.colDuration": "Duration",
  "dashboard.flatViews.colDurationTooltip": "Time spent fetching and processing this crawl request.",
  "dashboard.flatViews.colHttpTooltip": "HTTP response status for this request (e.g. 200 = OK).",
  "dashboard.flatViews.colMetrics": "Found / sent",
  "dashboard.flatViews.colMetricsTooltip": "List: jobs enqueued. Detail: sent to processor or not. Other page types: raw counts. Hover a cell for more detail.",
  "dashboard.flatViews.colOkTooltip": "Green: crawl succeeded. Red: failed or bad HTTP. If there are multiple runs for the same URL, hover the time column for per-run status.",
  "dashboard.flatViews.colPage": "Page",
  "dashboard.flatViews.colPageTooltip": "Page type (list vs detail) and badges: TMT, Skipped, Y-tunnus hints, etc.",
  "dashboard.flatViews.colPipelineLogsTooltip": "Links to CloudWatch log streams for crawler, processor, and related stages.",
  "dashboard.flatViews.colTime": "Time",
  "dashboard.flatViews.colTimeTooltip": "When this crawl run started. If the same URL was crawled more than once, the newest run is shown in this row.",
  "dashboard.flatViews.colTrace": "Pipeline logs",
  "dashboard.flatViews.colTraceFull": "Trace",
  "dashboard.flatViews.colTraceFullTooltip": "Open the full job pipeline trace (Raw/Final/Enriched, DynamoDB & CloudWatch).",
  "dashboard.flatViews.colUrlTooltip": "URL fetched by the crawler.",
  "dashboard.flatViews.colYtunnus": "Y-tunnus (TMT)",
  "dashboard.flatViews.colYtunnusTooltip": "Työmarkkinatori only: whether a Finnish business ID (Y-tunnus) was extracted from HTML and matched to your company database.",
  "dashboard.flatViews.crawlRunCount": "{n} crawls",
  "dashboard.flatViews.failure.algolia": "Algolia errors (metadata)",
  "dashboard.flatViews.failure.all": "All outcomes",
  "dashboard.flatViews.failure.cookie": "Cookie / overlay",
  "dashboard.flatViews.failure.nav": "Navigation / timeout",
  "dashboard.flatViews.failure.net": "Network",
  "dashboard.flatViews.failure.ok": "Crawl OK",
  "dashboard.flatViews.failure.other": "Other crawl failure",
  "dashboard.flatViews.failureFilterLabel": "Crawl outcome",
  "dashboard.flatViews.first": "First",
  "dashboard.flatViews.hint": "Sort, Source, Outliers, and Crawl outcome apply only to this flat table. Rows group repeat crawls of the same URL (newest first; crawl count on the time column). Outliers use job-detail rows only (Algolia errors in metadata, or crawl OK but jobsExtracted 0 and not skipped). Crawl outcome uses IndexedDB export fields (not live Dynamo). Use Trace for a row to load Raw/Final/Enriched + AWS console links. Row set also uses the same Filters (Työmarkkinatori, TMT Y-tunnus) as above.",
  "dashboard.flatViews.jobPages": "All job pages",
  "dashboard.flatViews.last": "Last",
  "dashboard.flatViews.listPages": "All list pages",
  "dashboard.flatViews.next": "Next",
  "dashboard.flatViews.pageJumpLabel": "Go to page",
  "dashboard.flatViews.pageOf": "Page {p} of {t} ({n} rows)",
  "dashboard.flatViews.prev": "Prev",
  "dashboard.flatViews.sort.companyAsc": "Company · A–Z",
  "dashboard.flatViews.sort.companyDesc": "Company · Z–A",
  "dashboard.flatViews.sort.failedFirst": "OK · failures first",
  "dashboard.flatViews.sort.jobsFoundAsc": "Jobs found · low → high",
  "dashboard.flatViews.sort.jobsFoundDesc": "Jobs found · high → low",
  "dashboard.flatViews.sort.successFirst": "OK · successes first",
  "dashboard.flatViews.sort.timeAsc": "Time · oldest first",
  "dashboard.flatViews.sort.timeDesc": "Time · newest first",
  "dashboard.flatViews.sort.urlAsc": "URL · A–Z",
  "dashboard.flatViews.sort.urlDesc": "URL · Z–A",
  "dashboard.flatViews.sortLabel": "Sort",
  "dashboard.flatViews.source.all": "All crawls",
  "dashboard.flatViews.source.nonTmt": "Exclude Työmarkkinatori",
  "dashboard.flatViews.source.tmtOnly": "Työmarkkinatori only",
  "dashboard.flatViews.sourceLabel": "Source",
  "dashboard.flatViews.title": "Flat crawl views",
  "dashboard.flatViews.yt.legacy": "Older row: no Y-tunnus metadata (re-crawl to classify)",
  "dashboard.flatViews.yt.na": "Not a Työmarkkinatori detail row",
  "dashboard.flatViews.yt.nocompany": "Y-tunnus extracted but not found in CompaniesTable",
  "dashboard.flatViews.yt.none": "No Y-tunnus extracted from page HTML",
  "dashboard.flatViews.yt.ok": "Y-tunnus extracted and company matched",
  "dashboard.greenSuccess": "Green (Success)",
  "dashboard.groupBy": "Group By",
  "dashboard.groupCrawlCount": "Crawl Count",
  "dashboard.groupJobsCount": "Jobs Count",
  "dashboard.groupLogoFailed": "Logo Status",
  "dashboard.groupMetrics": "Metrics",
  "dashboard.groupNone": "None",
  "dashboard.groupPaginationIssue": "Pagination Issues",
  "dashboard.groupStatus": "Status (Red/Yellow/Green)",
  "dashboard.groupStatusIssues": "Status & Issues",
  "dashboard.groupSuccessRate": "Success Rate",
  "dashboard.hasAnyFailedCrawl": "Any failed crawl (in window)",
  "dashboard.hasComments": "Has Comments",
  "dashboard.hasCrawlData.label": "Crawl Data",
  "dashboard.hasCrawlData.option": "Has Data",
  "dashboard.heroImage": "Hero Image",
  "dashboard.howToRunCrawl": "How to Run a Crawl",
  "dashboard.htmlModal.liveExtractedHint": "Same object ID as search index. Long text fields are truncated for display.",
  "dashboard.htmlModal.liveExtractedTitle": "Live extracted job (DynamoDB)",
  "dashboard.htmlModal.loadingLive": "Loading FinalJobs / Enriched…",
  "dashboard.htmlModal.noJobUrl": "This crawl row has no URL — cannot resolve live job records.",
  "dashboard.httpStatusCellTooltip": "HTTP response status for this request (e.g. 200 = OK, 404 = not found).",
  "dashboard.industry": "Industry",
  "dashboard.isChecked": "Checked",
  "dashboard.isSaved": "Saved",
  "dashboard.issuesOnly": "Issues Only",
  "dashboard.itemsPerPage": "Items per page",
  "dashboard.jobLookup.activeHint": "Showing detail crawls for job ID: {id}",
  "dashboard.jobLookup.clear": "Clear export filter",
  "dashboard.jobLookup.find": "Find in export",
  "dashboard.jobLookup.noMatchInExport": "No detail crawl in the loaded window has this job ID. Reload crawl data or widen the export window.",
  "dashboard.jobLookup.parseError": "Could not find a job ID. Paste a full JobCrawls job page URL (…/en/job/…/company/…) or the object ID from the address bar.",
  "dashboard.jobLookup.placeholder": "Paste job page URL or object ID…",
  "dashboard.jobLookup.resolvingIds": "Matching job IDs to crawls…",
  "dashboard.jobSearch.matchExportLabel": "Match in loaded crawl export",
  "dashboard.jobSearch.sectionHint": "Find rows in the loaded export, or trace pipeline state from a job URL.",
  "dashboard.jobSearch.sectionTitle": "Job search",
  "dashboard.jobTrace.blurb": "Paste the exact job listing URL as stored in RawJobs. The dashboard loads RawJobs, FinalJobs, and EnrichedFinalJobs, infers how far the job got, and links to DynamoDB tables and CloudWatch log filters.",
  "dashboard.jobTrace.close": "Close",
  "dashboard.jobTrace.dynamo": "DynamoDB (console)",
  "dashboard.jobTrace.failureCode": "Code: {code}",
  "dashboard.jobTrace.load": "Get all information",
  "dashboard.jobTrace.loading": "Loading trace…",
  "dashboard.jobTrace.logs": "CloudWatch (filter)",
  "dashboard.jobTrace.modalTitle": "Pipeline trace",
  "dashboard.jobTrace.noAwsLinks": "Console links unavailable (pipeline log env incomplete).",
  "dashboard.jobTrace.noLogContext": "Pipeline log env vars missing on API — Dynamo links still work; set PIPELINE_LOG_GROUP_* on Dashboard Lambda for CloudWatch deep links in the API response.",
  "dashboard.jobTrace.rawJson": "Item summaries (JSON)",
  "dashboard.jobTrace.title": "Pipeline trace (Dynamo & CloudWatch)",
  "dashboard.jobTrace.urlLabel": "Job URL",
  "dashboard.jobTrace.visual": "Pipeline progress",
  "dashboard.jobsEnqueued": "{count} jobs enqueued",
  "dashboard.jobsEnqueuedCellTooltip": "List crawl: job URLs discovered on this page and enqueued for detail crawls. “List pages” counts extra listing URLs (e.g. pagination) also enqueued.",
  "dashboard.jobsExtracted": "Jobs Extracted",
  "dashboard.jobsFound": "Jobs Found",
  "dashboard.layout.company": "By company",
  "dashboard.layout.flat": "Flat crawls",
  "dashboard.layout.label": "Layout",
  "dashboard.listPages": "List Pages",
  "dashboard.listPagesEnqueued": "{count} list pages",
  "dashboard.liveJobLink": "Live job",
  "dashboard.loadAllCompanies": "Load all companies (86k)",
  "dashboard.loadCompaniesButton": "Load Companies",
  "dashboard.loadedCompanies": "Loaded: {current} of {total} companies",
  "dashboard.loadedCompaniesUnknown": "Loaded: {current} companies",
  "dashboard.loadingAllCompanies": "Loading all companies — slower initial load",
  "dashboard.loadingBatch": "Processing batch {current} of approximately {total}",
  "dashboard.loadingCompanies": "Loading Company Data",
  "dashboard.loadingCompaniesWithUrls": "Loading only companies with website URLs — faster",
  "dashboard.loadingNote": "This may take a few minutes. Please keep this page open.",
  "dashboard.logoFailed": "Logo Failed",
  "dashboard.logoFailedBadgeTitle": "Logo failed to load in the dashboard — use Logo Lambda logs below for ProcessCompanyLogos output",
  "dashboard.logoOk": "Logo OK",
  "dashboard.logoProcessingFailedBadgeTitle": "ProcessCompanyLogos failed on {failedAt}: {error}",
  "dashboard.logoProcessingFailedUnknownDate": "an unknown date",
  "dashboard.logoUrlFailedLabel": "Failed",
  "dashboard.map": "Map",
  "dashboard.menu.overview": "Overview",
  "dashboard.menu.overview.metricsHelpDesc": "Hover the (i) icon for what each count means.",
  "dashboard.menu.overview.metricsHelpTitle": "Metric definitions",
  "dashboard.menu.overview.noExport": "Load crawl export data (Tools) to see summary counts.",
  "dashboard.menu.overview.pipelineDesc": "Maintainer snapshot vs crawl window.",
  "dashboard.menu.overview.summaryDesc": "Counts from the crawl JSON loaded in this browser.",
  "dashboard.menu.overview.summaryTitle": "Export summary",
  "dashboard.menu.refine": "Refine",
  "dashboard.metricsFoundExtractedTooltip": "Jobs found vs jobs extracted for this page type (not a standard list/detail row).",
  "dashboard.mostRecent": "Most Recent",
  "dashboard.next": "Next",
  "dashboard.noCrawlData.message": "No crawl data available yet. Expand the \"How to Run a Crawl\" section above for instructions on running a crawl and exporting the data.",
  "dashboard.noCrawlData.option": "No Data",
  "dashboard.noCrawlData.withServerDetail": "No crawl export available: {detail}. If you are on localhost, ensure AWS credentials can read the crawl-data bucket and that Maintainer has written crawl-exports/latest.json.",
  "dashboard.noFieldFilter": "No Field Filter",
  "dashboard.noIssues": "No Issues",
  "dashboard.noLogoUrl": "No logo URL",
  "dashboard.notSent": "Not sent",
  "dashboard.notSentTooltip": "No job payload was extracted (jobsExtracted is 0). Not the same as “Skipped”: Skipped means the crawler intentionally did not re-run because the job already existed in RawJobs.",
  "dashboard.pageInfo": "Page {current} of {total}",
  "dashboard.pageType": "Page Type",
  "dashboard.pageType.detailTooltip": "Detail page: a single job posting URL. The crawler extracts structured data and may send it to the processor.",
  "dashboard.pageType.genericTooltip": "Crawler page type: {pageType}.",
  "dashboard.pageType.listTooltip": "List page: discovers job links on a listing or search page and enqueues them for detail crawls.",
  "dashboard.pagination.allRows": "All",
  "dashboard.pagination.first": "First",
  "dashboard.pagination.last": "Last",
  "dashboard.pagination.navGroup": "Page navigation",
  "dashboard.pagination.pageJumpAria": "Page number, 1 to {total}",
  "dashboard.pagination.pageJumpLabel": "Go to page",
  "dashboard.paginationIssueDescription": "Exactly {count} jobs sent - may indicate incomplete pagination.",
  "dashboard.pipelineHealth.active": "Active",
  "dashboard.pipelineHealth.activeFinland": "Active + Finland",
  "dashboard.pipelineHealth.activeNotFinland": "Active, not Finland",
  "dashboard.pipelineHealth.crawlCompare.body": "Jobs extracted on Työmarkkinatori crawl rows (sum of jobsExtracted): {count}. Compare to “Active Työmarkk. (URL)” above — large gaps often mean stale lastSeen (inactive), processor queue backlog, or URL/companyId mismatches.",
  "dashboard.pipelineHealth.crawlCompare.title": "Crawl export (this window)",
  "dashboard.pipelineHealth.generatedAt": "Snapshot from Maintainer scan: {when}",
  "dashboard.pipelineHealth.inactive": "Inactive",
  "dashboard.pipelineHealth.missingStats": "No snapshot yet. After the next successful Maintainer run (with CRAWL_DATA_BUCKET set), counts appear here. Refresh crawl data after Maintainer.",
  "dashboard.pipelineHealth.title": "Pipeline health (FinalJobs)",
  "dashboard.pipelineHealth.totalRows": "FinalJobs rows",
  "dashboard.pipelineHealth.tyoFlag": "Active Työmarkk. (flag)",
  "dashboard.pipelineHealth.tyoUrl": "Active Työmarkk. (URL)",
  "dashboard.pipelineHealth.tyoUrlBadFinland": "Työmarkk. URL + not Finland",
  "dashboard.pipelineLogs.algolia": "Algolia",
  "dashboard.pipelineLogs.allGroups": "Lambda log groups",
  "dashboard.pipelineLogs.aria": "CloudWatch log links along the crawl → processor → enrich → Algolia → maintainer path",
  "dashboard.pipelineLogs.crawlSearch": "Crawl (crawlId)",
  "dashboard.pipelineLogs.crawlStream": "Crawl stream",
  "dashboard.pipelineLogs.enrich": "Enrich",
  "dashboard.pipelineLogs.maintainer": "Maintainer",
  "dashboard.pipelineLogs.noObjectId": "ObjectID links on detail rows only",
  "dashboard.pipelineLogs.processor": "Processor",
  "dashboard.pipelineLogs.processorUrl": "Processor (URL)",
  "dashboard.pipelineLogs.region": "{r}",
  "dashboard.pipelineLogs.unconfigured": "Set PIPELINE_LOG_GROUP_* on Dashboard / API Lambda for log links",
  "dashboard.potentialPaginationIssue": "Potential Pagination Issue",
  "dashboard.previous": "Previous",
  "dashboard.processCompanyLogoLogs.link": "Logo Lambda logs",
  "dashboard.processCompanyLogoLogs.tooltip": "Open CloudWatch log group for ProcessCompanyLogos (filtered to this company id in log text)",
  "dashboard.processDlq": "Process DLQ",
  "dashboard.quickFilterUncrawled": "Uncrawled · top score",
  "dashboard.quickFilterUncrawled.tooltip": "Show companies where doCrawl is not TRUE, sorted by score descending — useful for manually processing the most important uncrawled companies",
  "dashboard.recordCount": "{count} {count, plural, one {record} other {records}}",
  "dashboard.recrawl": "Recrawl",
  "dashboard.recrawlDetailTriggered": "Detail recrawl queued for {companyName}",
  "dashboard.recrawlTriggered": "Recrawl triggered for {companyName}",
  "dashboard.recrawling": "Recrawling…",
  "dashboard.redLastCrawlFailed": "Red — last crawl failed",
  "dashboard.refine.quickOptionsTitle": "Quick options",
  "dashboard.refine.section.companyList": "Company list",
  "dashboard.refine.section.companyListDesc": "Narrow which companies appear in the list.",
  "dashboard.refine.section.fieldFilterDesc": "Match a single company field (and optional value).",
  "dashboard.refine.section.pipelineIndex": "Pipeline & index",
  "dashboard.refine.section.pipelineIndexDesc": "Detail-crawl signals from the loaded export.",
  "dashboard.refine.section.tyomarkkinatori": "Työmarkkinatori",
  "dashboard.refine.section.tyomarkkinatoriDesc": "Filter Työmarkkinatori-tagged rows and Y-tunnus metadata.",
  "dashboard.refreshCompanies": "Refresh Companies",
  "dashboard.refreshCrawlData": "Refresh Crawl Data",
  "dashboard.refreshCrawlData.title": "Refresh crawl data from S3",
  "dashboard.refreshing": "Refreshing...",
  "dashboard.registryInformation": "Registry Information",
  "dashboard.result": "Result",
  "dashboard.runMaintainer": "Run Maintainer",
  "dashboard.running": "Running...",
  "dashboard.save": "Save for later",
  "dashboard.saveError": "Error",
  "dashboard.saved": "Saved",
  "dashboard.saving": "Saving…",
  "dashboard.scanningDatabase": "Scanning database and loading companies...",
  "dashboard.searchCompanies": "Search companies...",
  "dashboard.sentForProcessing": "✓ Sent for processing",
  "dashboard.sentForProcessingTooltip": "Structured job data was extracted (jobsExtracted ≥ 1) and sent to the processing pipeline (SQS / processor).",
  "dashboard.sentToProcessor": "Sent to Processor",
  "dashboard.showing": "Showing {filtered} of {total} companies",
  "dashboard.skipped": "Skipped",
  "dashboard.skippedCrawlTooltip": "Skipped: the crawler did not re-fetch this URL because the job was already stored in RawJobs (duplicate prevention). A crawl row is still recorded for visibility.",
  "dashboard.socialMedia": "Social Media",
  "dashboard.sortAndGroup.sectionHint": "Change list order and optional grouping.",
  "dashboard.sortAndGroup.sectionTitle": "Sort & group",
  "dashboard.sortAscending": "Ascending",
  "dashboard.sortBasic": "Basic",
  "dashboard.sortBy": "Sort By",
  "dashboard.sortCrawls": "Crawls",
  "dashboard.sortDescending": "Descending",
  "dashboard.sortDetailPages": "Detail Pages",
  "dashboard.sortDirection": "Sort {direction}",
  "dashboard.sortFailed": "Failed Crawls",
  "dashboard.sortJobs": "Jobs",
  "dashboard.sortJobsExtracted": "Total Jobs Extracted",
  "dashboard.sortJobsFound": "Total Jobs Found",
  "dashboard.sortJobsSent": "Jobs Sent to Processor",
  "dashboard.sortLastCrawl": "Last Crawl Date",
  "dashboard.sortListPages": "List Pages",
  "dashboard.sortMostRecentJobs": "Most Recent Jobs Found",
  "dashboard.sortName": "Company Name",
  "dashboard.sortPages": "Pages",
  "dashboard.sortStatus": "Status",
  "dashboard.sortSuccessRate": "Success Rate",
  "dashboard.sortSuccessful": "Successful Crawls",
  "dashboard.status": "Status",
  "dashboard.successRate": "Success Rate",
  "dashboard.successful": "Successful",
  "dashboard.summary.extractedLabel": "Jobs extracted",
  "dashboard.summary.failedLabel": "Failed",
  "dashboard.summary.foundLabel": "Jobs found",
  "dashboard.summary.successLabel": "Successful",
  "dashboard.summary.totalCrawls": "Total crawls",
  "dashboard.summary.uniqueUrls": "Unique URLs",
  "dashboard.syncingCompanySettings": "Syncing company settings...",
  "dashboard.time": "Time",
  "dashboard.title": "Crawl Dashboard",
  "dashboard.tmtBadge.noYtunnus": "Työmarkkinatori detail: no Y-tunnus extracted from HTML",
  "dashboard.tmtBadge.noYtunnusShort": "No Y-tunnus",
  "dashboard.tmtBadge.yTunnusNoCompany": "Y-tunnus extracted but no matching company in CompaniesTable",
  "dashboard.tmtBadge.yTunnusNoCompanyShort": "Y-tunnus / no co.",
  "dashboard.tmtBadge.yTunnusUnknown": "Older crawl row: Y-tunnus metadata not recorded yet (re-crawl to classify)",
  "dashboard.tmtSourceTooltip": "This job was crawled from Työmarkkinatori (TE Services / Finnish public employment listings).",
  "dashboard.tmtYtunnusFilter.all": "Any",
  "dashboard.tmtYtunnusFilter.label": "TMT Y-tunnus",
  "dashboard.tmtYtunnusFilter.noCompany": "Y-tunnus not in Companies",
  "dashboard.tmtYtunnusFilter.noExtract": "No Y-tunnus extracted",
  "dashboard.toolsModal.actionsHeading": "Actions",
  "dashboard.toolsModal.closeBackdrop": "Close",
  "dashboard.toolsModal.closeButton": "Close",
  "dashboard.toolsModal.openButton": "Tools & config",
  "dashboard.toolsModal.openButtonSr": "Open maintainer, refresh, DLQ, and crawl instructions",
  "dashboard.toolsModal.title": "Tools & config",
  "dashboard.totalCrawls": "Total Crawls",
  "dashboard.tyomarkkinatoriCrawlFilter.all": "All crawl rows",
  "dashboard.tyomarkkinatoriCrawlFilter.label": "Työmarkkinatori",
  "dashboard.tyomarkkinatoriCrawlFilter.nonTmt": "Non-TMT rows only",
  "dashboard.tyomarkkinatoriCrawlFilter.tmtOnly": "TMT rows only",
  "dashboard.uncheck": "Uncheck",
  "dashboard.unsave": "Remove from saved",
  "dashboard.url": "URL",
  "dashboard.viewAttributes": "View Attributes",
  "dashboard.viewJobs": "View",
  "dashboard.viewMessageBody": "View Message Body",
  "dashboard.viewOnGoogleMaps": "View on Google Maps",
  "dashboard.yellowNoJobs": "Yellow (No Jobs)",
  "employerPortal.nav": "Employer portal",
  "employerScoreCard.dimension.benefits": "benefits",
  "employerScoreCard.dimension.flexibility": "flexibility",
  "employerScoreCard.dimension.growth": "growth",
  "employerScoreCard.dimension.pay": "pay",
  "employerScoreCard.dimension.stability": "stability",
  "employerScoreCard.dimension.transparency": "transparency",
  "employerScoreCard.disclaimer": "Computed from job data signals, not reviews",
  "employerScoreCard.howWeCalculate": "How we calculate this",
  "employerScoreCard.methodology": "This grade is based on salary competitiveness from posted bands (where we have enough listings), remote and hybrid flexibility, hiring stability over time, growth signals from role mix and hiring volume trends, benefits and perks mentioned in postings, and transparency (how often postings disclose a real, non-estimated salary and a recruitment-process timeline).",
  "employerScoreCard.strongestAt": "Strongest at {dimension}",
  "employerScoreCard.subscore.benefits": "Benefits",
  "employerScoreCard.subscore.flexibility": "Flexibility",
  "employerScoreCard.subscore.growth": "Growth",
  "employerScoreCard.subscore.pay": "Pay",
  "employerScoreCard.subscore.stability": "Stability",
  "employerScoreCard.subscore.transparency": "Transparency",
  "employerScoreCard.title": "JobCrawls Employer Score",
  "engagement.nav.signIn": "Sign in",
  "engagement.trustpilotPrompt.leaveReview": "Leave a review",
  "engagement.trustpilotPrompt.offer": "You've been getting good use out of My Jobs. Mind leaving us a quick review?",
  "facets.benefits": "Benefit",
  "facets.company": "Company",
  "facets.companyIndustry": "Industry",
  "facets.education": "Education",
  "facets.field": "Field",
  "facets.jobType": "Job type",
  "facets.language": "Language",
  "facets.location": "Location",
  "facets.management": "Leadership",
  "facets.remoteness": "Work setup",
  "facets.role": "Role",
  "facets.roleLevel": "Role level",
  "facets.skills": "Skill",
  "feedback.button.label": "Give us feedback",
  "feedback.cancel": "Cancel",
  "feedback.error": "Failed to submit feedback. Please try again.",
  "feedback.label": "Your Feedback",
  "feedback.modal.close": "Close",
  "feedback.modal.description": "We'd love to hear your thoughts. Share your feedback to help us improve.",
  "feedback.modal.title": "Send Feedback",
  "feedback.page.anonymous": "Anonymous",
  "feedback.page.attachmentDownloadError": "Failed to download attachment. Please try again.",
  "feedback.page.attachmentDownloadTitle": "Download attachment",
  "feedback.page.cannedReply.gdpr": "Thanks for reaching out. We've received your privacy request and will process it within 30 days, as required under GDPR. We'll follow up here once it's complete.",
  "feedback.page.category.abuse": "Abuse",
  "feedback.page.category.accessibility": "Accessibility",
  "feedback.page.category.all": "All categories",
  "feedback.page.category.ashton": "Ashton (personal)",
  "feedback.page.category.corrections": "Corrections",
  "feedback.page.category.crawler": "Crawler",
  "feedback.page.category.developers": "Developers",
  "feedback.page.category.dmarcReport": "DMARC report",
  "feedback.page.category.employers": "Employers",
  "feedback.page.category.jobAlerts": "Job alerts",
  "feedback.page.category.john": "John (personal)",
  "feedback.page.category.maria": "Maria (personal)",
  "feedback.page.category.other": "Other",
  "feedback.page.category.partners": "Partners",
  "feedback.page.category.postmaster": "Postmaster",
  "feedback.page.category.privacy": "Privacy",
  "feedback.page.category.security": "Security",
  "feedback.page.category.support": "Support",
  "feedback.page.channel.all": "All",
  "feedback.page.channel.email": "Email",
  "feedback.page.channel.form": "Form",
  "feedback.page.delete": "Delete feedback",
  "feedback.page.deleteConfirm": "Are you sure you want to delete this feedback?",
  "feedback.page.deleteError": "Failed to delete feedback. Please try again.",
  "feedback.page.description": "View and manage user feedback",
  "feedback.page.emailReporterTooltip": "Opens your email client with a draft reply to this reporter",
  "feedback.page.followUpEmailGreeting": "Hi{name},",
  "feedback.page.followUpEmailSubject": "Following up on your JobCrawls report",
  "feedback.page.followUpEmailThanksLine": "Thanks for reporting this to JobCrawls:",
  "feedback.page.followUpEmailWhatWeDidLine": "Here is what we did about it:",
  "feedback.page.identifyReporter": "Identify reporter",
  "feedback.page.listTitle": "All Feedback",
  "feedback.page.noFeedback": "No feedback yet",
  "feedback.page.refresh": "Refresh",
  "feedback.page.replyError": "Failed to send reply. Please try again.",
  "feedback.page.replyPlaceholder": "Write a reply…",
  "feedback.page.sendReply": "Send reply",
  "feedback.page.signOffNameLabel": "Sign replies as",
  "feedback.page.signOffNamePlaceholder": "Your name",
  "feedback.page.signOffTitlePlaceholder": "Title",
  "feedback.page.signingAs": "Signing as",
  "feedback.page.submitTitle": "Submit Feedback",
  "feedback.page.threadStatus.closed": "Closed",
  "feedback.page.threadStatus.open": "Open",
  "feedback.page.threadStatus.replied": "Replied",
  "feedback.page.title": "Feedback",
  "feedback.page.useGdprTemplate": "Use GDPR reply template",
  "feedback.page.viewMetadata": "View metadata",
  "feedback.page.viewReportedCompany": "View company",
  "feedback.page.viewReportedJob": "View reported job",
  "feedback.page.viewReportedPage": "View reported page",
  "feedback.placeholder": "Tell us what we should change or add...",
  "feedback.postSubmit.signInBody": "Create a free account so we can reply if we have questions about your feedback.",
  "feedback.postSubmit.signInButton": "Sign in or create account",
  "feedback.postSubmit.signInTitle": "Want us to follow up?",
  "feedback.submit": "Submit",
  "feedback.submitting": "Submitting...",
  "feedback.success": "Thank you! Your feedback has been submitted.",
  "filters.allFilters.navigation": "All filter options",
  "filters.connector.and": "AND",
  "filters.connector.or": "OR",
  "filters.top.ariaLabel": "Filter categories",
  "filters.top.clearAll": "Clear all filters",
  "footer.aboutJobcrawls": "About JobCrawls",
  "footer.accessibilityStatementLink": "Accessibility statement",
  "footer.aiTranslationDisclaimer": "Note: Some content on this website contains machine-translations using AI and may contain errors.",
  "footer.allLocations": "All locations",
  "footer.bestEmployers": "Employers",
  "footer.brandDescription": "JobCrawls is a job search engine for Finland. We index openings directly from thousands of employer career pages daily, in English, Finnish, and Swedish, with transparent salary data and no sponsored rankings.",
  "footer.browseAllPages": "Browse all pages",
  "footer.businessIdLabel": "Business ID",
  "footer.colCompany": "Company",
  "footer.colEmployersAndDevelopers": "Employers & developers",
  "footer.colFindJobs": "Find jobs",
  "footer.colJobSeekers": "Job seekers",
  "footer.collectiveAgreementsLink": "Collective agreements",
  "footer.connectorPrivacy": "Connector privacy",
  "footer.contact": "Contact",
  "footer.cookieSettings": "Cookie settings",
  "footer.copyright": "© 2026 {company}",
  "footer.editorialStandards": "Editorial standards",
  "footer.featuresLink": "Features",
  "footer.forDevelopers": "For Developers",
  "footer.forEmployersLink": "For employers",
  "footer.freeCareersPageLink": "Free careers page",
  "footer.guidesAndArticles": "Guides & articles",
  "footer.howCrawlerWorks": "How our crawler works",
  "footer.jobsInEspoo": "Jobs in Espoo",
  "footer.jobsInHelsinki": "Jobs in Helsinki",
  "footer.jobsInOulu": "Jobs in Oulu",
  "footer.jobsInTampere": "Jobs in Tampere",
  "footer.jobsInTurku": "Jobs in Turku",
  "footer.openJobsInFinland": "Open jobs in Finland",
  "footer.partnerships": "Media partnerships",
  "footer.privacy": "Privacy Policy",
  "footer.remoteJobs": "Remote jobs",
  "footer.rolesIndex": "Jobs by role",
  "footer.salariesByRole": "Salaries by role",
  "footer.signIn": "Sign in",
  "footer.sitemap": "Site Map",
  "footer.terms": "Terms of Service",
  "forEmployers.contact.desc": "Tell us what you're interested in and a bit about your team. We read every message ourselves — no sales queue.",
  "forEmployers.contact.error": "Something went wrong. Please try again.",
  "forEmployers.contact.interest.branding": "Employer Branding Support",
  "forEmployers.contact.interest.careers": "Free Careers Page",
  "forEmployers.contact.interest.other": "Something else",
  "forEmployers.contact.interest.promoted": "Promoted Roles",
  "forEmployers.contact.interestLabel": "What are you interested in?",
  "forEmployers.contact.learnMore": "Learn More About Us",
  "forEmployers.contact.placeholder": "Tell us about your hiring needs…",
  "forEmployers.contact.submit": "Send Inquiry",
  "forEmployers.contact.submitting": "Submitting…",
  "forEmployers.contact.success": "Thanks! We'll get back to you soon.",
  "forEmployers.contact.title": "Express interest",
  "forEmployers.cta.expressInterest": "Express Interest",
  "forEmployers.cta.seeScore": "See How the Employer Score Works",
  "forEmployers.hero.body": "We crawl your careers page directly, so job seekers find your real listings next to real salary data — no posting, no dashboard, no fee to be listed. Now we're opening up two new ways to stand out: Promoted Roles and hands-on employer branding support.",
  "forEmployers.hero.point.automatic": "Automatic, no-signup visibility",
  "forEmployers.hero.point.real": "Real crawl data, not paid placement",
  "forEmployers.hero.point.score": "Transparent, published Employer Score",
  "forEmployers.hero.point.trilingual": "Trilingual reach — EN, FI, SV",
  "forEmployers.new.branding.cta": "Talk to us about branding",
  "forEmployers.new.branding.desc": "We work directly with your team to sharpen how your company profile reads — culture, values, and role clarity — so it matches what your Employer Score already says about you.",
  "forEmployers.new.branding.title": "Employer Branding Support",
  "forEmployers.new.careers.cta": "Get a free careers page",
  "forEmployers.new.careers.desc": "No careers page? We host a branded one for you, free — you paste your job ad links, we handle the rest. Your site's open-positions button finally has somewhere real to point.",
  "forEmployers.new.careers.learnMore": "Learn more",
  "forEmployers.new.careers.pilotNote": "We're opening this up to a small group of employers first.",
  "forEmployers.new.careers.title": "Free Hosted Careers Page",
  "forEmployers.new.promoted.cta": "Express interest in Promoted Roles",
  "forEmployers.new.promoted.desc": "Priority placement for your open roles in relevant searches and category pages, with a badge that draws attention where seekers are already looking.",
  "forEmployers.new.promoted.title": "Promoted Roles",
  "forEmployers.new.subtitle": "We're opening these up to a small group of employers first.",
  "forEmployers.new.title": "New: ways to stand out",
  "forEmployers.score.cta": "Read the full methodology",
  "forEmployers.score.ctaBestCompanies": "See the Companies rankings",
  "forEmployers.score.desc": "One letter grade, six pillars, fully published. Companies that score well get surfaced in our Companies rankings, no submission required.",
  "forEmployers.score.pillar.benefits": "Benefits & perks",
  "forEmployers.score.pillar.flex": "Flexibility",
  "forEmployers.score.pillar.growth": "Growth signals",
  "forEmployers.score.pillar.pay": "Pay",
  "forEmployers.score.pillar.stability": "Hiring stability",
  "forEmployers.score.pillar.transparency": "Transparency",
  "forEmployers.score.title": "The Employer Score",
  "forEmployers.subtitle": "Your open roles already show up here — automatically, in English, Finnish, and Swedish.",
  "forEmployers.title": "For Employers",
  "forEmployers.today.step1.desc": "Like a search engine, we index the job listings already live on your own site — no submission or integration needed.",
  "forEmployers.today.step1.title": "We crawl your careers page",
  "forEmployers.today.step2.desc": "Through search, salary comparisons, and our Companies rankings, all trilingual, all SEO-optimized.",
  "forEmployers.today.step2.title": "Job seekers find you",
  "forEmployers.today.step3.desc": "On pay transparency, flexibility, hiring stability, and growth signals — the same published methodology for every company.",
  "forEmployers.today.step3.title": "You get scored, transparently",
  "forEmployers.today.title": "How you already show up",
  "forEmployers.values.desc": "We only want to be worth your applicants' time. That means surfacing employers who pay fairly, communicate clearly, and treat candidates well — and building anything new, like Promoted Roles or employer branding support, on top of that standard, not around it.",
  "forEmployers.values.title": "Our values",
  "freeCareersPage.breadcrumb": "Free careers page",
  "freeCareersPage.cta": "Get your free careers page",
  "freeCareersPage.cta.hint": "Tell us your company name and we'll take it from there.",
  "freeCareersPage.cta.pilotNote": "We're opening these up to a small group of employers first, so we read and set up every request ourselves.",
  "freeCareersPage.features.apply": "Candidates apply through your original LinkedIn ad — no new inbox to watch",
  "freeCareersPage.features.branded": "Your branding — logo, colors, and your own intro text",
  "freeCareersPage.features.fresh": "Listings expire automatically when the ad closes",
  "freeCareersPage.features.languages": "Three languages: English, Finnish, and Swedish",
  "freeCareersPage.features.search": "Your roles also appear in JobCrawls search, reaching candidates across Finland",
  "freeCareersPage.features.title": "What's included",
  "freeCareersPage.features.zero": "Zero maintenance: no plugins, no CMS, no hosting bills",
  "freeCareersPage.hero.subtitle": "Hiring through LinkedIn but have nowhere on your own site to show it? We host a branded careers page for you — your logo, your colors, your open roles — completely free, with nothing to install or maintain.",
  "freeCareersPage.hero.title": "A free careers page for your company",
  "freeCareersPage.how.step1.desc": "One email to get started. We create your branded page — logo, brand color, and an intro you can edit — in English, Finnish, and Swedish.",
  "freeCareersPage.how.step1.title": "We set up your page",
  "freeCareersPage.how.step2.desc": "Post on LinkedIn like you already do, then paste the ad's link into your portal. We pull in the details, translate them, and keep the listing fresh — it disappears automatically when the ad closes.",
  "freeCareersPage.how.step2.title": "Paste your job links",
  "freeCareersPage.how.step3.desc": "Change your website's “Open positions” button to link to your new careers page. That one link is all we ask for — it's how the free page pays for itself.",
  "freeCareersPage.how.step3.title": "Point your site at it",
  "freeCareersPage.how.title": "How it works",
  "freeCareersPage.portalLink": "Already set up? Open your employer portal",
  "freeCareersPage.whyFree.desc": "JobCrawls is a job search engine for Finland. When your careers page lives with us, your openings become part of our index — jobs that would otherwise only exist on LinkedIn — and the link from your website tells search engines (and us) the page is really yours. That's the whole trade: no fees, no lock-in, and you can leave whenever you like.",
  "freeCareersPage.whyFree.title": "Why is it free?",
  "hit.applicationDeadline": "Deadline: {date}",
  "hit.companyInsights.cue": "Company insights",
  "hit.companyLinkTitle": "Open company profile: data and insights for {company}",
  "hit.companyProfile.aria": "View company profile, hiring data, and insights for {company}",
  "hit.driversLicenseRequired": "Driver's Licence Required",
  "hit.hidden": "Hidden",
  "hit.hide.button": "Hide",
  "hit.hide.menu": "Hide",
  "hit.jobTitle": "Job",
  "hit.jobTypeLinkAria": "Search for {jobType} jobs",
  "hit.jobTypeLinkTitle": "Search for {jobType} jobs",
  "hit.linkCopied": "Link copied to clipboard!",
  "hit.locationLinkAria": "Search for jobs in {location}",
  "hit.locationLinkTitle": "Search for jobs in {location}",
  "hit.locationNotAvailable": "Location not available",
  "hit.markAsApplied.menu": "Mark as Applied",
  "hit.markAsState": "Mark as {state}",
  "hit.moreLocations": "+{count} more",
  "hit.moreOptions": "More options",
  "hit.openApplication": "Open Application",
  "hit.postedDate": "Posted: {date}",
  "hit.postedDate.detail": "Posted: {date}",
  "hit.remotenessLinkAria": "Search for {remoteness} jobs",
  "hit.remotenessLinkTitle": "Search for {remoteness} jobs",
  "hit.removeApplied": "Remove from applied",
  "hit.roleLevelLinkAria": "Search for {roleLevel} jobs",
  "hit.roleLevelLinkLabel": "{roleLevel} jobs",
  "hit.roleLevelLinkTitle": "Search for {roleLevel} jobs",
  "hit.salaryNotSpecified": "Salary not specified",
  "hit.salaryNotSpecified.card": "Salary not specified",
  "hit.save": "Save",
  "hit.save.detail": "Save",
  "hit.saved": "Saved",
  "hit.saved.detail": "Saved",
  "hit.seeAd": "Details",
  "hit.share": "Share",
  "hit.share.detail": "Share",
  "hit.shareError": "Something went wrong while trying to share this job.",
  "hit.shareError.retry": "Retry",
  "hit.summerJob": "Summer Job",
  "hit.toast.applied": "Marked as applied",
  "hit.toast.hidden": "Job hidden",
  "hit.toast.hidden.undo": "Undo",
  "hit.toast.savedWithCount": "Saved: {count, plural, one {# job} other {# jobs}} in My Jobs",
  "hit.toast.unapplied": "Removed from applied",
  "hit.toast.unhidden": "Job unhidden",
  "hit.toast.unsaved": "Job removed from saved",
  "hit.toast.viewMyJobs": "View →",
  "hit.toast.viewed": "Marked as viewed",
  "hit.tooltip.details": "View full job details and description",
  "hit.tooltip.filterByCompany": "Filter jobs by this company",
  "hit.tooltip.filterByJobType": "Filter jobs by type: {jobType}",
  "hit.tooltip.filterByLanguages": "Filter jobs by required languages: {languages}",
  "hit.tooltip.filterByLevel": "Filter jobs by level: {level}",
  "hit.tooltip.filterByLocation": "Filter jobs in: {locations}",
  "hit.tooltip.filterByRemoteness": "Filter jobs by remoteness: {remoteness}",
  "hit.tooltip.moreOptions": "More options",
  "hit.tooltip.save": "Save this job to compare with others",
  "hit.tooltip.saved": "Remove from saved jobs",
  "hit.tooltip.share": "Share this job",
  "hit.unhide": "Unhide job",
  "hitGroup.openRoles": "{count, plural, one {# open role} other {# open roles}}",
  "hitGroup.viewCompanyProfile": "View company profile",
  "hitV2.estMonthly": "Est. Monthly",
  "hitV2.monthly": "Monthly",
  "hitV2.viewJob": "View job",
  "hub.bottomNav.alerts": "Alerts",
  "hub.bottomNav.ariaLabel": "Hub navigation",
  "hub.bottomNav.profile": "Profile",
  "hub.guestSyncNote": "Saved on this device — {signIn} to sync across devices",
  "hub.guestSyncNote.signIn": "sign in",
  "hub.nav.myJobs": "My Jobs",
  "hub.nav.myJobs.count": "{savedCount} saved · {activeCount} active",
  "hub.nav.profile": "Profile & CV",
  "hub.nav.searchesAlerts": "Searches & Alerts",
  "hub.nav.searchesAlerts.newCount": "{count} new",
  "hub.nav.watchlist": "Watchlist",
  "hub.nav.watchlist.newsCount": "{count} with news",
  "hub.title": "My Jobs",
  "instantsearch.searchBoxLink.placeholder": "Search for jobs",
  "instantsearch.searchbox.placeholder": "Search jobs, language, or city",
  "job.copyCompanyName": "Copy company name",
  "jobAlerts.confirm.confirm": "Confirm",
  "jobAlerts.confirm.errorBody": "Something went wrong. Please try again in a moment.",
  "jobAlerts.confirm.explanation": "Confirm your email address to start receiving job alert emails from JobCrawls.",
  "jobAlerts.confirm.heading": "Confirm your job alerts",
  "jobAlerts.confirm.invalidLink": "This confirmation link is invalid or has expired. Turn alerts on again from your saved searches to get a new one.",
  "jobAlerts.confirm.successBody": "You're all set — we'll email you when new jobs match your saved searches.",
  "jobAlerts.confirm.successHeading": "Your email is confirmed",
  "jobAlerts.confirm.working": "Confirming…",
  "jobAlerts.newMatches.errorBody": "We couldn't load your new matches. Please try again in a moment.",
  "jobAlerts.newMatches.summaryHeading": "{count, plural, one {# new job} other {# new jobs}} since your last visit",
  "jobAlerts.newMatches.summaryMore": "+{count} more in the searches below",
  "jobAlerts.newMatches.viewAllInSection": "View all {count} new matches",
  "jobAlerts.panel.activeStatus.v2": "Turn on alerts for individual searches below to start receiving them.",
  "jobAlerts.panel.detailCopy.v2": "Weekly on Monday mornings by default, or daily if you prefer. Sent to {email}. Turn off anytime here, or from the link in every email.",
  "jobAlerts.panel.disable": "Turn off email alerts",
  "jobAlerts.panel.enable": "Enable email alerts",
  "jobAlerts.panel.error": "Saving failed. Please try again.",
  "jobAlerts.panel.frequencyDaily": "Daily",
  "jobAlerts.panel.frequencyDailyHint": "Every day",
  "jobAlerts.panel.frequencyLegend": "How often",
  "jobAlerts.panel.frequencyWeekly.v2": "Weekly",
  "jobAlerts.panel.frequencyWeeklyHint": "Monday mornings",
  "jobAlerts.panel.heading": "Email alerts",
  "jobAlerts.panel.languageLegend": "Email language",
  "jobAlerts.panel.leadCopy": "Get an email the moment a job matches one of your saved searches.",
  "jobAlerts.panel.noEmail": "Your account has no email address, so alerts are unavailable.",
  "jobAlerts.panel.pendingStatus.v2": "Check your inbox to confirm your email and activate alerts.",
  "jobAlerts.panel.privacyLink": "Privacy policy",
  "jobAlerts.panel.sectionHeading": "Email digest",
  "jobAlerts.panel.seeNewMatches": "See new matches now",
  "jobAlerts.panel.statusOff": "Off",
  "jobAlerts.panel.statusOn": "On",
  "jobAlerts.panel.statusPending": "Confirming",
  "jobAlerts.panel.update": "Save changes",
  "jobAlerts.signInPrompt": "Never miss a new match — {signIn} to see live updates and turn on email alerts for your searches.",
  "jobAlerts.toggle.failed": "Couldn't save — try again",
  "jobAlerts.toggle.label": "Email me new matches",
  "jobAlerts.toggle.label.activate": "Activate email alerts",
  "jobAlerts.toggle.needsSubscription": "Enable email alerts above first",
  "jobAlerts.unsubscribe.confirm": "Unsubscribe",
  "jobAlerts.unsubscribe.errorBody": "Something went wrong. Please try again in a moment.",
  "jobAlerts.unsubscribe.explanation": "This stops all job alert emails from JobCrawls to your address. Your saved searches stay untouched.",
  "jobAlerts.unsubscribe.heading": "Unsubscribe from job alerts",
  "jobAlerts.unsubscribe.invalidLink": "This unsubscribe link is invalid or incomplete. Use the link from a recent alert email, or manage alerts from your saved searches when signed in.",
  "jobAlerts.unsubscribe.successBody": "You will no longer receive job alert emails. You can re-enable alerts anytime from your saved searches when signed in.",
  "jobAlerts.unsubscribe.successHeading": "You are unsubscribed",
  "jobAlerts.unsubscribe.working": "Unsubscribing…",
  "jobAlerts.watchlistDigest.combined": "Combined with this email",
  "jobAlerts.watchlistDigest.error.v2": "Couldn't save. Please try again.",
  "jobAlerts.watchlistDigest.frequencyLegend": "How often for the watchlist email",
  "jobAlerts.watchlistDigest.legend": "Watchlist updates",
  "jobAlerts.watchlistDigest.saving": "Saving…",
  "jobAlerts.watchlistDigest.separate": "Send as a separate email",
  "jobChart.popover.categoriesShown": "Categories shown",
  "jobChart.popover.companyContext": "Based on {companyName} listings in our data.",
  "jobChart.popover.count": "Job postings",
  "jobChart.popover.monthKey": "Period",
  "jobChart.popover.share": "Share of chart",
  "jobChart.popover.totalInRing": "Total in this ring",
  "jobChart.segmentHint": "Tap or hover a segment for details.",
  "jobDetail.lastSeen.daysAgo": "{value, plural, one {Seen {value} day ago} other {Seen {value} days ago}}",
  "jobDetail.lastSeen.hoursAgo": "{value, plural, one {Seen {value} hour ago} other {Seen {value} hours ago}}",
  "jobDetail.lastSeen.minutesAgo": "{value, plural, one {Seen {value} minute ago} other {Seen {value} minutes ago}}",
  "jobDetail.relatedPages.intro": "The role, city, employer and pay pages behind this listing.",
  "jobDetail.relatedPages.title": "Explore more",
  "jobDetail.roleHub.jobsInCity": "{role} jobs in {city}",
  "jobDetail.roleHub.moreJobs": "More {role} jobs",
  "jobDetail.save.alsoFollowAction": "Follow",
  "jobDetail.save.alsoFollowToast": "Job saved. Follow {company} to hear about their next roles?",
  "jobDetail.save.nowFollowingToast": "Following {company}. New roles will show on your watchlist.",
  "jobDetail.similarJobs.algoliaListTitle": "Similar jobs",
  "jobDetail.similarJobs.description": "Discover more opportunities that match your interests and skills",
  "jobDetail.similarJobs.seeAll": "See all",
  "jobDetail.similarJobs.sourceNote": "From JobCrawls search: same role title and primary location as this listing (this job excluded). Up to 8 results.",
  "jobDetail.similarJobs.title": "Related Opportunities",
  "jobDetail.viewOnMapCommute": "See on map & check your commute",
  "jobDetailAlertCta.bannerText": "Never miss a new {role} job like this",
  "jobDetailAlertCta.bannerTextWithLocation": "Never miss a new {role} job in {location}",
  "jobDetailAlertCta.ctaButton": "Get email alerts",
  "jobDetailAlertCta.dismissLabel": "Dismiss",
  "jobDetailAlertCta.errorText": "Something went wrong. We couldn't turn on alerts. Please try again.",
  "jobDetailAlertCta.manageLink": "Manage alerts",
  "jobDetailAlertCta.pendingText": "Almost there: check your inbox to confirm your email and activate alerts.",
  "jobDetailAlertCta.subText": "Free weekly or daily digest. Unsubscribe anytime.",
  "jobDetailAlertCta.successText": "You're set. We'll email you about jobs like this.",
  "jobDetailPage.404.backHome": "Back to Home",
  "jobDetailPage.404.description": "Sorry, we couldn't find this job. It may have been removed or the link is incorrect.",
  "jobDetailPage.404.heading": "This page is not found",
  "jobDetailPage.aboutCompany": "About",
  "jobDetailPage.applicationDeadline": "Application deadline",
  "jobDetailPage.applied": "Applied ✓",
  "jobDetailPage.applyMoreOptions": "More apply options",
  "jobDetailPage.applyNavigation": "Apply to job",
  "jobDetailPage.applyNow": "Apply",
  "jobDetailPage.autofillApplyCta": "Autofill this application",
  "jobDetailPage.availableLanguages": "Available in:",
  "jobDetailPage.benefits": "Benefits",
  "jobDetailPage.benefitsAndPerks": "Benefits & Perks",
  "jobDetailPage.businessId": "Business ID",
  "jobDetailPage.byRemoteness": "By Remoteness",
  "jobDetailPage.chartsDataRange": "Data shown is based on historical job postings from our database.",
  "jobDetailPage.collapseCompensation": "Collapse compensation details",
  "jobDetailPage.companiesHiringInLocation": "Companies Hiring in {location}",
  "jobDetailPage.companyCollapsedBody": "Expand to view trend charts, location distribution, language demand, and map details.",
  "jobDetailPage.companyDistributionDescription": "Showing top {count} companies by number of job postings",
  "jobDetailPage.companyInfoFromTradeRegister": "Includes details from the Finnish Trade Register.",
  "jobDetailPage.compensation": "Compensation",
  "jobDetailPage.contact": "Contact:",
  "jobDetailPage.coverLetter.basedOn": "Based on: {entries}",
  "jobDetailPage.coverLetter.copied": "Copied!",
  "jobDetailPage.coverLetter.copy": "Copy text",
  "jobDetailPage.coverLetter.download": "Download cover letter",
  "jobDetailPage.coverLetter.editHint": "Edit the text below before copying or downloading; it's yours to adjust.",
  "jobDetailPage.coverLetter.failed": "Could not draft your cover letter. Try again later.",
  "jobDetailPage.coverLetter.generateCta": "Draft my cover letter",
  "jobDetailPage.coverLetter.intro": "Draft a cover letter using your profile and this job; you can edit it before downloading.",
  "jobDetailPage.coverLetter.loading": "Drafting your cover letter…",
  "jobDetailPage.coverLetter.networkError": "Network error. Check your connection.",
  "jobDetailPage.coverLetter.notConfigured": "Cover letter drafting is not enabled for this environment.",
  "jobDetailPage.coverLetter.overclaimWarning": "We couldn't find \"{skill}\" in your profile; make sure this is true.",
  "jobDetailPage.coverLetter.quotaExceeded": "You've hit today's cover letter limit; it resets tomorrow.",
  "jobDetailPage.coverLetter.sourceCompany": "Company info",
  "jobDetailPage.coverLetter.sourceSkills": "Skills",
  "jobDetailPage.coverLetter.ungroundedFlag": "{count, plural, one {One part} other {# parts}} of this letter wasn't tied to anything specific in your profile; please check {count, plural, one {it's} other {they're}} accurate.",
  "jobDetailPage.description": "Job Description",
  "jobDetailPage.estimatedExpiry": "Estimated expiry",
  "jobDetailPage.estimatedNetSalary.explanation": "Estimated {year} take-home pay after Finnish income tax, pension, and unemployment insurance contributions. Assumes the national average municipal tax rate ({rate}%), no church tax, and standard deductions only; your actual net pay depends on your municipality, church membership, age, and family situation.",
  "jobDetailPage.expandCompanyData": "Expand company information to view trends, distributions, and map",
  "jobDetailPage.expandCompensation": "Expand compensation details",
  "jobDetailPage.expired.backToSearch": "Back to search results",
  "jobDetailPage.expired.toastMessage": "This listing may be too old or no longer active.",
  "jobDetailPage.headcount": "Headcount",
  "jobDetailPage.hideCharts": "Hide Charts",
  "jobDetailPage.hiringSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.hiringSnapshotSeo.caption": "Current open roles at {company} on JobCrawls",
  "jobDetailPage.hiringSnapshotSeo.location": "Location",
  "jobDetailPage.languageNavigation": "Available languages",
  "jobDetailPage.languageRequirements": "Language Requirements",
  "jobDetailPage.lastSeenAgoCompact": "{days, plural, =0 {today} one {#d ago} other {#d ago}}",
  "jobDetailPage.lastSeenDetail": "Last seen: {date}{ago}",
  "jobDetailPage.listingCompanyIndustryLabel": "Listing",
  "jobDetailPage.loadingMap": "Loading map...",
  "jobDetailPage.location": "Location",
  "jobDetailPage.locationAndRemotenessDistribution": "Location & Remoteness Distribution",
  "jobDetailPage.locationDistribution": "Location Distribution",
  "jobDetailPage.mapError": "Unable to load map",
  "jobDetailPage.markAppliedAction": "Mark as Applied",
  "jobDetailPage.markAppliedPrompt": "Opened the application in a new tab. Mark this job as applied?",
  "jobDetailPage.matchBreakdown.collapse": "Collapse match breakdown",
  "jobDetailPage.matchBreakdown.expand": "Expand match breakdown",
  "jobDetailPage.matchBreakdown.title": "How this job matches your profile",
  "jobDetailPage.noItems": "No items to show.",
  "jobDetailPage.noLocation": "No location",
  "jobDetailPage.noRemoteness": "Not specified",
  "jobDetailPage.officialRegisterName": "Registered name",
  "jobDetailPage.originalLanguage": "Original",
  "jobDetailPage.period.day": "day",
  "jobDetailPage.period.hour": "hour",
  "jobDetailPage.period.month": "month",
  "jobDetailPage.period.year": "year",
  "jobDetailPage.perks": "Perks",
  "jobDetailPage.postedAgo": "{days, plural, =0 {Posted today} one {Posted 1 day ago} other {Posted # days ago}}",
  "jobDetailPage.recruitmentProcess": "Recruitment Process",
  "jobDetailPage.remoteness": "Remoteness",
  "jobDetailPage.remotenessDistribution": "Remoteness Distribution",
  "jobDetailPage.remotenessDistribution.short": "Remoteness",
  "jobDetailPage.requiredLanguages": "Required Languages",
  "jobDetailPage.requirements": "Requirements",
  "jobDetailPage.responsibilities": "Responsibilities",
  "jobDetailPage.roleAndRoleLevelDistribution": "Role & Role Level Distribution",
  "jobDetailPage.roleDistribution": "Role Distribution",
  "jobDetailPage.roleLevelDistribution": "Role Level Distribution",
  "jobDetailPage.roleLevelSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.roleLevelSnapshotSeo.caption": "Current role-level mix at {company} on JobCrawls",
  "jobDetailPage.roleLevelSnapshotSeo.level": "Role level",
  "jobDetailPage.roleSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.roleSnapshotSeo.caption": "Current role mix at {company} on JobCrawls",
  "jobDetailPage.roleSnapshotSeo.role": "Role type",
  "jobDetailPage.salaryProvenance.employerQuote": "Pay range is taken from wording in the job ad.",
  "jobDetailPage.salaryProvenance.extractedNoQuote": "This is the pay range listed for this job, not a market average — it wasn't found as quoted text in the ad, so treat it as unverified.",
  "jobDetailPage.salarySourceBadge.estimated": "Estimated",
  "jobDetailPage.salarySourceBadge.fromListing": "Listed",
  "jobDetailPage.salarySourceBadge.unverified": "Unverified",
  "jobDetailPage.salaryStatistics": "Salary Statistics",
  "jobDetailPage.section.company": "Company Information",
  "jobDetailPage.section.jobDetails": "Job Details",
  "jobDetailPage.seeLocation": "See Location",
  "jobDetailPage.seeOriginal": "See original",
  "jobDetailPage.showCharts": "Show Charts",
  "jobDetailPage.showCompanyContact": "Show Company Contact",
  "jobDetailPage.showContact": "Show Contact Email",
  "jobDetailPage.showConverted": "Show EUR/month",
  "jobDetailPage.showingItemsAboveThreshold": "Showing only items above {percentage}%",
  "jobDetailPage.skillsAndTechnologies": "Skills & Technologies",
  "jobDetailPage.specialisations": "Specialisations",
  "jobDetailPage.tailorCv.disclaimer": "Only your existing experience was reworded and reordered to highlight what this job cares about. Nothing was invented. Review it below before downloading.",
  "jobDetailPage.tailorCv.download": "Download tailored CV",
  "jobDetailPage.tailorCv.emptyProfile": "Fill in your profile first: we need your work experience or skills to tailor a CV.",
  "jobDetailPage.tailorCv.failed": "Could not tailor your CV. Try again later.",
  "jobDetailPage.tailorCv.goToProfile": "Go to your profile",
  "jobDetailPage.tailorCv.loading": "Rewording your existing experience for this job…",
  "jobDetailPage.tailorCv.networkError": "Network error. Check your connection.",
  "jobDetailPage.tailorCv.notConfigured": "CV tailoring is not enabled for this environment.",
  "jobDetailPage.tailorCv.quotaExceeded": "You've hit today's tailoring limit; it resets tomorrow.",
  "jobDetailPage.tailorCv.tabCoverLetter": "Cover letter",
  "jobDetailPage.tailorCv.tabCv": "CV",
  "jobDetailPage.tailorCv.title": "Tailor my CV for this job",
  "jobDetailPage.tailorCvCta": "Tailor my CV for this job",
  "jobDetailPage.tradeRegisterWebsite": "Trade register website",
  "jobDetailPage.tyomarkkinatori.about": "<strong>Työmarkkinatori</strong> is Finland's official public employment service portal, operated by the Ministry of Economic Affairs and Employment (TEM). It lists job openings from across the Finnish public sector, municipalities, and employers who use the government's recruitment infrastructure.",
  "jobDetailPage.tyomarkkinatori.dataSourceAttribution": "Source: <link>Job Market Finland customer information system</link>",
  "jobDetailPage.tyomarkkinatori.whyWeIndex": "We include Työmarkkinatori listings so that JobCrawls covers the full breadth of the Finnish job market — including roles that only appear through official government channels and would otherwise be missed.",
  "jobDetailPage.vacationWeeks": "Vacation: {weeks} weeks",
  "jobDetailPage.viewBenefits": "View benefits",
  "jobDetailPage.watchCompanyVideo": "Watch Company Video",
  "jobDetailPageV2.awardsAndCertifications": "Awards & certifications",
  "jobDetailPageV2.collectiveAgreement.browseAll": "Browse all Finnish collective agreements",
  "jobDetailPageV2.collectiveAgreement.confidence": "{percent}% confidence",
  "jobDetailPageV2.collectiveAgreement.explicit": "Employer states this job follows the {agreementName} collective agreement.",
  "jobDetailPageV2.collectiveAgreement.inferred": "Best guess: {agreementName} collective agreement, inferred from this employer's industry and the role; could be a different one.",
  "jobDetailPageV2.coreValues": "Core values",
  "jobDetailPageV2.daysAgo": "{days, plural, one {# day ago} other {# days ago}}",
  "jobDetailPageV2.daysLeft": "{days, plural, one {# day left} other {# days left}}",
  "jobDetailPageV2.daysOpen.longer": "Open {days, plural, one {# day} other {# days}}, longer than the usual {typical} for this role",
  "jobDetailPageV2.daysOpen.usual": "Open {days, plural, one {# day} other {# days}}. This role usually stays open about {typical} days",
  "jobDetailPageV2.deadline": "Deadline {date}",
  "jobDetailPageV2.descriptionDisclaimer": "The text above is the employer's original job description, extracted as written. Other details on this page, like salary, responsibilities, and requirements, are interpreted from that text by our system, not values the employer explicitly confirmed, so treat them as our best interpretation rather than verified facts.",
  "jobDetailPageV2.employerOverview": "About the employer",
  "jobDetailPageV2.employerScore.aria": "Employer Score {tier}. See the full company profile",
  "jobDetailPageV2.employerScore.label": "Employer Score",
  "jobDetailPageV2.estTakeHome": "Est. take-home {amount}",
  "jobDetailPageV2.estTakeHome.infoLabel": "What assumptions does this estimate use?",
  "jobDetailPageV2.estimatedExpiry": "Est. expiry {date}",
  "jobDetailPageV2.experienceYears": "{years} {years, plural, one {year} other {years}} experience",
  "jobDetailPageV2.financialOverview": "Financial overview",
  "jobDetailPageV2.fitLedger.action.addLanguage": "Speak {list}? Add it to your profile",
  "jobDetailPageV2.fitLedger.action.fillProfile": "Fill in your profile for a real comparison",
  "jobDetailPageV2.fitLedger.action.tailorCv": "Tailor your CV to this role",
  "jobDetailPageV2.fitLedger.action.weights": "Change what matters most to you",
  "jobDetailPageV2.fitLedger.basis.current": "Compared with your current role. Set a desired job on your profile to compare against what you actually want.",
  "jobDetailPageV2.fitLedger.basis.desired": "Compared with the job you said you want on your profile; where you left something blank, your current role is used instead.",
  "jobDetailPageV2.fitLedger.cell.benefitsNow": "{count, plural, one {# benefit now} other {# benefits now}}",
  "jobDetailPageV2.fitLedger.cell.more": "+{count} more",
  "jobDetailPageV2.fitLedger.cell.notSet": "Not set",
  "jobDetailPageV2.fitLedger.cell.notStated": "Not stated",
  "jobDetailPageV2.fitLedger.cell.weeks": "{weeks, plural, one {# week} other {# weeks}} / year",
  "jobDetailPageV2.fitLedger.column.thisJob": "This job",
  "jobDetailPageV2.fitLedger.column.you": "You",
  "jobDetailPageV2.fitLedger.column.yourSearches": "Your searches",
  "jobDetailPageV2.fitLedger.delta.benefitsFewer": "Fewer than you have now",
  "jobDetailPageV2.fitLedger.delta.benefitsGain": "{count, plural, one {One you don’t have now} other {# you don’t have now}}",
  "jobDetailPageV2.fitLedger.delta.benefitsSame": "Nothing you don’t already have",
  "jobDetailPageV2.fitLedger.delta.contractDifferent": "Not the contract you want",
  "jobDetailPageV2.fitLedger.delta.contractSame": "The contract you want",
  "jobDetailPageV2.fitLedger.delta.languagesAll": "You have every required language",
  "jobDetailPageV2.fitLedger.delta.languagesMissing": "Missing {list}",
  "jobDetailPageV2.fitLedger.delta.languagesNone": "No language requirement",
  "jobDetailPageV2.fitLedger.delta.levelDifferent": "A different level",
  "jobDetailPageV2.fitLedger.delta.levelDown": "{steps, plural, one {One level down} other {# levels down}}",
  "jobDetailPageV2.fitLedger.delta.levelSame": "The level you want",
  "jobDetailPageV2.fitLedger.delta.levelUp": "{steps, plural, one {One level up} other {# levels up}}",
  "jobDetailPageV2.fitLedger.delta.locationIn": "In your area",
  "jobDetailPageV2.fitLedger.delta.locationOut": "Outside your areas",
  "jobDetailPageV2.fitLedger.delta.notStated": "Not stated in the listing",
  "jobDetailPageV2.fitLedger.delta.salaryMeets": "Meets your {basis, select, desired {floor} other {current pay}}",
  "jobDetailPageV2.fitLedger.delta.salaryOver": "{amount} over your {basis, select, desired {floor} other {current pay}}",
  "jobDetailPageV2.fitLedger.delta.salaryRangeCovers": "Top of the range covers your {basis, select, desired {floor} other {current pay}}",
  "jobDetailPageV2.fitLedger.delta.salaryUnder": "{amount} under your {basis, select, desired {floor} other {current pay}}",
  "jobDetailPageV2.fitLedger.delta.styleExact": "The setup you want",
  "jobDetailPageV2.fitLedger.delta.styleHybrid": "Hybrid, close enough",
  "jobDetailPageV2.fitLedger.delta.styleMismatch": "Not the setup you want",
  "jobDetailPageV2.fitLedger.delta.titleClose": "Close to your target title",
  "jobDetailPageV2.fitLedger.delta.titleDifferent": "A different kind of role",
  "jobDetailPageV2.fitLedger.delta.titleExact": "The title you’re after",
  "jobDetailPageV2.fitLedger.delta.titleOverlap": "Shares words with your target",
  "jobDetailPageV2.fitLedger.delta.vacationLess": "{weeks, plural, one {One week less} other {# weeks less}} than now",
  "jobDetailPageV2.fitLedger.delta.vacationMore": "{weeks, plural, one {One week more} other {# weeks more}} than now",
  "jobDetailPageV2.fitLedger.delta.vacationSame": "Same as now",
  "jobDetailPageV2.fitLedger.kicker": "Your fit",
  "jobDetailPageV2.fitLedger.kicker.searches": "Estimated from your searches",
  "jobDetailPageV2.fitLedger.noun.benefits": "benefits",
  "jobDetailPageV2.fitLedger.noun.jobType": "contract type",
  "jobDetailPageV2.fitLedger.noun.languages": "languages",
  "jobDetailPageV2.fitLedger.noun.location": "location",
  "jobDetailPageV2.fitLedger.noun.remoteness": "working style",
  "jobDetailPageV2.fitLedger.noun.roleLevel": "seniority",
  "jobDetailPageV2.fitLedger.noun.salary": "pay",
  "jobDetailPageV2.fitLedger.noun.title": "the role",
  "jobDetailPageV2.fitLedger.noun.vacation": "time off",
  "jobDetailPageV2.fitLedger.perMonth": "{amount} / mo",
  "jobDetailPageV2.fitLedger.row.benefits": "Benefits",
  "jobDetailPageV2.fitLedger.row.jobType": "Contract",
  "jobDetailPageV2.fitLedger.row.keywords": "Keywords",
  "jobDetailPageV2.fitLedger.row.languages": "Languages",
  "jobDetailPageV2.fitLedger.row.location": "Location",
  "jobDetailPageV2.fitLedger.row.remoteness": "Work style",
  "jobDetailPageV2.fitLedger.row.roleLevel": "Level",
  "jobDetailPageV2.fitLedger.row.salary": "Pay",
  "jobDetailPageV2.fitLedger.row.searchCompany": "Employer",
  "jobDetailPageV2.fitLedger.row.searchRoles": "Role & field",
  "jobDetailPageV2.fitLedger.row.title": "Role",
  "jobDetailPageV2.fitLedger.row.vacation": "Time off",
  "jobDetailPageV2.fitLedger.verdict.A": "Strong fit",
  "jobDetailPageV2.fitLedger.verdict.B": "Good fit",
  "jobDetailPageV2.fitLedger.verdict.C": "Mixed fit",
  "jobDetailPageV2.fitLedger.verdict.D": "Weak fit",
  "jobDetailPageV2.fitLedger.verdict.F": "Not a fit on paper",
  "jobDetailPageV2.fitLedger.verdict.allMiddle": "Every factor lands somewhere in the middle.",
  "jobDetailPageV2.fitLedger.verdict.gaps": "{count, plural, one {The gap: {list}.} other {The gaps: {list}.}}",
  "jobDetailPageV2.fitLedger.verdict.noGaps": "Nothing stands out as a gap.",
  "jobDetailPageV2.fitLedger.verdict.strengths": "{list} {count, plural, one {lines up} other {line up}} with what you want.",
  "jobDetailPageV2.hideOriginalDescription": "Hide original description",
  "jobDetailPageV2.homeCommute.addHome": "Add your home address once and you'll see your commute time on every job.",
  "jobDetailPageV2.homeCommute.addressLabel": "Your home address",
  "jobDetailPageV2.homeCommute.calculating": "Calculating travel times…",
  "jobDetailPageV2.homeCommute.cancelChange": "Keep current",
  "jobDetailPageV2.homeCommute.change": "Change",
  "jobDetailPageV2.homeCommute.changeHome": "Search a new home address.",
  "jobDetailPageV2.homeCommute.chip": "{time} from home",
  "jobDetailPageV2.homeCommute.fromHome": "From {home}",
  "jobDetailPageV2.homeCommute.hours": "{hours} h",
  "jobDetailPageV2.homeCommute.hoursMinutes": "{hours} h {minutes} min",
  "jobDetailPageV2.homeCommute.minutes": "{minutes} min",
  "jobDetailPageV2.homeCommute.noTransit": "Public transport times aren't available yet.",
  "jobDetailPageV2.homeCommute.privacyNote": "Saved to your profile and only used for travel times. Never shared with employers.",
  "jobDetailPageV2.homeCommute.unavailable": "Travel times aren't available for this address.",
  "jobDetailPageV2.includesVariablePay": "+ variable pay",
  "jobDetailPageV2.jobDescription": "Job description",
  "jobDetailPageV2.lastSeen": "Last seen {date}",
  "jobDetailPageV2.locationModal.close": "Close map",
  "jobDetailPageV2.locationModal.headingWithCount": "{count, plural, one {Job location} other {Job locations · {count} sites}}",
  "jobDetailPageV2.locationModal.title": "Job location",
  "jobDetailPageV2.mapChip": "Map",
  "jobDetailPageV2.mapChip.locationCount": "{count} locations",
  "jobDetailPageV2.matchBreakdown.overallLabel": "overall match",
  "jobDetailPageV2.mostHiredRoles": "Most-hired roles",
  "jobDetailPageV2.numberOfPositions": "{count} openings",
  "jobDetailPageV2.officePhotos": "Office photos",
  "jobDetailPageV2.openRoles": "{count} open roles",
  "jobDetailPageV2.originalDescription": "Original job description",
  "jobDetailPageV2.originallyListedAs": "Originally listed as {amount}",
  "jobDetailPageV2.otherLocations": "+{count} other locations",
  "jobDetailPageV2.postedOn": "Posted {date}",
  "jobDetailPageV2.profit": "Profit",
  "jobDetailPageV2.profitMargin": "Profit margin",
  "jobDetailPageV2.readFullDescription": "Read full description",
  "jobDetailPageV2.realSalaryNote": "(real pay, quoted by the employer)",
  "jobDetailPageV2.revenue": "Revenue",
  "jobDetailPageV2.roleLevelMix": "Role-level mix",
  "jobDetailPageV2.salaryCompares": "How this salary compares",
  "jobDetailPageV2.salaryEstimateSampleSize": "Estimated from {count, plural, one {# comparable listing} other {# comparable listings}}",
  "jobDetailPageV2.salaryGauge.benchmark.companyLocation": "this company in {location}",
  "jobDetailPageV2.salaryGauge.benchmark.companySalaryStats": "this company",
  "jobDetailPageV2.salaryGauge.benchmark.locationMarket": "all roles in {location}",
  "jobDetailPageV2.salaryGauge.benchmark.title": "{title} roles",
  "jobDetailPageV2.salaryGauge.benchmark.titleLocation": "{title} in {location}",
  "jobDetailPageV2.salaryGauge.benchmark.titleRoleLevel": "{roleLevel} level roles",
  "jobDetailPageV2.salaryGauge.headline": "{percent}% {direction, select, above {above} other {below}} {benchmark}",
  "jobDetailPageV2.salaryGauge.headlineLevel": "In line with {benchmark}",
  "jobDetailPageV2.salaryGauge.headlineNoJobSalary": "Benchmarked against {benchmark}",
  "jobDetailPageV2.salaryGauge.median": "median",
  "jobDetailPageV2.salaryGauge.thisOffer": "This offer",
  "jobDetailPageV2.taxIcebergLink": "See the full tax breakdown →",
  "jobDetailPageV2.tldr": "At a glance",
  "jobDetailPageV2.topLocations": "Top locations:",
  "jobDetailPageV2.vacationWeeks": "{count, plural, one {# week vacation} other {# weeks vacation}}",
  "jobDetailPageV2.viewCompany": "View company",
  "jobDetailPageV2.watchCompanyVideo": "Watch company video",
  "layoutErrorFallback.body": "Please try reloading the page. If the problem continues, we have been notified.",
  "layoutErrorFallback.home": "Go to home",
  "layoutErrorFallback.reload": "Reload page",
  "layoutErrorFallback.title": "Something went wrong",
  "locationHub.activeJobs": "Jobs",
  "locationHub.avgSalary": "Salary",
  "locationHub.cityCard.languageDonut.englishPercent": "{percent}% EN",
  "locationHub.cityCard.qa.languageAnswer": "{percent}% of jobs require English.",
  "locationHub.cityCard.qa.languageQuestion": "What languages are required in {city}?",
  "locationHub.cityCard.qa.remoteAnswerFallback": "Remote work options are available.",
  "locationHub.cityCard.qa.remoteAnswerWithPercent": "Yes, {percent}% of roles are remote or hybrid.",
  "locationHub.cityCard.qa.remoteQuestion": "Is {city} remote-friendly?",
  "locationHub.cityCard.qa.salaryAnswerFallback": "Salary data available.",
  "locationHub.cityCard.qa.salaryAnswerWithValue": "Average salary is {salary}.",
  "locationHub.cityCard.qa.salaryQuestion": "What is the average salary in {city}?",
  "locationHub.cityCard.workModel.flexiblePercent": "{percent}% Flexible",
  "locationHub.cityCard.workModel.hybridTooltip": "{percent}% Hybrid",
  "locationHub.cityCard.workModel.onsiteTooltip": "{percent}% Onsite",
  "locationHub.cityCard.workModel.remoteTooltip": "{percent}% Remote",
  "locationHub.hero.description": "Explore major Finnish cities with job counts, salary insights, and market data updated regularly. Discover your next opportunity across Finland's job market.",
  "locationHub.hero.subtitle": "Curated city guides and job searches across Finland",
  "locationHub.hero.title": "Finland Job Market",
  "locationHub.hero.title.breadcrumb": "Explore Jobs by Location",
  "locationHub.languages": "Languages",
  "locationHub.metropolitan.seo": "The Helsinki Metropolitan area, including Espoo and Vantaa, is Finland's primary economic engine, offering the highest density of English-speaking and remote roles with excellent transport connectivity (HSL).",
  "locationHub.overview.description": "Explore Finland's leading technology and innovation centers with real-time job market data, salary insights, and industry trends.",
  "locationHub.overview.title": "Major Tech Hubs",
  "locationHub.popularRoles.heading": "Popular Roles",
  "locationHub.quickJump.overview": "Overview",
  "locationHub.resourcesLink": "Explore Job Market Insights & Career Tips",
  "locationHub.structuredData.collectionPage.description": "Discover job opportunities in major Finnish cities with salary insights and market data",
  "locationHub.structuredData.collectionPage.name": "Finland Locations Hub",
  "locationHub.structuredData.itemList.description": "Explore job opportunities across major cities in Finland",
  "locationHub.structuredData.itemList.name": "Finland Job Locations",
  "locationHub.table.activeJobs": "Active Jobs",
  "locationHub.table.avgSalary": "Avg Salary",
  "locationHub.table.city": "City",
  "locationHub.table.notAvailable": "N/A",
  "locationHub.table.specialty": "Specialty",
  "locationHub.workModel": "Work Model",
  "map.cappedResultsNotice": "Showing {shown} of {total} — zoom in further to narrow down",
  "map.commute.addSecond": "Add a second starting point",
  "map.commute.addressAriaLabel": "Search for a starting address",
  "map.commute.addressPlaceholder": "Or type an address…",
  "map.commute.button": "Commute search",
  "map.commute.clear": "Clear commute filter",
  "map.commute.customMinutesAriaLabel": "Custom commute time in minutes",
  "map.commute.customMinutesLabel": "Custom",
  "map.commute.error": "Couldn't load the commute area. Try again.",
  "map.commute.loading": "Finding the commute area…",
  "map.commute.minutes": "{minutes} min",
  "map.commute.minutesUnit": "min",
  "map.commute.panelHeading": "Commute time",
  "map.commute.profile.cycling": "Bike",
  "map.commute.profile.driving": "Drive",
  "map.commute.profile.transit": "Transit",
  "map.commute.profile.walking": "Walk",
  "map.commute.prompt": "Click the map to set your starting point",
  "map.commute.promptSecond": "Click the map to set the second starting point",
  "map.commute.removeSecond": "Remove second starting point",
  "map.commute.transitApproxNote": "Transit area is approximate",
  "map.companies.count": "{count, plural, one {# company} other {# companies}}",
  "map.companies.none": "No companies in this area",
  "map.companies.openRoles": "{count, plural, one {# open role} other {# open roles}}",
  "map.companiesInView": "Companies in view",
  "map.companyLogoAlt": "Company logo",
  "map.densityBubble.perCapitaSuffix": "/1k",
  "map.densityZoomPrompt": "Zoom in to see individual jobs and company logos",
  "map.densityZoomPrompt.button": "Zoom in",
  "map.draw.button": "Draw an area",
  "map.draw.cancel": "Cancel",
  "map.draw.clear": "Clear drawn area",
  "map.draw.finish": "Finish ({count})",
  "map.draw.prompt": "Click the map to outline an area",
  "map.jobs": "jobs",
  "map.jobsInView": "Jobs in view",
  "map.loading": "Loading map...",
  "map.newThisWeekToggle": "New this week",
  "map.noJobs": "No jobs in this area",
  "map.noJobsInView": "No jobs in this area",
  "map.noLocationsForPins": "No location coordinates for map pins in this view.",
  "map.panel.companiesTab": "Companies",
  "map.panel.jobsTab": "Jobs",
  "map.perCapitaToggle": "Per 1,000 residents",
  "map.popup.close": "Close",
  "map.popup.companyFallback": "Company",
  "map.popup.jobFallback": "Job",
  "map.popup.more": "+{count} more",
  "map.popup.titleMultiLocation": "{count, plural, one {# job} other {# jobs}} near {locationCount, plural, one {# location} other {# locations}}",
  "map.popup.titleSingleLocation": "{count, plural, one {# job} other {# jobs}} in {location}",
  "map.pulse.button": "Hiring pulse",
  "map.pulse.error": "Couldn't load hiring history",
  "map.pulse.loading": "Loading hiring history…",
  "map.pulse.pause": "Pause",
  "map.pulse.play": "Play",
  "map.pulse.scrubber": "Week",
  "map.pulse.weekOf": "Week of {date}",
  "map.remoteCard.label": "{count, plural, one {# remote job} other {# remote jobs}}",
  "map.remoteCard.more": "+{count} more",
  "map.resetView": "Reset map to show all of Finland",
  "map.tokenMissing": "Map view requires Mapbox access token",
  "map.tools.hideLabels": "Hide labels",
  "map.tools.showLabels": "Show labels",
  "map.unknownLocation": "Unknown location",
  "map.workInEnglishToggle": "Jobs in English",
  "marketHeader.language.english": "English",
  "marketHeader.language.finlandComparison": "Finland: {finlandEnglish}% English",
  "marketHeader.language.label": "Language Demand",
  "marketHeader.language.mixed": "Mixed",
  "marketHeader.languageSeo.caption": "Language demand in {location}",
  "marketHeader.languageSeo.english": "English",
  "marketHeader.languageSeo.language": "Language category",
  "marketHeader.languageSeo.localLanguages": "Local languages",
  "marketHeader.languageSeo.share": "Share of listings",
  "marketHeader.nearbyMarkets": "Nearby markets",
  "marketHeader.qa.languageAnswer": "{percent}% of jobs require English.",
  "marketHeader.qa.languageAnswerFallback": "Language requirements vary by role.",
  "marketHeader.qa.languageQuestion": "What languages are required in {location}?",
  "marketHeader.qa.remoteAnswer": "Yes, {answer}",
  "marketHeader.qa.remoteAnswerFallback": "Remote work options are available.",
  "marketHeader.qa.remoteAnswerWithPercent": "{percent}% of roles are remote or hybrid.",
  "marketHeader.qa.remoteQuestion": "Is {location} remote-friendly?",
  "marketHeader.qa.salaryAnswerFallback": "Salary data available.",
  "marketHeader.qa.salaryAnswerWithValue": "Average salary is {salary}.",
  "marketHeader.qa.salaryQuestion": "What is the average salary in {location}?",
  "marketHeader.rail.samplesUpdatedDaily": "{count} open jobs · updated daily",
  "marketHeader.removeLocation": "Remove location",
  "marketHeader.salary.finlandComparison": "Finland avg: {finlandAvg}",
  "marketHeader.salary.label": "Salary Trends",
  "marketHeader.salary.range": "Salary range",
  "marketHeader.salary.rangePercentile": "25th-75th percentile range",
  "marketHeader.salaryPercentileSeo.caption": "Advertised salary distribution in {location}, Finland (full-time roles)",
  "marketHeader.salaryPercentileSeo.p25": "25th percentile",
  "marketHeader.salaryPercentileSeo.p50": "Median (50th percentile)",
  "marketHeader.salaryPercentileSeo.p75": "75th percentile",
  "marketHeader.salaryPercentileSeo.percentile": "Percentile",
  "marketHeader.salaryPercentileSeo.salary": "Monthly salary (EUR)",
  "marketHeader.salaryPercentileSeo.sampleSize": "Based on {count} job postings with explicit salary data in {location}, Finland.",
  "marketHeader.toggle": "Toggle market header",
  "marketHeader.updated": "Updated:",
  "marketHeader.workModel.finlandComparison": "Finland: {finlandRemote}% remote/hybrid",
  "marketHeader.workModel.label": "Work Model",
  "marketHeader.workModel.noData": "Flexible",
  "marketHeader.workModelSeo.caption": "Work model distribution in {location}",
  "marketHeader.workModelSeo.hybrid": "Hybrid",
  "marketHeader.workModelSeo.model": "Work model",
  "marketHeader.workModelSeo.onsite": "Onsite",
  "marketHeader.workModelSeo.remote": "Remote",
  "marketHeader.workModelSeo.share": "Share of listings",
  "marketingConsent.checkbox.description": "Optional. Unsubscribe anytime.",
  "marketingConsent.checkbox.label": "Job market emails and tips",
  "matchDonut.ariaLabel": "Match score: {score}%",
  "matchDonut.breakdown.benefits": "Benefits",
  "matchDonut.breakdown.languages": "Languages",
  "matchDonut.breakdown.remoteness": "Remoteness",
  "matchDonut.breakdown.salary": "Salary",
  "matchDonut.breakdown.title": "Match Score Breakdown",
  "matchDonut.breakdown.vacation": "Vacation",
  "matchDonut.loginPrompt.createAccount": "Create account",
  "matchDonut.loginPrompt.description": "Create a profile and add your current job details to see how well jobs match your preferences",
  "matchDonut.loginPrompt.title": "Login to see your match score",
  "matchDonut.loginPromptAria": "Log in to see your match score",
  "matchDonut.profilePrompt.description": "Add your current job details and preferences on your profile to see how well jobs match.",
  "matchDonut.profilePrompt.goToProfile": "Go to profile",
  "matchDonut.profilePrompt.title": "Complete your profile to see your match score",
  "matchDonut.profilePromptAria": "Complete your profile to see your match score",
  "matchDonut.searchBreakdown.employer": "Employer & industry",
  "matchDonut.searchBreakdown.keywords": "Search keywords",
  "matchDonut.searchBreakdown.location": "Location",
  "matchDonut.searchBreakdown.remoteness": "Remoteness",
  "matchDonut.searchBreakdown.roleFit": "Role & field",
  "matchDonut.searchInference.bullet.company": "You’ve shown interest in employers like {company}; we factor that into the score.",
  "matchDonut.searchInference.bullet.keywords": "Your searches included terms like \"{terms}\"; we compared them to this job’s title and role.",
  "matchDonut.searchInference.bullet.locations": "You’ve searched in areas such as {locations}; this listing’s location is compared to that.",
  "matchDonut.searchInference.bullet.remoteness": "You often use remoteness filters ({values}); this job is scored against those preferences.",
  "matchDonut.searchInference.bullet.roles": "Your searches include role filters such as {hints}; similar signals are compared to this job.",
  "matchDonut.searchInference.intro": "We don’t have your profile yet, so this score estimates fit using filters and keywords from searches you’ve run on JobCrawls (recent activity counts more).",
  "matchDonut.searchInference.title": "Match from your recent searches",
  "modal.close": "Close",
  "nav.index.employersHiring": "employers hiring",
  "nav.index.newToday": "new today",
  "nav.index.openJobs": "open jobs",
  "nav.index.remote": "remote",
  "nav.index.updatedAgo": "Updated {minutes} min ago",
  "nav.search.placeholder": "Search jobs, skills or city",
  "nav.search.shortcutAria": "Shortcut: / to focus search",
  "nav.sheet.alerts": "New matches by email",
  "nav.sheet.alertsNote": "<em>{n}</em> new today, only the ones that fit",
  "nav.sheet.alertsNoteLoading": "new today, only the ones that fit",
  "nav.sheet.device": "On this device only. Sign in to keep them everywhere and get alerts.",
  "nav.sheet.email": "or use email",
  "nav.sheet.fine": "Free. No ads, ever.",
  "nav.sheet.free": "Free account",
  "nav.sheet.google": "Continue with Google",
  "nav.sheet.keep": "Keep what you have",
  "nav.sheet.keepGoogle": "Keep these, continue with Google",
  "nav.sheet.kit": "Tailored CV and cover letter",
  "nav.sheet.kitNote": "one click per job",
  "nav.sheet.searches": "{n} recent searches",
  "nav.sheet.track": "Track every application",
  "nav.sheet.trackNote": "saved, applied, interviews: one board",
  "nav.sheet.viewed": "Last viewed",
  "nav.sheet.viewedCount": "{n, plural, one {# viewed job} other {# viewed jobs}}",
  "nav.tape.and": "and",
  "nav.tape.clearAll": "Clear all",
  "nav.tape.not": "not",
  "nav.tape.only": "only",
  "nav.tape.or": "or",
  "nav.tape.quickAddPrefix": "+ {label}",
  "nav.tape.results": "{count} results",
  "nav.tape.sortNewest": "newest first",
  "nav.tape.sortSalary": "highest salary first",
  "nav.view.list": "List",
  "nav.view.map": "Map",
  "navigation.home.breadcrumb": "Home",
  "navigation.language": "Language",
  "navigation.language.label": "Language",
  "navigation.menu": "Menu",
  "navigation.menu.adminTools": "Admin tools",
  "navigation.menu.continue": "Pick up where you left off",
  "navigation.menu.explore": "Explore",
  "navigation.menu.forYou": "For you",
  "navigation.menu.heading": "Menu",
  "navigation.menu.more": "More",
  "navigation.menu.note.apiKeys": "keys for your agent",
  "navigation.menu.note.employerPortal": "your job ads",
  "navigation.menu.note.employers": "who's hiring now",
  "navigation.menu.note.feedback": "tell us what's missing",
  "navigation.menu.note.followed": "{count} followed",
  "navigation.menu.note.install": "add to your home screen",
  "navigation.menu.note.jobs": "all open roles",
  "navigation.menu.note.locations": "jobs by city",
  "navigation.menu.note.myJobsEmpty": "nothing saved yet",
  "navigation.menu.note.profileEmpty": "build your CV",
  "navigation.menu.note.profilePct": "{pct}% complete",
  "navigation.menu.note.remote": "work from anywhere",
  "navigation.menu.note.reset": "back to all jobs",
  "navigation.menu.note.resources": "guides and articles",
  "navigation.menu.note.roles": "jobs by title",
  "navigation.menu.note.salaries": "pay by role",
  "navigation.menu.note.searches": "saved searches",
  "navigation.menu.note.watchlistEmpty": "follow employers",
  "navigation.menu.open": "Open menu",
  "navigation.menu.searchPrompt": "Search {count} open jobs",
  "navigation.menu.searchSubmit": "Search",
  "navigation.menu.signInHint": "Keep saved jobs and alerts in sync across your devices.",
  "navigation.menu.translatorTools": "Translator tools",
  "navigation.menu.unit.hiring": "hiring",
  "navigation.menu.unit.open": "open",
  "navigation.menu.unit.remote": "remote",
  "navigation.mobileBottomBar.ariaLabel": "Mobile navigation",
  "navigation.search.reset": "Reset search",
  "notes.field.add": "Add note",
  "notes.field.placeholder": "Add a private note…",
  "numberSelector.any": "Any",
  "numberSelector.decrease": "Decrease",
  "numberSelector.increase": "Increase",
  "pagination.ariaLabel": "Job search results pagination",
  "pagination.first": "First",
  "pagination.keyboardShortcuts": "Keyboard shortcuts",
  "pagination.last": "Last",
  "pagination.next": "Next",
  "pagination.previous": "Previous",
  "postSignup.alertNudge.enabled": "You're set. We'll email you about new jobs matching your searches.",
  "postSignup.alertNudge.failed": "Couldn't turn on job alerts. You can enable them any time from the Alerts page.",
  "postSignup.alertNudge.offer": "Welcome to JobCrawls! Want an email when new jobs matching your interests appear?",
  "postSignup.alertNudge.pendingConfirmation": "Almost there: confirm your email in your inbox to activate alerts.",
  "postSignup.alertNudge.turnOn": "Turn on",
  "profile.account.delete.button": "Delete account",
  "profile.account.delete.cancel": "Cancel",
  "profile.account.delete.close": "Close",
  "profile.account.delete.confirm": "Delete account",
  "profile.account.delete.confirmBody": "This permanently deletes your account, saved jobs, searches, application kits, and CV. This cannot be undone.",
  "profile.account.delete.confirmTitle": "Delete your account?",
  "profile.account.delete.done": "Your account has been deleted. Signing you out…",
  "profile.account.delete.error": "Something went wrong. Please try again.",
  "profile.account.delete.working": "Deleting…",
  "profile.account.title": "Account",
  "profile.aiApply": "Apply",
  "profile.aiLoading": "Thinking…",
  "profile.aiSuggest": "Suggest with AI",
  "profile.aiSuggestionsDisclaimer": "These are AI-drafted starting points based only on your job titles and degrees — not verified facts about you. Read each one and edit it to match what's actually true before applying.",
  "profile.aiSuggestionsEmpty": "Your profile looks complete. Add more experience or leave some fields empty and try again.",
  "profile.aiSuggestionsTitle": "AI suggestions",
  "profile.applicationDetails.emailPlaceholder": "Email",
  "profile.applicationDetails.firstNamePlaceholder": "First name",
  "profile.applicationDetails.hint": "Used to fill in job application forms on your behalf. Only ever sent to the employer's own application form, once you review and confirm it.",
  "profile.applicationDetails.lastNamePlaceholder": "Last name",
  "profile.applicationDetails.phonePlaceholder": "Phone",
  "profile.applicationDetails.salaryExpectationPlaceholder": "Salary expectation (annual)",
  "profile.applicationDetails.sectionTitle": "Application details",
  "profile.applicationDetails.workAuthorization.euEeaCitizen": "EU/EEA citizen",
  "profile.applicationDetails.workAuthorization.finnishCitizen": "Finnish citizen",
  "profile.applicationDetails.workAuthorization.notAuthorized": "Not currently authorized to work here",
  "profile.applicationDetails.workAuthorization.permanentResident": "Permanent resident",
  "profile.applicationDetails.workAuthorization.placeholder": "Work authorization (optional)",
  "profile.applicationDetails.workAuthorization.requiresSponsorship": "Require visa sponsorship",
  "profile.applicationDetails.workAuthorization.validWorkPermit": "Have a valid work permit",
  "profile.applicationKits.link": "Application Kits",
  "profile.benefits.label": "Current benefits (for matching)",
  "profile.benefitsWeight": "Benefits Weight: {weight}%",
  "profile.closePreview": "Close preview",
  "profile.closeSuggestions": "Close",
  "profile.commuteMode.label": "I usually travel by",
  "profile.completion.allDone": "Your profile is ready to generate great CVs.",
  "profile.completion.fix": "Fix",
  "profile.completion.itemBasic": "Add your title or most recent role",
  "profile.completion.itemCurrentRole": "Add your current role details (for matching)",
  "profile.completion.itemEducation": "Add your education",
  "profile.completion.itemExperience": "Add your work experience",
  "profile.completion.itemSkills": "Add at least 3 skills",
  "profile.completion.label": "profile complete",
  "profile.currentJob.label": "Current role (for matching)",
  "profile.currentSalary.label": "Current salary, monthly (for matching)",
  "profile.currentSalary.placeholder": "e.g. 3500",
  "profile.currentSalary.privacyShort": "Private. Used only for your match score.",
  "profile.currentSalary.unit": "€/mo",
  "profile.currentSalary.workPercent": "work %",
  "profile.currentWorkModel.label": "Current work model (for matching)",
  "profile.cvDownloadFailed": "Failed to download your CV. Please try again.",
  "profile.cvDownloadFailed.retry": "Retry",
  "profile.cvExportPdfFailed": "Failed to export PDF. Please try again.",
  "profile.cvExportPdfFailed.retry": "Retry",
  "profile.cvImport.notConfigured": "CV import is not enabled for this environment.",
  "profile.cvUploadError": "Please upload a PDF file",
  "profile.cvUploadFailed": "Failed to upload CV. Please try again.",
  "profile.cvUploadSizeError": "File size must be less than 5MB",
  "profile.cvUploading": "Importing…",
  "profile.desiredBenefits": "Desired benefits",
  "profile.desiredIndustries": "Company Industries",
  "profile.desiredJob": "What you're looking for",
  "profile.desiredJobDescription": "Tell us what you're looking for. These preferences take priority over your current role when we score how well a job matches you.",
  "profile.desiredJobTypes": "Job Types",
  "profile.desiredLocations": "Locations",
  "profile.desiredRemoteness": "Remoteness Options",
  "profile.desiredRoleLevels": "Role Levels",
  "profile.desiredSalaryMin": "Minimum salary, monthly",
  "profile.desiredTitles": "Job Titles",
  "profile.desiredVacationWeeks": "Minimum vacation weeks",
  "profile.downloadCV": "Download my CV",
  "profile.europass.additionalInfo": "Additional information",
  "profile.europass.basedOn": "Based on Europass CV structure (europass.europa.eu)",
  "profile.europass.educationAndTraining": "Education and training",
  "profile.europass.noEducation": "No education added.",
  "profile.europass.noSkills": "No skills added.",
  "profile.europass.noWorkExperience": "No work experience added.",
  "profile.europass.personalSkills": "Personal skills",
  "profile.europass.workExperience": "Work experience",
  "profile.exportCV": "Export CV",
  "profile.homeAddress.hint": "Sets the default starting point for the job map's commute search, so you don't have to click the map every time. Optional, only visible to you, and only ever sent to Mapbox to look up the coordinates — never shared with employers.",
  "profile.homeAddress.placeholder": "Search an address…",
  "profile.homeAddress.remove": "Remove",
  "profile.homeAddress.sectionTitle": "Home address",
  "profile.jobType": "Job Type",
  "profile.jobTypeWeight": "Job Type Weight: {weight}%",
  "profile.languageSwitcher.hint": "Import, Upload, and Suggest with AI fill in whichever language tab is selected. Each version is independent — nothing is auto-translated.",
  "profile.languages.label": "Languages (professional level)",
  "profile.languagesWeight": "Languages Weight: {weight}%",
  "profile.linkedInImport.button": "Import from LinkedIn",
  "profile.linkedInImport.failed": "Could not import profile. Try again later.",
  "profile.linkedInImport.hint": "Paste your public profile URL (linkedin.com/in/…), then import. Data is fetched via Proxycurl (third-party) and may not include everything on your page. It fills in the form below, not your saved profile — read it over and fix anything before you save.",
  "profile.linkedInImport.invalidProfileUrl": "Use your personal profile link (linkedin.com/in/…).",
  "profile.linkedInImport.invalidUrl": "Enter a valid LinkedIn URL.",
  "profile.linkedInImport.loading": "Importing…",
  "profile.linkedInImport.networkError": "Network error. Check your connection.",
  "profile.linkedInImport.notConfigured": "LinkedIn import is not enabled for this environment.",
  "profile.linkedInImport.ownProfileOnlyWarning": "Only use this for your own LinkedIn profile — entering someone else's profile URL will fetch and display their personal data without their knowledge.",
  "profile.linkedInImport.placeholder": "https://www.linkedin.com/in/your-profile/",
  "profile.linkedInImport.sectionTitle": "LinkedIn profile",
  "profile.loading": "Loading...",
  "profile.locationWeight": "Location Weight: {weight}%",
  "profile.locations": "Locations",
  "profile.matchPreferences": "Match Preferences",
  "profile.matchPreferencesDescription": "Adjust the importance of different factors when calculating your job match score. The total must equal 100%.",
  "profile.prefillFromSearches.banner": "We filled in some fields from your recent job searches. Review them and adjust anything that looks off.",
  "profile.prefillFromSearches.dismiss": "Dismiss",
  "profile.preview": "Preview",
  "profile.previewEuropass": "CV preview (Europass format)",
  "profile.profilePhoto.errorCompressedTooLarge": "Image is still too large after compression. Try a smaller original.",
  "profile.profilePhoto.errorProcess": "Could not process this image. Try another file.",
  "profile.profilePhoto.errorTooLarge": "Image is too large (max 5 MB).",
  "profile.profilePhoto.errorType": "Use a JPEG, PNG, WebP, or GIF image.",
  "profile.profilePhoto.remove": "Remove uploaded photo",
  "profile.profilePhoto.uploadAria": "Upload or change profile photo",
  "profile.quickActions.title": "Your CV",
  "profile.remotenessWeight": "Remoteness Weight: {weight}%",
  "profile.roleLevel": "Role Level",
  "profile.roleLevelWeight": "Role Level Weight: {weight}%",
  "profile.salaryWeight": "Salary Weight: {weight}%",
  "profile.selectJobType": "Select job type",
  "profile.selectLocations": "Select locations",
  "profile.selectMultipleIndustries": "Select one or more industries",
  "profile.selectMultipleJobTypes": "Select one or more job types",
  "profile.selectMultipleLocations": "Select one or more locations",
  "profile.selectMultipleRemoteness": "Select one or more remoteness options",
  "profile.selectMultipleRoleLevels": "Select one or more role levels",
  "profile.selectMultipleTitles": "Select one or more job titles",
  "profile.selectRoleLevel": "Select your role level",
  "profile.title": "Job Title",
  "profile.titlePlaceholder": "e.g., Software Engineer",
  "profile.titleWeight": "Title Weight: {weight}%",
  "profile.totalWeight": "Total",
  "profile.uploadCV": "Upload CV to prefill",
  "profile.uploadCV.disclaimer": "AI-extracted from your PDF — it fills in the form below, not your saved profile. Read it over and fix anything before you save.",
  "profile.vacationWeeks.label": "Vacation weeks per year",
  "profile.vacationWeeks.unit": "weeks/year",
  "profile.vacationWeight": "Vacation Weight: {weight}%",
  "recentSearches.delete": "Remove",
  "recentSearches.noSearches": "You haven't saved any searches yet.",
  "role.follow.createAccount": "Create account",
  "role.follow.cta": "Watch role",
  "role.follow.emailPrompt.enabled": "You're set. New postings in roles you watch will be in your job-alert emails.",
  "role.follow.emailPrompt.failed": "Couldn't turn on email updates. You can enable them any time from the Alerts page.",
  "role.follow.emailPrompt.offer": "Watching {role}. Want an email when new postings appear?",
  "role.follow.emailPrompt.pendingConfirmation": "Almost there: confirm your email in your inbox to activate updates.",
  "role.follow.emailPrompt.turnOn": "Turn on",
  "role.follow.undo": "Undo",
  "role.follow.unwatchedToast": "Stopped watching. You won’t be notified of new postings for this role",
  "role.follow.watchedToast": "Watching {role}. New postings will show on your watchlist",
  "role.follow.watching": "Watching",
  "rolesIndex.breadcrumb": "Roles",
  "rolesIndex.floorNote": "Roles with only a handful of current listings are shown without a link until more open up.",
  "rolesIndex.lede": "{roles} roles, collected straight from employers' own sites and Työmarkkinatori. Every role has its own page with the live listings, salary data and the cities hiring most.",
  "rolesIndex.ledeWithCount": "{roles} roles and {jobs} open positions, collected straight from employers' own sites and Työmarkkinatori. Every role has its own page with the live listings, salary data and the cities hiring most.",
  "rolesIndex.title": "Open jobs by role",
  "salary.period.day": "/day",
  "salary.period.hour": "/hr",
  "salary.period.month": "/mo",
  "salary.period.year": "/yr",
  "salaryChart.allRolesInLocation": "All roles in {location}",
  "salaryChart.analysisTitle": "Salary analysis",
  "salaryChart.companyLocation": "Company in {location}",
  "salaryChart.estimatedFromMarket": "Estimated from market data (no pay in ad)",
  "salaryChart.fromJobAd": "From job ad",
  "salaryChart.fromJobAdWithLevel": "From job ad ({roleLevel})",
  "salaryChart.locationAverage": "In {location}: {title}",
  "salaryChart.marketAverage": "Market Average: {title}",
  "salaryChart.marketAverageRoleLevel": "Market Average: {roleLevel} Level",
  "salaryChart.payInDataNotInAd": "This job's pay range — not quoted in ad",
  "salaryChart.payInDataNotInAdWithLevel": "This job's pay range — not quoted in ad ({roleLevel})",
  "salaryChart.popover.average": "Average band",
  "salaryChart.popover.benchmarkEstimateNote": "Not from employer — modelled from benchmarks",
  "salaryChart.popover.dimension": "Dimension",
  "salaryChart.popover.extractedNoQuoteNote": "Numeric pay without quoted text in ad",
  "salaryChart.popover.fromAdText": "Grounded in job-ad salary wording",
  "salaryChart.popover.jobEstimatedRange": "Estimated range",
  "salaryChart.popover.jobListedRange": "Listed range",
  "salaryChart.popover.max": "Maximum",
  "salaryChart.popover.median": "Median band",
  "salaryChart.popover.min": "Minimum",
  "salaryChart.popover.monthlyNote": "All amounts are shown as EUR per month for comparison on this chart.",
  "salaryChart.popover.p25": "25th percentile",
  "salaryChart.popover.p75": "75th percentile",
  "salaryChart.popover.p90": "90th percentile",
  "salaryChart.popover.sample": "Sample size",
  "salaryChart.popover.seeFullSalaryPage": "See the full salary page for {title} →",
  "salaryChart.rangeAria": "Salary range from {min} to {max} per month, median near {median}",
  "salaryChart.salaryContext": "Salary Context: {title}",
  "salaryChart.segmentHint": "Hover or tap a row for full statistics (EUR / month on this chart).",
  "salaryChart.seoTable.caption": "Monthly salary comparison for {title}",
  "salaryChart.seoTable.lowerBound": "Lower bound (25th percentile)",
  "salaryChart.seoTable.market": "Market",
  "salaryChart.seoTable.median": "Median",
  "salaryChart.seoTable.upperBound": "Upper bound (75th percentile)",
  "salaryChart.thisRole": "this role",
  "salaryChart.thisRoleLevel": "this role level",
  "salaryChart.verifiedPayBanner": "Real pay, quoted by the employer — not an estimate",
  "salaryDisplayToggle.label": "Show original currency",
  "salaryIndexPage.allRolesHeading": "Browse all roles",
  "salaryIndexPage.empty": "No salary data is available right now — check back soon.",
  "salaryIndexPage.eyebrow": "{count} roles tracked",
  "salaryIndexPage.heading": "Salary Data by Role in Finland",
  "salaryIndexPage.intro": "Real salary data from Finnish job listings, broken down by role. Pick a role to see median pay, ranges, and city-by-city comparisons.",
  "salaryIndexPage.methodologyLink": "How we calculate these numbers",
  "salaryIndexPage.postingsSuffix": "postings",
  "salaryIndexPage.search.clear": "Clear search",
  "salaryIndexPage.search.label": "Search roles",
  "salaryIndexPage.search.noResults": "No roles match “{query}”. Try a different search term.",
  "salaryIndexPage.search.placeholder": "Search roles, e.g. \"nurse\" or \"carpenter\"…",
  "salaryIndexPage.search.resultsCount": "{shown, plural, one {# role} other {# roles}} found",
  "salaryIndexPage.searchResultsHeading": "Search results",
  "salaryIndexPage.stat.postings": "postings analyzed",
  "salaryIndexPage.stat.roles": "roles tracked",
  "salaryIndexPage.stat.topRole": "most-analyzed role",
  "salaryIndexPage.taxIcebergLink": "The tax iceberg calculator",
  "salaryIndexPage.topRolesHeading": "Most in-demand roles",
  "salaryIndexPage.topRolesSub": "Ranked by number of postings behind the salary estimate — more postings, more reliable numbers.",
  "salaryInsight.above": "This role's salary of <strong>{salary}</strong> is <strong>{percent}%</strong> above {benchmark}.",
  "salaryInsight.below": "This role's salary of <strong>{salary}</strong> is <strong>{percent}%</strong> below {benchmark}.",
  "salaryInsight.benchmark.finlandOnly": "the Finland-wide median in our salary data",
  "salaryInsight.benchmark.finlandWithRole": "the Finland-wide median for {role} roles",
  "salaryInsight.benchmark.locationOnly": "the median salary in {location}",
  "salaryInsight.benchmark.locationWithRole": "the median for {role} roles in {location}",
  "salaryMethodology.backToSalary": "Back to the salary guide",
  "salaryMethodology.breadcrumb.current": "Salary methodology",
  "salaryMethodology.breadcrumb.parent": "Salary guide",
  "salaryMethodology.byline": "Written by {author}",
  "salaryMethodology.intro": "Every salary figure on JobCrawls — medians, ranges, and per-role or per-city stats — goes through the same pipeline. Here is exactly what that pipeline does.",
  "salaryMethodology.limits.confidence": "Stats built from fewer than 10 postings are labelled as low-confidence — treat them as a rough guide, not a precise figure.",
  "salaryMethodology.limits.disclaimer": "Salary data is derived from published job listings and may not represent total compensation. Figures are in EUR/month and may include employer estimates where stated salary ranges are not publicly disclosed.",
  "salaryMethodology.limits.notVerified": "We do not independently verify what employers publish — figures reflect what listings state, not audited payroll data.",
  "salaryMethodology.limits.title": "Important limitations",
  "salaryMethodology.step1.body": "Our extraction pass pulls salary figures directly from the posting text. It is explicitly instructed not to guess a number from vague phrases like \"competitive salary\" — if the listing does not state a figure, we do not invent one here.",
  "salaryMethodology.step1.title": "We collect salaries stated in the listing",
  "salaryMethodology.step2.body": "When a listing has no stated salary, we estimate one from a credibility-weighted blend of comparable postings for the same title, location, role level, and company — weighted more heavily toward broader, larger samples when a narrow one is thin. Estimated figures are labelled as estimates wherever they appear next to a job listing, so you can always tell a stated salary from an inferred one.",
  "salaryMethodology.step2.title": "We estimate when nothing is stated — and flag it",
  "salaryMethodology.step3.body": "Listings state pay in different ways — hourly, monthly, annual — and periods are sometimes mislabeled. We convert every figure to monthly EUR and run a plausibility check (roughly €500–€30,000/month, with the top of a range no more than 5× the bottom) to catch placeholder or garbled data before it reaches any statistic.",
  "salaryMethodology.step3.title": "We normalize every figure to monthly EUR",
  "salaryMethodology.step4.body": "With fewer than 5 postings we apply no trimming — there is not enough data to safely discard anything. From 5–24 postings we trim using an interquartile-range check. At 25 or more postings we apply a stricter 10th–90th percentile trim before computing the median, mean, and percentiles.",
  "salaryMethodology.step4.title": "We trim outliers based on sample size",
  "salaryMethodology.step5.body": "A single unusual posting can otherwise set an entire published range. The low and high figures we show are the 10th percentile of minimums and the 90th percentile of maximums across the sample — not the single lowest or highest number we saw.",
  "salaryMethodology.step5.title": "The displayed range is not the raw min and max",
  "salaryMethodology.steps.heading": "The pipeline, step by step",
  "salaryMethodology.title": "How we compute salary statistics",
  "salaryRolePage.alsoKnownAs": "Also listed under: {titles}",
  "salaryRolePage.breadcrumb.salaryData": "Salary Data",
  "salaryRolePage.cityTable.footnote": "Bar shows P25–P75 band. Vertical line = median. All values in EUR/month.",
  "salaryRolePage.cityTable.title": "{roleTitle} Salary by City",
  "salaryRolePage.ctaBanner": "Looking for {roleTitle} roles? {link}",
  "salaryRolePage.ctaBanner.link": "Browse open positions on JobCrawls →",
  "salaryRolePage.disclaimer": "Salary data is derived from published job listings and may not represent total compensation. Figures are in EUR/month and may include employer estimates where stated salary ranges are not publicly disclosed.",
  "salaryRolePage.examplePostings.inactiveBadge": "No longer active",
  "salaryRolePage.examplePostings.title": "Based on postings like these",
  "salaryRolePage.heading": "{roleTitle} Salary in Finland",
  "salaryRolePage.hero.perMonthNational": "/ month, national median",
  "salaryRolePage.hero.sampleEyebrow": "Based on {count} postings",
  "salaryRolePage.hiringCompanies.browseAll": "Browse best employers in Finland →",
  "salaryRolePage.hiringCompanies.empty": "Browse all ranked employers to find one hiring for this kind of role.",
  "salaryRolePage.hiringCompanies.sub": "From our employer rankings — some may be worth reaching out to directly even without an open listing.",
  "salaryRolePage.hiringCompanies.title": "Companies hiring {roleTitle}s",
  "salaryRolePage.intro": "Based on job listing data from Finnish employers. Updated regularly.",
  "salaryRolePage.methodologyLink": "How we calculate these numbers",
  "salaryRolePage.overallPanel.footnote": "Monthly EUR · P25–P75 band with median marker · based on {count} job listings",
  "salaryRolePage.overallPanel.title": "{roleTitle} — Finland Average",
  "salaryRolePage.rangeBar.hint": "Tap or hover for details.",
  "salaryRolePage.rangeBar.popoverListings": "{count, plural, one {Based on # job listing} other {Based on # job listings}}",
  "salaryRolePage.remotePanel.title": "{roleTitle} — Remote Work in Finland",
  "salaryRolePage.seeOpenJobs": "See open {roleTitle} jobs →",
  "salaryRolePage.stat.average": "Average",
  "salaryRolePage.stat.median": "Median",
  "salaryRolePage.stat.middle50": "Middle 50%",
  "salaryRolePage.stat.p25": "P25",
  "salaryRolePage.stat.p75": "P75",
  "salaryRolePage.stat.p90": "P90",
  "salaryRolePage.stat.range": "Full range",
  "salaryRolePage.stat.sampleSize": "Sample size",
  "salaryRolePage.trend.down": "▼ {percent}% vs last month",
  "salaryRolePage.trend.flat": "No change vs last month",
  "salaryRolePage.trend.up": "▲ {percent}% vs last month",
  "salaryStats.aboveMarket": "This salary is above the market median",
  "salaryStats.accuracy.exact": "Based on similar roles at this company",
  "salaryStats.accuracy.general": "Based on market data",
  "salaryStats.accuracy.location": "Based on salaries in {location}",
  "salaryStats.atMarket": "This salary is competitive with the market median",
  "salaryStats.average": "Average",
  "salaryStats.belowMarket": "This salary is below the market median",
  "salaryStats.jobSalary": "This job",
  "salaryStats.marketRange": "Market range: {min} - {max} (median: {median})",
  "salaryStats.median": "Median",
  "salaryStats.noJobSalary": "No salary range provided for this job. Chart shows market distribution.",
  "salaryStats.noValidValues": "Salary statistics are available ({sampleSize} {samples}) but all values are zero. This may indicate the data needs to be regenerated.",
  "salaryStats.perDay": "per day",
  "salaryStats.perHour": "per hour",
  "salaryStats.perMonth": "per month",
  "salaryStats.perYear": "per year",
  "salaryStats.percentiles": "25th-75th percentile",
  "salaryStats.samples": "samples",
  "salaryStats.smallSampleWarning": "Note: Based on a small sample size ({sampleSize} {samples}). Results may not be representative.",
  "savedSearches.card.continue": "Continue",
  "savedSearches.card.dragAria": "Drag to reorder \"{title}\"",
  "savedSearches.card.moveDownAria": "Move \"{title}\" down",
  "savedSearches.card.moveUpAria": "Move \"{title}\" up",
  "savedSearches.card.selectAria": "Select \"{title}\"",
  "savedSearches.confirmRemove.bulkBody": "{count} saved searches and their alert settings will be removed.",
  "savedSearches.confirmRemove.bulkTitle": "Remove {count} searches?",
  "savedSearches.confirmRemove.cancel": "Cancel",
  "savedSearches.confirmRemove.close": "Close",
  "savedSearches.confirmRemove.confirm": "Remove",
  "savedSearches.confirmRemove.singleBody": "“{title}” and its saved alert settings will be removed.",
  "savedSearches.confirmRemove.singleTitle": "Remove this search?",
  "savedSearches.confirmRemove.working": "Removing…",
  "savedSearches.emptyHint": "Run a search with keywords or filters on the jobs page — it will show up here automatically. You can also pin one with “Save search”.",
  "savedSearches.folder.collapseToggle": "Toggle folder",
  "savedSearches.folder.count": "{count, plural, one {# search} other {# searches}}",
  "savedSearches.folder.delete": "Delete folder",
  "savedSearches.folder.menuAria": "Folder options",
  "savedSearches.folder.moveDown": "Move down",
  "savedSearches.folder.moveUp": "Move up",
  "savedSearches.folder.rename": "Rename",
  "savedSearches.folder.renameSave": "Save",
  "savedSearches.folder.sheetCancel": "Cancel",
  "savedSearches.folder.sheetClose": "Close",
  "savedSearches.folder.unsorted": "Unsorted",
  "savedSearches.newMatchesBadge": "{count} new",
  "savedSearches.noFilterResults": "No saved searches match “{filterText}”.",
  "savedSearches.openSearchAria": "Open search: {title}",
  "savedSearches.rename.action": "Name this search",
  "savedSearches.rename.placeholder": "e.g. Backend jobs in Helsinki",
  "savedSearches.rename.save": "Save",
  "savedSearches.summary.filtered": "Filtered search",
  "savedSearches.summary.location": "Location: {values}",
  "savedSearches.summary.page": "Page {page}",
  "savedSearches.summary.sortDate": "Sort: newest",
  "savedSearches.summary.sortSalary": "Sort: salary",
  "savedSearches.summary.worldwide": "All countries",
  "savedSearches.toolbar.cancelSelect": "Cancel",
  "savedSearches.toolbar.deleteSelected": "Delete",
  "savedSearches.toolbar.filterAria": "Filter saved searches",
  "savedSearches.toolbar.filterPlaceholder": "Filter your searches…",
  "savedSearches.toolbar.moveToFolder": "Move to folder",
  "savedSearches.toolbar.moveToNewFolder": "New folder…",
  "savedSearches.toolbar.moveToUnsorted": "Unsorted",
  "savedSearches.toolbar.newFolderButton": "New folder",
  "savedSearches.toolbar.newFolderPrompt": "Folder name",
  "savedSearches.toolbar.newFolderSave": "Create",
  "savedSearches.toolbar.selectAll": "Select all",
  "savedSearches.toolbar.selectButton": "Select",
  "savedSearches.toolbar.selectedCount": "{count, plural, one {# selected} other {# selected}}",
  "savedSearches.toolbar.sortAlphabetical": "A–Z",
  "savedSearches.toolbar.sortAria": "Sort saved searches",
  "savedSearches.toolbar.sortCustom": "Custom order",
  "savedSearches.toolbar.sortNewest": "Newest",
  "savedSearches.toolbar.sortSuggested": "Suggested",
  "search.bestCompaniesStrip.hubCta": "Companies hiring in Finland →",
  "search.bestCompaniesStrip.label": "Top employers",
  "search.controls.navigation": "Search controls and filters",
  "search.jobCount": "{count, number} jobs",
  "search.noresults.clearAllParameters": "Clear all search parameters",
  "search.noresults.description": "Try adjusting your search or filters to find more opportunities.",
  "search.noresults.filtersLabel": "Filters:",
  "search.noresults.goToFirstPage": "Go to page 1",
  "search.noresults.hybridJobs": "Hybrid jobs",
  "search.noresults.pageLabel": "Page:",
  "search.noresults.popularSearches": "Popular searches",
  "search.noresults.queryLabel": "Query:",
  "search.noresults.removeQuery": "Remove",
  "search.noresults.searchParameters": "Your Search Parameters",
  "search.noresults.searchTips": "Search Tips",
  "search.noresults.tip1": "Try using broader search terms or remove some filters",
  "search.noresults.tip2": "Check your spelling or try alternative keywords",
  "search.noresults.tip3": "Browse popular categories above to discover new opportunities",
  "search.noresults.title": "No results found",
  "search.noresults.unavailable.description": "Our job search is temporarily unavailable. Try refreshing the page, or check out these pages in the meantime.",
  "search.noresults.unavailable.exploreResources": "Read career resources",
  "search.noresults.unavailable.exploreSalary": "Explore salary data",
  "search.noresults.unavailable.linksLabel": "In the meantime",
  "search.noresults.unavailable.retry": "Try again",
  "search.noresults.unavailable.title": "We're having trouble loading jobs",
  "search.refinements.advancedFilters": "Advanced Filters",
  "search.refinements.advancedFilters.aria": "Advanced Filters",
  "search.refinements.allFilters.aria": "All Filters",
  "search.refinements.benefits.label": "Benefits",
  "search.refinements.clearAll": "Clear all ({count})",
  "search.refinements.company": "Company",
  "search.refinements.company.label": "Company",
  "search.refinements.company.openProfileAria": "Open company profile for {company}{count, plural, =0 {} other {, {count} open roles on JobCrawls}}",
  "search.refinements.company.searchPlaceholder": "Search companies...",
  "search.refinements.educationLevel.detail": "Education Level",
  "search.refinements.educationLevel.label": "Education Level",
  "search.refinements.excludeApplied.label": "Exclude Applied Jobs",
  "search.refinements.excludeConsultingCompany.filter": "Hide Consulting Company Postings",
  "search.refinements.excludeFreelance.filter": "Hide Freelance Postings",
  "search.refinements.excludeJobs": "Exclude Jobs",
  "search.refinements.excludeRecruitmentCompany.filter": "Hide Recruitment Agency Postings",
  "search.refinements.excludeSaved.label": "Exclude Saved Jobs",
  "search.refinements.excludeViewed.label": "Exclude Viewed Jobs",
  "search.refinements.field.label": "Field",
  "search.refinements.headcount.chip": "Up to {count} employees",
  "search.refinements.headcount.max": "Max Headcount",
  "search.refinements.industry.label": "Industry",
  "search.refinements.isDriversLicenseRequired.filter": "Driver's Licence Required",
  "search.refinements.isOpenApplication.filter": "Open Application",
  "search.refinements.job": "Job",
  "search.refinements.jobTitle": "Job Title",
  "search.refinements.jobType.label": "Job Type",
  "search.refinements.languages.label": "Languages",
  "search.refinements.lastSeen.all": "All",
  "search.refinements.lastSeen.aria": "Date posted",
  "search.refinements.lastSeen.past1Month": "Past 1 month",
  "search.refinements.lastSeen.past1Week": "Past 1 week",
  "search.refinements.lastSeen.past24Hours": "Past 24 hours",
  "search.refinements.lastSeen.past2Weeks": "Past 2 weeks",
  "search.refinements.lastSeen.past3Days": "Past 3 days",
  "search.refinements.lastSeen.past6Hours": "Past 6 hours",
  "search.refinements.location": "Location",
  "search.refinements.location.searchPlaceholder": "Search locations...",
  "search.refinements.peopleManagementTier.label": "People Management Tier",
  "search.refinements.posted.section": "Posted",
  "search.refinements.quickFilter.salary": "€{amount}+",
  "search.refinements.quickFilter.thisWeek": "This week",
  "search.refinements.quickFilters.heading": "Quick filters",
  "search.refinements.regionTags.breadcrumb.root": "All Locations",
  "search.refinements.regionTags.drillIn": "Browse {value}",
  "search.refinements.regionTags.finlandQuickChip": "Finland",
  "search.refinements.regionTags.group.continent": "Continents",
  "search.refinements.regionTags.group.country": "Countries",
  "search.refinements.regionTags.group.finland": "Finland",
  "search.refinements.regionTags.group.recruitingRegion": "Regions",
  "search.refinements.regionTags.label": "Region",
  "search.refinements.regionTags.remoteCountLabel": "{value} remote",
  "search.refinements.regionTags.showBeyondFinland": "Show locations outside Finland",
  "search.refinements.remoteness.heading": "Remoteness",
  "search.refinements.roleLevel.label": "Role Level",
  "search.refinements.salary": "Salary",
  "search.refinements.salary.min": "Minimum Salary",
  "search.refinements.search.placeholder": "Search...",
  "search.refinements.showJobsInFinlandOnly": "Show jobs in Finland only",
  "search.refinements.showLess": "Show less",
  "search.refinements.showMore": "Show more",
  "search.refinements.showResults": "Show {count} results",
  "search.refinements.showResultsNoCount": "Show results",
  "search.refinements.skillsAndTechnologies.label": "Skills & Technologies",
  "search.refinements.sort.section": "Sort",
  "search.refinements.vacationWeeks": "Vacation Weeks",
  "search.refinements.vacationWeeks.chip": "{count}+ vacation weeks",
  "search.results.title": "Job Search Results",
  "search.resultsPerPage.aria": "Results per page",
  "search.resultsPerPage.optionLabel": "{count} per page",
  "search.signInCta.benefit1": "Save jobs to review later",
  "search.signInCta.benefit2": "Track every application in one board",
  "search.signInCta.benefit3": "Get alerted the moment new roles match",
  "search.signInCta.button": "Create free account",
  "search.signInCta.secondaryText": "Already have an account? Sign in",
  "search.signInCta.title": "Never lose track of a job again",
  "search.topRolesStrip.hubCta": "Salary data for Finland roles →",
  "search.topRolesStrip.label": "In-demand roles",
  "search.view.ariaLabel": "View",
  "sort.ariaLabel": "Sort results",
  "sort.newest": "Newest",
  "sort.relevance": "Relevance",
  "sort.salary": "Salary",
  "srpAlertCta.bannerText": "Stop checking back. We'll email you when new jobs like this are posted.",
  "srpAlertCta.ctaButton": "Get email alerts",
  "srpAlertCta.dismissLabel": "Dismiss",
  "srpAlertCta.errorText": "Something went wrong. We couldn't turn on alerts. Please try again.",
  "srpAlertCta.manageLink": "Manage alerts",
  "srpAlertCta.pendingText": "Almost there: check your inbox to confirm your email and activate alerts.",
  "srpAlertCta.subText": "Free weekly or daily digest. Unsubscribe anytime.",
  "srpAlertCta.successText": "You're set. We'll email you about jobs like this.",
  "stats.appliedJobs": "{count} applied jobs",
  "stats.finlandJobsSubtitle": "Jobs available in Finnish or remotely to Finnish residents",
  "stats.newThisWeekInline": "· {count, number} new this week",
  "stats.savedJobs": "{count} saved jobs",
  "stats.viewedJobs": "{count} viewed jobs",
  "tags.field.addTrigger": "Add tag",
  "tags.field.placeholder": "Tag and press Enter…",
  "tags.field.remove": "Remove tag {tag}",
  "taxIceberg.accuracyNote": "Checked against Veronmaksajat's {year} wage-earner table: within €1 at 15 income levels from €20,000 to €200,000.",
  "taxIceberg.advanced.group.deductions": "Deductions",
  "taxIceberg.advanced.group.employer": "Employer",
  "taxIceberg.advanced.group.otherIncome": "Other income",
  "taxIceberg.advanced.group.person": "About you",
  "taxIceberg.advanced.group.picture": "Picture",
  "taxIceberg.advanced.toggle": "Advanced options: deductions, other income, employer, family",
  "taxIceberg.agents.body": "Every salary has its own page: {urlTemplate}, with the options above as query parameters (municipality, employer, vat, church, age, children, sole, union, commuting, dividends, gains, own, assets). The same result as JSON: {apiUrl}. AI assistants can call the {tool} tool on the JobCrawls MCP connector ({connectorUrl}).",
  "taxIceberg.agents.heading": "For AI assistants and developers",
  "taxIceberg.amounts.perMonth": "All amounts per month",
  "taxIceberg.amounts.perYear": "All amounts per year",
  "taxIceberg.backToSalary": "Back to the salary guide",
  "taxIceberg.breadcrumb.current": "Tax iceberg",
  "taxIceberg.breadcrumb.parent": "Salary guide",
  "taxIceberg.breakdown.capitalGross": "Dividends and capital gains",
  "taxIceberg.breakdown.capitalTax": "Capital income tax",
  "taxIceberg.breakdown.gross": "Gross salary",
  "taxIceberg.breakdown.heading": "Full breakdown",
  "taxIceberg.breakdown.investmentsKeep": "You keep from dividends and gains",
  "taxIceberg.breakdown.investmentsTax": "Tax on dividends and gains",
  "taxIceberg.breakdown.netPay": "Net pay",
  "taxIceberg.breakdown.totalIn": "Everything that comes in before tax",
  "taxIceberg.breakdown.trueCost": "True cost to employer (gross + employer contributions)",
  "taxIceberg.byline": "Written by {author}",
  "taxIceberg.compare.add": "Compare with another salary",
  "taxIceberg.compare.hint": "Icebergs are drawn to the same scale, so you can compare them directly.",
  "taxIceberg.compare.remove": "Remove this salary from the comparison",
  "taxIceberg.copyLink": "Copy link",
  "taxIceberg.copyLink.copied": "Copied",
  "taxIceberg.destinations.averageMunicipality": "the average municipality",
  "taxIceberg.destinations.employmentFund": "Employment Fund",
  "taxIceberg.destinations.employmentFund.desc": "Unemployment insurance contributions: earnings-related unemployment allowance, adult education allowance, pension accrual during unemployment.",
  "taxIceberg.destinations.heading": "Where the money goes",
  "taxIceberg.destinations.insurers": "Insurers",
  "taxIceberg.destinations.insurers.desc": "The employer's accident and group life insurance premiums.",
  "taxIceberg.destinations.intro": "Every euro below the waterline has one recipient by law. Open the municipality and the state to see what they spend it on.",
  "taxIceberg.destinations.kela": "Kela health insurance",
  "taxIceberg.destinations.kela.desc": "Medical-care and daily-allowance contributions and the employer's health insurance contribution: sickness and parental allowances, reimbursements for medicines and private doctors.",
  "taxIceberg.destinations.legend": "Dark part of a bar: withheld from your pay. Light part: paid by your employer on top. The municipal and state splits follow their published spending (municipal accounts 2025, state budget 2026); they are proportional, not earmarked.",
  "taxIceberg.destinations.muni.administrationOther": "Administration and other",
  "taxIceberg.destinations.muni.basicEducation": "Basic education (comprehensive school)",
  "taxIceberg.destinations.muni.cultureSport": "Culture, libraries, sport and youth",
  "taxIceberg.destinations.muni.earlyChildhood": "Early childhood and pre-primary education",
  "taxIceberg.destinations.muni.employmentBusiness": "Employment services and business development",
  "taxIceberg.destinations.muni.streetsParksPlanning": "Streets, parks, planning, housing and rescue",
  "taxIceberg.destinations.muni.upperSecondary": "Upper secondary and vocational education",
  "taxIceberg.destinations.municipality": "Your municipality ({name})",
  "taxIceberg.destinations.municipality.desc": "Municipal income tax, spent by {name} on its own services.",
  "taxIceberg.destinations.parish": "Your parish",
  "taxIceberg.destinations.parish.desc": "Church tax to the Evangelical Lutheran parish of your municipality.",
  "taxIceberg.destinations.pensions": "Earnings-related pensions",
  "taxIceberg.destinations.pensions.desc": "Your and your employer's TyEL contributions, paid to pension insurers: they fund today's pensions and build your own pension record.",
  "taxIceberg.destinations.state": "The state",
  "taxIceberg.destinations.state.administrationOther": "Administration and other",
  "taxIceberg.destinations.state.agriculture": "Agriculture and forestry",
  "taxIceberg.destinations.state.debtInterest": "Interest on state debt",
  "taxIceberg.destinations.state.defence": "Defence",
  "taxIceberg.destinations.state.desc": "State income tax{vat}, spent through the {year} state budget.",
  "taxIceberg.destinations.state.education": "Education, science and culture",
  "taxIceberg.destinations.state.employmentEconomy": "Employment and the economy",
  "taxIceberg.destinations.state.environment": "Environment",
  "taxIceberg.destinations.state.eu": "EU membership contributions",
  "taxIceberg.destinations.state.foreignAffairs": "Foreign affairs and development aid",
  "taxIceberg.destinations.state.healthSocialCounties": "Health and social care (wellbeing services counties)",
  "taxIceberg.destinations.state.municipalGrants": "State grants to municipalities",
  "taxIceberg.destinations.state.securityJustice": "Police, rescue, border and justice",
  "taxIceberg.destinations.state.socialSecurity": "Social security: Kela benefits and state pensions",
  "taxIceberg.destinations.state.transport": "Transport and communications",
  "taxIceberg.destinations.state.vat": "and VAT",
  "taxIceberg.destinations.total": "{total} {period} in taxes and contributions",
  "taxIceberg.destinations.yle": "Yle",
  "taxIceberg.destinations.yle.desc": "The Yle tax funds public broadcasting.",
  "taxIceberg.detail.capital.unlistedLight": "Own-company dividend within the 8% yield: {light} taxed on 25%",
  "taxIceberg.detail.capital.unlistedSplit": "Own-company dividend: {light} lightly taxed (25%), {heavy} at 85%",
  "taxIceberg.detail.employee.capitalTax": "Capital income tax on dividends and gains: {amount}",
  "taxIceberg.detail.employee.church": "Church tax: {amount}",
  "taxIceberg.detail.employee.commutingDeducted": "Commuting deduction applied: {amount}",
  "taxIceberg.detail.employee.credit": "Earned-income tax credit: {amount}",
  "taxIceberg.detail.employee.dailyAllowance": "Daily allowance contribution: {amount}",
  "taxIceberg.detail.employee.medical": "Medical care contribution: {amount}",
  "taxIceberg.detail.employee.municipal": "Municipal tax ({rate}): {amount}",
  "taxIceberg.detail.employee.pension": "Your pension contribution: {amount}",
  "taxIceberg.detail.employee.state": "State income tax: {amount}",
  "taxIceberg.detail.employee.unemployment": "Your unemployment insurance: {amount}",
  "taxIceberg.detail.employee.unionDeducted": "Union fees deducted from taxable income: {amount}",
  "taxIceberg.detail.employee.unlistedEarned": "Own-company dividend beyond the 8% yield, taxed as earned income: {amount}",
  "taxIceberg.detail.employee.yle": "Yle tax: {amount}",
  "taxIceberg.detail.employer.accident": "Accident & group life insurance: {amount}",
  "taxIceberg.detail.employer.health": "Health insurance contribution: {amount}",
  "taxIceberg.detail.employer.tyel": "Pension (TyEL) {rate}: {amount}",
  "taxIceberg.detail.employer.unemployment": "Unemployment insurance: {amount}",
  "taxIceberg.detail.investments.gains": "Capital gains: {amount} (taxable in full)",
  "taxIceberg.detail.investments.gross": "Dividends and gains before tax: {amount}",
  "taxIceberg.detail.investments.listed": "Dividends from listed companies: {amount} (85% taxable)",
  "taxIceberg.detail.investments.minusTax": "minus tax on them: {amount}",
  "taxIceberg.detail.investments.own": "Dividends from your own company: {amount}",
  "taxIceberg.detail.net.minusVat": "minus VAT paid when you spend it: {amount}",
  "taxIceberg.detail.net.payslip": "Net pay on your payslip: {amount}",
  "taxIceberg.detail.net.shareOfGross": "{share} of your gross salary",
  "taxIceberg.detail.share": "{share} of what it costs to employ you",
  "taxIceberg.detail.share.investments": "{share} of your dividends and gains",
  "taxIceberg.detail.vat.assumption": "Assumes {share} of net pay is spent, taxed at a blended VAT rate of {rate}",
  "taxIceberg.detail.vat.basis": "Spending patterns from Statistics Finland by income level",
  "taxIceberg.genericEstimateNote.both": "Using the national-average municipal tax rate ({rate}) and a blended unemployment-insurance rate. Pick a municipality and employer payroll size above for a more precise figure.",
  "taxIceberg.genericEstimateNote.employerSize": "Using a blended unemployment-insurance rate. Pick your employer's payroll size above for a more precise figure.",
  "taxIceberg.genericEstimateNote.municipal": "Using the national-average municipal tax rate ({rate}). Pick your municipality above for a more precise figure.",
  "taxIceberg.headlineStat": "It costs {trueEmployerCost} to employ you, but you only get to keep {netAfterVat} of it once tax and VAT are both counted.",
  "taxIceberg.headlineStat.noVat": "It costs {trueEmployerCost} to employ you, but you only get to keep {netAfterVat} of it after tax.",
  "taxIceberg.headlineStat.withCapital": "Your salary and investments add up to {total} before tax, but you only get to keep {netAfterVat} once tax and VAT are both counted.",
  "taxIceberg.headlineStat.withCapital.noVat": "Your salary and investments add up to {total} before tax, but you only get to keep {netAfterVat} after tax.",
  "taxIceberg.iceberg.title.month": "{amount} / month",
  "taxIceberg.iceberg.title.year": "{amount} / year",
  "taxIceberg.input.advancedOptions.toggle": "Advanced options (municipality, employer size)",
  "taxIceberg.input.age.hint": "Pension and unemployment contributions depend on it",
  "taxIceberg.input.age.label": "Age (affects pension and unemployment contributions)",
  "taxIceberg.input.age.placeholder": "Working age",
  "taxIceberg.input.age.short": "Age",
  "taxIceberg.input.capitalGains.hint": "Taxable in full as capital income",
  "taxIceberg.input.capitalGains.label": "Capital gains (net of purchase price)",
  "taxIceberg.input.children.hint": "Raises the earned-income credit",
  "taxIceberg.input.children.label": "Minor children (raises the earned-income credit)",
  "taxIceberg.input.children.short": "Minor children",
  "taxIceberg.input.church.hint": "Adds church tax of about {rate}",
  "taxIceberg.input.church.label": "Church member (church tax about {rate})",
  "taxIceberg.input.church.short": "Church member",
  "taxIceberg.input.commuting.hint": "Deductible above {ownLiability}, up to {max} a year",
  "taxIceberg.input.commuting.label": "Commuting costs (deductible above {ownLiability}, up to {max} a year)",
  "taxIceberg.input.commuting.short": "Commuting costs",
  "taxIceberg.input.detail.full": "Every tax",
  "taxIceberg.input.detail.hint": "Show one band per tax and contribution",
  "taxIceberg.input.detail.label": "Iceberg strata",
  "taxIceberg.input.detail.simple": "Four layers",
  "taxIceberg.input.dividends.hint": "85% taxable as capital income",
  "taxIceberg.input.dividends.label": "Dividends from listed companies",
  "taxIceberg.input.employerSize.hint": "Sets the unemployment-insurance rate",
  "taxIceberg.input.employerSize.label": "Employer's total payroll (affects unemployment insurance rate)",
  "taxIceberg.input.employerSize.large": "Over €2.5M/year",
  "taxIceberg.input.employerSize.short": "Employer's total payroll",
  "taxIceberg.input.employerSize.small": "Under €2.5M/year",
  "taxIceberg.input.employerSize.unknown": "Not sure",
  "taxIceberg.input.municipality.label": "Municipality (for municipal tax rate)",
  "taxIceberg.input.municipality.placeholder": "National average",
  "taxIceberg.input.netAssets.hint": "Optional; empty assumes the dividend stays within the 8% yield",
  "taxIceberg.input.netAssets.label": "Your share of the company's net assets",
  "taxIceberg.input.option.no": "No",
  "taxIceberg.input.option.yes": "Yes",
  "taxIceberg.input.otherIncome.hint": "Taxed as capital income at {lower} up to {threshold} and {upper} above; no employer cost. Your own company must first pay its 20% corporate tax, which is not shown here.",
  "taxIceberg.input.period.month": "Month",
  "taxIceberg.input.period.year": "Year",
  "taxIceberg.input.salary.label": "Gross salary",
  "taxIceberg.input.salary.modeLabel": "Enter a gross salary or a target net",
  "taxIceberg.input.salary.modeNet": "Net salary (target)",
  "taxIceberg.input.salary.presetGross": "{amount} gross",
  "taxIceberg.input.salary.presetNet": "{amount} net",
  "taxIceberg.input.salary.presets": "Pick a common salary",
  "taxIceberg.input.soleGuardian.hint": "Doubles the per-child credit",
  "taxIceberg.input.soleGuardian.label": "Sole guardian",
  "taxIceberg.input.unionFees.hint": "Deducted in full from earned income",
  "taxIceberg.input.unionFees.label": "Union and unemployment fund fees",
  "taxIceberg.input.unit.month": "/ month",
  "taxIceberg.input.unit.year": "/ year",
  "taxIceberg.input.unlistedDividends.hint": "Unlisted: 25% taxable up to {cap} a year within an 8% yield",
  "taxIceberg.input.unlistedDividends.label": "Dividends from your own company",
  "taxIceberg.input.vat.hint": "Adds the VAT you pay when you spend your net pay",
  "taxIceberg.input.vat.label": "Count VAT on what you spend",
  "taxIceberg.intro": "Your payslip shows one number. What employing you really costs, and what you keep after tax and contributions, sit below the waterline. Enter a gross salary to see your own iceberg.",
  "taxIceberg.investments.stat": "Your dividends and capital gains add {gross}, of which you keep {net}.",
  "taxIceberg.investments.title": "Dividends & capital gains",
  "taxIceberg.keepRateStat": "You keep {rate} of what it actually costs to employ you.",
  "taxIceberg.keepRateStat.total": "You keep {rate} of everything that comes in.",
  "taxIceberg.layer.capitalTax": "Capital income tax",
  "taxIceberg.layer.church": "Church tax",
  "taxIceberg.layer.employeeDailyAllowance": "Daily allowance contribution",
  "taxIceberg.layer.employeePension": "Your pension contribution",
  "taxIceberg.layer.employeeTax": "Your income tax & contributions",
  "taxIceberg.layer.employeeUnemployment": "Your unemployment insurance",
  "taxIceberg.layer.employerAccident": "Accident and group life insurance",
  "taxIceberg.layer.employerContributions": "Employer contributions",
  "taxIceberg.layer.employerHealth": "Employer's health insurance",
  "taxIceberg.layer.employerTyel": "Employer pension (TyEL)",
  "taxIceberg.layer.employerUnemployment": "Employer's unemployment insurance",
  "taxIceberg.layer.investmentEarnedTax": "Income tax on own-company dividend",
  "taxIceberg.layer.investmentTax": "Tax on dividends & gains",
  "taxIceberg.layer.medicalCare": "Medical care contribution",
  "taxIceberg.layer.municipalTax": "Municipal tax",
  "taxIceberg.layer.netAfterVat": "What you actually keep",
  "taxIceberg.layer.stateTax": "State income tax",
  "taxIceberg.layer.vat": "VAT when you spend it",
  "taxIceberg.layer.yle": "Yle tax",
  "taxIceberg.methodology.capital": "Dividends and capital gains: taxed as capital income at {lower} up to {threshold} of taxable capital income and {upper} above (Verohallinto, 2026). Dividends from listed companies are 85% taxable and 15% exempt. Dividends from an unlisted company you own: up to an 8% yield on your share of its net assets, 25% is taxable capital income for the first {cap} a year and 85% above that; the part beyond the 8% yield is 75% taxable earned income. The company's own 20% corporate tax, capital-income deductions and loss carry-forwards are not modelled.",
  "taxIceberg.methodology.deductions": "Deductions: union and unemployment-fund fees are deducted in full from earned income; commuting costs are deductible above the {ownLiability} own-liability share up to {max} a year (Verohallinto, 2026). Church tax uses the Evangelical Lutheran parish rate of the chosen municipality (Verohallinto, 2026 decision), or the {churchRate} national average when none is chosen.",
  "taxIceberg.methodology.destinations": "Where the money goes: each contribution and tax is attributed to its recipient by law (pension insurers, the Employment Fund, Kela, the municipality, the state, the parish, Yle, insurers). The municipal euro is then split by what the chosen municipality spent on each task in 2025 (net operating costs, Kuntaliitto from Valtiokonttori data; national average when no municipality is chosen), and the state euro by the 2026 state budget regrouped by purpose, with the wellbeing services counties, municipal grants, EU contributions and state pensions separated out of the Ministry of Finance class. Those splits are proportional attributions, not earmarks.",
  "taxIceberg.methodology.employeeTax": "Income tax, municipal tax, church tax, Yle tax, employee pension and unemployment insurance, and the earned-income tax credit: computed per Verohallinto's (Finnish Tax Administration) 2026 withholding basis and Finlex's 2026 tax scale act.",
  "taxIceberg.methodology.employerAccident": "Occupational accident and group life insurance ({accidentRate} combined, industry average): Tapaturmavakuutuskeskus (TVK) annual forecast. Actual employer rates vary by industry risk class and cannot be personalized without knowing the specific employer.",
  "taxIceberg.methodology.employerOther": "Employer unemployment insurance ({unemploymentLow}–{unemploymentHigh}, tiered by payroll size) and health insurance contribution ({healthInsurance}): Työllisyysrahasto and Verohallinto, 2026 rates.",
  "taxIceberg.methodology.employerTyel": "Employer pension contribution (TyEL), {tyelRate}: Eläketurvakeskus (Finnish Centre for Pensions), 2026 contribution rates. This rate became flat across all ages in the 2026 reform; before 2026 it was banded by employee age.",
  "taxIceberg.methodology.heading": "Sources & methodology",
  "taxIceberg.methodology.intro": "Every figure below traces to a named, checkable source. Nothing here is estimated without saying so.",
  "taxIceberg.methodology.limitations": "This is an estimate, not tax advice: it assumes standard deductions, full-year residence, and no fringe benefits, and the VAT figure assumes typical spending patterns for your income level rather than your actual receipts.",
  "taxIceberg.methodology.municipal": "Municipal tax rates for all 308 reporting municipalities: Suomen Kuntaliitto (Association of Finnish Municipalities), official 2026 rate table, sourced from Verohallinto.",
  "taxIceberg.methodology.vat": "VAT rates: Verohallinto (25.5% standard, 13.5% reduced for food/restaurants/books/medicine/transport/accommodation as of 2026). How much of your income is actually spent (versus saved) at each income level: Statistics Finland's Household Consumption Survey, 2022, the most recent wave, broken down by income quintile — the finest breakdown Statistics Finland publishes.",
  "taxIceberg.methodology.vatInterpolation": "The 5 quintile data points are real survey data; the smooth curve between them is our own interpolation, not raw Statistics Finland output.",
  "taxIceberg.netModeStat": "For {net} in hand you need {gross} gross.",
  "taxIceberg.perMonthWord": "a month",
  "taxIceberg.perYearWord": "a year",
  "taxIceberg.popularNets": "Or start from what you want in hand",
  "taxIceberg.popularNets.link": "{amount} net",
  "taxIceberg.popularSalaries": "See the iceberg for other salaries",
  "taxIceberg.popularSalaries.link": "{amount} / month",
  "taxIceberg.raise.employer": "It costs your employer {cost} more.",
  "taxIceberg.raise.heading": "What would a raise leave you?",
  "taxIceberg.raise.result": "A {raise} raise leaves you {gain} more {period}: you keep {kept} of it.",
  "taxIceberg.raise.sliderLabel": "Raise amount",
  "taxIceberg.resetOptions": "Reset options",
  "taxIceberg.roles.all": "All roles with salary data",
  "taxIceberg.roles.heading": "Roles that pay about {amount} a month",
  "taxIceberg.roles.intro": "National medians from disclosed salary ranges in live postings. Open a role for its range, cities and current openings.",
  "taxIceberg.roles.postings": "{count, plural, one {# posting} other {# postings}}",
  "taxIceberg.share": "Share",
  "taxIceberg.share.email": "Send by email",
  "taxIceberg.share.linkedin": "Share on LinkedIn",
  "taxIceberg.share.menuLabel": "Share this iceberg",
  "taxIceberg.share.whatsapp": "Share on WhatsApp",
  "taxIceberg.share.x": "Share on X",
  "taxIceberg.sources.heading": "Sources",
  "taxIceberg.summary.capital": "Dividends and capital gains: {amount}",
  "taxIceberg.summary.delta": "vs. the first salary: {deltaGross} gross, {deltaKept} kept",
  "taxIceberg.summary.gross": "Gross salary: {amount}",
  "taxIceberg.summary.investmentsKeep": "You keep {amount} ({rate} of it)",
  "taxIceberg.summary.investmentsTax": "Tax on it: {amount}",
  "taxIceberg.summary.keep": "You keep {amount} ({rate} of the true cost)",
  "taxIceberg.summary.trueCost": "True cost to employer: {amount}",
  "taxIceberg.taxCard.backTax": "At {card} your card withholds about {amountYear} a year too little ({amountMonth} a month): expect back taxes.",
  "taxIceberg.taxCard.barCard": "Your tax card",
  "taxIceberg.taxCard.barSalary": "Tax on this salary",
  "taxIceberg.taxCard.extra": "Additional rate",
  "taxIceberg.taxCard.extraHint": "Above the limit",
  "taxIceberg.taxCard.heading": "Is your tax card right?",
  "taxIceberg.taxCard.intro": "The income tax on this salary comes to {actual} of gross. Compare that with the withholding rate printed on your tax card.",
  "taxIceberg.taxCard.limit": "Income limit",
  "taxIceberg.taxCard.limitHint": "€ per year, optional",
  "taxIceberg.taxCard.limitToggle": "My card has an income limit",
  "taxIceberg.taxCard.note": "Withholding covers taxes only; pension and unemployment contributions are deducted separately. Only the standard deductions are counted, so a card that includes your own deductions can be lower on purpose.",
  "taxIceberg.taxCard.onTarget": "At {card} your card matches this salary: the difference is under €60 a year.",
  "taxIceberg.taxCard.rate": "Rate on your tax card",
  "taxIceberg.taxCard.refund": "At {card} your card withholds about {amountYear} a year too much ({amountMonth} a month): expect a refund.",
  "taxIceberg.taxCard.where": "In OmaVero it is the base rate (perusprosentti) on your tax card.",
  "taxIceberg.taxRateStat": "Your tax rate on this salary: {rate} (with pension and unemployment contributions: {total})",
  "taxIceberg.taxYearNote": "Calculated with the {year} tax rules",
  "taxIceberg.title": "The tax iceberg: what your salary really costs, and what you actually keep",
  "taxIceberg.toolbar.employerSize": "Employer's payroll",
  "taxIceberg.toolbar.municipality": "Municipality",
  "taxIceberg.vatField.label": "VAT",
  "taxIceberg.visual.ariaLabel": "Tax icebergs floating in the sea in front of Helsinki. The visible tip is the pay you actually keep; the much larger mass below the waterline is tax and contributions.",
  "test.greeting": "Hello",
  "tools.applicationKits.cvBadge": "CV ready",
  "tools.applicationKits.deleteKit": "Delete",
  "tools.applicationKits.downloadCv": "Download CV",
  "tools.applicationKits.downloadLetter": "Download letter",
  "tools.applicationKits.emptyBody": "Tailor a CV or draft a cover letter from any job page — it'll be saved here automatically.",
  "tools.applicationKits.emptyTitle": "No application kits yet",
  "tools.applicationKits.kitReadyBadge": "Application kit ready",
  "tools.applicationKits.lead": "Your tailored CVs and cover letters, saved per job — reopen, review, or download anytime.",
  "tools.applicationKits.letterBadge": "Letter ready",
  "tools.applicationKits.openJob": "Open job page",
  "tools.applicationKits.title": "Application Kits",
  "tools.applicationKits.updatedOn": "Updated {date}",
  "tools.applicationState.applied": "Applied",
  "tools.applicationState.hidden": "Hidden",
  "tools.applicationState.label": "State:",
  "tools.applicationState.updated": "State updated to {state}",
  "tools.empty.browseJobs": "Browse jobs →",
  "tools.exportApplied.button": "Export applications for reporting",
  "tools.exportApplied.buttonHint": "Get a list of your applications — employer, position, date — to use when reporting your job search, e.g. to TE services.",
  "tools.exportApplied.close": "Close",
  "tools.exportApplied.colDateApplied": "Date applied",
  "tools.exportApplied.colEmployer": "Employer",
  "tools.exportApplied.colLink": "Link",
  "tools.exportApplied.colMethod": "Method",
  "tools.exportApplied.colPosition": "Position",
  "tools.exportApplied.description": "A ready-to-copy list of what you applied to and when — keep this open while you fill out your report, or download it as a spreadsheet.",
  "tools.exportApplied.downloadCsv": "Download CSV",
  "tools.exportApplied.empty": "No applications in this date range yet.",
  "tools.exportApplied.from": "From",
  "tools.exportApplied.methodExternal": "Other application (your link)",
  "tools.exportApplied.methodListing": "Job listing",
  "tools.exportApplied.rowCount": "{count, plural, one {# application} other {# applications}}",
  "tools.exportApplied.title": "Export your applications",
  "tools.exportApplied.to": "To",
  "tools.exportApplied.viewLink": "Open",
  "tools.externalApplication.add": "Add to applied",
  "tools.externalApplication.adding": "Adding…",
  "tools.externalApplication.closeModal": "Close",
  "tools.externalApplication.error.disallowedScheme": "Only http and https links are allowed.",
  "tools.externalApplication.error.empty": "Enter a link to the job or application page.",
  "tools.externalApplication.error.invalid": "That does not look like a valid URL.",
  "tools.externalApplication.error.syncFailed": "Could not save. Check your connection or try signing in.",
  "tools.externalApplication.error.tooLong": "That link is too long.",
  "tools.externalApplication.lead": "Paste a link to a job you applied to on another site. It appears with your other applications on this page.",
  "tools.externalApplication.title": "Track an application elsewhere",
  "tools.externalApplication.titleLabel": "Title (optional)",
  "tools.externalApplication.urlLabel": "Job link",
  "tools.externalApplication.urlPlaceholder": "https://…",
  "tools.history.emptyHidden": "You haven't hidden any jobs.",
  "tools.history.emptyViewed": "You have not viewed any jobs yet.",
  "tools.history.hiddenTab": "Hidden ({count})",
  "tools.history.resetViewed": "Reset viewed jobs",
  "tools.history.showMore": "Show more",
  "tools.history.viewedTab": "Viewed ({count})",
  "tools.historySummary.counts": "Viewed {viewedCount} · Hidden {hiddenCount}",
  "tools.historySummary.heading": "History",
  "tools.historySummary.openDrawer": "Open drawer",
  "tools.jobFlowSankey.activityChartHeading": "Activity",
  "tools.jobFlowSankey.applied": "Applied",
  "tools.jobFlowSankey.browsed": "Browsed",
  "tools.jobFlowSankey.conversionSummary": "{interviewRate}% reached interview · {offerRate}% got an offer",
  "tools.jobFlowSankey.emptyState": "Not enough data to display your activity yet. View, save, or apply to jobs to see your journey visualized!",
  "tools.jobFlowSankey.hideActivityChart": "Hide activity chart",
  "tools.jobFlowSankey.hired": "Hired",
  "tools.jobFlowSankey.interviewing": "Interviewing",
  "tools.jobFlowSankey.offer": "Offer",
  "tools.jobFlowSankey.rejected": "Rejected",
  "tools.jobFlowSankey.saved": "Saved",
  "tools.jobFlowSankey.showActivityChart": "Show activity chart",
  "tools.jobFlowSankey.summary": "Browsed {browsed} → Viewed {viewed} → Saved {saved} → Applied {applied}",
  "tools.jobFlowSankey.tooltip.hint.applied": "You applied or tracked these as submitted applications.",
  "tools.jobFlowSankey.tooltip.hint.browsed": "Roles you opened from search — the start of your funnel.",
  "tools.jobFlowSankey.tooltip.hint.hired": "Marked hired — great outcome.",
  "tools.jobFlowSankey.tooltip.hint.interviewing": "Currently in the interview process.",
  "tools.jobFlowSankey.tooltip.hint.offer": "Offer stage — negotiation or decision time.",
  "tools.jobFlowSankey.tooltip.hint.rejected": "Marked closed or not moving forward.",
  "tools.jobFlowSankey.tooltip.hint.saved": "Saved for later — easy to come back and apply.",
  "tools.jobFlowSankey.tooltip.hint.viewed": "You opened these listings but have not saved them yet.",
  "tools.jobFlowSankey.tooltip.link.pathCount": "{count, plural, one {# job} other {# jobs}} on this path",
  "tools.jobFlowSankey.tooltip.link.pctFrom": "{pct}% of flow leaving {fromName}",
  "tools.jobFlowSankey.tooltip.link.pctTo": "{pct}% of flow into {toName}",
  "tools.jobFlowSankey.tooltip.link.splitBrowsedApplied": "{direct} from browse without save · {external} from elsewhere",
  "tools.jobFlowSankey.tooltip.node.beyondBrowse": "Includes applications not counted in browse (e.g. off-site).",
  "tools.jobFlowSankey.tooltip.node.jobCount": "{count, plural, one {# job} other {# jobs}}",
  "tools.jobFlowSankey.tooltip.node.pctApplied": "{pct}% of your applications",
  "tools.jobFlowSankey.tooltip.node.pctBrowsed": "{pct}% of listings you browsed",
  "tools.jobFlowSankey.viewed": "Viewed",
  "tools.kanban.addExternalApplication": "Add off-site application",
  "tools.kanban.cancelSelectMode": "Cancel",
  "tools.kanban.chip.appliedAgo": "Applied {relativeAge}",
  "tools.kanban.column.applied": "Applied",
  "tools.kanban.column.collapse": "Collapse {column} column",
  "tools.kanban.column.expand": "Expand {column} column",
  "tools.kanban.column.hired": "Hired",
  "tools.kanban.column.interviewing": "Interviewing",
  "tools.kanban.column.offer": "Offer",
  "tools.kanban.column.rejected": "Rejected",
  "tools.kanban.column.saved": "Saved",
  "tools.kanban.companyFilterAll": "All companies",
  "tools.kanban.companyFilterLabel": "Filter by company",
  "tools.kanban.confirmRemove.appliedBody": "“{jobTitle}” will leave your application board. You can apply again from search later.",
  "tools.kanban.confirmRemove.appliedTitle": "Remove from applications?",
  "tools.kanban.confirmRemove.cancel": "Cancel",
  "tools.kanban.confirmRemove.close": "Close",
  "tools.kanban.confirmRemove.confirm": "Remove",
  "tools.kanban.confirmRemove.savedBody": "“{jobTitle}” will be removed from saved jobs.",
  "tools.kanban.confirmRemove.savedTitle": "Remove from saved?",
  "tools.kanban.confirmRemove.working": "Removing…",
  "tools.kanban.deadlineChip": "Closes in {days, plural, one {# day} other {# days}}",
  "tools.kanban.dragHandle": "Drag to move to another column or position",
  "tools.kanban.dragHandleGroup": "Drag to move this whole group to another column or position",
  "tools.kanban.emptyBoard": "No saved or applied jobs yet. Add an off-site application with the button above, or save and apply to jobs from search.",
  "tools.kanban.emptyColumn": "None yet",
  "tools.kanban.groupMixedHeading": "{count} applications",
  "tools.kanban.groupMixedSavedHeading": "{count} saved",
  "tools.kanban.hideInactive": "Hide no longer active jobs",
  "tools.kanban.keepLooking": "Keep looking →",
  "tools.kanban.loadingApplications": "Loading your applications…",
  "tools.kanban.mobile.cancel": "Cancel",
  "tools.kanban.mobile.close": "Close",
  "tools.kanban.mobile.companyFilterAll": "All companies",
  "tools.kanban.mobile.companyFilterLabel": "Filter by company",
  "tools.kanban.mobile.emptyTab": "No applications in {stage}.",
  "tools.kanban.mobile.move": "Move",
  "tools.kanban.mobile.moveTo": "Move to",
  "tools.kanban.mobile.searchPlaceholder": "Search company or role",
  "tools.kanban.mobile.searchToggle": "Search applications",
  "tools.kanban.mobile.sortCompanyAsc": "Company (A–Z)",
  "tools.kanban.mobile.sortDateAsc": "Oldest first",
  "tools.kanban.mobile.sortDateDesc": "Newest first",
  "tools.kanban.mobile.sortLabel": "Sort by",
  "tools.kanban.mobile.sortTitleAsc": "Job title (A–Z)",
  "tools.kanban.mobile.tabAll": "All",
  "tools.kanban.mobile.viewJob": "View job posting",
  "tools.kanban.moveSelectedTo": "Move to…",
  "tools.kanban.removeFailed": "Could not update. Try again.",
  "tools.kanban.removeFailed.retry": "Retry",
  "tools.kanban.removeIcon.applied": "Remove from applications",
  "tools.kanban.removeIcon.saved": "Remove from saved jobs",
  "tools.kanban.removeSelected": "Remove",
  "tools.kanban.savedJob.expired": "No longer active",
  "tools.kanban.savedJob.findSimilar": "Find similar →",
  "tools.kanban.searchLabel": "Search",
  "tools.kanban.searchPlaceholder": "Search company or role",
  "tools.kanban.selectCard": "Select {title}",
  "tools.kanban.selectMode": "Select",
  "tools.kanban.selectedCount": "{count, plural, one {# selected} other {# selected}}",
  "tools.kanban.sortCompanyAsc": "Company (A–Z)",
  "tools.kanban.sortDateAsc": "Oldest first",
  "tools.kanban.sortDateDesc": "Newest first",
  "tools.kanban.sortLabel": "Sort by",
  "tools.kanban.sortTitleAsc": "Job title (A–Z)",
  "tools.kanban.staleChip": "Follow up? {days, plural, one {# day} other {# days}} since applying",
  "tools.kanban.title": "Applications by stage",
  "tools.kanban.untitledJob": "Untitled job",
  "tools.savedJobs.tailorCvAction": "Tailor CV",
  "tooltip.allFilters": "Open all filters to refine your job search by location, salary, work type, and more",
  "tooltip.view.list": "Switch to list view to see jobs in a compact list format",
  "tooltip.view.map": "Switch to map view to see job locations on a map",
  "usermenu.account": "Account",
  "usermenu.apiKeys": "AI agent search",
  "usermenu.installPwa": "Install App",
  "usermenu.logout": "Log Out",
  "usermenu.profile": "My Profile",
  "usermenu.theme": "Theme",
  "usermenu.theme.auto": "Auto",
  "usermenu.theme.dark": "Dark",
  "usermenu.theme.light": "Light",
  "usermenu.translationInspector": "Translation inspector",
  "usermenu.translationInspectorGuide": "How to use the translation inspector",
  "view.list": "List view",
  "view.map": "Map view",
  "watchlist.company.closedRoles": "{count, plural, one {# role you saw is no longer open} other {# roles you saw are no longer open}}",
  "watchlist.company.dataUnavailable": "Company data isn't available right now.",
  "watchlist.company.employerScore": "employer score",
  "watchlist.company.hiringActivity": "Hiring activity",
  "watchlist.company.hiringPace": "Posted {count} jobs this month — about {multiple}× their usual pace",
  "watchlist.company.hiringTrend.declining": "Declining",
  "watchlist.company.hiringTrend.growing": "Growing",
  "watchlist.company.hiringTrend.stable": "Stable",
  "watchlist.company.newRolesBadge": "+{count} new",
  "watchlist.company.newSinceLastVisit": "New since your last visit",
  "watchlist.company.openRoles": "open roles",
  "watchlist.company.roleMatch": "{score}% match",
  "watchlist.company.scoreGradeDropped": "Employer grade dropped to {tier} since your last visit",
  "watchlist.company.scoreGradeImproved": "Employer grade improved to {tier} since your last visit",
  "watchlist.company.similarEmpty": "Couldn't find similar companies right now.",
  "watchlist.company.similarTrigger": "Similar companies",
  "watchlist.company.sparklineLabel": "Job postings per month, last {months} months",
  "watchlist.compare.company": "Company",
  "watchlist.compare.exportCsv": "Export CSV",
  "watchlist.compare.flexibility": "Flexibility",
  "watchlist.compare.jobsPerMonth": "Jobs/mo",
  "watchlist.compare.newBadge": "+{count} new",
  "watchlist.compare.openRoles": "Open roles",
  "watchlist.compare.pay": "Pay",
  "watchlist.compare.remote": "Remote",
  "watchlist.compare.salary": "Median salary €/mo",
  "watchlist.compare.score": "Score",
  "watchlist.compare.share": "Share",
  "watchlist.compare.shareCopied": "Link copied. Anyone with it can view this comparison",
  "watchlist.compare.stability": "Stability",
  "watchlist.compare.topRoles": "Mostly hiring",
  "watchlist.empty.body": "Follow a company from its profile page to track new roles, employer score, and hiring trend here.",
  "watchlist.empty.browse": "Browse top companies →",
  "watchlist.empty.title": "You aren't following any companies yet.",
  "watchlist.filter.all": "All",
  "watchlist.filter.noMatches": "No followed companies have this tag yet.",
  "watchlist.relationshipTag.inConversation": "In conversation",
  "watchlist.relationshipTag.interested": "Interested",
  "watchlist.relationshipTag.reachedOut": "Reached out",
  "watchlist.roles.heading": "Roles you watch",
  "watchlist.roles.newBadge": "+{count} new",
  "watchlist.roles.newSinceLastVisit": "New since your last visit",
  "watchlist.roles.openCount": "{count, plural, one {# open job} other {# open jobs}}",
  "watchlist.roles.unwatch": "Stop watching",
  "watchlist.sharedCompare.banner": "You're viewing a comparison someone shared with you — not your own watchlist.",
  "watchlist.sharedCompare.cta": "Start your own watchlist →",
  "watchlist.sharedCompare.empty": "This shared comparison doesn't have any companies to show.",
  "watchlist.sharedCompare.loading": "Loading the shared comparison…",
  "watchlist.suggestions.heading": "Companies you might want to watch",
  "watchlist.suggestions.reasonIndustry": "Similar to companies you follow",
  "watchlist.suggestions.reasonIndustryScoreDiff": "Scores {delta} points higher than your average follow",
  "watchlist.suggestions.reasonSavedJobs": "{count, plural, one {You saved # of their jobs} other {You saved # of their jobs}}",
  "watchlist.suggestions.reasonTopRated": "Top-rated employer",
  "watchlist.thresholdAlert.add": "Add alert",
  "watchlist.thresholdAlert.cancel": "Cancel",
  "watchlist.thresholdAlert.condition.above": "rises above",
  "watchlist.thresholdAlert.condition.below": "drops below",
  "watchlist.thresholdAlert.metric.employerScore": "Employer score",
  "watchlist.thresholdAlert.metric.openRoles": "Open roles",
  "watchlist.thresholdAlert.remove": "Remove alert",
  "watchlist.thresholdAlert.save": "Save alert",
  "watchlist.thresholdAlert.summaryAbove": "{metric} above {value}",
  "watchlist.thresholdAlert.summaryBelow": "{metric} below {value}",
  "watchlist.view.cards": "Cards",
  "watchlist.view.compare": "Compare",
  "translation.test": "Translation Test: English"
};

const messages_sv = {
  ...messages_en, // Use English as fallback
  "aboutEmployerScore.backToRankings": "Tillbaka till Företag",
  "aboutEmployerScore.breadcrumb.current": "Arbetsgivarens poäng",
  "aboutEmployerScore.breadcrumb.parent": "Företag",
  "aboutEmployerScore.intro": "JobCrawls Employer Score betygsätter arbetsgivare på en bokstavsskala, från A ner till E, som härleds från mönster vi konsekvent kan mäta i platsannonser. Syftet är att lyfta fram arbetsgivare som kommunicerar tydligt, strukturerar ersättningar rättvist och annonserar flexibla, kandidatvänliga roller, inte att ersätta dina egna intervjuer och undersökningar.",
  "aboutEmployerScore.limits.changes": "Vikter och signaler kan komma att ändras i takt med att vi förbättrar detekteringen; vårt mål är att hålla metodiken riktningsmässigt stabil.",
  "aboutEmployerScore.limits.listings": "Poängen återspeglar vad arbetsgivare publicerar i de annonser vi indexerar – inte interna HR-policyer som vi inte har insyn i.",
  "aboutEmployerScore.limits.notEndorsement": "En högre poäng är inte en rekommendation, en kvalitetsgaranti eller juridisk/finansiell rådgivning.",
  "aboutEmployerScore.limits.title": "Viktiga begränsningar",
  "aboutEmployerScore.pillar.benefits.body": "Vi räknar hur många olika förmåner och personalförmåner (t.ex. sjukvårdsförsäkring, pensionstillägg, utrustningsbudget) arbetsgivare nämner i sina annonser, samt semester utöver Finlands lagstadgade minimum.",
  "aboutEmployerScore.pillar.benefits.title": "Förmåner och personalförmåner",
  "aboutEmployerScore.pillar.flex.body": "Alternativ för distans- och hybridarbete poängsätts utifrån hur konsekvent arbetsgivare annonserar flexibla arbetsmodeller i sina öppna roller.",
  "aboutEmployerScore.pillar.flex.title": "Flexibilitet (distans / hybrid)",
  "aboutEmployerScore.pillar.growth.body": "När platsannonser inkluderar senioritetsstruktur och tecken på karriärutveckling, tolkar vi det som starkare interna tillväxtvägar.",
  "aboutEmployerScore.pillar.growth.title": "Tillväxtsignaler",
  "aboutEmployerScore.pillar.pay.body": "När vi har tillräckligt många annonser med strukturerade löneintervall, bedömer vi hur konkurrenskraftigt det typiska spannet är jämfört med den finländska arbetsmarknaden.",
  "aboutEmployerScore.pillar.pay.title": "Lön (publicerade löneintervall)",
  "aboutEmployerScore.pillar.stability.body": "Vi tittar på kontinuiteten i rekryteringen över tid – arbetsgivare som upprätthåller jämna, stabila rekryteringsmönster får högre poäng än those med ett kaotiskt publiceringsbeteende.",
  "aboutEmployerScore.pillar.stability.title": "Rekryteringsstabilitet",
  "aboutEmployerScore.pillar.transparency.body": "Vi följer hur ofta annonser anger en verklig, icke uppskattad lön i stället för en vag formulering som \"konkurrenskraftig lön\", samt hur ofta de beskriver en rekryteringsprocess som kandidater kan förvänta sig.",
  "aboutEmployerScore.pillar.transparency.title": "Transparens",
  "aboutEmployerScore.pillars.title": "Vad som ingår i poängen",
  "aboutEmployerScore.tierExplainer": "Vi visar ett betyg i stället för en exakt siffra med flit: arbetsgivare nära varandra ska inte framstå som mer olika än den underliggande signalen faktiskt stöder. Betyg, från starkast till svagast: A, B, C, D, E.",
  "aboutEmployerScore.title": "Hur Employer Score fungerar",
  "apiKeys.settings.alreadyConnectedBody": "Du har redan skapat en anslutningsnyckel. Vi visar hela nyckeln bara en gång, så om du behöver se den igen, till exempel för att koppla en ny enhet, skapar du en ny nedan. Din befintliga anslutning fortsätter att fungera ändå.",
  "apiKeys.settings.alreadyConnectedHeading": "Du är redan ansluten",
  "apiKeys.settings.authHeaderLabel": "Värde för Authorization-rubriken",
  "apiKeys.settings.autoKeyLabel": "AI-agent",
  "apiKeys.settings.breadcrumbSeeker": "AI-sökning",
  "apiKeys.settings.claudeCodeBody": "Om ditt Claude-konto inte har Request headers än, eller om du hellre använder terminalen, kör det här i stället:",
  "apiKeys.settings.claudeCodeHeading": "Eller använd Claude Code",
  "apiKeys.settings.claudeHeading": "Anslut Claude",
  "apiKeys.settings.claudeStep1": "Öppna Claude och gå till Customize, sedan Connectors (i en Team- eller Enterprise-arbetsyta använder du Organization settings i stället för Customize), sedan Add custom connector.",
  "apiKeys.settings.claudeStep2": "Klistra in serveradressen nedan i anslutningens URL-fält.",
  "apiKeys.settings.claudeStep3": "Ställ in Authentication till None.",
  "apiKeys.settings.claudeStep4": "Lägg till en rubrik med namnet Authorization under Request headers och ange värdet nedan. Anthropic rullar fortfarande ut den här funktionen, så den syns inte i alla konton än. Om du inte ser den kan du använda Claude Code i stället.",
  "apiKeys.settings.claudeStep5": "Spara och prova sedan att be Claude om något i stil med: \"Hitta jobb inom mjukvaruutveckling på distans i Helsingfors.\"",
  "apiKeys.settings.claudeStep5Generic": "Spara och prova sedan att be Claude använda ett av verktygen som den här anslutningen erbjuder.",
  "apiKeys.settings.copiedButton": "Kopierat",
  "apiKeys.settings.copyButton": "Kopiera",
  "apiKeys.settings.createButton": "Skapa nyckel",
  "apiKeys.settings.createHeading": "Skapa en ny nyckel",
  "apiKeys.settings.createdLabel": "Skapad {date}",
  "apiKeys.settings.creatingButton": "Skapar…",
  "apiKeys.settings.doneButton": "Klart",
  "apiKeys.settings.emptyState": "Du har inte skapat några nycklar än.",
  "apiKeys.settings.existingHeading": "Dina nycklar",
  "apiKeys.settings.generateNewButton": "Skapa en ny nyckel",
  "apiKeys.settings.generatingButton": "Skapar…",
  "apiKeys.settings.labelFieldLabel": "Namnge den här nyckeln",
  "apiKeys.settings.labelFieldPlaceholder": "t.ex. Claude Desktop",
  "apiKeys.settings.lastUsedLabel": "Senast använd {date}",
  "apiKeys.settings.manageKeysToggle": "Hantera nycklar",
  "apiKeys.settings.neverUsedLabel": "Aldrig använd",
  "apiKeys.settings.newKeyHeading": "Din nya nyckel",
  "apiKeys.settings.newKeyWarning": "Kopiera den här nu. Du kommer inte att kunna se den igen.",
  "apiKeys.settings.noEmployerAccess": "Ditt konto har ännu ingen arbetsgivaråtkomst. Skriv till {email} så ordnar vi det.",
  "apiKeys.settings.otherAgentsBody": "De flesta agenter som stöder MCP över HTTP frågar efter en serveradress och låter dig lägga till en anpassad rubrik i förfrågan. Använd samma serveradress och Authorization-rubrik som ovan. ChatGPTs anslutningsinställningar stöder inte den här typen av nyckel än, så det går inte att använda där för tillfället.",
  "apiKeys.settings.otherAgentsHeading": "Andra AI-agenter",
  "apiKeys.settings.revokeButton": "Återkalla",
  "apiKeys.settings.revokeConfirm": "Återkalla den här nyckeln? Allt som använder den slutar fungera omedelbart.",
  "apiKeys.settings.revokedLabel": "Återkallad {date}",
  "apiKeys.settings.serverUrlLabel": "Serveradress",
  "apiKeys.settings.setupHint": "Skapa en nyckel nedan, så visar vi steg för steg hur du tar den i bruk.",
  "apiKeys.settings.subtitleEmployer": "Anslut Claude eller en annan MCP-klient för att hantera {companyName}s jobb och karriärsida.",
  "apiKeys.settings.subtitleInternal": "Anslut Claude eller en annan MCP-klient till JobCrawls interna dataverktyg.",
  "apiKeys.settings.subtitleSeeker": "Anslut JobCrawls till Claude eller en annan AI-agent så att den kan söka riktiga lediga jobb i Finland åt dig.",
  "apiKeys.settings.title": "API-nycklar",
  "apiKeys.settings.titleSeeker": "JobCrawls-sökning i din AI-agent",
  "applyAutofill.applyManually": "Ansök i stället på arbetsgivarens webbplats",
  "applyAutofill.coverLetterLabel": "Personligt brev (valfritt)",
  "applyAutofill.email": "E-post",
  "applyAutofill.failedGeneric": "Vi kunde inte slutföra att skicka in den här ansökan automatiskt.",
  "applyAutofill.firstName": "Förnamn",
  "applyAutofill.lastName": "Efternamn",
  "applyAutofill.no": "Nej",
  "applyAutofill.nothingSentYet": "Inget har skickats till arbetsgivaren ännu.",
  "applyAutofill.pageTitle": "Granska din ansökan",
  "applyAutofill.phone": "Telefon",
  "applyAutofill.polling": "Skickar din ansökan nu, det kan ta en minut…",
  "applyAutofill.preparing": "Förbereder din ansökan…",
  "applyAutofill.regenerate": "Generera på nytt",
  "applyAutofill.resumeAttached": "resume.pdf bifogas",
  "applyAutofill.submitTo": "Skicka till {company}",
  "applyAutofill.submitting": "Skickar…",
  "applyAutofill.success": "Ansökan skickad.",
  "applyAutofill.viewInTracker": "Visa i din ansökningsöversikt",
  "applyAutofill.yes": "Ja",
  "auth.signInPrompt.closeLabel": "Stäng",
  "auth.signInPrompt.description": "Skapa ett gratis konto för att spara jobb, synkronisera dina framsteg och fortsätta ditt sökande på vilken enhet som helst.",
  "auth.signInPrompt.primaryAction": "Skapa konto",
  "auth.signInPrompt.secondaryAction": "Kanske senare",
  "auth.signInPrompt.title": "Logga in för att spara jobb",
  "autocomplete.filters": "Matchande filter",
  "autocomplete.noMatches": "Inga matchande filter hittades",
  "autocomplete.scrollHint": "Scrolla för fler",
  "backoffice.architecture": "Arkitektur",
  "backoffice.dashboard": "Instrumentpanel",
  "backoffice.dataExplorer.nav": "Datautforskare",
  "backoffice.dataExplorer.title": "Datautforskare",
  "backoffice.emailAlerts.nav": "E-postaviseringar",
  "backoffice.hub.nav": "Alla verktyg",
  "backoffice.hub.open": "Öppna",
  "backoffice.hub.subtitle": "Välj ett verktyg att öppna. Åtkomst är begränsad till behöriga konton.",
  "backoffice.jobDataExplorer.nav": "Jobbdata-API",
  "backoffice.mcpKeys.nav": "API-nycklar",
  "backoffice.nav.jumpToTool": "Gå till backoffice-verktyg",
  "backoffice.nav.jumpToToolPlaceholder": "Välj ett verktyg…",
  "backoffice.testing": "Testning",
  "backoffice.userAgents.description": "Övervakning på en enda skärm: kartcentrerad, uppdaterar automatiskt senaste minuten vid laddning. Justera tidsintervall och filter, fördjupa dig sedan i tabellen.",
  "backoffice.userAgents.hours": "Titta tillbaka",
  "backoffice.userAgents.mapboxTokenMissing": "Kartvyn kräver en Mapbox-åtkomsttoken (PUBLIC_ENV__MAPBOX_ACCESS_TOKEN).",
  "backoffice.userAgents.nav": "Användaragenter",
  "backoffice.userAgents.noData": "Inga poster för user agents under detta tidsintervall.",
  "backoffice.userAgents.run": "Uppdatera",
  "backoffice.userAgents.title": "Instrumentpanel för crawlning och trafik",
  "bestCompanies.breadcrumb.current": "Arbetsgivare",
  "bestCompanies.breadcrumb.hub": "Företag",
  "bestCompanies.dimension.backToHub": "← Alla arbetsgivarrankningar",
  "bestCompanies.dimension.empty": "Inga arbetsgivare hittades för det här filtret ännu. Titta igen efter nästa indexkörning.",
  "bestCompanies.dimension.introPrefix": "Mest aktiv rekrytering först. Varje arbetsgivare har också sin",
  "bestCompanies.dimension.introSuffix": ", beräknad utifrån lönetransparens, distansflexibilitet, rekryteringsstabilitet och förmåner i annonser riktade till den finländska arbetsmarknaden (inklusive många distansjobb). Inte omdömen.",
  "bestCompanies.dimension.title": "Arbetsgivare som rekryterar i {label}",
  "bestCompanies.hub.agenciesHidden": "Rekryteringsbyråer dolda",
  "bestCompanies.hub.azHeading": "Alla arbetsgivare från A till Ö",
  "bestCompanies.hub.browseAzChip": "Alla arbetsgivare från A till Ö",
  "bestCompanies.hub.browseCity": "Arbetsgivare per stad",
  "bestCompanies.hub.browseLabel": "Bläddra",
  "bestCompanies.hub.chip.all": "Alla",
  "bestCompanies.hub.chip.growing": "Växande",
  "bestCompanies.hub.chip.hiringMyRole": "Rekryterar till min roll",
  "bestCompanies.hub.chip.nearHelsinki": "Nära Helsingfors",
  "bestCompanies.hub.chip.pays5k": "Lön €5 000+",
  "bestCompanies.hub.clearSearch": "Rensa sökning",
  "bestCompanies.hub.filteredCount": "{count, plural, one {# matchande arbetsgivare} other {# matchande arbetsgivare}}",
  "bestCompanies.hub.heroLede": "Lönespann, distansandel, rekryteringstakt och trend för varje arbetsgivare vi bevakar. Följ en arbetsgivare, så kollar vi deras karriärsida dagligen och säger till när en roll dyker upp.",
  "bestCompanies.hub.hiringNowCount": "· {count} rekryterar nu",
  "bestCompanies.hub.loadingMoreMatches": "letar efter fler matchningar…",
  "bestCompanies.hub.matchCount": "{count, plural, one {# träff} other {# träffar}}",
  "bestCompanies.hub.moreWaysToBrowse": "Fler sätt att bläddra",
  "bestCompanies.hub.networkWorthyFilter": "Publicerar sällan",
  "bestCompanies.hub.noMatches": "Inga företag matchar dina filter. Prova att rensa ett filter eller sök på ett annat namn.",
  "bestCompanies.hub.overallEmpty": "Arbetsgivare är inte tillgängliga just nu. Försök igen senare.",
  "bestCompanies.hub.remoteFriendlyFilter": "Distansvänliga",
  "bestCompanies.hub.resultsCount": "{count, plural, one {# arbetsgivare} other {# arbetsgivare}}",
  "bestCompanies.hub.searchPlaceholder": "Sök arbetsgivare på namn, bransch eller yrke…",
  "bestCompanies.hub.showMore": "Visa fler",
  "bestCompanies.hub.showingCount": "Visar {shown}",
  "bestCompanies.hub.showingOfTotal": "Visar {shown} av {total}",
  "bestCompanies.hub.sort.hiring": "Rekryteringstakt",
  "bestCompanies.hub.sort.pay": "Lön",
  "bestCompanies.hub.sort.score": "Arbetsgivarpoäng",
  "bestCompanies.hub.sortLabel": "Sortera efter",
  "bestCompanies.hub.title": "Arbetsgivare i Finland",
  "bestCompanies.hub.watchlistStrip.following": "Följer <b>{count}</b>",
  "bestCompanies.hub.watchlistStrip.newThisWeek": "<b>{count} nya</b> roller den här veckan",
  "bestCompanies.hub.watchlistStrip.open": "Öppna Mina jobb →",
  "bestCompanies.row.hiringPace": "~{count} nya roller/mån",
  "bestCompanies.row.networkWorthy": "Värt att nätverka med",
  "bestCompanies.row.perMonth": "{range}/mån",
  "bestCompanies.row.remoteHybridPercent": "{percent}% distans/hybrid",
  "bestCompanies.row.remotePercent": "{percent}% distans",
  "bestCompaniesCard.employees": "{range} anställda",
  "bestCompaniesCard.hiresLabel": "Anställer",
  "bestCompaniesCard.noOpenRoles": "inga lediga jobb just nu",
  "bestCompaniesCard.noPayBands": "Inget angivet lönespann",
  "bestCompaniesCard.openRoles": "{count, plural, one {# ledigt jobb} other {# lediga jobb}}",
  "bestCompaniesCard.pace": "~{count} / mån",
  "bestCompaniesCard.payBandRange": "€{min}–{max}<small>/mån</small>",
  "bestCompaniesCard.payBandSingle": "€{amount}<small>/mån</small>",
  "bestCompaniesCard.rarelyPostsPublicly": "Publicerar sällan",
  "bestCompaniesCard.remoteOrHybridPercent": "{percent}% distans eller hybrid",
  "bestCompaniesCard.remotePercent": "{percent}% distans",
  "bestCompaniesCard.scoreCaption": "Arbetsgivarpoäng",
  "bestCompaniesCard.trendDeclining": "Minskande ↘",
  "bestCompaniesCard.trendGrowing": "Växande ↗",
  "bestCompaniesCard.trendStable": "Stabil",
  "breadcrumb.benefits": "Förmåner",
  "breadcrumb.company": "Företag",
  "breadcrumb.educationLevel": "Utbildning",
  "breadcrumb.industry": "Bransch",
  "breadcrumb.isDriversLicenseRequired": "Körkort",
  "breadcrumb.isOpenApplication": "Öppen ansökan",
  "breadcrumb.jobType": "Anställningsform",
  "breadcrumb.jobs": "Jobb",
  "breadcrumb.language": "Språk",
  "breadcrumb.level": "Nivå",
  "breadcrumb.location": "Plats",
  "breadcrumb.navigation": "Brödsmulemeny",
  "breadcrumb.peopleManagementTier": "Ledning",
  "breadcrumb.remote": "Distans",
  "breadcrumb.skillsAndTechnologies": "Kompetens/Teknik",
  "checklist.field.addTrigger": "Lägg till checklista",
  "checklist.field.placeholder": "Lägg till en uppgift och tryck på Enter…",
  "checklist.field.progressTrigger": "{done}/{total} klara",
  "checklist.field.remove": "Ta bort uppgiften {text}",
  "collectiveAgreements.aiTranslatedBadge": "AI-översatt",
  "collectiveAgreements.bindingLegend": "Vad \"olöst\" betyder:",
  "collectiveAgreements.bindingLegendBody": "bekräftelsenämnden nämnde inte det avtalet i någon av de årliga genomgångarna som vi har i våra arkiv – det är en faktisk lucka i underlaget, inte ett \"nej\".",
  "collectiveAgreements.bindingNo": "Ej bindande",
  "collectiveAgreements.bindingUnknown": "Okänt",
  "collectiveAgreements.bindingYes": "Bindande",
  "collectiveAgreements.breadcrumb.current": "Kollektivavtal",
  "collectiveAgreements.decisionNoPrefix": "Beslut nr",
  "collectiveAgreements.editorialStandardsLinkLabel": "redaktionella riktlinjer",
  "collectiveAgreements.eyebrow": "Referens · Finlex & Social- och hälsovårdsministeriet",
  "collectiveAgreements.filterLabel": "Filtrera kollektivavtal efter namn",
  "collectiveAgreements.filterPlaceholder": "Sök på avtalsnamn…",
  "collectiveAgreements.intro": "Ett työehtosopimus fastställer minimilön och villkor för ett jobb – vilket avtal som gäller beror på arbetsgivarens bransch och typ av roll. Vi länkar jobbannonser till vår bästa gissning automatiskt; detta är den fullständiga källistan så att du själv kan kontrollera den gissningen.",
  "collectiveAgreements.noResults": "Inga avtal matchar din sökning.",
  "collectiveAgreements.pdfFi": "PDF (finska)",
  "collectiveAgreements.pdfSv": "PDF (svenska)",
  "collectiveAgreements.resultsCount": "Visar {shown} av {total} avtal — {binding} bekräftade som allmänt bindande",
  "collectiveAgreements.scopeHeading": "Tillämpningsområde",
  "collectiveAgreements.scopeUnavailable": "Ingen text om tillämpningsområde är tillgänglig för detta avtal.",
  "collectiveAgreements.sourceLanguageDisclaimer": "Avtalens namn och text om tillämpningsområde nedan visas på engelska/svenska där en AI-översättning finns tillgänglig, och annars på originalspråket finska: Finlex publicerar ingen officiell översättning av dem. Dessa översättningar är inte officiella och kan innehålla fel: Finlex ursprungliga finska formulering är avgörande. Övrig text på denna sida kan också vara maskinöversatt; se våra {editorialStandardsLink}.",
  "collectiveAgreements.stat.binding": "Bekräftat bindande",
  "collectiveAgreements.stat.total": "Arkiverade avtal",
  "collectiveAgreements.stat.unresolved": "Status ej fastställd",
  "collectiveAgreements.title": "Finländska kollektivavtal",
  "company.bulkFollow.cta": "{count, plural, one {Följ det här företaget} other {Följ alla {count} företag}}",
  "company.bulkFollow.followedToast": "{count, plural, one {Följer 1 företag. Bevakningslistan uppdaterad} other {Följer {count} företag. Bevakningslistan uppdaterad}}",
  "company.follow.createAccount": "Skapa konto",
  "company.follow.cta": "Följ",
  "company.follow.emailPrompt.enabled": "Klart — nya jobb från företag du följer kommer med i dina jobbevaknings-mejl.",
  "company.follow.emailPrompt.failed": "Det gick inte att aktivera e-postuppdateringarna — du kan aktivera dem när som helst på Bevakningar-sidan.",
  "company.follow.emailPrompt.offer": "Du följer nu {company} — vill du få ett mejl när de publicerar nya jobb?",
  "company.follow.emailPrompt.pendingConfirmation": "Nästan klart — bekräfta din e-postadress i din inkorg för att aktivera uppdateringarna.",
  "company.follow.emailPrompt.turnOn": "Aktivera",
  "company.follow.followedToast": "Följer. Bevakningslistan uppdaterad",
  "company.follow.following": "Följer",
  "company.follow.followingCheck": "Följer ✓",
  "company.follow.undo": "Ångra",
  "company.follow.unfollow": "Sluta följa",
  "company.follow.unfollowedToast": "Slutade följa. Du får inte längre aviseringar om deras nya jobb",
  "company.follow.viewWatchlist": "Visa →",
  "company.logoAlt": "{company}-logotyp",
  "company.logoAltGeneric": "Arbetsgivarens logotyp",
  "companyChart.caption.averaging": "i genomsnitt {avg} jobb per månad",
  "companyChart.caption.hiringDeclining": "{companyName}s rekrytering minskar",
  "companyChart.caption.hiringGrowing": "{companyName}s rekrytering växer",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}s rekrytering minskar kraftigt",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}s rekrytering växer kraftigt",
  "companyChart.caption.hiringStable": "{companyName}s rekrytering är stabil",
  "companyChart.caption.levelDistributionDouble": "{companyName} rekryterar främst på nivåerna {level1} och {level2}.",
  "companyChart.caption.levelDistributionSingle": "{companyName} anställer främst på {level}-nivå.",
  "companyChart.caption.levelDistributionTriple": "{companyName} anställer främst på nivåerna {level1}, {level2} och {level3}.",
  "companyChart.caption.locationDistributionDouble": "{companyName} anställer främst i {location1} och {location2}.",
  "companyChart.caption.locationDistributionSingle": "{companyName} anställer främst i {location}.",
  "companyChart.caption.locationDistributionTriple": "{companyName} anställer främst i {location1}, {location2} och {location3}.",
  "companyChart.caption.margin": "och en vinstmarginal på {margin}",
  "companyChart.caption.marginOnly": "{companyName} hade en vinstmarginal på {margin} under 2024",
  "companyChart.caption.profitable": "{companyName} gick med vinst under 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} anställer främst till hybridtjänster.",
  "companyChart.caption.remotenessOnsite": "{companyName} anställer främst till tjänster på plats.",
  "companyChart.caption.remotenessRemote": "{companyName} anställer främst till distanspositioner.",
  "companyChart.caption.revenue": "{companyName} hade en omsättning på {revenue} under 2024",
  "companyChart.caption.revenueWith": "med en omsättning på {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} anställer främst roller som {role1} och {role2}.",
  "companyChart.caption.roleDistributionSingle": "{companyName} anställer främst roller som {role}.",
  "companyChart.caption.roleDistributionTriple": "{companyName} anställer främst roller som {role1}, {role2} och {role3}.",
  "companyChart.caption.unprofitable": "{companyName} var olönsamma under 2024",
  "companyChart.caption.workforceRate": "({rate}% av sin arbetsstyrka)",
  "companyChart.financialOverview": "Ekonomisk översikt (2024)",
  "companyChart.insufficientData": "Begränsad data tillgänglig – trender kräver minst 3 månaders data",
  "companyChart.monthlyHiringTrends": "Månatliga rekryteringstrender",
  "companyChart.moreCategories": "+{count} till",
  "companyChart.profit": "Vinst",
  "companyChart.profitMargin": "Vinstmarginal",
  "companyChart.revenue": "Intäkter",
  "companyChart.trend.declining": "Nedåtgående",
  "companyChart.trend.growing": "Uppåtgående",
  "companyChart.trend.insufficientData": "Begränsad data",
  "companyChart.trend.rapidlyDeclining": "Snabbt nedåtgående",
  "companyChart.trend.rapidlyGrowing": "Snabbt uppåtgående",
  "companyChart.trend.stable": "Stabil",
  "companyChart.trendDescription.declining": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.growing": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.rapidlyDeclining": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.rapidlyGrowing": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.simpleDeclining": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.simpleGrowing": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.simpleStable": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.stable": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyGroupingToggle.label": "Gruppera jobb efter företag",
  "companyHeader.jobCount": "{count, plural, one {# ledig tjänst} other {# lediga tjänster}}",
  "companyHeader.locationCount": "{count, plural, one {# plats} other {# platser}}",
  "companyInsight.bodyNoLocations": "förekommer i {count, plural, one {# indexerad jobbannons} other {# indexerade jobbannonser}} i JobCrawls dataset för Finland sedan {sinceDate}. Detta återspeglar historiska indexdata, inte ett aktuellt antal lediga tjänster.",
  "companyInsight.bodyWithLocations": "förekommer i {count, plural, one {# indexerad jobbannons} other {# indexerade jobbannonser}} i JobCrawls dataset för Finland sedan {sinceDate}. I det historiska indexet är de starkaste platssignalerna för denna arbetsgivare {locationList}.",
  "companyInsight.englishRequirement": "{percent}% av dessa indexerade annonser nämner engelska som ett krav.",
  "companyInsight.locationSegment": "{location} ({count, plural, one {# indexerad annons} other {# indexerade annonser}})",
  "companyProfile.commonBenefits.heading": "Vanligaste förmånerna",
  "companyProfile.communityInsights.consTitle": "Vanliga klagomål",
  "companyProfile.communityInsights.heading": "Vad folk säger online",
  "companyProfile.communityInsights.prosTitle": "Vad folk gillar",
  "companyProfile.communityInsights.sentimentInsufficient": "Otillräckligt med data",
  "companyProfile.communityInsights.sentimentMixed": "Blandat",
  "companyProfile.communityInsights.sentimentNegative": "Övervägande negativt",
  "companyProfile.communityInsights.sentimentPositive": "Övervägande positivt",
  "companyProfile.communityInsights.sourcesTitle": "Källor",
  "companyProfile.communityInsights.subtitle": "Sammanställt från offentliga diskussioner på Reddit, Suomi24 och forum",
  "companyProfile.companyFacts.benefitsLabel": "Förmåner",
  "companyProfile.companyFacts.contactLabel": "Kontakt",
  "companyProfile.companyFacts.corporateHistoryLabel": "Ägande",
  "companyProfile.companyFacts.heading": "Bra att veta",
  "companyProfile.companyFacts.officeLocationsLabel": "Kontor",
  "companyProfile.companyFacts.remotePolicyLabel": "Distansarbete",
  "companyProfile.companyFacts.teamLinkText": "Träffa teamet",
  "companyProfile.companyFacts.valuesLabel": "Värderingar",
  "companyProfile.ownedBrands.heading": "Egna varumärken",
  "companyProfile.siteSources.sourceLabel": "Källa",
  "cookie.consent.accept": "Acceptera analys",
  "cookie.consent.analyticsBody": "Hjälper oss att hitta sökningar som inte ger några resultat och sidor där användare fastnar, så att vi kan åtgärda dem. Valfritt, och används aldrig för annonser.",
  "cookie.consent.analyticsTitle": "Analys",
  "cookie.consent.banner": "Vi använder nödvändiga cookies för att driva JobCrawls. Med ditt godkännande använder vi även integritetsvänlig analys – det hjälper oss att hitta sökningar som är tomma och sidor där användare fastnar, så att vi kan åtgärda dem snabbare. Aldrig för annonser. Du kan ändra dig när som helst.",
  "cookie.consent.cancel": "Avbryt",
  "cookie.consent.manage": "Hantera inställningar",
  "cookie.consent.modalTitle": "Cookie-inställningar",
  "cookie.consent.necessaryNote": "Nödvändiga cookies (session, inställningar, säkerhet) används alltid för att webbplatsen ska fungera.",
  "cookie.consent.nudge": "Du kan aktivera integritetsvänlig analys när som helst – det hjälper oss att hitta trasiga sökningar snabbare.",
  "cookie.consent.privacyLink": "Integritetspolicy",
  "cookie.consent.reject": "Neka icke-nödvändiga",
  "cookie.consent.save": "Spara val",
  "cookie.consent.title": "Cookies och integritet",
  "dashboard.actions": "Åtgärder",
  "dashboard.addComment": "Lägg till kommentar",
  "dashboard.addComment.placeholder": "Lägg till en kommentar...",
  "dashboard.addCompany.cancel": "Avbryt",
  "dashboard.addCompany.close": "Stäng",
  "dashboard.addCompany.doCrawl": "Aktivera crawling (doCrawl = TRUE)",
  "dashboard.addCompany.errorName": "Företagsnamn krävs.",
  "dashboard.addCompany.fieldCareers": "URL till karriär-/jobbsida",
  "dashboard.addCompany.fieldEnqueue": "Köläggnings-URL",
  "dashboard.addCompany.fieldLogo": "Logotyp-URL",
  "dashboard.addCompany.fieldName": "Företagsnamn",
  "dashboard.addCompany.fieldWebsite": "Webbplats",
  "dashboard.addCompany.hintId": "Företags-ID i databasen är det exakta företagsnamnet (trimmat). Om en rad med samma namn redan finns kommer skapandet att misslyckas.",
  "dashboard.addCompany.open": "Lägg till företag",
  "dashboard.addCompany.placeholderName": "t.ex. Acme Oy",
  "dashboard.addCompany.saving": "Skapar…",
  "dashboard.addCompany.submit": "Skapa företag",
  "dashboard.addCompany.title": "Lägg till företag",
  "dashboard.adding": "Lägger till...",
  "dashboard.address": "Adress",
  "dashboard.all": "Alla",
  "dashboard.allAts": "Alla ATS",
  "dashboard.allCompanies": "Alla företag",
  "dashboard.allStatus": "Alla statusar",
  "dashboard.atsSystem": "ATS-system",
  "dashboard.businessId": "FO-nummer",
  "dashboard.cancelEdit": "Avbryt",
  "dashboard.careersUrl": "URL till karriärsida",
  "dashboard.charts.closeBackdrop": "Stäng",
  "dashboard.charts.closeButton": "Stäng diagram",
  "dashboard.charts.modalTitle": "Diagram över crawl-aktivitet",
  "dashboard.charts.toolbarDisabledHint": "Ladda först exportdata från crawl",
  "dashboard.charts.toolbarHint": "Öppna diagram över crawl-aktivitet",
  "dashboard.charts.toolbarLabel": "Diagram",
  "dashboard.check": "Markera som granskad",
  "dashboard.clearDlq": "Töm DLQ",
  "dashboard.clearFilters": "Rensa filter",
  "dashboard.clearLogoFailures": "Rensa loggmisslyckanden ({count})",
  "dashboard.comments": "Kommentarer",
  "dashboard.companiesHeader": "Företag ({count} av {total})",
  "dashboard.companyAttributes": "Företagsattribut",
  "dashboard.companyBasic": "Företagsgrundläggande",
  "dashboard.companyBasic.short": "Grundläggande info",
  "dashboard.companyBusiness": "Företagsinformation",
  "dashboard.companyContact": "Kontakt",
  "dashboard.companyCrawl": "Inställningar för crawlning",
  "dashboard.companyCrawlRecordsPerPageLabel": "Rader per sida",
  "dashboard.companyCrawlRecordsShowing": "Visar {from}-{to} av {total}",
  "dashboard.companyFinancial": "Ekonomi",
  "dashboard.companyId": "Företags-ID",
  "dashboard.companyIndustry": "Bransch",
  "dashboard.companyInformation": "Företagsinformation",
  "dashboard.companyLocation": "Plats",
  "dashboard.companyModal.close": "Stäng företagsfönster",
  "dashboard.companyModal.closeBackdrop": "Stäng",
  "dashboard.companyModal.subtitle": "{crawls} crawls · {ok} lyckade · {jobs} skickade till processor",
  "dashboard.companyModal.tabCrawls": "Crawl-körningar",
  "dashboard.companyModal.tabSettings": "Företags- och crawl-inställningar",
  "dashboard.companyName": "Företagsnamn",
  "dashboard.companyRegistry": "Register",
  "dashboard.companyRow.jobs": "jobb",
  "dashboard.companyRow.openBadge": "Öppen",
  "dashboard.companyRow.paginationWarningShort": "Pagineringsvarning ⚠ {n}",
  "dashboard.companySocial": "Sociala medier",
  "dashboard.companyUrl": "Företags-URL",
  "dashboard.coordinates": "Koordinater",
  "dashboard.crawlActions.companyColumnHint": "HTML · Live · Trace · Loggar",
  "dashboard.crawlActions.flatLogsColumnHint": "⋯ meny",
  "dashboard.crawlActions.legendHtml": "Öga — HTML: ögonblicksbild från S3 så som den crawlades (plus live-extraherad JSON när raden har en URL).",
  "dashboard.crawlActions.legendLive": "Pil ut — Live-sida: öppna den publika jobb-sidan på JobCrawls (detalj-rader med endast ett objekt-ID).",
  "dashboard.crawlActions.legendLogs": "⋯ — CloudWatch: hoppa till crawler, processor, enrich, Algolia, etc. (filter använder detta crawl-id eller jobb-URL).",
  "dashboard.crawlActions.legendRecrawlDetail": "Pilar — Recrawl-sida: lägg till en detalj-crawl för denna URL i kön (inte hela företagslistan).",
  "dashboard.crawlActions.legendTitle": "Vad radknapparna gör",
  "dashboard.crawlActions.legendTrace": "Förstoringsglas — Trace: en modal med status för Raw/Final/Enriched, samt länkar till DynamoDB och AWS-konsolen.",
  "dashboard.crawlActions.liveJobAria": "Öppna offentlig jobbannons på JobCrawls",
  "dashboard.crawlActions.liveJobTooltip": "Öppna den offentliga annonssidan för detta jobb på JobCrawls (samma URL som besökare ser när jobbet är indexerat).",
  "dashboard.crawlActions.logsMenuAria": "Meny för CloudWatch-pipelineloggar för denna crawl",
  "dashboard.crawlActions.logsMenuTooltip": "Länkar till CloudWatch-loggar: exakt crawl-ström när tillgängligt, därefter filtrerade vyer för crawler (crawlId), processor, enrich, Algolia, maintainer och processor per URL.",
  "dashboard.crawlActions.recrawlDetailAria": "Recrawla denna jobbsida (endast detalj-crawl)",
  "dashboard.crawlActions.recrawlDetailTooltip": "Köa en crawl av endast denna jobbsida (detalj). Kör inte om hela företagets listningssidor — använd företagets ”Recrawl” för det.",
  "dashboard.crawlActions.traceAria": "Öppna fullständig pipeline-trace för denna jobb-URL",
  "dashboard.crawlActions.traceTooltip": "Öppna pipeline-trace: sammanfattningar för RawJobs / FinalJobs / Enriched, objekt-ID:n samt länkar till DynamoDB och CloudWatch för denna jobb-URL.",
  "dashboard.crawlActions.viewHtmlAria": "Visa lagrad HTML-snapshot för denna crawl",
  "dashboard.crawlActions.viewHtmlTooltip": "Öppna HTML-snapshoten som lagrats för denna crawl (S3). Visar renderad eller rå markup och live DynamoDB job-JSON bredvid.",
  "dashboard.crawlDataLoadedNoCompanies": "Crawl-data har laddats ({count} poster), men företagsdata har inte laddats i den här webbläsaren än — därför visas inga grupper nedan. Ladda företag för att se dem.",
  "dashboard.crawlDlq": "Sökning DLQ",
  "dashboard.crawlExportWindow": "Laddade crawl-poster från {from} till {to} (maintainer export window).",
  "dashboard.crawlFailIconTooltip": "Denna crawl-körning misslyckades eller returnerade ett HTTP-fel — öppna CloudWatch / pipeline-loggar för detta crawlId.",
  "dashboard.crawlHistory.hideOlder": "Dölj {n} äldre crawl(s)",
  "dashboard.crawlHistory.hint": "Den senaste körningen finns i raden ovan. Varje äldre körning har sitt eget crawlId och CloudWatch-länkar.",
  "dashboard.crawlHistory.showOlder": "Visa {n} äldre crawl(s) — tid, loggar, HTML",
  "dashboard.crawlHourlyChart.ariaDuration": "Timvis diagram över genomsnittlig sidtid och totala crawl-minuter",
  "dashboard.crawlHourlyChart.ariaPages": "Timvis diagram över hämtningar av listnings- och jobbsidor, sparade jobb, listningslänkar och osparade jobbsidor",
  "dashboard.crawlHourlyChart.avgSecPhrase": "snitt {seconds} s per sida som rapporterade tidtagning",
  "dashboard.crawlHourlyChart.axisAvgSec": "Genomsnitt s / sida",
  "dashboard.crawlHourlyChart.axisExtracted": "Jobbrelaterade antal / h",
  "dashboard.crawlHourlyChart.axisPageFetches": "Sidhämtningar / h",
  "dashboard.crawlHourlyChart.axisTotalMin": "Totalt min / h",
  "dashboard.crawlHourlyChart.collapsedEmpty": "Inga rader i det laddade fönstret",
  "dashboard.crawlHourlyChart.collapsedSummary": "{hours} timmar · {fetches} sidhämtningar",
  "dashboard.crawlHourlyChart.durationHms": "Totalt {hours}t {minutes}m {seconds}s (summa av tider per sida)",
  "dashboard.crawlHourlyChart.durationMs": "Totalt {minutes}m {seconds}s (summa av tider per sida)",
  "dashboard.crawlHourlyChart.durationSecOnly": "Totalt {seconds}s (summa av tider per sida)",
  "dashboard.crawlHourlyChart.durationZero": "0s totalt",
  "dashboard.crawlHourlyChart.empty": "Inga crawl-rader i det laddade fönstret — uppdatera crawl-data efter en maintainer-export.",
  "dashboard.crawlHourlyChart.helpCollapsibleLabel": "Förklaring & fönstertotaler",
  "dashboard.crawlHourlyChart.hoverAllFetches": "Alla sidhämtningar",
  "dashboard.crawlHourlyChart.hoverAllFetchesValue": "{total} ({ok} ok / {fail} misslyckade)",
  "dashboard.crawlHourlyChart.hoverAvgPageTime": "Genomsnittlig sidtid (tidtagna rader)",
  "dashboard.crawlHourlyChart.hoverDetailJobsCounted": "Från enskilda jobb-sidor (sedda annonser)",
  "dashboard.crawlHourlyChart.hoverDetailNotSaved": "Enskilda jobb-sidor som vi inte sparade",
  "dashboard.crawlHourlyChart.hoverFoundOtherPages": "Hittades på andra sidtyper",
  "dashboard.crawlHourlyChart.hoverJobPages": "Jobbsidor (detaljer)",
  "dashboard.crawlHourlyChart.hoverJobPagesValue": "{ok} ok / {fail} misslyckades",
  "dashboard.crawlHourlyChart.hoverJobsFound": "Totalt \"hittade\" (summan av allt)",
  "dashboard.crawlHourlyChart.hoverListPages": "Listningssidor",
  "dashboard.crawlHourlyChart.hoverListPagesValue": "{ok} ok / {fail} misslyckades",
  "dashboard.crawlHourlyChart.hoverListUrlsEnqueued": "Från listningssidor (jobblänkar räknade)",
  "dashboard.crawlHourlyChart.hoverPipeline": "Sparade i pipeline",
  "dashboard.crawlHourlyChart.hoverPipelineBreakdown": "{total} (Työmarkkinatori {tm}, övriga {other})",
  "dashboard.crawlHourlyChart.hoverTotalReportedTime": "Total rapporterad tid för crawlning",
  "dashboard.crawlHourlyChart.noTiming": "ingen varaktighet per sida registrerad i denna export",
  "dashboard.crawlHourlyChart.panelDuration": "Crawl-varaktighet",
  "dashboard.crawlHourlyChart.panelPages": "Hämtningar och antal jobb per timme",
  "dashboard.crawlHourlyChart.plainGuide1": "”Hittade” är ofta ett högt tal eftersom varje jobblänk på en listningssida räknas. Dessa länkar betyder bara ”vi har lagt till denna URL i kön” – inte att ett jobb har sparats ännu.",
  "dashboard.crawlHourlyChart.plainGuide2": "”Extraherade” innebär att vi faktiskt har sparat det jobbet till rålagring från en enskild jobbsida. Rader i listningar räknas aldrig som extraherade (enligt design).",
  "dashboard.crawlHourlyChart.plainGuide3": "Använd kryssrutorna i diagrammet: den lila streckade linjen = länkar räknade på listningssidor; den bruna streckade linjen = jobbsidor vi besökte men inte sparade; den solida guldfärgade linjen = sparade till pipelinen. Håll muspekaren över grafen för att se siffrorna för en specifik timme.",
  "dashboard.crawlHourlyChart.plainGuideTitle": "Enkelt förklarat",
  "dashboard.crawlHourlyChart.subtitle": "Övre diagrammet: sidor vi hämtade och antal jobb per timme. Nedre diagrammet: hur lång tid crawlningen tog. Tidsaxeln matchar ditt exporterade crawl-fönster (ofta cirka en vecka).",
  "dashboard.crawlHourlyChart.title": "Crawl-aktivitet per timme (lokal tid)",
  "dashboard.crawlHourlyChart.totalDetailSkipped": "Jobbsidor besökta men ej sparade",
  "dashboard.crawlHourlyChart.totalExtracted": "Jobb sparade som rådata (\"extraherade\")",
  "dashboard.crawlHourlyChart.totalFoundRaw": "\"Hittade\" (alla rader summerade)",
  "dashboard.crawlHourlyChart.totalJobPages": "Enskilda jobbsidor crawlade",
  "dashboard.crawlHourlyChart.totalJobPagesValue": "{total} ({ok} lyckades, {fail} misslyckades)",
  "dashboard.crawlHourlyChart.totalListLinks": "Av dessa, länkar räknade på listningssidor",
  "dashboard.crawlHourlyChart.totalListPages": "Listningssidor crawlade",
  "dashboard.crawlHourlyChart.totalListPagesValue": "{total} ({ok} lyckades, {fail} misslyckades)",
  "dashboard.crawlHourlyChart.totalTiming": "Tid rapporterad av crawler",
  "dashboard.crawlHourlyChart.totalsTitle": "Totalt för tidsintervallet ovan",
  "dashboard.crawlKey": "Crawl-nyckel",
  "dashboard.crawlMetricsExplainer.crawls": "Crawlningar — en loggrad varje gång vi öppnar en listningssida eller en enskild jobbannons.",
  "dashboard.crawlMetricsExplainer.extracted": "Extraherade — jobb som vi faktiskt sparat från en jobbsida. Listningssidor räknas inte här.",
  "dashboard.crawlMetricsExplainer.found": "Hittade — främst ”hur många jobblänkar vi räknade på listningssidorna”, plus det vi såg på jobbsidorna. Höga siffror här är normalt.",
  "dashboard.crawlMetricsExplainer.foundVsExtracted": "För en mer komplett bild, använd det timvisa diagrammet nedan: där är de lila, bruna och guldfärgade linjerna märkta för att matcha denna förklaring.",
  "dashboard.crawlMetricsExplainer.successFailed": "Lyckad / misslyckad — laddades sidan och slutfördes utan ett crawlningsfel?",
  "dashboard.crawlMetricsExplainer.title": "Vad dessa siffror betyder",
  "dashboard.crawlMetricsExplainer.triggerAria": "Vad dessa siffror i crawl-sammanfattningen betyder",
  "dashboard.crawlOkIconTooltip": "Denna crawlning lyckades (HTTP OK, inget crawler-fel).",
  "dashboard.crawlOutliersFilter.all": "Alla crawl-rader",
  "dashboard.crawlOutliersFilter.any": "Crawlad men ej skickad",
  "dashboard.crawlOutliersFilter.hint": "Använder endast exportfält från IndexedDB. Rader på list-sidan döljs när detta inte är inställt på ”Alla”. Kombinera med platta flikar för ”Jobb / list-sidor”.",
  "dashboard.crawlOutliersFilter.label": "Pipeline / index-avvikelser (detalj-crawls)",
  "dashboard.crawlOutliersFilter.notSent": "Crawlad OK men jobsExtracted = 0 (ej hoppad över)",
  "dashboard.crawlRecords": "Crawl-poster",
  "dashboard.crawlStatistics": "Crawl-statistik",
  "dashboard.crawlType": "Crawl-typ",
  "dashboard.crawlingInformation": "Crawlingsinformation",
  "dashboard.deleteComment": "Ta bort kommentar",
  "dashboard.deleteCompany": "Ta bort",
  "dashboard.deleteCompany.confirm": "Ta bort \"{name}\" från tabellen Companies (DynamoDB)? Detta kan inte ångras. Lokala rader i instrumentpanelen för detta företag kommer att tas bort.",
  "dashboard.deleteCompany.done": "Företaget \"{name}\" raderades.",
  "dashboard.deleteCompany.failed": "Misslyckades med att radera företaget: {message}",
  "dashboard.deleteCompany.modalTooltip": "Ta bort det här företaget från tabellen Företag (DynamoDB)",
  "dashboard.deleteCompany.rowTooltip": "Radera företaget från DynamoDB och ta bort från den lokala instrumentpanelen",
  "dashboard.deleteCompany.virtualBlocked": "Den aggregerade raden för Työmarkkinatori är inte ett post i tabellen Företag. Den kan inte raderas här.",
  "dashboard.detailPages": "Detaljsidor",
  "dashboard.details": "Detaljer",
  "dashboard.dlqEmpty": "DLQ är tom - inga misslyckade meddelanden",
  "dashboard.dlqMessageCount": "{count} {count, plural, one {meddelande} other {meddelanden}} i DLQ",
  "dashboard.duration": "Varaktighet",
  "dashboard.editCompany": "Redigera",
  "dashboard.enqueueUrlPattern": "Mönster för köläggning av URL:er",
  "dashboard.error": "Fel",
  "dashboard.failed": "Misslyckade",
  "dashboard.failedToLoadCompanySettings": "Kunde inte ladda företagsinställningar: {error}",
  "dashboard.filterByField": "Filtrera efter fält",
  "dashboard.filterValue": "Filtervärde... (använd __NOT_EMPTY__ för icke-tomma)",
  "dashboard.flatView.noCrawlRows": "Inga crawl-rader att visa i platt vy. Ladda först in data från crawl-exporten.",
  "dashboard.flatViews.colActions": "Åtgärder",
  "dashboard.flatViews.colActionsTooltip": "Live-listning på webbplatsen, HTML-snapshot från S3 när tillgängligt.",
  "dashboard.flatViews.colCompany": "Företag",
  "dashboard.flatViews.colCompanyTooltip": "Företagsnamn lagrat i crawl-posten.",
  "dashboard.flatViews.colDuration": "Varaktighet",
  "dashboard.flatViews.colDurationTooltip": "Tid som lagts på att hämta och behandla denna crawl-förfrågan.",
  "dashboard.flatViews.colHttpTooltip": "HTTP-svarsstatus för denna förfrågan (t.ex. 200 = OK).",
  "dashboard.flatViews.colMetrics": "Hittade / skickade",
  "dashboard.flatViews.colMetricsTooltip": "Lista: jobb i kö. Detaljer: skickat till processor eller ej. Andra sidtyper: råa antal. Håll muspekaren över en cell för mer detaljer.",
  "dashboard.flatViews.colOkTooltip": "Grön: crawl lyckades. Röd: misslyckades eller felaktig HTTP. Om det finns flera körningar för samma URL, håll muspekaren över tidskolumnen för status per körning.",
  "dashboard.flatViews.colPage": "Sida",
  "dashboard.flatViews.colPageTooltip": "Sidtyp (lista vs detalj) och märken: TMT, Hoppad, Y-tunnus-tips, etc.",
  "dashboard.flatViews.colPipelineLogsTooltip": "Länkar till CloudWatch-loggströmmar för crawler, processor och relaterade steg.",
  "dashboard.flatViews.colTime": "Tid",
  "dashboard.flatViews.colTimeTooltip": "När denna crawl-körning startade. Om samma URL crawlades mer än en gång visas den senaste körningen i denna rad.",
  "dashboard.flatViews.colTrace": "Pipeline-loggar",
  "dashboard.flatViews.colTraceFull": "Spårning",
  "dashboard.flatViews.colTraceFullTooltip": "Öppna hela jobbpipeline-tracen (Raw/Final/Enriched, DynamoDB & CloudWatch).",
  "dashboard.flatViews.colUrlTooltip": "URL som hämtats av crawlern.",
  "dashboard.flatViews.colYtunnus": "Y-nummer (TMT)",
  "dashboard.flatViews.colYtunnusTooltip": "Endast Työmarkkinatori: om ett finländskt företagskennande (Y-tunnus) extraherades från HTML och matchades mot din företagsdatabas.",
  "dashboard.flatViews.crawlRunCount": "{n} crawlningar",
  "dashboard.flatViews.failure.algolia": "Algolia-fel (metadata)",
  "dashboard.flatViews.failure.all": "Alla utfall",
  "dashboard.flatViews.failure.cookie": "Kaka / overlay",
  "dashboard.flatViews.failure.nav": "Navigering / timeout",
  "dashboard.flatViews.failure.net": "Nätverk",
  "dashboard.flatViews.failure.ok": "Sökning OK",
  "dashboard.flatViews.failure.other": "Annat crawl-fel",
  "dashboard.flatViews.failureFilterLabel": "Crawl-utfall",
  "dashboard.flatViews.first": "Första",
  "dashboard.flatViews.hint": "Sortering, Källa, Avvikelser och Crawl-resultat gäller endast för denna platta tabell. Rader grupperar upprepade crawls av samma URL (nyaste först; antal crawls i tidskolumnen). Avvikelser använder endast rader för jobbdetaljer (Algolia-fel i metadata, eller crawl OK men jobsExtracted 0 och ej hoppad över). Crawl-resultat använder IndexedDB-exportfält (inte live Dynamo). Använd Trace för en rad för att ladda Raw/Final/Enriched + AWS-konsolens länkar. Raduppsättningen använder även samma filter (Työmarkkinatori, TMT Y-tunnus) som ovan.",
  "dashboard.flatViews.jobPages": "Alla jobbsidor",
  "dashboard.flatViews.last": "Sista",
  "dashboard.flatViews.listPages": "Alla listsidor",
  "dashboard.flatViews.next": "Nästa",
  "dashboard.flatViews.pageJumpLabel": "Gå till sida",
  "dashboard.flatViews.pageOf": "Sida {p} av {t} ({n} rader)",
  "dashboard.flatViews.prev": "Föregående",
  "dashboard.flatViews.sort.companyAsc": "Företag · A–Ö",
  "dashboard.flatViews.sort.companyDesc": "Företag · Ö–A",
  "dashboard.flatViews.sort.failedFirst": "OK · misslyckade först",
  "dashboard.flatViews.sort.jobsFoundAsc": "Hittade jobb · låg → hög",
  "dashboard.flatViews.sort.jobsFoundDesc": "Hittade jobb · hög → låg",
  "dashboard.flatViews.sort.successFirst": "OK · lyckade först",
  "dashboard.flatViews.sort.timeAsc": "Tid · äldsta först",
  "dashboard.flatViews.sort.timeDesc": "Tid · nyaste först",
  "dashboard.flatViews.sort.urlAsc": "URL · A–Ö",
  "dashboard.flatViews.sort.urlDesc": "URL · Ö–A",
  "dashboard.flatViews.sortLabel": "Sortera",
  "dashboard.flatViews.source.all": "Alla crawlningar",
  "dashboard.flatViews.source.nonTmt": "Exkludera Työmarkkinatori",
  "dashboard.flatViews.source.tmtOnly": "Endast Työmarkkinatori",
  "dashboard.flatViews.sourceLabel": "Källa",
  "dashboard.flatViews.title": "Platta crawl-vyer",
  "dashboard.flatViews.yt.legacy": "Äldre rad: ingen Y-tunnus-metadata (crawl om för att klassificera)",
  "dashboard.flatViews.yt.na": "Inte en Työmarkkinatori-detaljrad",
  "dashboard.flatViews.yt.nocompany": "Y-tunnus extraherad men hittades inte i CompaniesTable",
  "dashboard.flatViews.yt.none": "Ingen Y-tunnus extraherad från sidans HTML",
  "dashboard.flatViews.yt.ok": "Y-tunnus extraherad och företag matchat",
  "dashboard.greenSuccess": "Grön (Lyckad)",
  "dashboard.groupBy": "Gruppera efter",
  "dashboard.groupCrawlCount": "Antal crawlningar",
  "dashboard.groupJobsCount": "Antal jobb",
  "dashboard.groupLogoFailed": "Logostatus",
  "dashboard.groupMetrics": "Mätvärden",
  "dashboard.groupNone": "Ingen",
  "dashboard.groupPaginationIssue": "Pagineringsproblem",
  "dashboard.groupStatus": "Status (Röd/Gul/Grön)",
  "dashboard.groupStatusIssues": "Status & Problem",
  "dashboard.groupSuccessRate": "Framgångsgrad",
  "dashboard.hasAnyFailedCrawl": "Någon misslyckad crawl (inom tidsfönstret)",
  "dashboard.hasComments": "Har kommentarer",
  "dashboard.hasCrawlData.label": "Crawl-data",
  "dashboard.hasCrawlData.option": "Har data",
  "dashboard.heroImage": "Hero-bild",
  "dashboard.howToRunCrawl": "Så här kör du en crawl",
  "dashboard.htmlModal.liveExtractedHint": "Samma objekt-ID som sökindexet. Långa textfält är trunkerade i vyn.",
  "dashboard.htmlModal.liveExtractedTitle": "Live-extraherat jobb (DynamoDB)",
  "dashboard.htmlModal.loadingLive": "Laddar FinalJobs / Enriched…",
  "dashboard.htmlModal.noJobUrl": "Denna crawl-rad saknar URL – kan inte hämta live-jobbposter.",
  "dashboard.httpStatusCellTooltip": "HTTP-svarstatus för denna begäran (t.ex. 200 = OK, 404 = inte hittad).",
  "dashboard.industry": "Bransch",
  "dashboard.isChecked": "Granskade",
  "dashboard.isSaved": "Sparade",
  "dashboard.issuesOnly": "Endast problem",
  "dashboard.itemsPerPage": "Objekt per sida",
  "dashboard.jobLookup.activeHint": "Visar detaljerade crawlningar för jobb-ID: {id}",
  "dashboard.jobLookup.clear": "Rensa exportfilter",
  "dashboard.jobLookup.find": "Sök i export",
  "dashboard.jobLookup.noMatchInExport": "Ingen detaljerad crawlning i det laddade fönstret har detta jobb-ID. Ladda om crawl-data eller utöka exportfönstret.",
  "dashboard.jobLookup.parseError": "Kunde inte hitta något jobb-ID. Klistra in en fullständig URL till JobCrawls jobb-sida (…/en/job/…/company/…) eller objekt-ID från adressfältet.",
  "dashboard.jobLookup.placeholder": "Klistra in URL till jobbsida eller objekt-ID…",
  "dashboard.jobLookup.resolvingIds": "Matchar jobb-ID:n med crawls…",
  "dashboard.jobSearch.matchExportLabel": "Matcha i laddad crawl-export",
  "dashboard.jobSearch.sectionHint": "Hitta rader i den laddade exporten, eller spåra pipelinens status från en jobb-URL.",
  "dashboard.jobSearch.sectionTitle": "Jobbsökning",
  "dashboard.jobTrace.blurb": "Klistra in den exakta URL:en till jobbannonsen så som den är lagrad i RawJobs. Instrumentpanelen laddar RawJobs, FinalJobs och EnrichedFinalJobs, drar slutsatser om hur långt jobbet kommit och länkar till DynamoDB-tabeller och CloudWatch-loggfilter.",
  "dashboard.jobTrace.close": "Stäng",
  "dashboard.jobTrace.dynamo": "DynamoDB (konsol)",
  "dashboard.jobTrace.failureCode": "Kod: {code}",
  "dashboard.jobTrace.load": "Hämta all information",
  "dashboard.jobTrace.loading": "Laddar spårning…",
  "dashboard.jobTrace.modalTitle": "Pipeline-spårning",
  "dashboard.jobTrace.noAwsLinks": "Konsollänkarna är inte tillgängliga (pipeline log env är ofullständig).",
  "dashboard.jobTrace.noLogContext": "Pipeline log env-variabler saknas i API:et — Dynamo-länkar fungerar fortfarande; ställ in PIPELINE_LOG_GROUP_* på Dashboard Lambda för CloudWatch-djup länkar i API-svaret.",
  "dashboard.jobTrace.rawJson": "Objektsammanfattningar (JSON)",
  "dashboard.jobTrace.title": "Pipeline-spårning (Dynamo & CloudWatch)",
  "dashboard.jobTrace.urlLabel": "Jobb-URL",
  "dashboard.jobTrace.visual": "Pipeline-förlopp",
  "dashboard.jobsEnqueued": "{count} jobb i kön",
  "dashboard.jobsEnqueuedCellTooltip": "Listcrawl: jobb-URL:er som upptäckts på denna sida och lagts i kön för detaljcrawlning. ”Listpages” räknar även extra listnings-URL:er (t.ex. paginering) som lagts i kön.",
  "dashboard.jobsExtracted": "Extraherade jobb",
  "dashboard.jobsFound": "Hittade jobb",
  "dashboard.layout.company": "Per företag",
  "dashboard.layout.flat": "Platta crawls",
  "dashboard.listPages": "Listningssidor",
  "dashboard.listPagesEnqueued": "{count} listningssidor",
  "dashboard.liveJobLink": "Live-jobb",
  "dashboard.loadAllCompanies": "Ladda alla företag (86k)",
  "dashboard.loadCompaniesButton": "Ladda företag",
  "dashboard.loadedCompanies": "Laddade: {current} av {total} företag",
  "dashboard.loadedCompaniesUnknown": "Laddade: {current} företag",
  "dashboard.loadingAllCompanies": "Laddar alla företag — långsammare initial laddning",
  "dashboard.loadingBatch": "Bearbetar batch {current} av ungefär {total}",
  "dashboard.loadingCompanies": "Laddar företagsdata",
  "dashboard.loadingCompaniesWithUrls": "Laddar endast företag med webbadresser — snabbare",
  "dashboard.loadingNote": "Detta kan ta några minuter. Vänligen håll kvar denna sida öppen.",
  "dashboard.logoFailed": "Logotyp misslyckades",
  "dashboard.logoFailedBadgeTitle": "Logotypen kunde inte laddas i instrumentpanelen — använd Logo Lambda-loggarna nedan för ProcessCompanyLogos-utdata",
  "dashboard.logoOk": "Logotyp OK",
  "dashboard.logoProcessingFailedBadgeTitle": "ProcessCompanyLogos misslyckades ({failedAt}): {error}",
  "dashboard.logoProcessingFailedUnknownDate": "okänt datum",
  "dashboard.logoUrlFailedLabel": "Misslyckades",
  "dashboard.map": "Karta",
  "dashboard.menu.overview": "Översikt",
  "dashboard.menu.overview.metricsHelpDesc": "Håll muspekaren över (i)-ikonen för att se vad varje antal betyder.",
  "dashboard.menu.overview.metricsHelpTitle": "Definitioner av mätvärden",
  "dashboard.menu.overview.noExport": "Ladda data från crawl-export (Verktyg) för att se sammanfattande antal.",
  "dashboard.menu.overview.pipelineDesc": "Maintainer-ögonblicksbild jämfört med crawl-fönster.",
  "dashboard.menu.overview.summaryDesc": "Antal från den crawl-JSON som laddats i denna webbläsare.",
  "dashboard.menu.overview.summaryTitle": "Exportsammanfattning",
  "dashboard.menu.refine": "Förfina",
  "dashboard.metricsFoundExtractedTooltip": "Hittade jobb jämfört med extraherade jobb för denna sidtyp (inte en standardrad för lista/detaljer).",
  "dashboard.mostRecent": "Senaste",
  "dashboard.next": "Nästa",
  "dashboard.noCrawlData.message": "Inga crawl-data tillgängliga än. Expandera avsnittet \"Hur man kör en crawl\" ovan för instruktioner om hur du kör en crawl och exporterar data.",
  "dashboard.noCrawlData.option": "Inga data",
  "dashboard.noCrawlData.withServerDetail": "Ingen crawl-export tillgänglig: {detail}. Om du kör på localhost, se till att AWS-uppgifterna kan läsa crawl-data-bucketen och att Maintainer har skrivit crawl-exports/latest.json.",
  "dashboard.noFieldFilter": "Inget fältfilter",
  "dashboard.noIssues": "Inga problem",
  "dashboard.noLogoUrl": "Ingen logotyp-URL",
  "dashboard.notSent": "Ej skickad",
  "dashboard.notSentTooltip": "Ingen jobbinformation extraherades (jobsExtracted är 0). Detta är inte samma sak som ”Hoppades över”: Hoppades över innebär att crawlern avsiktligt inte kördes igen eftersom jobbet redan fanns i RawJobs.",
  "dashboard.pageInfo": "Sida {current} av {total}",
  "dashboard.pageType": "Sidtyp",
  "dashboard.pageType.detailTooltip": "Detaljsida: en enskild URL för en jobbannons. Crawlern extraherar strukturerad data och kan skicka den till processorn.",
  "dashboard.pageType.genericTooltip": "Crawler-sidtyp: {pageType}.",
  "dashboard.pageType.listTooltip": "Listningssida: hittar jobblänkar på en listnings- eller söksida och lägger till dem i kön för detalj-crawling.",
  "dashboard.pagination.allRows": "Alla",
  "dashboard.pagination.first": "Första",
  "dashboard.pagination.last": "Sista",
  "dashboard.pagination.navGroup": "Sidnavigering",
  "dashboard.pagination.pageJumpAria": "Sidnummer, 1 till {total}",
  "dashboard.pagination.pageJumpLabel": "Gå till sida",
  "dashboard.paginationIssueDescription": "Exakt {count} jobb skickades – kan tyda på ofullständig paginering.",
  "dashboard.pipelineHealth.active": "Aktiv",
  "dashboard.pipelineHealth.activeFinland": "Aktiv + Finland",
  "dashboard.pipelineHealth.activeNotFinland": "Aktiv, ej Finland",
  "dashboard.pipelineHealth.crawlCompare.body": "Jobb extraherade i rader från Työmarkkinatori-crawl (summa av jobsExtracted): {count}. Jämför med ”Active Työmarkk. (URL)” ovan – stora skillnader beror ofta på föråldrad lastSeen (inaktiv), köbildning i processorn eller felaktiga URL/companyId.",
  "dashboard.pipelineHealth.crawlCompare.title": "Crawl-export (detta fönster)",
  "dashboard.pipelineHealth.generatedAt": "Snapshot från Maintainer-skanning: {when}",
  "dashboard.pipelineHealth.inactive": "Inaktiv",
  "dashboard.pipelineHealth.missingStats": "Ingen snapshot ännu. Efter nästa lyckade Maintainer-körning (med CRAWL_DATA_BUCKET inställd) visas siffrorna här. Uppdatera crawl-data efter Maintainer.",
  "dashboard.pipelineHealth.title": "Pipeline-hälsa (FinalJobs)",
  "dashboard.pipelineHealth.totalRows": "FinalJobs-rader",
  "dashboard.pipelineHealth.tyoFlag": "Active Työmarkk. (flagga)",
  "dashboard.pipelineHealth.tyoUrl": "Aktiv Työmarkk. (URL)",
  "dashboard.pipelineHealth.tyoUrlBadFinland": "Työmarkk. URL + inte Finland",
  "dashboard.pipelineLogs.allGroups": "Lambda-loggrupper",
  "dashboard.pipelineLogs.aria": "CloudWatch-logglänkar längs sökvägen crawl → processor → enrich → Algolia → maintainer",
  "dashboard.pipelineLogs.crawlSearch": "Sökning (crawlId)",
  "dashboard.pipelineLogs.crawlStream": "Crawl-ström",
  "dashboard.pipelineLogs.enrich": "Berika",
  "dashboard.pipelineLogs.maintainer": "Underhållare",
  "dashboard.pipelineLogs.noObjectId": "ObjectID-länkar endast på detaljraderna",
  "dashboard.pipelineLogs.unconfigured": "Ange PIPELINE_LOG_GROUP_* på Dashboard / API Lambda för logglänkar",
  "dashboard.potentialPaginationIssue": "Potentiellt problem med paginering",
  "dashboard.previous": "Föregående",
  "dashboard.processCompanyLogoLogs.link": "Logo Lambda-loggar",
  "dashboard.processCompanyLogoLogs.tooltip": "Öppna CloudWatch-loggrupp för ProcessCompanyLogos (filtrerad på detta företags-id i logtexten)",
  "dashboard.processDlq": "Processa DLQ",
  "dashboard.quickFilterUncrawled": "Ej crawlade · högsta poäng",
  "dashboard.quickFilterUncrawled.tooltip": "Visa företag där doCrawl inte är TRUE, sorterat efter poäng i fallande ordning — användbart för att manuellt processa de viktigaste ej crawlade företagen",
  "dashboard.recordCount": "{count} {count, plural, one {post} other {poster}}",
  "dashboard.recrawl": "Crawla om",
  "dashboard.recrawlDetailTriggered": "Detalj-omcrawlning köad för {companyName}",
  "dashboard.recrawlTriggered": "Omcrawlning startad för {companyName}",
  "dashboard.recrawling": "Krälar om…",
  "dashboard.redLastCrawlFailed": "Röd – senaste krälningen misslyckades",
  "dashboard.refine.quickOptionsTitle": "Snabbalternativ",
  "dashboard.refine.section.companyList": "Företagslista",
  "dashboard.refine.section.companyListDesc": "Begränsa vilka företag som visas i listan.",
  "dashboard.refine.section.fieldFilterDesc": "Matcha ett enskilt företagsfält (och ett valfritt värde).",
  "dashboard.refine.section.pipelineIndexDesc": "Detaljerade kräl-signaler från den laddade exporten.",
  "dashboard.refine.section.tyomarkkinatoriDesc": "Filtrera rader taggade med Työmarkkinatori och Y-tunnus-metadata.",
  "dashboard.refreshCompanies": "Uppdatera företag",
  "dashboard.refreshCrawlData": "Uppdatera crawl-data",
  "dashboard.refreshCrawlData.title": "Uppdatera crawl-data från S3",
  "dashboard.refreshing": "Uppdaterar...",
  "dashboard.registryInformation": "Registerinformation",
  "dashboard.result": "Resultat",
  "dashboard.runMaintainer": "Kör underhåll",
  "dashboard.running": "Körs...",
  "dashboard.saveError": "Fel",
  "dashboard.saved": "Sparad",
  "dashboard.saving": "Sparar…",
  "dashboard.scanningDatabase": "Söker igenom databasen och laddar företag...",
  "dashboard.searchCompanies": "Sök företag...",
  "dashboard.sentForProcessing": "✓ Skickat för bearbetning",
  "dashboard.sentForProcessingTooltip": "Strukturerad jobbdata extraherades (jobsExtracted ≥ 1) och skickades till bearbetningsflödet (SQS / processor).",
  "dashboard.sentToProcessor": "Skickat till processor",
  "dashboard.showing": "Visar {filtered} av {total} företag",
  "dashboard.skipped": "Hoppades över",
  "dashboard.skippedCrawlTooltip": "Hoppades över: crawlern hämtade inte denna URL igen eftersom jobbet redan fanns lagrat i RawJobs (för att förhindra dubbletter). En crawl-rad registreras ändå för synlighets skull.",
  "dashboard.socialMedia": "Sociala medier",
  "dashboard.sortAndGroup.sectionHint": "Ändra listordning och valfri gruppering.",
  "dashboard.sortAndGroup.sectionTitle": "Sortera & gruppera",
  "dashboard.sortAscending": "Stigande",
  "dashboard.sortBasic": "Grundläggande",
  "dashboard.sortBy": "Sortera efter",
  "dashboard.sortCrawls": "Sökningar",
  "dashboard.sortDescending": "Fallande",
  "dashboard.sortDetailPages": "Detaljsidor",
  "dashboard.sortDirection": "Sortera {direction}",
  "dashboard.sortFailed": "Misslyckade crawlningar",
  "dashboard.sortJobs": "Jobb",
  "dashboard.sortJobsExtracted": "Totalt extraherade jobb",
  "dashboard.sortJobsFound": "Totalt hittade jobb",
  "dashboard.sortJobsSent": "Jobb skickade till processor",
  "dashboard.sortLastCrawl": "Datum för senaste crawlning",
  "dashboard.sortListPages": "Listningssidor",
  "dashboard.sortMostRecentJobs": "Senast hittade jobb",
  "dashboard.sortName": "Företagsnamn",
  "dashboard.sortPages": "Sidor",
  "dashboard.sortSuccessRate": "Framgångsgrad",
  "dashboard.sortSuccessful": "Lyckade crawlningar",
  "dashboard.successRate": "Framgångsgrad",
  "dashboard.successful": "Lyckade",
  "dashboard.summary.extractedLabel": "Extraherade jobb",
  "dashboard.summary.failedLabel": "Misslyckade",
  "dashboard.summary.foundLabel": "Hittade jobb",
  "dashboard.summary.successLabel": "Lyckade",
  "dashboard.summary.totalCrawls": "Totalt antal crawlningar",
  "dashboard.summary.uniqueUrls": "Unika URL:er",
  "dashboard.syncingCompanySettings": "Synkroniserar företagsinställningar...",
  "dashboard.time": "Tid",
  "dashboard.title": "Crawl-instrumentpanel",
  "dashboard.tmtBadge.noYtunnus": "Työmarkkinatori-detalj: inget Y-tunnus extraherades från HTML",
  "dashboard.tmtBadge.noYtunnusShort": "Inget Y-tunnus",
  "dashboard.tmtBadge.yTunnusNoCompany": "Y-tunnus extraherades men inget matchande företag hittades i CompaniesTable",
  "dashboard.tmtBadge.yTunnusNoCompanyShort": "Y-tunnus / inget fört.",
  "dashboard.tmtBadge.yTunnusUnknown": "Äldre crawl-rad: Y-tunnus-metadata har inte registrerats ännu (crawl om för att klassificera)",
  "dashboard.tmtSourceTooltip": "Det här jobbet hämtades från Työmarkkinatori (TE-tjänsterna / finländska offentliga arbetsförmedlingslistor).",
  "dashboard.tmtYtunnusFilter.all": "Vilken som helst",
  "dashboard.tmtYtunnusFilter.noCompany": "Y-tunnus saknas i Companies",
  "dashboard.tmtYtunnusFilter.noExtract": "Ingen Y-tunnus extraherad",
  "dashboard.toolsModal.actionsHeading": "Åtgärder",
  "dashboard.toolsModal.closeBackdrop": "Stäng",
  "dashboard.toolsModal.closeButton": "Stäng",
  "dashboard.toolsModal.openButton": "Verktyg & konfig",
  "dashboard.toolsModal.openButtonSr": "Öppna underhåll, uppdatering, DLQ och instruktioner för hämtning",
  "dashboard.toolsModal.title": "Verktyg och konfiguration",
  "dashboard.totalCrawls": "Totalt antal crawlningar",
  "dashboard.tyomarkkinatoriCrawlFilter.all": "Alla crawl-rader",
  "dashboard.tyomarkkinatoriCrawlFilter.nonTmt": "Endast rader utan TMT",
  "dashboard.tyomarkkinatoriCrawlFilter.tmtOnly": "Endast TMT-rader",
  "dashboard.uncheck": "Avmarkera",
  "dashboard.unsave": "Ta bort från sparade",
  "dashboard.viewAttributes": "Visa attribut",
  "dashboard.viewJobs": "Visa",
  "dashboard.viewMessageBody": "Visa meddelandetext",
  "dashboard.viewOnGoogleMaps": "Visa på Google Maps",
  "dashboard.yellowNoJobs": "Gul (Inga jobb)",
  "employerPortal.nav": "Arbetsgivarportal",
  "employerScoreCard.dimension.benefits": "förmåner",
  "employerScoreCard.dimension.flexibility": "flexibilitet",
  "employerScoreCard.dimension.growth": "tillväxt",
  "employerScoreCard.dimension.pay": "lön",
  "employerScoreCard.dimension.stability": "stabilitet",
  "employerScoreCard.dimension.transparency": "transparens",
  "employerScoreCard.disclaimer": "Beräknat utifrån jobbdata, inte recensioner",
  "employerScoreCard.howWeCalculate": "Hur vi beräknar detta",
  "employerScoreCard.methodology": "Betyget baseras på lönekonkurrenskraft från publicerade löneintervall (där vi har tillräckligt många annonser), flexibilitet gällande distans- och hybridarbete, anställningsstabilitet över tid, tillväxtsignaler från rollfördelning och trender i rekryteringsvolym, förmåner och personalförmåner som nämns i annonser samt transparens (hur ofta annonser anger en verklig, icke uppskattad lön och en rekryteringsprocess).",
  "employerScoreCard.strongestAt": "Starkast inom {dimension}",
  "employerScoreCard.subscore.benefits": "Förmåner",
  "employerScoreCard.subscore.flexibility": "Flexibilitet",
  "employerScoreCard.subscore.growth": "Tillväxt",
  "employerScoreCard.subscore.pay": "Lön",
  "employerScoreCard.subscore.stability": "Stabilitet",
  "employerScoreCard.subscore.transparency": "Transparens",
  "engagement.nav.signIn": "Logga in",
  "engagement.trustpilotPrompt.leaveReview": "Lämna en recension",
  "engagement.trustpilotPrompt.offer": "Du använder Mina jobb flitigt. Skulle du vilja lämna oss en snabb recension?",
  "facets.benefits": "Förmån",
  "facets.company": "Företag",
  "facets.companyIndustry": "Bransch",
  "facets.education": "Utbildningsnivå",
  "facets.field": "Område",
  "facets.jobType": "Anställningsform",
  "facets.language": "Språk",
  "facets.location": "Plats",
  "facets.management": "Ledarskap",
  "facets.remoteness": "Arbetsupplägg",
  "facets.role": "Roll",
  "facets.roleLevel": "Rollnivå",
  "facets.skills": "Kompetens",
  "feedback.button.label": "Lämna feedback",
  "feedback.cancel": "Avbryt",
  "feedback.error": "Kunde inte skicka feedback. Försök igen.",
  "feedback.label": "Din feedback",
  "feedback.modal.close": "Stäng",
  "feedback.modal.description": "Vi vill gärna höra dina tankar. Dela med dig av din feedback för att hjälpa oss att bli bättre.",
  "feedback.modal.title": "Skicka feedback",
  "feedback.page.anonymous": "Anonym",
  "feedback.page.attachmentDownloadError": "Det gick inte att ladda ner bilagan. Försök igen.",
  "feedback.page.attachmentDownloadTitle": "Ladda ner bilaga",
  "feedback.page.cannedReply.gdpr": "Tack för att du hör av dig. Vi har tagit emot din integritetsbegäran och behandlar den inom 30 dagar enligt GDPR. Vi återkommer i den här tråden när den är klar.",
  "feedback.page.category.abuse": "Missbruk",
  "feedback.page.category.accessibility": "Tillgänglighet",
  "feedback.page.category.all": "Alla kategorier",
  "feedback.page.category.ashton": "Ashton (personlig)",
  "feedback.page.category.corrections": "Rättelser",
  "feedback.page.category.developers": "Utvecklare",
  "feedback.page.category.dmarcReport": "DMARC-rapport",
  "feedback.page.category.employers": "Arbetsgivare",
  "feedback.page.category.jobAlerts": "Jobbevakning",
  "feedback.page.category.john": "John (personlig)",
  "feedback.page.category.maria": "Maria (personlig)",
  "feedback.page.category.other": "Övrigt",
  "feedback.page.category.partners": "Partner",
  "feedback.page.category.privacy": "Integritet",
  "feedback.page.category.security": "Säkerhet",
  "feedback.page.channel.all": "Alla",
  "feedback.page.channel.email": "E-post",
  "feedback.page.channel.form": "Formulär",
  "feedback.page.delete": "Ta bort feedback",
  "feedback.page.deleteConfirm": "Är du säker på att du vill ta bort den här feedbacken?",
  "feedback.page.deleteError": "Kunde inte ta bort feedbacken. Försök igen.",
  "feedback.page.description": "Visa och hantera användarfeedback",
  "feedback.page.emailReporterTooltip": "Öppnar ditt e-postprogram med ett förifyllt svar till denna anmälare",
  "feedback.page.followUpEmailGreeting": "Hej{name},",
  "feedback.page.followUpEmailSubject": "Uppföljning av din anmälan till JobCrawls",
  "feedback.page.followUpEmailThanksLine": "Tack för att du anmälde detta till JobCrawls:",
  "feedback.page.followUpEmailWhatWeDidLine": "Här är vad vi gjorde åt saken:",
  "feedback.page.identifyReporter": "Identifiera anmälaren",
  "feedback.page.listTitle": "All feedback",
  "feedback.page.noFeedback": "Ingen feedback än",
  "feedback.page.refresh": "Uppdatera",
  "feedback.page.replyError": "Det gick inte att skicka svaret. Försök igen.",
  "feedback.page.replyPlaceholder": "Skriv ett svar…",
  "feedback.page.sendReply": "Skicka svar",
  "feedback.page.signOffNameLabel": "Underteckna svar som",
  "feedback.page.signOffNamePlaceholder": "Ditt namn",
  "feedback.page.signOffTitlePlaceholder": "Titel",
  "feedback.page.signingAs": "Signatur",
  "feedback.page.submitTitle": "Skicka feedback",
  "feedback.page.threadStatus.closed": "Stängd",
  "feedback.page.threadStatus.open": "Öppen",
  "feedback.page.threadStatus.replied": "Besvarad",
  "feedback.page.useGdprTemplate": "Använd GDPR-svarsmall",
  "feedback.page.viewMetadata": "Visa metadata",
  "feedback.page.viewReportedCompany": "Visa företag",
  "feedback.page.viewReportedJob": "Visa anmält jobb",
  "feedback.page.viewReportedPage": "Visa anmäld sida",
  "feedback.placeholder": "Berätta för oss vad vi bör ändra eller lägga till...",
  "feedback.postSubmit.signInBody": "Skapa ett gratis konto så att vi kan svara om vi har frågor om din feedback.",
  "feedback.postSubmit.signInButton": "Logga in eller skapa konto",
  "feedback.postSubmit.signInTitle": "Vill du att vi följer upp?",
  "feedback.submit": "Skicka",
  "feedback.submitting": "Skickar...",
  "feedback.success": "Tack! Din feedback har skickats.",
  "filters.allFilters.navigation": "Alla filteralternativ",
  "filters.top.ariaLabel": "Filterkategorier",
  "filters.top.clearAll": "Rensa alla filter",
  "footer.aboutJobcrawls": "Om JobCrawls",
  "footer.accessibilityStatementLink": "Tillgänglighetsutlåtande",
  "footer.aiTranslationDisclaimer": "Obs: En del av innehållet på denna webbplats är maskinöversatt med AI och kan innehålla fel.",
  "footer.allLocations": "Alla platser",
  "footer.bestEmployers": "Arbetsgivare",
  "footer.brandDescription": "JobCrawls är en jobbsökmotor för Finland. Vi indexerar lediga jobb direkt från tusentals arbetsgivares karriärsidor varje dag, på engelska, finska och svenska, med transparent lönedata och inga sponsrade rankningar.",
  "footer.browseAllPages": "Bläddra bland alla sidor",
  "footer.businessIdLabel": "FO-nummer",
  "footer.colCompany": "Företag",
  "footer.colEmployersAndDevelopers": "Arbetsgivare och utvecklare",
  "footer.colFindJobs": "Hitta jobb",
  "footer.colJobSeekers": "Arbetssökande",
  "footer.collectiveAgreementsLink": "Kollektivavtal",
  "footer.connectorPrivacy": "Connectors integritetspolicy",
  "footer.contact": "Kontakt",
  "footer.cookieSettings": "Cookie-inställningar",
  "footer.editorialStandards": "Redaktionella riktlinjer",
  "footer.featuresLink": "Funktioner",
  "footer.forDevelopers": "För utvecklare",
  "footer.forEmployersLink": "För arbetsgivare",
  "footer.freeCareersPageLink": "Gratis karriärsida",
  "footer.guidesAndArticles": "Guider och artiklar",
  "footer.howCrawlerWorks": "Hur vår crawler fungerar",
  "footer.jobsInEspoo": "Jobb i Esbo",
  "footer.jobsInHelsinki": "Jobb i Helsingfors",
  "footer.jobsInOulu": "Jobb i Uleåborg",
  "footer.jobsInTampere": "Jobb i Tammerfors",
  "footer.jobsInTurku": "Jobb i Åbo",
  "footer.openJobsInFinland": "Lediga jobb i Finland",
  "footer.partnerships": "Mediepartnerskap",
  "footer.privacy": "Integritetspolicy",
  "footer.remoteJobs": "Distansjobb",
  "footer.rolesIndex": "Jobb per yrke",
  "footer.salariesByRole": "Löner per yrke",
  "footer.signIn": "Logga in",
  "footer.sitemap": "Webbplatskarta",
  "footer.terms": "Användarvillkor",
  "forEmployers.contact.desc": "Berätta vad ni är intresserade av och lite om ert team. Vi läser varje meddelande själva — ingen säljkö.",
  "forEmployers.contact.error": "Något gick fel. Försök igen.",
  "forEmployers.contact.interest.branding": "Stöd för arbetsgivarvarumärke",
  "forEmployers.contact.interest.careers": "Gratis karriärsida",
  "forEmployers.contact.interest.other": "Något annat",
  "forEmployers.contact.interest.promoted": "Framhävda tjänster",
  "forEmployers.contact.interestLabel": "Vad är ni intresserade av?",
  "forEmployers.contact.learnMore": "Läs mer om oss",
  "forEmployers.contact.placeholder": "Berätta om era rekryteringsbehov…",
  "forEmployers.contact.submit": "Skicka förfrågan",
  "forEmployers.contact.submitting": "Skickar…",
  "forEmployers.contact.success": "Tack! Vi återkommer snart.",
  "forEmployers.contact.title": "Anmäl intresse",
  "forEmployers.cta.expressInterest": "Anmäl intresse",
  "forEmployers.cta.seeScore": "Se hur arbetsgivarpoängen fungerar",
  "forEmployers.hero.body": "Vi indexerar er karriärsida direkt, så att jobbsökare hittar era riktiga annonser bredvid riktig lönedata: ingen annonsering, ingen instrumentpanel, ingen avgift för att synas. Nu öppnar vi upp två nya sätt att sticka ut: framhävda tjänster och personligt stöd för arbetsgivarvarumärke.",
  "forEmployers.hero.point.automatic": "Automatisk synlighet utan registrering",
  "forEmployers.hero.point.real": "Riktig indexeringsdata, ingen betald placering",
  "forEmployers.hero.point.score": "Transparent, publicerad arbetsgivarpoäng",
  "forEmployers.hero.point.trilingual": "Trespråkig räckvidd — EN, FI, SV",
  "forEmployers.new.branding.cta": "Prata med oss om varumärket",
  "forEmployers.new.branding.desc": "Vi arbetar direkt med ert team för att skärpa hur er företagsprofil framstår — kultur, värderingar och rolltydlighet — så att den matchar det er arbetsgivarpoäng redan säger om er.",
  "forEmployers.new.branding.title": "Stöd för arbetsgivarvarumärke",
  "forEmployers.new.careers.cta": "Skaffa en gratis karriärsida",
  "forEmployers.new.careers.desc": "Ingen karriärsida? Vi står för en sida med ert varumärke, gratis — ni klistrar in annonslänkarna, vi sköter resten. Er webbplats ”Lediga jobb”-knapp får äntligen någonstans riktigt att peka.",
  "forEmployers.new.careers.learnMore": "Läs mer",
  "forEmployers.new.careers.pilotNote": "Vi öppnar det här först för en mindre grupp arbetsgivare.",
  "forEmployers.new.careers.title": "Gratis karriärsida",
  "forEmployers.new.promoted.cta": "Anmäl intresse för framhävda tjänster",
  "forEmployers.new.promoted.desc": "Prioriterad placering för era lediga tjänster i relevanta sökningar och kategorisidor, med en markering som drar uppmärksamhet dit sökare redan tittar.",
  "forEmployers.new.promoted.title": "Framhävda tjänster",
  "forEmployers.new.subtitle": "Vi öppnar dessa först för en mindre grupp arbetsgivare.",
  "forEmployers.new.title": "Nytt: sätt att sticka ut",
  "forEmployers.score.cta": "Läs hela metodiken",
  "forEmployers.score.ctaBestCompanies": "Se rankingen för företag",
  "forEmployers.score.desc": "Ett bokstavsbetyg, sex pelare, helt publicerat. Företag som får bra poäng lyfts fram i vår Företag-ranking, ingen anmälan krävs.",
  "forEmployers.score.pillar.benefits": "Förmåner och personalförmåner",
  "forEmployers.score.pillar.flex": "Flexibilitet",
  "forEmployers.score.pillar.growth": "Tillväxtsignaler",
  "forEmployers.score.pillar.pay": "Lön",
  "forEmployers.score.pillar.stability": "Anställningsstabilitet",
  "forEmployers.score.pillar.transparency": "Transparens",
  "forEmployers.score.title": "Arbetsgivarpoängen",
  "forEmployers.subtitle": "Era lediga tjänster syns redan här — automatiskt, på engelska, finska och svenska.",
  "forEmployers.title": "För arbetsgivare",
  "forEmployers.today.step1.desc": "Precis som en sökmotor indexerar vi de jobbannonser som redan finns på er egen webbplats — ingen inlämning eller integration behövs.",
  "forEmployers.today.step1.title": "Vi indexerar er karriärsida",
  "forEmployers.today.step2.desc": "Via sökningar, lönejämförelser och vår företagsranking, allt trespråkigt och SEO-optimerat.",
  "forEmployers.today.step2.title": "Jobbsökare hittar er",
  "forEmployers.today.step3.desc": "Baserat på lönetransparens, flexibilitet, anställningsstabilitet och tillväxtsignaler — samma publicerade metod för alla företag.",
  "forEmployers.today.step3.title": "Ni får poäng, transparent",
  "forEmployers.today.title": "Så här syns ni redan idag",
  "forEmployers.values.desc": "Vi vill bara vara värda era sökandes tid. Det innebär att lyfta fram arbetsgivare som betalar rättvist, kommunicerar tydligt och behandlar kandidater väl, och att bygga allt nytt, som framhävda tjänster eller stöd för arbetsgivarvarumärke, ovanpå den standarden, inte vid sidan av den.",
  "forEmployers.values.title": "Våra värderingar",
  "freeCareersPage.breadcrumb": "Gratis karriärsida",
  "freeCareersPage.cta": "Skaffa er gratis karriärsida",
  "freeCareersPage.cta.hint": "Berätta ert företagsnamn så tar vi det därifrån.",
  "freeCareersPage.cta.pilotNote": "Vi öppnar det här först för en mindre grupp arbetsgivare, så vi läser och ordnar varje förfrågan själva.",
  "freeCareersPage.features.apply": "Kandidater söker via er ursprungliga LinkedIn-annons — ingen ny inkorg att bevaka",
  "freeCareersPage.features.branded": "Ert varumärke — logotyp, färger och er egen introduktion",
  "freeCareersPage.features.fresh": "Annonser går ut automatiskt när ansökningstiden stängs",
  "freeCareersPage.features.languages": "Tre språk: engelska, finska och svenska",
  "freeCareersPage.features.search": "Era jobb syns också i JobCrawls sök och når kandidater i hela Finland",
  "freeCareersPage.features.title": "Vad som ingår",
  "freeCareersPage.features.zero": "Noll underhåll: inga tillägg, inget CMS, inga hostingfakturor",
  "freeCareersPage.hero.subtitle": "Rekryterar ni via LinkedIn men saknar en plats för jobben på er egen webbplats? Vi står för en karriärsida med ert varumärke — er logotyp, era färger, era lediga roller — helt gratis, utan något att installera eller underhålla.",
  "freeCareersPage.hero.title": "Gratis karriärsida för ditt företag",
  "freeCareersPage.how.step1.desc": "Det räcker med ett mejl för att komma igång. Vi skapar er sida med ert varumärke — logotyp, färg och en introduktion ni kan redigera — på engelska, finska och svenska.",
  "freeCareersPage.how.step1.title": "Vi sätter upp er sida",
  "freeCareersPage.how.step2.desc": "Publicera på LinkedIn som vanligt och klistra in annonslänken i portalen. Vi hämtar uppgifterna, översätter dem och håller listan aktuell — annonsen försvinner automatiskt när den stängs.",
  "freeCareersPage.how.step2.title": "Klistra in annonslänkarna",
  "freeCareersPage.how.step3.desc": "Ändra er webbplats ”Lediga jobb”-knapp så att den pekar på er nya karriärsida. Den enda länken är allt vi ber om — det är så den kostnadsfria sidan betalar sig.",
  "freeCareersPage.how.step3.title": "Peka er webbplats dit",
  "freeCareersPage.how.title": "Så fungerar det",
  "freeCareersPage.portalLink": "Redan igång? Öppna din arbetsgivarportal",
  "freeCareersPage.whyFree.desc": "JobCrawls är en jobbsökmotor för Finland. När er karriärsida bor hos oss blir era lediga jobb en del av vårt index — jobb som annars bara skulle finnas på LinkedIn — och länken från er webbplats visar sökmotorer (och oss) att sidan verkligen är er. Det är hela affären: inga avgifter, ingen inlåsning, och ni kan lämna när ni vill.",
  "freeCareersPage.whyFree.title": "Varför är den gratis?",
  "hit.applicationDeadline": "Sista ansökningsdag: {date}",
  "hit.companyInsights.cue": "Företagsinsikter",
  "hit.companyLinkTitle": "Öppna företagsprofilen: data och insikter om {company}",
  "hit.companyProfile.aria": "Visa företagsprofil, rekryteringsdata och insikter för {company}",
  "hit.driversLicenseRequired": "Körkort krävs",
  "hit.hidden": "Dold",
  "hit.hide.button": "Dölj",
  "hit.hide.menu": "Dölj",
  "hit.jobTitle": "Jobb",
  "hit.jobTypeLinkAria": "Sök efter {jobType}-jobb",
  "hit.jobTypeLinkTitle": "Sök efter {jobType}-jobb",
  "hit.linkCopied": "Länken kopierades till urklipp!",
  "hit.locationLinkAria": "Sök efter jobb i {location}",
  "hit.locationLinkTitle": "Sök efter jobb i {location}",
  "hit.locationNotAvailable": "Plats saknas",
  "hit.markAsApplied.menu": "Markera som ansökt",
  "hit.markAsState": "Markera som {state}",
  "hit.moreLocations": "+{count} till",
  "hit.moreOptions": "Fler alternativ",
  "hit.openApplication": "Öppen ansökan",
  "hit.postedDate": "Publicerad: {date}",
  "hit.postedDate.detail": "Publicerad: {date}",
  "hit.remotenessLinkAria": "Sök efter {remoteness}-jobb",
  "hit.remotenessLinkTitle": "Sök efter {remoteness}-jobb",
  "hit.removeApplied": "Ta bort från ansökta",
  "hit.roleLevelLinkAria": "Sök efter {roleLevel}-jobb",
  "hit.roleLevelLinkLabel": "{roleLevel}-jobb",
  "hit.roleLevelLinkTitle": "Sök efter {roleLevel}-jobb",
  "hit.salaryNotSpecified": "Lön ej angiven",
  "hit.salaryNotSpecified.card": "Lön ej angiven",
  "hit.save": "Spara",
  "hit.save.detail": "Spara",
  "hit.saved": "Sparad",
  "hit.saved.detail": "Sparad",
  "hit.seeAd": "Detaljer",
  "hit.share": "Dela",
  "hit.share.detail": "Dela",
  "hit.shareError": "Något gick fel när det försöktes dela det här jobbet.",
  "hit.shareError.retry": "Försök igen",
  "hit.summerJob": "Sommarjobb",
  "hit.toast.applied": "Markerad som ansökt",
  "hit.toast.hidden": "Jobbet är dolt",
  "hit.toast.hidden.undo": "Ångra",
  "hit.toast.savedWithCount": "Sparat: {count, plural, one {# jobb} other {# jobb}} i Mina jobb",
  "hit.toast.unapplied": "Tagen bort från ansökta",
  "hit.toast.unhidden": "Jobbet är synligt igen",
  "hit.toast.unsaved": "Jobbet togs bort från sparade",
  "hit.toast.viewMyJobs": "Visa →",
  "hit.toast.viewed": "Markerad som läst",
  "hit.tooltip.details": "Visa fullständiga jobbdetaljer och beskrivning",
  "hit.tooltip.filterByCompany": "Filtrera jobb efter det här företaget",
  "hit.tooltip.filterByJobType": "Filtrera jobb efter typ: {jobType}",
  "hit.tooltip.filterByLanguages": "Filtrera jobb efter krävda språk: {languages}",
  "hit.tooltip.filterByLevel": "Filtrera jobb efter nivå: {level}",
  "hit.tooltip.filterByLocation": "Filtrera jobb i: {locations}",
  "hit.tooltip.filterByRemoteness": "Filtrera jobb efter arbetsform: {remoteness}",
  "hit.tooltip.moreOptions": "Fler alternativ",
  "hit.tooltip.save": "Spara det här jobbet för att jämföra med andra",
  "hit.tooltip.saved": "Ta bort från sparade jobb",
  "hit.tooltip.share": "Dela det här jobbet",
  "hit.unhide": "Visa jobb igen",
  "hitGroup.openRoles": "{count, plural, one {# ledig tjänst} other {# lediga tjänster}}",
  "hitGroup.viewCompanyProfile": "Visa företagsprofil",
  "hitV2.estMonthly": "Beräknad månadslön",
  "hitV2.monthly": "Månadslön",
  "hitV2.viewJob": "Visa jobb",
  "hub.bottomNav.alerts": "Bevakningar",
  "hub.bottomNav.ariaLabel": "Verktygsnavigering",
  "hub.bottomNav.profile": "Profil",
  "hub.guestSyncNote": "Sparat på den här enheten — {signIn} för att synka mellan enheter",
  "hub.guestSyncNote.signIn": "logga in",
  "hub.nav.myJobs": "Mina jobb",
  "hub.nav.myJobs.count": "{savedCount} sparade · {activeCount} aktiva",
  "hub.nav.profile": "Profil och CV",
  "hub.nav.searchesAlerts": "Sökningar och bevakningar",
  "hub.nav.searchesAlerts.newCount": "{count} nya",
  "hub.nav.watchlist": "Bevakade",
  "hub.nav.watchlist.newsCount": "{count} med nyheter",
  "hub.title": "Mina jobb",
  "instantsearch.searchBoxLink.placeholder": "Sök jobb",
  "instantsearch.searchbox.placeholder": "Sök jobb, språk eller stad",
  "job.copyCompanyName": "Kopiera företagsnamn",
  "jobAlerts.confirm.confirm": "Bekräfta",
  "jobAlerts.confirm.errorBody": "Något gick fel. Försök igen om en liten stund.",
  "jobAlerts.confirm.explanation": "Bekräfta din e-postadress för att börja få jobbaviseringar från JobCrawls.",
  "jobAlerts.confirm.heading": "Bekräfta din jobbevakning",
  "jobAlerts.confirm.invalidLink": "Denna bekräftelselänk är ogiltig eller har gått ut. Aktivera aviseringar igen via dina sparade sökningar för att få en ny länk.",
  "jobAlerts.confirm.successBody": "Klart – vi skickar e-post till dig när nya jobb matchar dina sparade sökningar.",
  "jobAlerts.confirm.successHeading": "Din e-postadress är bekräftad",
  "jobAlerts.confirm.working": "Bekräftar…",
  "jobAlerts.newMatches.errorBody": "Vi kunde inte ladda dina nya matchningar. Försök igen om en liten stund.",
  "jobAlerts.newMatches.summaryHeading": "{count, plural, one {# nytt jobb} other {# nya jobb}} sedan ditt senaste besök",
  "jobAlerts.newMatches.summaryMore": "+{count} till i dina sökningar nedan",
  "jobAlerts.newMatches.viewAllInSection": "Visa alla {count} nya matchningar",
  "jobAlerts.panel.activeStatus.v2": "Aktivera aviseringar per sökning nedan för att börja få dem.",
  "jobAlerts.panel.detailCopy.v2": "Som standard varje måndagsmorgon, eller dagligen om du föredrar det. Skickas till {email}. Du kan stänga av när som helst här eller via länken i varje e-postmeddelande.",
  "jobAlerts.panel.disable": "Stäng av e-postaviseringar",
  "jobAlerts.panel.enable": "Aktivera e-postaviseringar",
  "jobAlerts.panel.error": "Kunde inte spara. Försök igen.",
  "jobAlerts.panel.frequencyDaily": "Dagligen",
  "jobAlerts.panel.frequencyDailyHint": "Varje dag",
  "jobAlerts.panel.frequencyLegend": "Hur ofta",
  "jobAlerts.panel.frequencyWeekly.v2": "Veckovis",
  "jobAlerts.panel.frequencyWeeklyHint": "Måndag morgon",
  "jobAlerts.panel.heading": "E-postaviseringar",
  "jobAlerts.panel.languageLegend": "Språk för e-post",
  "jobAlerts.panel.leadCopy": "Få ett e-postmeddelande så fort ett jobb matchar en av dina sparade sökningar.",
  "jobAlerts.panel.noEmail": "Ditt konto saknar en e-postadress, så aviseringar är inte tillgängliga.",
  "jobAlerts.panel.pendingStatus.v2": "Kontrollera din inkorg och bekräfta din e-postadress för att aktivera aviseringar.",
  "jobAlerts.panel.privacyLink": "Integritetspolicy",
  "jobAlerts.panel.sectionHeading": "E-postsammanfattning",
  "jobAlerts.panel.seeNewMatches": "Se nya matchningar nu",
  "jobAlerts.panel.statusOff": "Av",
  "jobAlerts.panel.statusOn": "På",
  "jobAlerts.panel.statusPending": "Bekräftas",
  "jobAlerts.panel.update": "Spara ändringar",
  "jobAlerts.signInPrompt": "Missa aldrig en ny matchning — {signIn} för att se uppdateringar i realtid och aktivera e-postaviseringar för dina sökningar.",
  "jobAlerts.toggle.failed": "Kunde inte spara — försök igen",
  "jobAlerts.toggle.label": "Mejla mig nya matchningar",
  "jobAlerts.toggle.label.activate": "Aktivera aviseringar",
  "jobAlerts.toggle.needsSubscription": "Aktivera e-postaviseringar ovanför först",
  "jobAlerts.unsubscribe.confirm": "Avregistrera",
  "jobAlerts.unsubscribe.errorBody": "Något gick fel. Försök igen om en liten stund.",
  "jobAlerts.unsubscribe.explanation": "Detta stoppar alla e-postaviseringar om jobb från JobCrawls till din adress. Dina sparade sökningar förblir orörda.",
  "jobAlerts.unsubscribe.heading": "Avregistrera dig från jobbaviseringar",
  "jobAlerts.unsubscribe.invalidLink": "Denna avregistreringslänk är ogiltig eller ofullständig. Använd länken från ett nyligen mottaget aviseringsmejl, eller hantera aviseringar via dina sparade sökningar när du är inloggad.",
  "jobAlerts.unsubscribe.successBody": "Du kommer inte längre att få e-postaviseringar om jobb. Du kan när som helst återaktivera aviseringar via dina sparade sökningar när du är inloggad.",
  "jobAlerts.unsubscribe.successHeading": "Du är nu avregistrerad",
  "jobAlerts.unsubscribe.working": "Avregistrerar…",
  "jobAlerts.watchlistDigest.combined": "Kombinerat med detta e-postmeddelande",
  "jobAlerts.watchlistDigest.error.v2": "Det gick inte att spara. Försök igen.",
  "jobAlerts.watchlistDigest.frequencyLegend": "Frekvens för bevakningslistans e-post",
  "jobAlerts.watchlistDigest.legend": "Uppdateringar för bevakningslistan",
  "jobAlerts.watchlistDigest.saving": "Sparar…",
  "jobAlerts.watchlistDigest.separate": "Skicka som ett separat e-postmeddelande",
  "jobChart.popover.categoriesShown": "Visade kategorier",
  "jobChart.popover.companyContext": "Baserat på {companyName}s annonser i vår data.",
  "jobChart.popover.count": "Jobbannonser",
  "jobChart.popover.share": "Andel av diagrammet",
  "jobChart.popover.totalInRing": "Totalt i denna ring",
  "jobChart.segmentHint": "Tryck på eller hovra över ett segment för detaljer.",
  "jobDetail.lastSeen.daysAgo": "{value, plural, one {Sedd för {value} dag sedan} other {Sedd för {value} dagar sedan}}",
  "jobDetail.lastSeen.hoursAgo": "{value, plural, one {Sedd för {value} timme sedan} other {Sedd för {value} timmar sedan}}",
  "jobDetail.lastSeen.minutesAgo": "{value, plural, one {Sedd för {value} minut sedan} other {Sedd för {value} minuter sedan}}",
  "jobDetail.relatedPages.intro": "Yrket, staden, arbetsgivaren och lönerna bakom den här annonsen, var och en på sin egen sida.",
  "jobDetail.relatedPages.title": "Utforska mer",
  "jobDetail.roleHub.jobsInCity": "{role}, jobb i {city}",
  "jobDetail.roleHub.moreJobs": "Fler jobb som {role}",
  "jobDetail.save.alsoFollowAction": "Följ",
  "jobDetail.save.alsoFollowToast": "Jobbet sparat. Vill du följa {company} och höra om deras nästa jobb?",
  "jobDetail.save.nowFollowingToast": "Du följer nu {company}. Nya jobb visas på din bevakningslista.",
  "jobDetail.similarJobs.algoliaListTitle": "Liknande jobb",
  "jobDetail.similarJobs.description": "Hitta fler möjligheter som matchar dina intressen och färdigheter",
  "jobDetail.similarJobs.seeAll": "Visa alla",
  "jobDetail.similarJobs.sourceNote": "Från JobCrawls sökning: samma rolltitel och primära plats som denna annons (denna tjänst exkluderad). Upp till 8 resultat.",
  "jobDetail.similarJobs.title": "Relaterade möjligheter",
  "jobDetail.viewOnMapCommute": "Se på kartan och kolla din pendling",
  "jobDetailAlertCta.bannerText": "Missa aldrig ett nytt liknande {role}-jobb",
  "jobDetailAlertCta.bannerTextWithLocation": "Missa aldrig ett nytt {role}-jobb i {location}",
  "jobDetailAlertCta.ctaButton": "Få e-postaviseringar",
  "jobDetailAlertCta.dismissLabel": "Stäng",
  "jobDetailAlertCta.errorText": "Något gick fel. Vi kunde inte aktivera aviseringar. Försök igen.",
  "jobDetailAlertCta.manageLink": "Hantera aviseringar",
  "jobDetailAlertCta.pendingText": "Nästan klart: kontrollera din inkorg och bekräfta din e-postadress för att aktivera aviseringar.",
  "jobDetailAlertCta.subText": "Gratis vecko- eller dagsvis sammanfattning. Avregistrera dig när som helst.",
  "jobDetailAlertCta.successText": "Klart – vi skickar e-post till dig om liknande jobb.",
  "jobDetailPage.404.backHome": "Tillbaka till startsidan",
  "jobDetailPage.404.description": "Tyvärr kunde vi inte hitta det här jobbet. Det kan ha tagits bort eller så är länken felaktig.",
  "jobDetailPage.404.heading": "Sidan kunde inte hittas",
  "jobDetailPage.aboutCompany": "Om",
  "jobDetailPage.applicationDeadline": "Sista ansökningsdag",
  "jobDetailPage.applied": "Ansökt ✓",
  "jobDetailPage.applyMoreOptions": "Fler alternativ för att ansöka",
  "jobDetailPage.applyNavigation": "Sök jobbet",
  "jobDetailPage.applyNow": "Ansök",
  "jobDetailPage.autofillApplyCta": "Fyll i den här ansökan automatiskt",
  "jobDetailPage.availableLanguages": "Tillgänglig på:",
  "jobDetailPage.benefits": "Förmåner",
  "jobDetailPage.benefitsAndPerks": "Förmåner & Perks",
  "jobDetailPage.businessId": "FO-nummer",
  "jobDetailPage.byRemoteness": "Efter distansarbete",
  "jobDetailPage.chartsDataRange": "Visad data är baserad på historiska platsannonser från vår databas.",
  "jobDetailPage.collapseCompensation": "Dölj ersättningsdetaljer",
  "jobDetailPage.companiesHiringInLocation": "Företag som anställer i {location}",
  "jobDetailPage.companyCollapsedBody": "Expandera för att se trenddiagram, platsfördelning, språkefterfrågan och kartdetaljer.",
  "jobDetailPage.companyDistributionDescription": "Visar de {count} främsta företagen baserat på antal jobbannonser",
  "jobDetailPage.companyInfoFromTradeRegister": "Innehåller uppgifter från det finländska handelsregistret.",
  "jobDetailPage.compensation": "Ersättning",
  "jobDetailPage.contact": "Kontakt:",
  "jobDetailPage.coverLetter.basedOn": "Baserat på: {entries}",
  "jobDetailPage.coverLetter.copied": "Kopierat!",
  "jobDetailPage.coverLetter.copy": "Kopiera text",
  "jobDetailPage.coverLetter.download": "Ladda ner personligt brev",
  "jobDetailPage.coverLetter.editHint": "Redigera texten nedan innan du kopierar eller laddar ner den. Den är din att justera.",
  "jobDetailPage.coverLetter.failed": "Kunde inte skapa ditt personliga brev. Försök igen senare.",
  "jobDetailPage.coverLetter.generateCta": "Skapa mitt personliga brev",
  "jobDetailPage.coverLetter.intro": "Skapa ett personligt brev utifrån din profil och det här jobbet. Du kan redigera det innan du laddar ner det.",
  "jobDetailPage.coverLetter.loading": "Skapar ditt personliga brev…",
  "jobDetailPage.coverLetter.networkError": "Nätverksfel. Kontrollera din anslutning.",
  "jobDetailPage.coverLetter.notConfigured": "Att skapa personliga brev är inte aktiverat för den här miljön.",
  "jobDetailPage.coverLetter.overclaimWarning": "Vi kunde inte hitta ”{skill}” i din profil. Se till att det stämmer.",
  "jobDetailPage.coverLetter.quotaExceeded": "Du har nått dagens gräns för personliga brev. Den återställs i morgon.",
  "jobDetailPage.coverLetter.sourceCompany": "Företagsinformation",
  "jobDetailPage.coverLetter.sourceSkills": "Kompetenser",
  "jobDetailPage.coverLetter.ungroundedFlag": "{count, plural, one {En del} other {# delar}} av brevet var inte kopplad till något specifikt i din profil. Kontrollera att {count, plural, one {den stämmer} other {de stämmer}}.",
  "jobDetailPage.description": "Jobbeskrivning",
  "jobDetailPage.estimatedExpiry": "Beräknat utgångsdatum",
  "jobDetailPage.estimatedNetSalary.explanation": "Uppskattad nettolön för {year} efter finländsk inkomstskatt, pensionsavgift och arbetslöshetsförsäkringsavgift. Beräkningen utgår från landets genomsnittliga kommunalskatt ({rate} %), ingen kyrkoskatt och endast standardavdrag. Din faktiska nettolön beror på din kommun, ditt kyrkomedlemskap, din ålder och din familjesituation.",
  "jobDetailPage.expandCompanyData": "Expandera företagsinformation för att se trender, fördelningar och karta",
  "jobDetailPage.expandCompensation": "Expandera ersättningsdetaljer",
  "jobDetailPage.expired.backToSearch": "Tillbaka till sökresultaten",
  "jobDetailPage.expired.toastMessage": "Den här annonsen kan vara för gammal eller inte längre aktiv.",
  "jobDetailPage.headcount": "Antal anställda",
  "jobDetailPage.hideCharts": "Dölj diagram",
  "jobDetailPage.hiringSnapshotSeo.activeListings": "Aktiva annonser",
  "jobDetailPage.hiringSnapshotSeo.caption": "Aktuella lediga tjänster på {company} via JobCrawls",
  "jobDetailPage.hiringSnapshotSeo.location": "Plats",
  "jobDetailPage.languageNavigation": "Tillgängliga språk",
  "jobDetailPage.languageRequirements": "Språkkrav",
  "jobDetailPage.lastSeenAgoCompact": "{days, plural, =0 {idag} one {#d sedan} other {#d sedan}}",
  "jobDetailPage.lastSeenDetail": "Senast sedd: {date}{ago}",
  "jobDetailPage.listingCompanyIndustryLabel": "Annons",
  "jobDetailPage.loadingMap": "Laddar karta...",
  "jobDetailPage.location": "Plats",
  "jobDetailPage.locationAndRemotenessDistribution": "Fördelning av plats & distansarbete",
  "jobDetailPage.locationDistribution": "Platsfördelning",
  "jobDetailPage.mapError": "Kunde inte ladda kartan",
  "jobDetailPage.markAppliedAction": "Markera som ansökt",
  "jobDetailPage.markAppliedPrompt": "Vi öppnade ansökan i en ny flik. Vill du markera det här jobbet som ansökt?",
  "jobDetailPage.matchBreakdown.collapse": "Dölj matchningsöversikt",
  "jobDetailPage.matchBreakdown.expand": "Expandera matchningsöversikt",
  "jobDetailPage.matchBreakdown.title": "Så här matchar det här jobbet din profil",
  "jobDetailPage.noItems": "Inga objekt att visa.",
  "jobDetailPage.noLocation": "Ingen plats",
  "jobDetailPage.noRemoteness": "Ej angivet",
  "jobDetailPage.officialRegisterName": "Registrerat namn",
  "jobDetailPage.period.day": "dag",
  "jobDetailPage.period.hour": "timme",
  "jobDetailPage.period.month": "månad",
  "jobDetailPage.period.year": "år",
  "jobDetailPage.perks": "Förmåner",
  "jobDetailPage.postedAgo": "{days, plural, =0 {Publicerad idag} one {Publicerad för 1 dag sedan} other {Publicerad för # dagar sedan}}",
  "jobDetailPage.recruitmentProcess": "Rekryteringsprocess",
  "jobDetailPage.remoteness": "Arbetsform",
  "jobDetailPage.remotenessDistribution": "Fördelning av arbetsform",
  "jobDetailPage.remotenessDistribution.short": "Arbetsform",
  "jobDetailPage.requiredLanguages": "Krav på språkkunskaper",
  "jobDetailPage.requirements": "Krav",
  "jobDetailPage.responsibilities": "Ansvarsområden",
  "jobDetailPage.roleAndRoleLevelDistribution": "Fördelning av roll & rollnivå",
  "jobDetailPage.roleDistribution": "Rollfördelning",
  "jobDetailPage.roleLevelDistribution": "Fördelning av rollnivåer",
  "jobDetailPage.roleLevelSnapshotSeo.activeListings": "Aktiva annonser",
  "jobDetailPage.roleLevelSnapshotSeo.caption": "Aktuell fördelning av rollnivåer på {company} via JobCrawls",
  "jobDetailPage.roleLevelSnapshotSeo.level": "Rollnivå",
  "jobDetailPage.roleSnapshotSeo.activeListings": "Aktiva annonser",
  "jobDetailPage.roleSnapshotSeo.caption": "Aktuell rollfördelning på {company} via JobCrawls",
  "jobDetailPage.roleSnapshotSeo.role": "Rolltyp",
  "jobDetailPage.salaryProvenance.employerQuote": "Löneintervallet är hämtat från formuleringen i jobbannonsen.",
  "jobDetailPage.salaryProvenance.extractedNoQuote": "Det här är löneintervallet som anges för just detta jobb, inte ett marknadsgenomsnitt — det hittades inte som citerad text i annonsen, så betrakta det som obekräftat.",
  "jobDetailPage.salarySourceBadge.estimated": "Uppskattad",
  "jobDetailPage.salarySourceBadge.fromListing": "Angiven",
  "jobDetailPage.salarySourceBadge.unverified": "Obekräftad",
  "jobDetailPage.salaryStatistics": "Lönestatistik",
  "jobDetailPage.section.company": "Företagsinformation",
  "jobDetailPage.section.jobDetails": "Jobbdetaljer",
  "jobDetailPage.seeLocation": "Visa plats",
  "jobDetailPage.seeOriginal": "Visa original",
  "jobDetailPage.showCharts": "Visa diagram",
  "jobDetailPage.showCompanyContact": "Visa företagskontakt",
  "jobDetailPage.showContact": "Visa kontakt-e-post",
  "jobDetailPage.showConverted": "Visa EUR/månad",
  "jobDetailPage.showingItemsAboveThreshold": "Visar endast objekt över {percentage}%",
  "jobDetailPage.skillsAndTechnologies": "Kompetenser & tekniker",
  "jobDetailPage.specialisations": "Specialiseringar",
  "jobDetailPage.tailorCv.disclaimer": "Endast din befintliga erfarenhet har omformulerats och organiserats om för att lyfta fram det som är viktigt för det här jobbet. Inget har hittats på. Granska texten nedan innan du laddar ner den.",
  "jobDetailPage.tailorCv.download": "Ladda ner anpassat CV",
  "jobDetailPage.tailorCv.emptyProfile": "Fyll i din profil först: vi behöver din arbetslivserfarenhet eller dina kompetenser för att anpassa ett CV.",
  "jobDetailPage.tailorCv.failed": "Kunde inte anpassa ditt CV. Försök igen senare.",
  "jobDetailPage.tailorCv.goToProfile": "Gå till din profil",
  "jobDetailPage.tailorCv.loading": "Omformulerar din befintliga erfarenhet för det här jobbet…",
  "jobDetailPage.tailorCv.networkError": "Nätverksfel. Kontrollera din anslutning.",
  "jobDetailPage.tailorCv.notConfigured": "CV-anpassning är inte aktiverat för den här miljön.",
  "jobDetailPage.tailorCv.quotaExceeded": "Du har nått dagens gräns för CV-anpassning. Den återställs i morgon.",
  "jobDetailPage.tailorCv.tabCoverLetter": "Personligt brev",
  "jobDetailPage.tailorCv.title": "Anpassa mitt CV för det här jobbet",
  "jobDetailPage.tailorCvCta": "Anpassa mitt CV för det här jobbet",
  "jobDetailPage.tradeRegisterWebsite": "Handelsregistrets webbplats",
  "jobDetailPage.tyomarkkinatori.about": "<strong>Jobbmarknaden</strong> är Finlands officiella portal för offentliga arbetsförmedlingstjänster, som drivs av arbets- och näringsministeriet (ANM). Den listar lediga jobb från hela den finländska offentliga sektorn, kommuner och arbetsgivare som använder regeringens rekryteringsinfrastruktur.",
  "jobDetailPage.tyomarkkinatori.dataSourceAttribution": "Källa: <link>Job Market Finlands kundinformationssystem</link>",
  "jobDetailPage.tyomarkkinatori.whyWeIndex": "Vi inkluderar annonser från Jobbmarknaden så att JobCrawls täcker hela bredden av den finländska arbetsmarknaden, inklusive roller som endast visas via officiella statliga kanaler och som annars skulle missas.",
  "jobDetailPage.vacationWeeks": "Semester: {weeks} veckor",
  "jobDetailPage.viewBenefits": "Visa förmåner",
  "jobDetailPage.watchCompanyVideo": "Se företagsvideo",
  "jobDetailPageV2.awardsAndCertifications": "Utmärkelser och certifieringar",
  "jobDetailPageV2.collectiveAgreement.browseAll": "Bläddra bland alla finländska kollektivavtal",
  "jobDetailPageV2.collectiveAgreement.confidence": "{percent} % konfidens",
  "jobDetailPageV2.collectiveAgreement.explicit": "Arbetsgivaren anger att denna tjänst följer kollektivavtalet {agreementName}.",
  "jobDetailPageV2.collectiveAgreement.inferred": "Bästa gissning: kollektivavtalet {agreementName}, härlett från arbetsgivarens bransch och rollen. Det kan vara ett annat avtal.",
  "jobDetailPageV2.coreValues": "Kärnvärden",
  "jobDetailPageV2.daysAgo": "{days, plural, one {för # dag sedan} other {för # dagar sedan}}",
  "jobDetailPageV2.daysLeft": "{days, plural, one {# dag kvar} other {# dagar kvar}}",
  "jobDetailPageV2.daysOpen.longer": "Öppen i {days, plural, one {# dag} other {# dagar}}, längre än de vanliga {typical} dagarna för den här rollen",
  "jobDetailPageV2.daysOpen.usual": "Öppen i {days, plural, one {# dag} other {# dagar}}. Den här rollen är vanligtvis öppen i cirka {typical} dagar",
  "jobDetailPageV2.deadline": "Sista ansökningsdag {date}",
  "jobDetailPageV2.descriptionDisclaimer": "Texten ovan är arbetsgivarens ursprungliga arbetsbeskrivning, hämtad som den skrivits. Övriga uppgifter på sidan, som lön, ansvarsområden och krav, har vårt system tolkat ur samma text och är inte värden som arbetsgivaren uttryckligen har bekräftat. Betrakta dem därför som vår bästa tolkning, inte som verifierade fakta.",
  "jobDetailPageV2.employerOverview": "Om arbetsgivaren",
  "jobDetailPageV2.employerScore.aria": "Employer Score {tier}. Se hela företagsprofilen",
  "jobDetailPageV2.estTakeHome": "Uppskattad nettolön {amount}",
  "jobDetailPageV2.estTakeHome.infoLabel": "Vilka antaganden bygger den här uppskattningen på?",
  "jobDetailPageV2.estimatedExpiry": "Beräknat utgångsdatum {date}",
  "jobDetailPageV2.experienceYears": "{years} {years, plural, one {års} other {års}} erfarenhet",
  "jobDetailPageV2.financialOverview": "Ekonomisk översikt",
  "jobDetailPageV2.fitLedger.action.addLanguage": "Talar du {list}? Lägg till det i din profil",
  "jobDetailPageV2.fitLedger.action.fillProfile": "Fyll i din profil för en riktig jämförelse",
  "jobDetailPageV2.fitLedger.action.tailorCv": "Skräddarsy ditt CV för den här rollen",
  "jobDetailPageV2.fitLedger.action.weights": "Ändra vad som är viktigast för dig",
  "jobDetailPageV2.fitLedger.basis.current": "Jämfört med din nuvarande roll. Ange ett önskat jobb i din profil för att jämföra mot det du faktiskt vill ha.",
  "jobDetailPageV2.fitLedger.basis.desired": "Jämfört med det jobb du angett att du vill ha i din profil. Där du lämnat något tomt används i stället din nuvarande roll.",
  "jobDetailPageV2.fitLedger.cell.benefitsNow": "{count, plural, one {# förmån nu} other {# förmåner nu}}",
  "jobDetailPageV2.fitLedger.cell.more": "+{count} till",
  "jobDetailPageV2.fitLedger.cell.notSet": "Inte angett",
  "jobDetailPageV2.fitLedger.cell.notStated": "Inte angivet",
  "jobDetailPageV2.fitLedger.cell.weeks": "{weeks, plural, one {# vecka} other {# veckor}} / år",
  "jobDetailPageV2.fitLedger.column.thisJob": "Detta jobb",
  "jobDetailPageV2.fitLedger.column.you": "Du",
  "jobDetailPageV2.fitLedger.column.yourSearches": "Dina sökningar",
  "jobDetailPageV2.fitLedger.delta.benefitsFewer": "Färre än du har nu",
  "jobDetailPageV2.fitLedger.delta.benefitsGain": "{count, plural, one {En du inte har nu} other {# du inte har nu}}",
  "jobDetailPageV2.fitLedger.delta.benefitsSame": "Inget du inte redan har",
  "jobDetailPageV2.fitLedger.delta.contractDifferent": "Inte den anställningsform du vill ha",
  "jobDetailPageV2.fitLedger.delta.contractSame": "Anställningsformen du vill ha",
  "jobDetailPageV2.fitLedger.delta.languagesAll": "Du kan alla språk som krävs",
  "jobDetailPageV2.fitLedger.delta.languagesMissing": "Saknas: {list}",
  "jobDetailPageV2.fitLedger.delta.languagesNone": "Inget språkkrav",
  "jobDetailPageV2.fitLedger.delta.levelDifferent": "En annan nivå",
  "jobDetailPageV2.fitLedger.delta.levelDown": "{steps, plural, one {En nivå lägre} other {# nivåer lägre}}",
  "jobDetailPageV2.fitLedger.delta.levelSame": "Nivån du vill ha",
  "jobDetailPageV2.fitLedger.delta.levelUp": "{steps, plural, one {En nivå högre} other {# nivåer högre}}",
  "jobDetailPageV2.fitLedger.delta.locationIn": "I ditt område",
  "jobDetailPageV2.fitLedger.delta.locationOut": "Utanför dina områden",
  "jobDetailPageV2.fitLedger.delta.notStated": "Inte angivet i annonsen",
  "jobDetailPageV2.fitLedger.delta.salaryMeets": "Uppfyller {basis, select, desired {din minimigräns} other {din nuvarande lön}}",
  "jobDetailPageV2.fitLedger.delta.salaryOver": "{amount} mer än {basis, select, desired {din minimigräns} other {din nuvarande lön}}",
  "jobDetailPageV2.fitLedger.delta.salaryRangeCovers": "Intervallets övre gräns täcker {basis, select, desired {din minimigräns} other {din nuvarande lön}}",
  "jobDetailPageV2.fitLedger.delta.salaryUnder": "{amount} mindre än {basis, select, desired {din minimigräns} other {din nuvarande lön}}",
  "jobDetailPageV2.fitLedger.delta.styleExact": "Upplägget du vill ha",
  "jobDetailPageV2.fitLedger.delta.styleHybrid": "Hybrid, tillräckligt nära",
  "jobDetailPageV2.fitLedger.delta.styleMismatch": "Inte upplägget du vill ha",
  "jobDetailPageV2.fitLedger.delta.titleClose": "Nära din måltitel",
  "jobDetailPageV2.fitLedger.delta.titleDifferent": "En annan typ av roll",
  "jobDetailPageV2.fitLedger.delta.titleExact": "Titeln du är ute efter",
  "jobDetailPageV2.fitLedger.delta.titleOverlap": "Delar ord med din måltitel",
  "jobDetailPageV2.fitLedger.delta.vacationLess": "{weeks, plural, one {En vecka mindre} other {# veckor mindre}} än nu",
  "jobDetailPageV2.fitLedger.delta.vacationMore": "{weeks, plural, one {En vecka mer} other {# veckor mer}} än nu",
  "jobDetailPageV2.fitLedger.delta.vacationSame": "Samma som nu",
  "jobDetailPageV2.fitLedger.kicker": "Din matchning",
  "jobDetailPageV2.fitLedger.kicker.searches": "Uppskattad utifrån dina sökningar",
  "jobDetailPageV2.fitLedger.noun.benefits": "förmåner",
  "jobDetailPageV2.fitLedger.noun.jobType": "anställningsform",
  "jobDetailPageV2.fitLedger.noun.languages": "språk",
  "jobDetailPageV2.fitLedger.noun.location": "plats",
  "jobDetailPageV2.fitLedger.noun.remoteness": "arbetsplats",
  "jobDetailPageV2.fitLedger.noun.roleLevel": "erfarenhetsnivå",
  "jobDetailPageV2.fitLedger.noun.salary": "lön",
  "jobDetailPageV2.fitLedger.noun.title": "rollen",
  "jobDetailPageV2.fitLedger.noun.vacation": "semester",
  "jobDetailPageV2.fitLedger.perMonth": "{amount} / mån",
  "jobDetailPageV2.fitLedger.row.benefits": "Förmåner",
  "jobDetailPageV2.fitLedger.row.jobType": "Anställning",
  "jobDetailPageV2.fitLedger.row.keywords": "Sökord",
  "jobDetailPageV2.fitLedger.row.languages": "Språk",
  "jobDetailPageV2.fitLedger.row.location": "Plats",
  "jobDetailPageV2.fitLedger.row.remoteness": "Arbetsplats",
  "jobDetailPageV2.fitLedger.row.roleLevel": "Nivå",
  "jobDetailPageV2.fitLedger.row.salary": "Lön",
  "jobDetailPageV2.fitLedger.row.searchCompany": "Arbetsgivare",
  "jobDetailPageV2.fitLedger.row.searchRoles": "Roll & område",
  "jobDetailPageV2.fitLedger.row.title": "Roll",
  "jobDetailPageV2.fitLedger.row.vacation": "Semester",
  "jobDetailPageV2.fitLedger.verdict.A": "Utmärkt matchning",
  "jobDetailPageV2.fitLedger.verdict.B": "Bra matchning",
  "jobDetailPageV2.fitLedger.verdict.C": "Blandad matchning",
  "jobDetailPageV2.fitLedger.verdict.D": "Svag matchning",
  "jobDetailPageV2.fitLedger.verdict.F": "Ingen matchning på papperet",
  "jobDetailPageV2.fitLedger.verdict.allMiddle": "Alla faktorer hamnar någonstans i mitten.",
  "jobDetailPageV2.fitLedger.verdict.gaps": "{count, plural, one {Bristen: {list}.} other {Bristerna: {list}.}}",
  "jobDetailPageV2.fitLedger.verdict.noGaps": "Inget sticker ut som en brist.",
  "jobDetailPageV2.fitLedger.verdict.strengths": "{list} {count, plural, one {matchar} other {matchar}} det du vill ha.",
  "jobDetailPageV2.hideOriginalDescription": "Dölj originalbeskrivning",
  "jobDetailPageV2.homeCommute.addHome": "Lägg till din hemadress en gång, så ser du din pendlingstid för varje jobb.",
  "jobDetailPageV2.homeCommute.addressLabel": "Din hemadress",
  "jobDetailPageV2.homeCommute.calculating": "Beräknar restider…",
  "jobDetailPageV2.homeCommute.cancelChange": "Behåll nuvarande",
  "jobDetailPageV2.homeCommute.change": "Ändra",
  "jobDetailPageV2.homeCommute.changeHome": "Sök en ny hemadress.",
  "jobDetailPageV2.homeCommute.chip": "{time} från hemmet",
  "jobDetailPageV2.homeCommute.fromHome": "Från {home}",
  "jobDetailPageV2.homeCommute.noTransit": "Kollektivtrafikens restider är inte tillgängliga ännu.",
  "jobDetailPageV2.homeCommute.privacyNote": "Sparas i din profil och används endast för restider. Delas aldrig med arbetsgivare.",
  "jobDetailPageV2.homeCommute.unavailable": "Restider är inte tillgängliga för den här adressen.",
  "jobDetailPageV2.includesVariablePay": "+ rörlig lön",
  "jobDetailPageV2.jobDescription": "Jobbeskrivning",
  "jobDetailPageV2.lastSeen": "Senast sedd {date}",
  "jobDetailPageV2.locationModal.close": "Stäng kartan",
  "jobDetailPageV2.locationModal.headingWithCount": "{count, plural, one {Jobbets plats} other {Jobbets platser · {count} kontor}}",
  "jobDetailPageV2.locationModal.title": "Jobbets plats",
  "jobDetailPageV2.mapChip": "Karta",
  "jobDetailPageV2.mapChip.locationCount": "{count} platser",
  "jobDetailPageV2.matchBreakdown.overallLabel": "total matchning",
  "jobDetailPageV2.mostHiredRoles": "Vanligaste rollerna",
  "jobDetailPageV2.numberOfPositions": "{count} lediga platser",
  "jobDetailPageV2.officePhotos": "Kontorsbilder",
  "jobDetailPageV2.openRoles": "{count} lediga tjänster",
  "jobDetailPageV2.originalDescription": "Ursprunglig jobbeskrivning",
  "jobDetailPageV2.originallyListedAs": "Ursprungligen angiven som {amount}",
  "jobDetailPageV2.otherLocations": "+{count} andra platser",
  "jobDetailPageV2.postedOn": "Publicerad {date}",
  "jobDetailPageV2.profit": "Vinst",
  "jobDetailPageV2.profitMargin": "Vinstmarginal",
  "jobDetailPageV2.readFullDescription": "Läs hela beskrivningen",
  "jobDetailPageV2.realSalaryNote": "(verklig lön, uppgiven av arbetsgivaren)",
  "jobDetailPageV2.revenue": "Intäkter",
  "jobDetailPageV2.roleLevelMix": "Fördelning av senioritetsnivåer",
  "jobDetailPageV2.salaryCompares": "Hur denna lön står sig i jämförelse",
  "jobDetailPageV2.salaryEstimateSampleSize": "Uppskattat utifrån {count, plural, one {# jämförbar annons} other {# jämförbara annonser}}",
  "jobDetailPageV2.salaryGauge.benchmark.companyLocation": "detta företag i {location}",
  "jobDetailPageV2.salaryGauge.benchmark.companySalaryStats": "detta företag",
  "jobDetailPageV2.salaryGauge.benchmark.locationMarket": "alla roller i {location}",
  "jobDetailPageV2.salaryGauge.benchmark.title": "{title}-roller",
  "jobDetailPageV2.salaryGauge.benchmark.titleLocation": "{title} i {location}",
  "jobDetailPageV2.salaryGauge.benchmark.titleRoleLevel": "roller på {roleLevel}-nivå",
  "jobDetailPageV2.salaryGauge.headline": "{percent} % {direction, select, above {högre} other {lägre}} än {benchmark}",
  "jobDetailPageV2.salaryGauge.headlineLevel": "I linje med {benchmark}",
  "jobDetailPageV2.salaryGauge.headlineNoJobSalary": "Jämfört med {benchmark}",
  "jobDetailPageV2.salaryGauge.thisOffer": "Detta erbjudande",
  "jobDetailPageV2.taxIcebergLink": "Se hela skattespecifikationen →",
  "jobDetailPageV2.tldr": "I korthet",
  "jobDetailPageV2.topLocations": "Topporter:",
  "jobDetailPageV2.vacationWeeks": "{count, plural, one {# veckas semester} other {# veckors semester}}",
  "jobDetailPageV2.viewCompany": "Visa företag",
  "jobDetailPageV2.watchCompanyVideo": "Se företagsvideo",
  "layoutErrorFallback.body": "Vänligen försök ladda om sidan. Om problemet kvarstår har vi blivit meddelade.",
  "layoutErrorFallback.home": "Gå till startsidan",
  "layoutErrorFallback.reload": "Ladda om sidan",
  "layoutErrorFallback.title": "Något gick fel",
  "locationHub.activeJobs": "Jobb",
  "locationHub.avgSalary": "Lön",
  "locationHub.cityCard.qa.languageAnswer": "{percent}% av jobben kräver engelska.",
  "locationHub.cityCard.qa.languageQuestion": "Vilka språk krävs i {city}?",
  "locationHub.cityCard.qa.remoteAnswerFallback": "Distansarbete erbjuds.",
  "locationHub.cityCard.qa.remoteAnswerWithPercent": "Ja, {percent}% av rollerna är distans- eller hybridarbete.",
  "locationHub.cityCard.qa.remoteQuestion": "Är {city} anpassat för distansarbete?",
  "locationHub.cityCard.qa.salaryAnswerFallback": "Lönedata finns tillgänglig.",
  "locationHub.cityCard.qa.salaryAnswerWithValue": "Genomsnittslönen är {salary}.",
  "locationHub.cityCard.qa.salaryQuestion": "Vad är genomsnittslönen i {city}?",
  "locationHub.cityCard.workModel.flexiblePercent": "{percent}% flexibelt",
  "locationHub.cityCard.workModel.hybridTooltip": "{percent}% hybrid",
  "locationHub.cityCard.workModel.onsiteTooltip": "{percent}% på plats",
  "locationHub.cityCard.workModel.remoteTooltip": "{percent}% distans",
  "locationHub.hero.description": "Utforska Finlands största städer med antal jobb, löneinsikter och marknadsdata som uppdateras regelbundet. Hitta din nästa möjlighet på hela Finlands arbetsmarknad.",
  "locationHub.hero.subtitle": "Kurerade stadsguider och jobbsökningar över hela Finland",
  "locationHub.hero.title": "Arbetsmarknaden i Finland",
  "locationHub.hero.title.breadcrumb": "Utforska jobb efter plats",
  "locationHub.languages": "Språk",
  "locationHub.metropolitan.seo": "Helsingforsregionen, inklusive Esbo och Vanda, är Finlands främsta ekonomiska motor och erbjuder den högsta tätheten av engelskspråkiga och distansbaserade roller med utmärkta transportförbindelser (HSL).",
  "locationHub.overview.description": "Utforska Finlands ledande teknik- och innovationscenter med arbetsmarknadsdata i realtid, löneinsikter och branschtrender.",
  "locationHub.overview.title": "Större tekniknav",
  "locationHub.popularRoles.heading": "Populära yrken",
  "locationHub.quickJump.overview": "Översikt",
  "locationHub.resourcesLink": "Utforska arbetsmarknadsinsikter och karriärtips",
  "locationHub.structuredData.collectionPage.description": "Upptäck jobbmöjligheter i stora finländska städer med löneinsikter och marknadsdata",
  "locationHub.structuredData.collectionPage.name": "Finlands orter",
  "locationHub.structuredData.itemList.description": "Utforska jobbmöjligheter i stora städer över hela Finland",
  "locationHub.structuredData.itemList.name": "Jobbplatser i Finland",
  "locationHub.table.activeJobs": "Aktiva jobb",
  "locationHub.table.avgSalary": "Genomsnittslön",
  "locationHub.table.city": "Stad",
  "locationHub.table.notAvailable": "Ej tillgänglig",
  "locationHub.table.specialty": "Specialisering",
  "locationHub.workModel": "Arbetsmodell",
  "map.cappedResultsNotice": "Visar {shown} av {total} — zooma in för att begränsa sökningen",
  "map.commute.addSecond": "Lägg till en andra startpunkt",
  "map.commute.addressAriaLabel": "Sök en startadress",
  "map.commute.addressPlaceholder": "Eller skriv en adress…",
  "map.commute.button": "Pendlingssökning",
  "map.commute.clear": "Rensa pendlingsfiltret",
  "map.commute.customMinutesAriaLabel": "Anpassad pendlingstid i minuter",
  "map.commute.customMinutesLabel": "Anpassad",
  "map.commute.error": "Pendlingsområdet kunde inte laddas. Försök igen.",
  "map.commute.loading": "Hämtar pendlingsområdet…",
  "map.commute.panelHeading": "Pendlingstid",
  "map.commute.profile.cycling": "Med cykel",
  "map.commute.profile.driving": "Med bil",
  "map.commute.profile.transit": "Kollektivt",
  "map.commute.profile.walking": "Till fots",
  "map.commute.prompt": "Klicka på kartan för att ange din startpunkt",
  "map.commute.promptSecond": "Klicka på kartan för att ange den andra startpunkten",
  "map.commute.removeSecond": "Ta bort den andra startpunkten",
  "map.commute.transitApproxNote": "Kollektivtrafikområdet är ungefärligt",
  "map.companies.count": "{count, plural, one {# företag} other {# företag}}",
  "map.companies.none": "Inga företag i det här området",
  "map.companies.openRoles": "{count, plural, one {# öppen tjänst} other {# öppna tjänster}}",
  "map.companiesInView": "Företag i vyn",
  "map.companyLogoAlt": "Företagslogotyp",
  "map.densityZoomPrompt": "Zooma in för att se enskilda jobb och företagslogotyper",
  "map.densityZoomPrompt.button": "Zooma in",
  "map.draw.button": "Rita ett område",
  "map.draw.cancel": "Avbryt",
  "map.draw.clear": "Rensa det ritade området",
  "map.draw.finish": "Klar ({count})",
  "map.draw.prompt": "Klicka på kartan för att rita ett område",
  "map.jobs": "jobb",
  "map.jobsInView": "Jobb i vyn",
  "map.loading": "Laddar karta...",
  "map.newThisWeekToggle": "Nya denna vecka",
  "map.noJobs": "Inga jobb i det här området",
  "map.noJobsInView": "Inga jobb i det här området",
  "map.noLocationsForPins": "Inga platskoordinater för kartnålar i den här vyn.",
  "map.panel.companiesTab": "Företag",
  "map.panel.jobsTab": "Jobb",
  "map.perCapitaToggle": "Per 1 000 invånare",
  "map.popup.close": "Stäng",
  "map.popup.companyFallback": "Företag",
  "map.popup.jobFallback": "Jobb",
  "map.popup.more": "+{count} till",
  "map.popup.titleMultiLocation": "{count, plural, one {# jobb} other {# jobb}} nära {locationCount, plural, one {# plats} other {# platser}}",
  "map.popup.titleSingleLocation": "{count, plural, one {# jobb} other {# jobb}} i {location}",
  "map.pulse.button": "Rekryteringspuls",
  "map.pulse.error": "Rekryteringshistoriken kunde inte läsas in",
  "map.pulse.loading": "Läser in rekryteringshistorik…",
  "map.pulse.pause": "Pausa",
  "map.pulse.play": "Spela upp",
  "map.pulse.scrubber": "Vecka",
  "map.pulse.weekOf": "Veckan från {date}",
  "map.remoteCard.label": "{count, plural, one {# distansjobb} other {# distansjobb}}",
  "map.remoteCard.more": "+{count} till",
  "map.resetView": "Återställ kartan för att visa hela Finland",
  "map.tokenMissing": "Kartvyn kräver en Mapbox-åtkomsttoken",
  "map.tools.hideLabels": "Dölj etiketter",
  "map.tools.showLabels": "Visa etiketter",
  "map.unknownLocation": "Okänd plats",
  "map.workInEnglishToggle": "Jobb på engelska",
  "marketHeader.language.english": "Engelska",
  "marketHeader.language.finlandComparison": "Finland: {finlandEnglish}% engelska",
  "marketHeader.language.label": "Språkefterfrågan",
  "marketHeader.language.mixed": "Blandat",
  "marketHeader.languageSeo.caption": "Språkefterfrågan i {location}",
  "marketHeader.languageSeo.english": "Engelska",
  "marketHeader.languageSeo.language": "Språkkategori",
  "marketHeader.languageSeo.localLanguages": "Lokala språk",
  "marketHeader.languageSeo.share": "Andel annonser",
  "marketHeader.nearbyMarkets": "Närliggande områden",
  "marketHeader.qa.languageAnswer": "{percent}% av jobben kräver engelska.",
  "marketHeader.qa.languageAnswerFallback": "Språkkraven varierar beroende på roll.",
  "marketHeader.qa.languageQuestion": "Vilka språk krävs i {location}?",
  "marketHeader.qa.remoteAnswer": "Ja, {answer}",
  "marketHeader.qa.remoteAnswerFallback": "Distansarbete erbjuds.",
  "marketHeader.qa.remoteAnswerWithPercent": "{percent}% av rollerna är distans- eller hybridarbete.",
  "marketHeader.qa.remoteQuestion": "Är {location} anpassat för distansarbete?",
  "marketHeader.qa.salaryAnswerFallback": "Lönedata finns tillgänglig.",
  "marketHeader.qa.salaryAnswerWithValue": "Genomsnittslönen är {salary}.",
  "marketHeader.qa.salaryQuestion": "Vad är genomsnittslönen i {location}?",
  "marketHeader.rail.samplesUpdatedDaily": "{count} lediga jobb · uppdateras dagligen",
  "marketHeader.removeLocation": "Ta bort plats",
  "marketHeader.salary.finlandComparison": "Finland snitt: {finlandAvg}",
  "marketHeader.salary.label": "Lönetrender",
  "marketHeader.salary.range": "Löneintervall",
  "marketHeader.salary.rangePercentile": "Intervall för 25:e till 75:e percentilen",
  "marketHeader.salaryPercentileSeo.caption": "Annonserad lönefördelning i {location}, Finland (heltidsroller)",
  "marketHeader.salaryPercentileSeo.p25": "25:e percentilen",
  "marketHeader.salaryPercentileSeo.p50": "Median (50:e percentilen)",
  "marketHeader.salaryPercentileSeo.p75": "75:e percentilen",
  "marketHeader.salaryPercentileSeo.percentile": "Percentil",
  "marketHeader.salaryPercentileSeo.salary": "Månadslön (EUR)",
  "marketHeader.salaryPercentileSeo.sampleSize": "Baserat på {count} platsannonser med uttrycklig löneinformation i {location}, Finland.",
  "marketHeader.toggle": "Växla marknadshuvud",
  "marketHeader.updated": "Uppdaterad:",
  "marketHeader.workModel.finlandComparison": "Finland: {finlandRemote}% distans/hybrid",
  "marketHeader.workModel.label": "Arbetsmodell",
  "marketHeader.workModel.noData": "Flexibel",
  "marketHeader.workModelSeo.caption": "Fördelning av arbetsmodeller i {location}",
  "marketHeader.workModelSeo.model": "Arbetsmodell",
  "marketHeader.workModelSeo.onsite": "På plats",
  "marketHeader.workModelSeo.remote": "Distans",
  "marketHeader.workModelSeo.share": "Andel annonser",
  "marketingConsent.checkbox.description": "Valfritt. Avregistrera dig när som helst.",
  "marketingConsent.checkbox.label": "E-post om arbetsmarknaden och tips",
  "matchDonut.ariaLabel": "Matchningspoäng: {score}%",
  "matchDonut.breakdown.benefits": "Förmåner",
  "matchDonut.breakdown.languages": "Språk",
  "matchDonut.breakdown.remoteness": "Distansarbete",
  "matchDonut.breakdown.salary": "Lön",
  "matchDonut.breakdown.title": "Specifikation av matchningspoäng",
  "matchDonut.breakdown.vacation": "Semester",
  "matchDonut.loginPrompt.createAccount": "Skapa konto",
  "matchDonut.loginPrompt.description": "Skapa en profil och lägg till detaljer om ditt nuvarande jobb för att se hur väl jobb matchar dina preferenser",
  "matchDonut.loginPrompt.title": "Logga in för att se din matchningspoäng",
  "matchDonut.loginPromptAria": "Logga in för att se din matchningspoäng",
  "matchDonut.profilePrompt.description": "Lägg till detaljer om ditt nuvarande jobb och dina preferenser i din profil för att se hur väl jobben matchar.",
  "matchDonut.profilePrompt.goToProfile": "Gå till profil",
  "matchDonut.profilePrompt.title": "Komplettera din profil för att se din matchningspoäng",
  "matchDonut.profilePromptAria": "Komplettera din profil för att se din matchningspoäng",
  "matchDonut.searchBreakdown.employer": "Arbetsgivare & bransch",
  "matchDonut.searchBreakdown.keywords": "Sökord",
  "matchDonut.searchBreakdown.location": "Plats",
  "matchDonut.searchBreakdown.remoteness": "Distansarbete",
  "matchDonut.searchBreakdown.roleFit": "Roll & område",
  "matchDonut.searchInference.bullet.company": "Du har visat intresse för arbetsgivare som {company}. Vi tar hänsyn till det i poängsättningen.",
  "matchDonut.searchInference.bullet.keywords": "Dina sökningar innehöll ord som ”{terms}”. Vi jämförde dem med det här jobbets titel och roll.",
  "matchDonut.searchInference.bullet.locations": "Du har sökt i områden som {locations}. Den här annonsens plats jämförs med det.",
  "matchDonut.searchInference.bullet.remoteness": "Du använder ofta distansfilter ({values}). Det här jobbet poängsätts utifrån dessa preferenser.",
  "matchDonut.searchInference.bullet.roles": "Dina sökningar innehåller rollfilter som {hints}. Liknande signaler jämförs med det här jobbet.",
  "matchDonut.searchInference.intro": "Vi har inte din profil än, så den här poängen uppskattar matchningen med hjälp av filter och sökord från sökningar du gjort på JobCrawls (senaste aktiviteten väger tyngre).",
  "matchDonut.searchInference.title": "Matchning baserat på dina senaste sökningar",
  "modal.close": "Stäng",
  "nav.index.employersHiring": "arbetsgivare rekryterar",
  "nav.index.newToday": "nya idag",
  "nav.index.openJobs": "lediga jobb",
  "nav.index.remote": "på distans",
  "nav.index.updatedAgo": "Uppdaterad för {minutes} min sedan",
  "nav.search.placeholder": "Sök jobb, kompetens eller stad",
  "nav.search.shortcutAria": "Genväg: / fokuserar sökfältet",
  "nav.sheet.alerts": "Nya träffar via e-post",
  "nav.sheet.alertsNote": "<em>{n}</em> nya idag, bara de som passar",
  "nav.sheet.alertsNoteLoading": "nya idag, bara de som passar",
  "nav.sheet.device": "Bara på den här enheten. Logga in så finns de överallt och du får bevakningar.",
  "nav.sheet.email": "eller använd e-post",
  "nav.sheet.fine": "Gratis. Aldrig reklam.",
  "nav.sheet.free": "Gratis konto",
  "nav.sheet.google": "Fortsätt med Google",
  "nav.sheet.keep": "Behåll det du redan har",
  "nav.sheet.keepGoogle": "Behåll dessa, fortsätt med Google",
  "nav.sheet.kit": "Skräddarsytt CV och personligt brev",
  "nav.sheet.kitNote": "ett klick per jobb",
  "nav.sheet.searches": "{n} senaste sökningar",
  "nav.sheet.track": "Följ varje ansökan",
  "nav.sheet.trackNote": "sparade, sökta, intervjuer: en tavla",
  "nav.sheet.viewed": "Senast visat",
  "nav.sheet.viewedCount": "{n, plural, one {# visat jobb} other {# visade jobb}}",
  "nav.tape.and": "och",
  "nav.tape.clearAll": "Rensa alla",
  "nav.tape.not": "inte",
  "nav.tape.only": "bara",
  "nav.tape.or": "eller",
  "nav.tape.results": "{count} träffar",
  "nav.tape.sortNewest": "nyaste först",
  "nav.tape.sortSalary": "högsta lön först",
  "nav.view.list": "Lista",
  "nav.view.map": "Karta",
  "navigation.home.breadcrumb": "Hem",
  "navigation.language": "Språk",
  "navigation.language.label": "Språk",
  "navigation.menu": "Meny",
  "navigation.menu.adminTools": "Adminverktyg",
  "navigation.menu.continue": "Fortsätt där du slutade",
  "navigation.menu.explore": "Utforska",
  "navigation.menu.forYou": "För dig",
  "navigation.menu.heading": "Meny",
  "navigation.menu.more": "Mer",
  "navigation.menu.note.apiKeys": "nycklar för din AI-agent",
  "navigation.menu.note.employerPortal": "dina jobbannonser",
  "navigation.menu.note.employers": "vem som anställer just nu",
  "navigation.menu.note.feedback": "berätta vad som saknas",
  "navigation.menu.note.followed": "{count} bevakade",
  "navigation.menu.note.install": "lägg till på hemskärmen",
  "navigation.menu.note.jobs": "alla lediga jobb",
  "navigation.menu.note.locations": "jobb per ort",
  "navigation.menu.note.myJobsEmpty": "inget sparat ännu",
  "navigation.menu.note.profileEmpty": "bygg upp ditt CV",
  "navigation.menu.note.profilePct": "{pct} % klart",
  "navigation.menu.note.remote": "jobba varifrån som helst",
  "navigation.menu.note.reset": "tillbaka till alla jobb",
  "navigation.menu.note.resources": "guider och artiklar",
  "navigation.menu.note.roles": "jobb per yrke",
  "navigation.menu.note.salaries": "lön per yrke",
  "navigation.menu.note.searches": "sparade sökningar",
  "navigation.menu.note.watchlistEmpty": "bevaka arbetsgivare",
  "navigation.menu.open": "Öppna meny",
  "navigation.menu.searchPrompt": "Sök bland {count} lediga jobb",
  "navigation.menu.searchSubmit": "Sök",
  "navigation.menu.signInHint": "Håll sparade jobb och bevakningar synkade på alla dina enheter.",
  "navigation.menu.translatorTools": "Översättarverktyg",
  "navigation.menu.unit.hiring": "anställer",
  "navigation.menu.unit.open": "lediga",
  "navigation.menu.unit.remote": "på distans",
  "navigation.mobileBottomBar.ariaLabel": "Mobilnavigering",
  "navigation.search.reset": "Återställ sökning",
  "notes.field.add": "Lägg till anteckning",
  "notes.field.placeholder": "Lägg till en privat anteckning…",
  "numberSelector.any": "Vilken som helst",
  "numberSelector.decrease": "Minska",
  "numberSelector.increase": "Öka",
  "pagination.ariaLabel": "Sidnumrering för sökresultat av jobb",
  "pagination.first": "Första",
  "pagination.keyboardShortcuts": "Kortkommandon",
  "pagination.last": "Sista",
  "pagination.next": "Nästa",
  "pagination.previous": "Föregående",
  "postSignup.alertNudge.enabled": "Klart. Vi skickar e-post till dig om nya jobb som matchar dina sökningar.",
  "postSignup.alertNudge.failed": "Det gick inte att aktivera jobbevakningen. Du kan aktivera den när som helst på Bevakningar-sidan.",
  "postSignup.alertNudge.offer": "Välkommen till JobCrawls! Vill du få ett mejl när nya jobb som intresserar dig dyker upp?",
  "postSignup.alertNudge.pendingConfirmation": "Nästan klart: bekräfta din e-postadress i din inkorg för att aktivera aviseringar.",
  "postSignup.alertNudge.turnOn": "Aktivera",
  "profile.account.delete.button": "Radera konto",
  "profile.account.delete.cancel": "Avbryt",
  "profile.account.delete.close": "Stäng",
  "profile.account.delete.confirm": "Radera konto",
  "profile.account.delete.confirmBody": "Detta raderar permanent ditt konto, sparade jobb, sökningar, ansökningspaket och ditt CV. Detta kan inte ångras.",
  "profile.account.delete.confirmTitle": "Radera ditt konto?",
  "profile.account.delete.done": "Ditt konto har raderats. Loggar ut dig…",
  "profile.account.delete.error": "Något gick fel. Försök igen.",
  "profile.account.delete.working": "Raderar…",
  "profile.account.title": "Konto",
  "profile.aiApply": "Använd",
  "profile.aiLoading": "Tänker…",
  "profile.aiSuggest": "Föreslå med AI",
  "profile.aiSuggestionsDisclaimer": "Det här är AI-genererade utgångspunkter baserade enbart på dina jobbtitlar och examina — inte verifierade fakta om dig. Läs igenom varje förslag och redigera det så att det stämmer innan du använder det.",
  "profile.aiSuggestionsEmpty": "Din profil ser komplett ut. Lägg till mer erfarenhet eller lämna några fält tomma och försök igen.",
  "profile.aiSuggestionsTitle": "AI-förslag",
  "profile.applicationDetails.emailPlaceholder": "E-post",
  "profile.applicationDetails.firstNamePlaceholder": "Förnamn",
  "profile.applicationDetails.hint": "Används för att fylla i jobbansökningsformulär åt dig. Skickas endast till arbetsgivarens eget ansökningsformulär, efter att du har granskat och bekräftat det.",
  "profile.applicationDetails.lastNamePlaceholder": "Efternamn",
  "profile.applicationDetails.phonePlaceholder": "Telefon",
  "profile.applicationDetails.salaryExpectationPlaceholder": "Löneförväntan (årlig)",
  "profile.applicationDetails.sectionTitle": "Ansökningsuppgifter",
  "profile.applicationDetails.workAuthorization.euEeaCitizen": "EU/EES-medborgare",
  "profile.applicationDetails.workAuthorization.finnishCitizen": "Finsk medborgare",
  "profile.applicationDetails.workAuthorization.notAuthorized": "Har för närvarande inte rätt att arbeta här",
  "profile.applicationDetails.workAuthorization.permanentResident": "Permanent uppehållstillstånd",
  "profile.applicationDetails.workAuthorization.placeholder": "Arbetstillstånd (valfritt)",
  "profile.applicationDetails.workAuthorization.requiresSponsorship": "Behöver visum/arbetstillstånd",
  "profile.applicationDetails.workAuthorization.validWorkPermit": "Har giltigt arbetstillstånd",
  "profile.applicationKits.link": "Ansökningskit",
  "profile.benefits.label": "Nuvarande förmåner (för matchning)",
  "profile.benefitsWeight": "Viktning av förmåner: {weight}%",
  "profile.closePreview": "Stäng förhandsgranskning",
  "profile.closeSuggestions": "Stäng",
  "profile.commuteMode.label": "Jag reser vanligtvis med",
  "profile.completion.allDone": "Din profil är redo att generera fantastiska CV:n.",
  "profile.completion.fix": "Åtgärda",
  "profile.completion.itemBasic": "Lägg till din titel eller senaste roll",
  "profile.completion.itemCurrentRole": "Lägg till detaljer om din nuvarande roll (för matchning)",
  "profile.completion.itemEducation": "Lägg till din utbildning",
  "profile.completion.itemExperience": "Lägg till din arbetserfarenhet",
  "profile.completion.itemSkills": "Lägg till minst 3 kompetenser",
  "profile.completion.label": "profilen är klar",
  "profile.currentJob.label": "Nuvarande roll (för matchning)",
  "profile.currentSalary.label": "Nuvarande månadslön (för matchning)",
  "profile.currentSalary.placeholder": "t.ex. 3500",
  "profile.currentSalary.privacyShort": "Privat. Används endast för din matchningspoäng.",
  "profile.currentSalary.unit": "€/mån",
  "profile.currentSalary.workPercent": "arbetstid %",
  "profile.currentWorkModel.label": "Nuvarande arbetsmodell (för matchning)",
  "profile.cvDownloadFailed": "Kunde inte ladda ner ditt CV. Försök igen.",
  "profile.cvDownloadFailed.retry": "Försök igen",
  "profile.cvExportPdfFailed": "Kunde inte exportera PDF-filen. Försök igen.",
  "profile.cvExportPdfFailed.retry": "Försök igen",
  "profile.cvImport.notConfigured": "CV-import är inte aktiverat för denna miljö.",
  "profile.cvUploadError": "Vänligen ladda upp en PDF-fil",
  "profile.cvUploadFailed": "Kunde inte ladda upp CV. Försök igen.",
  "profile.cvUploadSizeError": "Filstorleken måste vara mindre än 5 MB",
  "profile.cvUploading": "Importerar…",
  "profile.desiredBenefits": "Önskade förmåner",
  "profile.desiredIndustries": "Branscher",
  "profile.desiredJob": "Vad du letar efter",
  "profile.desiredJobDescription": "Berätta vad du letar efter. Dessa preferenser prioriteras framför din nuvarande roll när vi beräknar hur väl ett jobb matchar dig.",
  "profile.desiredJobTypes": "Anställningsformer",
  "profile.desiredLocations": "Platser",
  "profile.desiredRemoteness": "Alternativ för distansarbete",
  "profile.desiredRoleLevels": "Nivåer",
  "profile.desiredSalaryMin": "Lägsta månadslön",
  "profile.desiredTitles": "Jobbtitlar",
  "profile.desiredVacationWeeks": "Minsta antal semesterveckor",
  "profile.downloadCV": "Ladda ner mitt CV",
  "profile.europass.additionalInfo": "Ytterligare information",
  "profile.europass.basedOn": "Baserat på Europass CV-struktur (europass.europa.eu)",
  "profile.europass.educationAndTraining": "Utbildning och kurser",
  "profile.europass.noEducation": "Ingen utbildning tillagd.",
  "profile.europass.noSkills": "Inga färdigheter tillagda.",
  "profile.europass.noWorkExperience": "Ingen arbetslivserfarenhet tillagd.",
  "profile.europass.personalSkills": "Personliga färdigheter",
  "profile.europass.workExperience": "Arbetslivserfarenhet",
  "profile.exportCV": "Exportera CV",
  "profile.homeAddress.hint": "Anger startpunkten som förval för kartans pendlingssökning, så att du slipper klicka på kartan varje gång. Valfritt, syns bara för dig, och adressen skickas endast till Mapbox för att slå upp koordinaterna – delas aldrig med arbetsgivare.",
  "profile.homeAddress.placeholder": "Sök en adress…",
  "profile.homeAddress.remove": "Ta bort",
  "profile.homeAddress.sectionTitle": "Hemadress",
  "profile.jobType": "Anställningsform",
  "profile.jobTypeWeight": "Viktning av anställningsform: {weight}%",
  "profile.languageSwitcher.hint": "Import, uppladdning och AI-förslag fylls i i den språkflik som är vald. Varje version är oberoende – inget översätts automatiskt.",
  "profile.languages.label": "Språk (professionell nivå)",
  "profile.languagesWeight": "Viktning av språk: {weight}%",
  "profile.linkedInImport.button": "Importera från LinkedIn",
  "profile.linkedInImport.failed": "Kunde inte importera profilen. Försök igen senare.",
  "profile.linkedInImport.hint": "Klistra in din publika profil-URL (linkedin.com/in/…) och importera. Uppgifterna hämtas via Proxycurl (tredje part) och kanske inte innehåller allt som finns på din sida. De fyller i formuläret nedan, inte din sparade profil — läs igenom och rätta till innan du sparar.",
  "profile.linkedInImport.invalidProfileUrl": "Använd länken till din personliga profil (linkedin.com/in/…).",
  "profile.linkedInImport.invalidUrl": "Ange en giltig LinkedIn-URL.",
  "profile.linkedInImport.loading": "Importerar…",
  "profile.linkedInImport.networkError": "Nätverksfel. Kontrollera din anslutning.",
  "profile.linkedInImport.notConfigured": "LinkedIn-import är inte aktiverat för den här miljön.",
  "profile.linkedInImport.ownProfileOnlyWarning": "Använd detta endast för din egen LinkedIn-profil — om du anger någon annans profil-URL hämtas och visas dennes personuppgifter utan dennes vetskap.",
  "profile.linkedInImport.placeholder": "https://www.linkedin.com/in/din-profil/",
  "profile.linkedInImport.sectionTitle": "LinkedIn-profil",
  "profile.loading": "Laddar...",
  "profile.locationWeight": "Platsvikt: {weight}%",
  "profile.locations": "Platser",
  "profile.matchPreferences": "Matchningsinställningar",
  "profile.matchPreferencesDescription": "Justera vikten av olika faktorer när din matchningspoäng för jobb beräknas. Summan måste vara 100 %.",
  "profile.prefillFromSearches.banner": "Vi har fyllt i några fält baserat på dina senaste jobbsökningar. Se över dem och ändra det som ser fel ut.",
  "profile.prefillFromSearches.dismiss": "Stäng",
  "profile.preview": "Förhandsgranska",
  "profile.previewEuropass": "Förhandsgranskning av CV (Europass-format)",
  "profile.profilePhoto.errorCompressedTooLarge": "Bilden är fortfarande för stor efter komprimering. Prova med en mindre originalbild.",
  "profile.profilePhoto.errorProcess": "Kunde inte behandla den här bilden. Prova med en annan fil.",
  "profile.profilePhoto.errorTooLarge": "Bilden är för stor (max 5 MB).",
  "profile.profilePhoto.errorType": "Använd en bild i formatet JPEG, PNG, WebP eller GIF.",
  "profile.profilePhoto.remove": "Ta bort uppladdad bild",
  "profile.profilePhoto.uploadAria": "Ladda upp eller ändra profilbild",
  "profile.quickActions.title": "Ditt CV",
  "profile.remotenessWeight": "Viktning av avstånd: {weight}%",
  "profile.roleLevel": "Rollnivå",
  "profile.roleLevelWeight": "Viktning av rollnivå: {weight}%",
  "profile.salaryWeight": "Viktning av lön: {weight}%",
  "profile.selectJobType": "Välj anställningsform",
  "profile.selectLocations": "Välj platser",
  "profile.selectMultipleIndustries": "Välj en eller flera branscher",
  "profile.selectMultipleJobTypes": "Välj en eller flera anställningsformer",
  "profile.selectMultipleLocations": "Välj en eller flera platser",
  "profile.selectMultipleRemoteness": "Välj ett eller flera alternativ för distansarbete",
  "profile.selectMultipleRoleLevels": "Välj en eller flera rollnivåer",
  "profile.selectMultipleTitles": "Välj en eller flera jobbtitlar",
  "profile.selectRoleLevel": "Välj din rollnivå",
  "profile.title": "Jobbtitel",
  "profile.titlePlaceholder": "t.ex. Programvarutekniker",
  "profile.titleWeight": "Titelvikt: {weight}%",
  "profile.totalWeight": "Totalt",
  "profile.uploadCV": "Ladda upp CV för att förifylla",
  "profile.uploadCV.disclaimer": "AI-extraherat från din PDF — det fyller i formuläret nedan, inte din sparade profil. Läs igenom det och rätta till innan du sparar.",
  "profile.vacationWeeks.label": "Semesterveckor per år",
  "profile.vacationWeeks.unit": "veckor/år",
  "profile.vacationWeight": "Semestervikt: {weight}%",
  "recentSearches.delete": "Ta bort",
  "recentSearches.noSearches": "Du har inte sparat några sökningar än.",
  "role.follow.createAccount": "Skapa konto",
  "role.follow.cta": "Bevaka roll",
  "role.follow.emailPrompt.enabled": "Klart. Nya jobb i roller du bevakar kommer med i dina jobbevaknings-mejl.",
  "role.follow.emailPrompt.failed": "Det gick inte att aktivera e-postuppdateringarna. Du kan aktivera dem när som helst på Bevakningar-sidan.",
  "role.follow.emailPrompt.offer": "Du bevakar nu {role}. Vill du få ett mejl när nya jobb publiceras?",
  "role.follow.emailPrompt.pendingConfirmation": "Nästan klart: bekräfta din e-postadress i din inkorg för att aktivera uppdateringarna.",
  "role.follow.emailPrompt.turnOn": "Aktivera",
  "role.follow.undo": "Ångra",
  "role.follow.unwatchedToast": "Slutade bevaka. Du får inte längre aviseringar om nya annonser för den här rollen",
  "role.follow.watchedToast": "Du bevakar {role}. Nya annonser visas på din bevakningslista",
  "role.follow.watching": "Bevakas",
  "rolesIndex.breadcrumb": "Yrken",
  "rolesIndex.floorNote": "Yrken med bara ett fåtal aktuella annonser visas utan länk tills fler öppnas.",
  "rolesIndex.lede": "{roles} yrken, hämtade direkt från arbetsgivarnas egna sidor och Jobbmarknaden. Varje yrke har en egen sida med aktuella annonser, lönedata och de städer som rekryterar mest.",
  "rolesIndex.ledeWithCount": "{roles} yrken och {jobs} lediga tjänster, hämtade direkt från arbetsgivarnas egna sidor och Jobbmarknaden. Varje yrke har en egen sida med aktuella annonser, lönedata och de städer som rekryterar mest.",
  "rolesIndex.title": "Lediga jobb per yrke",
  "salary.period.day": "/dag",
  "salary.period.hour": "/tim",
  "salary.period.month": "/mån",
  "salary.period.year": "/år",
  "salaryChart.allRolesInLocation": "Alla roller i {location}",
  "salaryChart.analysisTitle": "Löneanalys",
  "salaryChart.companyLocation": "Företag i {location}",
  "salaryChart.estimatedFromMarket": "Uppskattat utifrån marknadsdata (ingen lön i annonsen)",
  "salaryChart.fromJobAd": "Från jobbannons",
  "salaryChart.fromJobAdWithLevel": "Från jobbannons ({roleLevel})",
  "salaryChart.locationAverage": "I {location}: {title}",
  "salaryChart.marketAverage": "Marknadssnitt: {title}",
  "salaryChart.marketAverageRoleLevel": "Marknadsgenomsnitt: {roleLevel}-nivå",
  "salaryChart.payInDataNotInAd": "Det här jobbets löneintervall — anges ej i annonsen",
  "salaryChart.payInDataNotInAdWithLevel": "Det här jobbets löneintervall — anges ej i annonsen ({roleLevel})",
  "salaryChart.popover.average": "Genomsnittligt intervall",
  "salaryChart.popover.benchmarkEstimateNote": "Ej från arbetsgivaren — modellerat utifrån benchmarks",
  "salaryChart.popover.extractedNoQuoteNote": "Numerisk lön utan tillhörande text i annonsen",
  "salaryChart.popover.fromAdText": "Baserat på löneprecisering i jobbannonsen",
  "salaryChart.popover.jobEstimatedRange": "Uppskattat löneintervall",
  "salaryChart.popover.jobListedRange": "Angivet löneintervall",
  "salaryChart.popover.max": "Maximalt",
  "salaryChart.popover.median": "Medianintervall",
  "salaryChart.popover.min": "Minimalt",
  "salaryChart.popover.monthlyNote": "Alla belopp visas som EUR per månad för jämförelse i detta diagram.",
  "salaryChart.popover.p25": "25:e percentilen",
  "salaryChart.popover.p75": "75:e percentilen",
  "salaryChart.popover.p90": "90:e percentilen",
  "salaryChart.popover.sample": "Urvalsstorlek",
  "salaryChart.popover.seeFullSalaryPage": "Se hela lönesidan för {title} →",
  "salaryChart.rangeAria": "Löneintervall från {min} till {max} per månad, median nära {median}",
  "salaryChart.salaryContext": "Lönekontext: {title}",
  "salaryChart.segmentHint": "Håll muspekaren över eller tryck på en rad för fullständig statistik (EUR / månad i detta diagram).",
  "salaryChart.seoTable.caption": "Månadslönjämförelse för {title}",
  "salaryChart.seoTable.lowerBound": "Nedre gräns (25:e percentilen)",
  "salaryChart.seoTable.market": "Marknad",
  "salaryChart.seoTable.upperBound": "Övre gräns (75:e percentilen)",
  "salaryChart.thisRole": "denna roll",
  "salaryChart.thisRoleLevel": "denna rollnivå",
  "salaryChart.verifiedPayBanner": "Verklig lön, angiven av arbetsgivaren — ingen uppskattning",
  "salaryDisplayToggle.label": "Visa ursprunglig valuta",
  "salaryIndexPage.allRolesHeading": "Bläddra bland alla roller",
  "salaryIndexPage.empty": "Ingen lönedata är tillgänglig just nu — kom tillbaka snart.",
  "salaryIndexPage.eyebrow": "{count} roller spåras",
  "salaryIndexPage.heading": "Lönedata per yrke i Finland",
  "salaryIndexPage.intro": "Verklig lönedata från finländska jobbannonser, uppdelad per yrke. Välj ett yrke för att se medianlön, intervall och jämförelser mellan städer.",
  "salaryIndexPage.methodologyLink": "Så här beräknar vi dessa siffror",
  "salaryIndexPage.postingsSuffix": "annonser",
  "salaryIndexPage.search.clear": "Rensa sökning",
  "salaryIndexPage.search.label": "Sök roller",
  "salaryIndexPage.search.noResults": "Ingen roll matchar “{query}”. Prova en annan sökterm.",
  "salaryIndexPage.search.placeholder": "Sök roller, t.ex. \"sjuksköterska\" eller \"snickare\"…",
  "salaryIndexPage.search.resultsCount": "{shown, plural, one {# roll} other {# roller}} hittades",
  "salaryIndexPage.searchResultsHeading": "Sökresultat",
  "salaryIndexPage.stat.postings": "analyserade annonser",
  "salaryIndexPage.stat.roles": "spårade roller",
  "salaryIndexPage.stat.topRole": "mest analyserade roll",
  "salaryIndexPage.taxIcebergLink": "Skatteisbergskalkylatorn",
  "salaryIndexPage.topRolesHeading": "Mest eftertraktade roller",
  "salaryIndexPage.topRolesSub": "Rankade efter antal annonser bakom löneuppskattningen — fler annonser, mer tillförlitliga siffror.",
  "salaryInsight.above": "Lönen för denna roll, <strong>{salary}</strong>, ligger <strong>{percent}%</strong> över {benchmark}.",
  "salaryInsight.below": "Lönen för denna roll, <strong>{salary}</strong>, ligger <strong>{percent}%</strong> under {benchmark}.",
  "salaryInsight.benchmark.finlandOnly": "medianen för hela Finland i vår lönedata",
  "salaryInsight.benchmark.finlandWithRole": "medianen för hela Finland för roller som {role}",
  "salaryInsight.benchmark.locationOnly": "medianlönen i {location}",
  "salaryInsight.benchmark.locationWithRole": "medianen för {role}-roller i {location}",
  "salaryMethodology.backToSalary": "Tillbaka till löneguiden",
  "salaryMethodology.breadcrumb.current": "Lönemetodik",
  "salaryMethodology.breadcrumb.parent": "Löneguide",
  "salaryMethodology.byline": "Skrivet av {author}",
  "salaryMethodology.intro": "Varje lönesiffra på JobCrawls — medianer, intervall och statistik per roll eller stad — går igenom samma process. Här är exakt vad den processen gör.",
  "salaryMethodology.limits.confidence": "Statistik baserad på färre än 10 annonser märks som lågt konfidens — behandla dem som en grov uppskattning, inte en exakt siffra.",
  "salaryMethodology.limits.disclaimer": "Lönedata är hämtad från publicerade jobbannonser och representerar inte nödvändigtvis den totala ersättningen. Beloppen anges i EUR/månad och kan innehålla arbetsgivarens uppskattningar när det angivna löneintervallet inte offentliggjorts.",
  "salaryMethodology.limits.notVerified": "Vi verifierar inte oberoende vad arbetsgivare publicerar — siffrorna speglar vad annonserna anger, inte reviderad löneadministration.",
  "salaryMethodology.limits.title": "Viktiga begränsningar",
  "salaryMethodology.step1.body": "Vår extraheringsprocess hämtar lönesiffror direkt från annonstexten. Den är uttryckligen instruerad att inte gissa en siffra från vaga fraser som ”konkurrenskraftig lön” — om annonsen inte anger en siffra hittar vi inte på en här.",
  "salaryMethodology.step1.title": "Vi samlar in löner som anges i annonsen",
  "salaryMethodology.step2.body": "När en annons saknar angiven lön uppskattar vi en utifrån en trovärdighetsviktad blandning av jämförbara annonser för samma titel, plats, rollnivå och företag — viktat mer mot bredare, större urval när ett smalt urval är tunt. Uppskattade siffror märks som uppskattningar överallt där de visas bredvid en jobbannons, så du alltid kan skilja en angiven lön från en härledd.",
  "salaryMethodology.step2.title": "Vi uppskattar när inget anges — och flaggar det",
  "salaryMethodology.step3.body": "Annonser anger lön på olika sätt — timme, månad, år — och perioder är ibland felmärkta. Vi omvandlar varje siffra till EUR/månad och gör en rimlighetskontroll (ungefär 500–30 000 EUR/månad, med intervallets topp högst 5 gånger botten) för att fånga platshållar- eller felaktig data innan den når någon statistik.",
  "salaryMethodology.step3.title": "Vi normaliserar varje siffra till EUR/månad",
  "salaryMethodology.step4.body": "Med färre än 5 annonser tillämpar vi ingen trimning — det finns inte tillräckligt med data för att säkert utesluta något. Vid 5–24 annonser trimmar vi med en kvartilbaserad kontroll. Vid 25 eller fler annonser tillämpar vi en striktare trimning mellan 10:e och 90:e percentilen innan median, medelvärde och percentiler beräknas.",
  "salaryMethodology.step4.title": "Vi trimmar avvikare baserat på urvalsstorlek",
  "salaryMethodology.step5.body": "En enskild ovanlig annons skulle annars kunna sätta hela det publicerade intervallet. De låg- och högvärden vi visar är 10:e percentilen av minimivärden och 90:e percentilen av maxvärden i urvalet — inte den enskilt lägsta eller högsta siffran vi såg.",
  "salaryMethodology.step5.title": "Det visade intervallet är inte det råa min- och maxvärdet",
  "salaryMethodology.steps.heading": "Processen, steg för steg",
  "salaryMethodology.title": "Så här beräknar vi lönestatistik",
  "salaryRolePage.alsoKnownAs": "Listas även som: {titles}",
  "salaryRolePage.breadcrumb.salaryData": "Lönedata",
  "salaryRolePage.cityTable.footnote": "Stapeln visar P25–P75-intervallet. Den vertikala linjen = median. Alla värden i EUR/månad.",
  "salaryRolePage.cityTable.title": "{roleTitle}: lön per stad",
  "salaryRolePage.ctaBanner": "Letar du efter {roleTitle}-jobb? {link}",
  "salaryRolePage.ctaBanner.link": "Bläddra bland lediga jobb på JobCrawls →",
  "salaryRolePage.disclaimer": "Lönedata är hämtad från publicerade jobbannonser och representerar inte nödvändigtvis den totala ersättningen. Beloppen anges i EUR/månad och kan innehålla arbetsgivarens uppskattningar när det angivna löneintervallet inte offentliggjorts.",
  "salaryRolePage.examplePostings.inactiveBadge": "Inte längre aktiv",
  "salaryRolePage.examplePostings.title": "Baserat på dessa annonser",
  "salaryRolePage.heading": "{roleTitle}: lön i Finland",
  "salaryRolePage.hero.perMonthNational": "/ månad, nationellt medianvärde",
  "salaryRolePage.hero.sampleEyebrow": "Baserat på {count} annonser",
  "salaryRolePage.hiringCompanies.browseAll": "Bläddra bland bästa arbetsgivare i Finland →",
  "salaryRolePage.hiringCompanies.empty": "Bläddra bland alla rankade arbetsgivare för att hitta någon som anställer för den här typen av roll.",
  "salaryRolePage.hiringCompanies.sub": "Från våra arbetsgivarrankningar — vissa kan vara värda att kontakta direkt även utan en öppen annons.",
  "salaryRolePage.hiringCompanies.title": "Företag som anställer {roleTitle}s",
  "salaryRolePage.intro": "Baserat på jobbannonser från finländska arbetsgivare. Uppdateras regelbundet.",
  "salaryRolePage.methodologyLink": "Så här beräknar vi dessa siffror",
  "salaryRolePage.overallPanel.footnote": "EUR per månad · P25–P75-intervall med medianmarkör · baserat på {count} platsannonser",
  "salaryRolePage.overallPanel.title": "{roleTitle} — Finlands genomsnitt",
  "salaryRolePage.rangeBar.hint": "Klicka eller hovra för detaljer.",
  "salaryRolePage.rangeBar.popoverListings": "{count, plural, one {Baserat på # platsannons} other {Baserat på # platsannonser}}",
  "salaryRolePage.remotePanel.title": "{roleTitle} — distansarbete i Finland",
  "salaryRolePage.seeOpenJobs": "Se lediga {roleTitle}-jobb →",
  "salaryRolePage.stat.average": "Genomsnitt",
  "salaryRolePage.stat.middle50": "Mittersta 50 %",
  "salaryRolePage.stat.range": "Hela intervallet",
  "salaryRolePage.stat.sampleSize": "Urvalsstorlek",
  "salaryRolePage.trend.down": "▼ {percent} % jämfört med förra månaden",
  "salaryRolePage.trend.flat": "Ingen förändring jämfört med förra månaden",
  "salaryRolePage.trend.up": "▲ {percent} % jämfört med förra månaden",
  "salaryStats.aboveMarket": "Denna lön ligger över marknadens median",
  "salaryStats.accuracy.exact": "Baserat på liknande roller på detta företag",
  "salaryStats.accuracy.general": "Baserat på marknadsdata",
  "salaryStats.accuracy.location": "Baserat på löner i {location}",
  "salaryStats.atMarket": "Denna lön är konkurrenskraftig i förhållande till marknadens median",
  "salaryStats.average": "Genomsnitt",
  "salaryStats.belowMarket": "Denna lön ligger under marknadens median",
  "salaryStats.jobSalary": "Detta jobb",
  "salaryStats.marketRange": "Marknadsintervall: {min} - {max} (median: {median})",
  "salaryStats.noJobSalary": "Inget löneintervall angivet för det här jobbet. Diagrammet visar marknadsfördelningen.",
  "salaryStats.noValidValues": "Lönestatistik finns tillgänglig ({sampleSize} {samples}), men alla värden är noll. Detta kan tyda på att datan behöver genereras om.",
  "salaryStats.perDay": "per dag",
  "salaryStats.perHour": "per timme",
  "salaryStats.perMonth": "per månad",
  "salaryStats.perYear": "per år",
  "salaryStats.percentiles": "25:e-75:e percentilen",
  "salaryStats.samples": "prover",
  "salaryStats.smallSampleWarning": "Obs: Baserat på ett litet urval ({sampleSize} {samples}). Resultaten är eventuellt inte representativa.",
  "savedSearches.card.continue": "Fortsätt",
  "savedSearches.card.dragAria": "Dra för att ordna om ”{title}”",
  "savedSearches.card.moveDownAria": "Flytta ”{title}” nedåt",
  "savedSearches.card.moveUpAria": "Flytta ”{title}” uppåt",
  "savedSearches.card.selectAria": "Välj ”{title}”",
  "savedSearches.confirmRemove.bulkBody": "{count} sparade sökningar och deras aviseringsinställningar tas bort.",
  "savedSearches.confirmRemove.bulkTitle": "Ta bort {count} sökningar?",
  "savedSearches.confirmRemove.cancel": "Avbryt",
  "savedSearches.confirmRemove.close": "Stäng",
  "savedSearches.confirmRemove.confirm": "Ta bort",
  "savedSearches.confirmRemove.singleBody": "”{title}” och dess aviseringsinställningar tas bort.",
  "savedSearches.confirmRemove.singleTitle": "Ta bort den här sökningen?",
  "savedSearches.confirmRemove.working": "Tar bort…",
  "savedSearches.emptyHint": "Gör en sökning med sökord eller filter på jobbsidan – den kommer att visas här automatiskt. Du kan också fästa en med ”Spara sökning”.",
  "savedSearches.folder.collapseToggle": "Visa eller dölj mapp",
  "savedSearches.folder.count": "{count, plural, one {# sökning} other {# sökningar}}",
  "savedSearches.folder.delete": "Ta bort mapp",
  "savedSearches.folder.menuAria": "Mappalternativ",
  "savedSearches.folder.moveDown": "Flytta nedåt",
  "savedSearches.folder.moveUp": "Flytta uppåt",
  "savedSearches.folder.rename": "Byt namn",
  "savedSearches.folder.renameSave": "Spara",
  "savedSearches.folder.sheetCancel": "Avbryt",
  "savedSearches.folder.sheetClose": "Stäng",
  "savedSearches.folder.unsorted": "Osorterade",
  "savedSearches.newMatchesBadge": "{count} nya",
  "savedSearches.noFilterResults": "Inga sparade sökningar matchar ”{filterText}”.",
  "savedSearches.openSearchAria": "Öppna sökning: {title}",
  "savedSearches.rename.action": "Namnge denna sökning",
  "savedSearches.rename.placeholder": "t.ex. Backend-jobb i Helsingfors",
  "savedSearches.rename.save": "Spara",
  "savedSearches.summary.filtered": "Filtrerad sökning",
  "savedSearches.summary.location": "Plats: {values}",
  "savedSearches.summary.page": "Sida {page}",
  "savedSearches.summary.sortDate": "Sortera: nyaste",
  "savedSearches.summary.sortSalary": "Sortera: lön",
  "savedSearches.summary.worldwide": "Alla länder",
  "savedSearches.toolbar.cancelSelect": "Avbryt",
  "savedSearches.toolbar.deleteSelected": "Ta bort",
  "savedSearches.toolbar.filterAria": "Filtrera sparade sökningar",
  "savedSearches.toolbar.filterPlaceholder": "Filtrera dina sökningar…",
  "savedSearches.toolbar.moveToFolder": "Flytta till mapp",
  "savedSearches.toolbar.moveToNewFolder": "Ny mapp…",
  "savedSearches.toolbar.moveToUnsorted": "Osorterade",
  "savedSearches.toolbar.newFolderButton": "Ny mapp",
  "savedSearches.toolbar.newFolderPrompt": "Mappnamn",
  "savedSearches.toolbar.newFolderSave": "Skapa",
  "savedSearches.toolbar.selectAll": "Markera alla",
  "savedSearches.toolbar.selectButton": "Välj",
  "savedSearches.toolbar.selectedCount": "{count, plural, one {# vald} other {# valda}}",
  "savedSearches.toolbar.sortAlphabetical": "A–Ö",
  "savedSearches.toolbar.sortAria": "Sortera sparade sökningar",
  "savedSearches.toolbar.sortCustom": "Anpassad ordning",
  "savedSearches.toolbar.sortNewest": "Nyaste",
  "savedSearches.toolbar.sortSuggested": "Föreslagen",
  "search.bestCompaniesStrip.hubCta": "Företag som rekryterar i Finland →",
  "search.bestCompaniesStrip.label": "Topparbetsgivare",
  "search.controls.navigation": "Sökinställningar och filter",
  "search.jobCount": "{count, number} jobb",
  "search.noresults.clearAllParameters": "Rensa alla sökparametrar",
  "search.noresults.description": "Prova att justera din sökning eller dina filter för att hitta fler möjligheter.",
  "search.noresults.filtersLabel": "Filter:",
  "search.noresults.goToFirstPage": "Gå till sida 1",
  "search.noresults.hybridJobs": "Hybridjobb",
  "search.noresults.pageLabel": "Sida:",
  "search.noresults.popularSearches": "Populära sökningar",
  "search.noresults.queryLabel": "Sökord:",
  "search.noresults.removeQuery": "Ta bort",
  "search.noresults.searchParameters": "Dina sökparametrar",
  "search.noresults.searchTips": "Söktips",
  "search.noresults.tip1": "Prova att använda bredare söktermer eller ta bort några filter",
  "search.noresults.tip2": "Kontrollera stavningen eller prova alternativa sökord",
  "search.noresults.tip3": "Bläddra bland populära kategorier ovan för att upptäcka nya möjligheter",
  "search.noresults.title": "Inga resultat hittades",
  "search.noresults.unavailable.description": "Jobbsökningen är inte tillgänglig just nu. Försök uppdatera sidan, eller kolla in de här sidorna under tiden.",
  "search.noresults.unavailable.exploreResources": "Guider och artiklar",
  "search.noresults.unavailable.exploreSalary": "Löner per yrke",
  "search.noresults.unavailable.linksLabel": "Under tiden",
  "search.noresults.unavailable.retry": "Försök igen",
  "search.noresults.unavailable.title": "Sökningen fungerar inte just nu",
  "search.refinements.advancedFilters": "Avancerade filter",
  "search.refinements.advancedFilters.aria": "Avancerade filter",
  "search.refinements.allFilters.aria": "Alla filter",
  "search.refinements.benefits.label": "Förmåner",
  "search.refinements.clearAll": "Rensa allt ({count})",
  "search.refinements.company": "Företag",
  "search.refinements.company.label": "Företag",
  "search.refinements.company.openProfileAria": "Öppna företagsprofil för {company}{count, plural, =0 {} other { — {count} lediga tjänster på JobCrawls}}",
  "search.refinements.company.searchPlaceholder": "Sök företag...",
  "search.refinements.educationLevel.detail": "Utbildningsnivå",
  "search.refinements.educationLevel.label": "Utbildningsnivå",
  "search.refinements.excludeApplied.label": "Exkludera sökta jobb",
  "search.refinements.excludeConsultingCompany.filter": "Exkludera konsultföretags jobb",
  "search.refinements.excludeFreelance.filter": "Exkludera frilansjobb",
  "search.refinements.excludeJobs": "Exkludera jobb",
  "search.refinements.excludeRecruitmentCompany.filter": "Exkludera rekryteringsbyråers jobb",
  "search.refinements.excludeSaved.label": "Exkludera sparade jobb",
  "search.refinements.excludeViewed.label": "Exkludera visade jobb",
  "search.refinements.field.label": "Yrkesområde",
  "search.refinements.headcount.chip": "Upp till {count} anställda",
  "search.refinements.headcount.max": "Max antal anställda",
  "search.refinements.industry.label": "Bransch",
  "search.refinements.isDriversLicenseRequired.filter": "Körkort krävs",
  "search.refinements.isOpenApplication.filter": "Öppen ansökan",
  "search.refinements.job": "Jobb",
  "search.refinements.jobTitle": "Jobbtitel",
  "search.refinements.jobType.label": "Anställningsform",
  "search.refinements.languages.label": "Språk",
  "search.refinements.lastSeen.all": "Alla",
  "search.refinements.lastSeen.aria": "Publiceringsdatum",
  "search.refinements.lastSeen.past1Month": "Senaste månaden",
  "search.refinements.lastSeen.past1Week": "Senaste veckan",
  "search.refinements.lastSeen.past24Hours": "Senaste 24 timmarna",
  "search.refinements.lastSeen.past2Weeks": "Senaste 2 veckorna",
  "search.refinements.lastSeen.past3Days": "Senaste 3 dagarna",
  "search.refinements.lastSeen.past6Hours": "Senaste 6 timmarna",
  "search.refinements.location": "Plats",
  "search.refinements.location.searchPlaceholder": "Sök platser...",
  "search.refinements.peopleManagementTier.label": "Ledningsnivå",
  "search.refinements.posted.section": "Publicerad",
  "search.refinements.quickFilter.salary": "{amount} €+",
  "search.refinements.quickFilter.thisWeek": "Denna vecka",
  "search.refinements.quickFilters.heading": "Snabbfilter",
  "search.refinements.regionTags.breadcrumb.root": "Alla platser",
  "search.refinements.regionTags.drillIn": "Bläddra i {value}",
  "search.refinements.regionTags.group.continent": "Kontinenter",
  "search.refinements.regionTags.group.country": "Länder",
  "search.refinements.regionTags.group.recruitingRegion": "Regioner",
  "search.refinements.regionTags.remoteCountLabel": "{value} distans",
  "search.refinements.regionTags.showBeyondFinland": "Visa platser utanför Finland",
  "search.refinements.remoteness.heading": "Arbetsplats",
  "search.refinements.roleLevel.label": "Rollnivå",
  "search.refinements.salary": "Lön",
  "search.refinements.salary.min": "Minsta lön",
  "search.refinements.search.placeholder": "Sök...",
  "search.refinements.showJobsInFinlandOnly": "Visa endast jobb i Finland",
  "search.refinements.showLess": "Visa färre",
  "search.refinements.showMore": "Visa fler",
  "search.refinements.showResults": "Visa {count} resultat",
  "search.refinements.showResultsNoCount": "Visa resultat",
  "search.refinements.skillsAndTechnologies.label": "Kompetenser & tekniker",
  "search.refinements.sort.section": "Sortering",
  "search.refinements.vacationWeeks": "Semesterveckor",
  "search.refinements.vacationWeeks.chip": "{count}+ semesterveckor",
  "search.results.title": "Sökresultat för jobb",
  "search.resultsPerPage.aria": "Resultat per sida",
  "search.resultsPerPage.optionLabel": "{count} per sida",
  "search.signInCta.benefit1": "Spara jobb och granska dem senare",
  "search.signInCta.benefit2": "Följ alla dina ansökningar på en tavla",
  "search.signInCta.benefit3": "Få en avisering så snart ett nytt jobb matchar",
  "search.signInCta.button": "Skapa ett gratis konto",
  "search.signInCta.secondaryText": "Har du redan ett konto? Logga in",
  "search.signInCta.title": "Håll koll på ditt jobbsök",
  "search.topRolesStrip.hubCta": "Lönedata för roller i Finland →",
  "search.topRolesStrip.label": "Eftertraktade roller",
  "search.view.ariaLabel": "Vy",
  "sort.ariaLabel": "Sortera resultat",
  "sort.newest": "Senaste",
  "sort.relevance": "Relevans",
  "sort.salary": "Lön",
  "srpAlertCta.bannerText": "Sluta uppdatera sökningen. Vi meddelar dig när nya liknande jobb publiceras.",
  "srpAlertCta.ctaButton": "Få e-postaviseringar",
  "srpAlertCta.dismissLabel": "Stäng",
  "srpAlertCta.errorText": "Något gick fel. Vi kunde inte aktivera aviseringar. Försök igen.",
  "srpAlertCta.manageLink": "Hantera aviseringar",
  "srpAlertCta.pendingText": "Nästan klart: kontrollera din inkorg och bekräfta din e-postadress för att aktivera aviseringar.",
  "srpAlertCta.subText": "Gratis vecko- eller dagsvis sammanfattning. Avregistrera dig när som helst.",
  "srpAlertCta.successText": "Klart – vi skickar e-post till dig om liknande jobb.",
  "stats.appliedJobs": "{count} sökta jobb",
  "stats.finlandJobsSubtitle": "Jobb på finska eller på distans för personer bosatta i Finland",
  "stats.newThisWeekInline": "· {count, number} nya denna vecka",
  "stats.savedJobs": "{count} sparade jobb",
  "stats.viewedJobs": "{count} visade jobb",
  "tags.field.addTrigger": "Lägg till tagg",
  "tags.field.placeholder": "Skriv tagg och tryck Enter…",
  "tags.field.remove": "Ta bort taggen {tag}",
  "taxIceberg.accuracyNote": "Kontrollerad mot Skattebetalarnas löntagartabell för {year}: inom en euro på 15 inkomstnivåer från 20 000 till 200 000 euro.",
  "taxIceberg.advanced.group.deductions": "Avdrag",
  "taxIceberg.advanced.group.employer": "Arbetsgivare",
  "taxIceberg.advanced.group.otherIncome": "Övriga inkomster",
  "taxIceberg.advanced.group.person": "Om dig",
  "taxIceberg.advanced.group.picture": "Bild",
  "taxIceberg.advanced.toggle": "Avancerade inställningar: avdrag, övriga inkomster, arbetsgivare, familj",
  "taxIceberg.agents.body": "Varje lön har en egen sida: {urlTemplate}, och valen ovan följer med som parametrar i adressen (municipality, employer, vat, church, age, children, sole, union, commuting, dividends, gains, own, assets). Samma resultat som JSON: {apiUrl}. AI-assistenter kan anropa verktyget {tool} i JobCrawls MCP-koppling ({connectorUrl}).",
  "taxIceberg.agents.heading": "För AI-assistenter och utvecklare",
  "taxIceberg.amounts.perMonth": "Alla belopp per månad",
  "taxIceberg.amounts.perYear": "Alla belopp per år",
  "taxIceberg.backToSalary": "Tillbaka till löneguiden",
  "taxIceberg.breadcrumb.current": "Skatteisberg",
  "taxIceberg.breadcrumb.parent": "Löneguide",
  "taxIceberg.breakdown.capitalGross": "Dividender och kapitalvinster",
  "taxIceberg.breakdown.capitalTax": "Kapitalinkomstskatt",
  "taxIceberg.breakdown.gross": "Bruttolön",
  "taxIceberg.breakdown.heading": "Fullständig specifikation",
  "taxIceberg.breakdown.investmentsKeep": "Du behåller av dividender och vinster",
  "taxIceberg.breakdown.investmentsTax": "Skatt på dividender och vinster",
  "taxIceberg.breakdown.netPay": "Nettolön",
  "taxIceberg.breakdown.totalIn": "Alla inkomster före skatt",
  "taxIceberg.breakdown.trueCost": "Verklig kostnad för arbetsgivaren (bruttolön + arbetsgivaravgifter)",
  "taxIceberg.byline": "Skrivet av {author}",
  "taxIceberg.compare.add": "Jämför med en annan lön",
  "taxIceberg.compare.hint": "Isbergen är ritade i samma skala, så du kan jämföra dem direkt.",
  "taxIceberg.compare.remove": "Ta bort den här lönen från jämförelsen",
  "taxIceberg.copyLink": "Kopiera länk",
  "taxIceberg.copyLink.copied": "Kopierad",
  "taxIceberg.destinations.averageMunicipality": "en genomsnittlig kommun",
  "taxIceberg.destinations.employmentFund": "Sysselsättningsfonden",
  "taxIceberg.destinations.employmentFund.desc": "Arbetslöshetsförsäkringsavgifter: inkomstrelaterad dagpenning, vuxenutbildningsstöd och pension som tjänas in under arbetslöshet.",
  "taxIceberg.destinations.heading": "Vart pengarna går",
  "taxIceberg.destinations.insurers": "Försäkringsbolag",
  "taxIceberg.destinations.insurers.desc": "Arbetsgivarens olycksfalls- och grupplivförsäkringspremier.",
  "taxIceberg.destinations.intro": "Varje euro under ytan har enligt lag en mottagare. Öppna kommunen och staten för att se vad de använder pengarna till.",
  "taxIceberg.destinations.kela": "FPA:s sjukförsäkring",
  "taxIceberg.destinations.kela.desc": "Sjukvårds- och dagpenningsavgifterna samt arbetsgivarens sjukförsäkringsavgift: sjuk- och föräldradagpenning, ersättningar för läkemedel och privatläkare.",
  "taxIceberg.destinations.legend": "Stapelns mörka del: innehållen från din lön. Ljusa delen: betalas av arbetsgivaren ovanpå. Kommunens och statens fördelningar följer deras publicerade utgifter (kommunernas bokslut 2025, statsbudgeten 2026); de är proportionella, inte öronmärkta.",
  "taxIceberg.destinations.muni.administrationOther": "Förvaltning och övrigt",
  "taxIceberg.destinations.muni.basicEducation": "Grundläggande utbildning",
  "taxIceberg.destinations.muni.cultureSport": "Kultur, bibliotek, idrott och ungdom",
  "taxIceberg.destinations.muni.earlyChildhood": "Småbarnspedagogik och förskola",
  "taxIceberg.destinations.muni.employmentBusiness": "Sysselsättningstjänster och näringsliv",
  "taxIceberg.destinations.muni.streetsParksPlanning": "Gator, parker, planläggning, boende och räddning",
  "taxIceberg.destinations.muni.upperSecondary": "Gymnasie- och yrkesutbildning",
  "taxIceberg.destinations.municipality": "Din kommun ({name})",
  "taxIceberg.destinations.municipality.desc": "Kommunalskatt som {name} använder till sina egna tjänster.",
  "taxIceberg.destinations.parish": "Din församling",
  "taxIceberg.destinations.parish.desc": "Kyrkoskatt till den evangelisk-lutherska församlingen i din kommun.",
  "taxIceberg.destinations.pensions": "Arbetspensioner",
  "taxIceberg.destinations.pensions.desc": "Dina och arbetsgivarens ArPL-avgifter till pensionsbolagen: de betalar dagens pensioner och bygger upp din egen pension.",
  "taxIceberg.destinations.state": "Staten",
  "taxIceberg.destinations.state.administrationOther": "Förvaltning och övrigt",
  "taxIceberg.destinations.state.agriculture": "Jord- och skogsbruk",
  "taxIceberg.destinations.state.debtInterest": "Räntor på statsskulden",
  "taxIceberg.destinations.state.defence": "Försvar",
  "taxIceberg.destinations.state.desc": "Statlig inkomstskatt{vat}, som används via statsbudgeten {year}.",
  "taxIceberg.destinations.state.education": "Utbildning, vetenskap och kultur",
  "taxIceberg.destinations.state.employmentEconomy": "Sysselsättning och näringsliv",
  "taxIceberg.destinations.state.environment": "Miljö",
  "taxIceberg.destinations.state.eu": "EU-medlemsavgifter",
  "taxIceberg.destinations.state.foreignAffairs": "Utrikesärenden och utvecklingssamarbete",
  "taxIceberg.destinations.state.healthSocialCounties": "Social- och hälsovård (välfärdsområdena)",
  "taxIceberg.destinations.state.municipalGrants": "Statsandelar till kommunerna",
  "taxIceberg.destinations.state.securityJustice": "Polis, räddning, gräns och rättsväsende",
  "taxIceberg.destinations.state.socialSecurity": "Social trygghet: FPA-förmåner och statens pensioner",
  "taxIceberg.destinations.state.transport": "Trafik och kommunikation",
  "taxIceberg.destinations.state.vat": " och moms",
  "taxIceberg.destinations.total": "{total} {period} i skatter och avgifter",
  "taxIceberg.destinations.yle.desc": "Yle-skatten finansierar Rundradion.",
  "taxIceberg.detail.capital.unlistedLight": "Dividend från eget bolag inom 8 % avkastning: {light}, varav 25 % skattepliktigt",
  "taxIceberg.detail.capital.unlistedSplit": "Dividend från eget bolag: {light} lätt beskattat (25 %), {heavy} skattepliktigt till 85 %",
  "taxIceberg.detail.employee.capitalTax": "Kapitalinkomstskatt på dividender och vinster: {amount}",
  "taxIceberg.detail.employee.church": "Kyrkoskatt: {amount}",
  "taxIceberg.detail.employee.commutingDeducted": "Avdrag för resekostnader: {amount}",
  "taxIceberg.detail.employee.credit": "Arbetsinkomstavdrag: {amount}",
  "taxIceberg.detail.employee.dailyAllowance": "Dagpenningspremie: {amount}",
  "taxIceberg.detail.employee.medical": "Sjukvårdspremie: {amount}",
  "taxIceberg.detail.employee.municipal": "Kommunalskatt ({rate}): {amount}",
  "taxIceberg.detail.employee.pension": "Din pensionsavgift: {amount}",
  "taxIceberg.detail.employee.state": "Statlig inkomstskatt: {amount}",
  "taxIceberg.detail.employee.unemployment": "Din arbetslöshetsförsäkringsavgift: {amount}",
  "taxIceberg.detail.employee.unionDeducted": "Medlemsavgifter avdragna från den beskattningsbara inkomsten: {amount}",
  "taxIceberg.detail.employee.unlistedEarned": "Dividend från eget bolag över 8 % avkastning, beskattad som förvärvsinkomst: {amount}",
  "taxIceberg.detail.employee.yle": "Yle-skatt: {amount}",
  "taxIceberg.detail.employer.accident": "Olycksfalls- och grupplivförsäkring: {amount}",
  "taxIceberg.detail.employer.health": "Arbetsgivarens sjukförsäkringsavgift: {amount}",
  "taxIceberg.detail.employer.tyel": "Pensionsavgift (ArPL) {rate}: {amount}",
  "taxIceberg.detail.employer.unemployment": "Arbetslöshetsförsäkringsavgift: {amount}",
  "taxIceberg.detail.investments.gains": "Kapitalvinster: {amount} (skattepliktigt i sin helhet)",
  "taxIceberg.detail.investments.gross": "Dividender och vinster före skatt: {amount}",
  "taxIceberg.detail.investments.listed": "Dividender från börsbolag: {amount} (85 % skattepliktigt)",
  "taxIceberg.detail.investments.minusTax": "minus skatt på dem: {amount}",
  "taxIceberg.detail.investments.own": "Dividender från eget bolag: {amount}",
  "taxIceberg.detail.net.minusVat": "minus moms när du konsumerar: {amount}",
  "taxIceberg.detail.net.payslip": "Nettolön på lönespecifikationen: {amount}",
  "taxIceberg.detail.net.shareOfGross": "{share} av din bruttolön",
  "taxIceberg.detail.share": "{share} av vad det kostar att anställa dig",
  "taxIceberg.detail.share.investments": "{share} av dina dividender och vinster",
  "taxIceberg.detail.vat.assumption": "Antagande: {share} av nettolönen konsumeras, genomsnittlig momssats {rate}",
  "taxIceberg.detail.vat.basis": "Konsumtionsmönster från Statistikcentralen per inkomstnivå",
  "taxIceberg.genericEstimateNote.both": "Beräknat med landets genomsnittliga kommunalskatt ({rate}) och en genomsnittlig arbetslöshetsförsäkringsavgift. Välj kommun och arbetsgivarens lönesumma ovan för en exaktare siffra.",
  "taxIceberg.genericEstimateNote.employerSize": "Beräknat med en genomsnittlig arbetslöshetsförsäkringsavgift. Välj arbetsgivarens lönesumma ovan för en exaktare siffra.",
  "taxIceberg.genericEstimateNote.municipal": "Beräknat med landets genomsnittliga kommunalskatt ({rate}). Välj din kommun ovan för en exaktare siffra.",
  "taxIceberg.headlineStat": "Det kostar {trueEmployerCost} att anställa dig, men du får bara behålla {netAfterVat} av det när både skatt och moms räknats med.",
  "taxIceberg.headlineStat.noVat": "Det kostar {trueEmployerCost} att anställa dig, men du får bara behålla {netAfterVat} av det efter skatt.",
  "taxIceberg.headlineStat.withCapital": "Din lön och dina placeringar är {total} före skatt, men du får bara behålla {netAfterVat} när skatt och moms räknats med.",
  "taxIceberg.headlineStat.withCapital.noVat": "Din lön och dina placeringar är {total} före skatt, men du får bara behålla {netAfterVat} efter skatt.",
  "taxIceberg.iceberg.title.month": "{amount} / mån",
  "taxIceberg.iceberg.title.year": "{amount} / år",
  "taxIceberg.input.advancedOptions.toggle": "Avancerade alternativ (kommun, arbetsgivarens storlek)",
  "taxIceberg.input.age.hint": "Påverkar pensions- och arbetslöshetsavgifterna",
  "taxIceberg.input.age.label": "Ålder (påverkar pensions- och arbetslöshetsavgifterna)",
  "taxIceberg.input.age.placeholder": "I arbetsför ålder",
  "taxIceberg.input.age.short": "Ålder",
  "taxIceberg.input.capitalGains.hint": "Skattepliktig kapitalinkomst i sin helhet",
  "taxIceberg.input.capitalGains.label": "Kapitalvinster (efter anskaffningspris)",
  "taxIceberg.input.children.hint": "Höjer arbetsinkomstavdraget",
  "taxIceberg.input.children.label": "Minderåriga barn (höjer arbetsinkomstavdraget)",
  "taxIceberg.input.children.short": "Minderåriga barn",
  "taxIceberg.input.church.hint": "Lägger till cirka {rate} kyrkoskatt",
  "taxIceberg.input.church.label": "Medlem i kyrkan (kyrkoskatt cirka {rate})",
  "taxIceberg.input.church.short": "Medlem i kyrkan",
  "taxIceberg.input.commuting.hint": "Avdragsgillt över självrisken {ownLiability}, högst {max} per år",
  "taxIceberg.input.commuting.label": "Resekostnader (avdragsgillt över självrisken {ownLiability}, högst {max} per år)",
  "taxIceberg.input.commuting.short": "Resekostnader",
  "taxIceberg.input.detail.full": "Varje skatt",
  "taxIceberg.input.detail.hint": "Visa ett eget skikt för varje skatt och avgift",
  "taxIceberg.input.detail.label": "Isbergets skikt",
  "taxIceberg.input.detail.simple": "Fyra skikt",
  "taxIceberg.input.dividends.hint": "85 % skattepliktig kapitalinkomst",
  "taxIceberg.input.dividends.label": "Dividender från börsbolag",
  "taxIceberg.input.employerSize.hint": "Bestämmer arbetslöshetsförsäkringsavgiftens nivå",
  "taxIceberg.input.employerSize.label": "Arbetsgivarens totala lönesumma (påverkar arbetslöshetsförsäkringsavgiften)",
  "taxIceberg.input.employerSize.large": "Över 2,5 M€/år",
  "taxIceberg.input.employerSize.short": "Arbetsgivarens lönesumma",
  "taxIceberg.input.employerSize.small": "Under 2,5 M€/år",
  "taxIceberg.input.employerSize.unknown": "Vet inte",
  "taxIceberg.input.municipality.label": "Kommun (för kommunalskatten)",
  "taxIceberg.input.municipality.placeholder": "Riksgenomsnitt",
  "taxIceberg.input.netAssets.hint": "Valfritt; tomt betyder att dividenden antas hålla sig inom 8 % avkastning",
  "taxIceberg.input.netAssets.label": "Din andel av bolagets nettoförmögenhet",
  "taxIceberg.input.option.no": "Nej",
  "taxIceberg.input.option.yes": "Ja",
  "taxIceberg.input.otherIncome.hint": "Beskattas som kapitalinkomst: {lower} upp till {threshold} och {upper} därutöver; inga arbetsgivaravgifter. Ditt eget bolag betalar först 20 % samfundsskatt, som inte visas här.",
  "taxIceberg.input.period.month": "Månad",
  "taxIceberg.input.period.year": "År",
  "taxIceberg.input.salary.label": "Bruttolön",
  "taxIceberg.input.salary.modeLabel": "Ange bruttolön eller önskad nettolön",
  "taxIceberg.input.salary.modeNet": "Nettolön (mål)",
  "taxIceberg.input.salary.presetGross": "{amount} brutto",
  "taxIceberg.input.salary.presetNet": "{amount} netto",
  "taxIceberg.input.salary.presets": "Välj en vanlig lön",
  "taxIceberg.input.soleGuardian.hint": "Fördubblar barnförhöjningen",
  "taxIceberg.input.soleGuardian.label": "Ensamförsörjare",
  "taxIceberg.input.unionFees.hint": "Dras av i sin helhet från förvärvsinkomsten",
  "taxIceberg.input.unionFees.label": "Fackförenings- och arbetslöshetskasseavgifter",
  "taxIceberg.input.unit.month": "/ mån",
  "taxIceberg.input.unit.year": "/ år",
  "taxIceberg.input.unlistedDividends.hint": "Onoterat bolag: 25 % skattepliktigt upp till {cap} per år inom 8 % avkastning",
  "taxIceberg.input.unlistedDividends.label": "Dividender från ditt eget bolag",
  "taxIceberg.input.vat.hint": "Lägger till momsen du betalar när du konsumerar din nettolön",
  "taxIceberg.input.vat.label": "Räkna med momsen på det du konsumerar",
  "taxIceberg.intro": "Din lönespecifikation visar en enda siffra. Vad det verkligen kostar att anställa dig, och vad du har kvar efter skatter och avgifter, ligger under ytan. Ange en bruttolön och se ditt eget isberg.",
  "taxIceberg.investments.stat": "Dina dividender och kapitalvinster ger {gross}, varav du behåller {net}.",
  "taxIceberg.investments.title": "Dividender och kapitalvinster",
  "taxIceberg.keepRateStat": "Du behåller {rate} av vad det faktiskt kostar att anställa dig.",
  "taxIceberg.keepRateStat.total": "Du behåller {rate} av allt som kommer in.",
  "taxIceberg.layer.capitalTax": "Kapitalinkomstskatt",
  "taxIceberg.layer.church": "Kyrkoskatt",
  "taxIceberg.layer.employeeDailyAllowance": "Dagpenningspremie",
  "taxIceberg.layer.employeePension": "Din pensionsavgift",
  "taxIceberg.layer.employeeTax": "Din inkomstskatt & dina avgifter",
  "taxIceberg.layer.employeeUnemployment": "Din arbetslöshetsförsäkringsavgift",
  "taxIceberg.layer.employerAccident": "Olycksfalls- och grupplivförsäkring",
  "taxIceberg.layer.employerContributions": "Arbetsgivaravgifter",
  "taxIceberg.layer.employerHealth": "Arbetsgivarens sjukförsäkringsavgift",
  "taxIceberg.layer.employerTyel": "Arbetsgivarens pensionsavgift (ArPL)",
  "taxIceberg.layer.employerUnemployment": "Arbetsgivarens arbetslöshetsförsäkringsavgift",
  "taxIceberg.layer.investmentEarnedTax": "Inkomstskatt på dividend från eget bolag",
  "taxIceberg.layer.investmentTax": "Skatt på dividender och vinster",
  "taxIceberg.layer.medicalCare": "Sjukvårdspremie",
  "taxIceberg.layer.municipalTax": "Kommunalskatt",
  "taxIceberg.layer.netAfterVat": "Vad du faktiskt får behålla",
  "taxIceberg.layer.stateTax": "Statlig inkomstskatt",
  "taxIceberg.layer.vat": "Moms när du spenderar det",
  "taxIceberg.layer.yle": "Yle-skatt",
  "taxIceberg.methodology.capital": "Dividender och kapitalvinster: beskattas som kapitalinkomst med {lower} upp till {threshold} skattepliktig kapitalinkomst och {upper} därutöver (Skatteförvaltningen, 2026). Dividender från börsbolag är 85 % skattepliktiga och 15 % skattefria. Dividender från ett onoterat bolag du äger: inom 8 % avkastning på din andel av nettoförmögenheten är 25 % skattepliktig kapitalinkomst upp till {cap} per år och 85 % därutöver; delen över 8 % avkastning är 75 % skattepliktig förvärvsinkomst. Bolagets egen samfundsskatt på 20 %, avdrag från kapitalinkomster och förlustavdrag ingår inte.",
  "taxIceberg.methodology.deductions": "Avdrag: fackförenings- och arbetslöshetskasseavgifter dras av i sin helhet från förvärvsinkomsten; resekostnader är avdragsgilla över självrisken på {ownLiability} upp till {max} per år (Skatteförvaltningen, 2026). Kyrkoskatten följer den valda kommunens evangelisk-lutherska församlings skattesats (Skatteförvaltningens beslut 2026), eller riksgenomsnittet {churchRate} när ingen kommun är vald.",
  "taxIceberg.methodology.destinations": "Vart pengarna går: varje avgift och skatt förs till sin lagstadgade mottagare (pensionsbolagen, Sysselsättningsfonden, FPA, kommunen, staten, församlingen, Yle, försäkringsbolagen). Kommunens euro fördelas enligt vad den valda kommunen använde per uppgift 2025 (nettodriftskostnader, Kommunförbundet utifrån Statskontorets data; riksgenomsnitt när ingen kommun är vald), och statens euro enligt statsbudgeten 2026 omgrupperad efter ändamål, där välfärdsområdena, statsandelarna till kommunerna, EU-avgifterna och statens pensioner har skilts ut från finansministeriets huvudtitel. Fördelningarna är proportionella, inte öronmärkta.",
  "taxIceberg.methodology.employeeTax": "Inkomstskatt, kommunalskatt, kyrkoskatt, Yle-skatt, arbetstagarens pensions- och arbetslöshetsförsäkringsavgifter samt arbetsinkomstavdraget: beräknat enligt Skatteförvaltningens (Verohallinto) förskottsinnehållningsgrunder för 2026 och Finlex 2026 års inkomstskatteskala.",
  "taxIceberg.methodology.employerAccident": "Olycksfalls- och grupplivförsäkring ({accidentRate} sammanlagt, branschgenomsnitt): Olycksfallsförsäkringscentralens (TVK) årliga prognos. De faktiska avgifterna varierar per arbetsgivare beroende på branschens riskklass och kan inte anges exakt utan att känna till den specifika arbetsgivaren.",
  "taxIceberg.methodology.employerOther": "Arbetsgivarens arbetslöshetsförsäkringsavgift ({unemploymentLow}–{unemploymentHigh}, graderad efter lönesumma) och sjukförsäkringsavgift ({healthInsurance}): Sysselsättningsfondens (Työllisyysrahasto) och Skatteförvaltningens avgifter för 2026.",
  "taxIceberg.methodology.employerTyel": "Arbetsgivarens pensionsavgift (ArPL/TyEL), {tyelRate}: Pensionsskyddscentralens (Eläketurvakeskus) avgiftsnivåer för 2026. Avgiften blev lika stor för alla åldrar i 2026 års reform; innan dess var den graderad efter den anställdas ålder.",
  "taxIceberg.methodology.heading": "Källor och metod",
  "taxIceberg.methodology.intro": "Varje siffra nedan går att spåra till en namngiven, kontrollerbar källa. Inget här är uppskattat utan att det sägs tydligt.",
  "taxIceberg.methodology.limitations": "Detta är en uppskattning, inte skatterådgivning: beräkningen förutsätter standardavdrag, bosättning i Finland hela året och inga naturaförmåner, och momssiffran baseras på typiska konsumtionsmönster för din inkomstnivå snarare än dina faktiska kvitton.",
  "taxIceberg.methodology.municipal": "Kommunalskattesatser för alla 308 rapporterande kommuner: Finlands Kommunförbunds (Kuntaliitto) officiella skattesatstabell för 2026, med Skatteförvaltningen som källa.",
  "taxIceberg.methodology.vat": "Momssatser: Skatteförvaltningen (25,5 % allmän skattesats, 13,5 % nedsatt skattesats för mat, restauranger, böcker, mediciner, transport och boende från och med 2026). Hur stor del av din inkomst som faktiskt spenderas (i stället för sparas) på olika inkomstnivåer: Statistikcentralens konsumtionsundersökning från 2022, den senaste tillgängliga, uppdelad per inkomstkvintil — den mest detaljerade indelning Statistikcentralen publicerar.",
  "taxIceberg.methodology.vatInterpolation": "De 5 kvintildatapunkterna är verklig undersökningsdata; den jämna kurvan mellan dem är vår egen interpolering, inte rådata direkt från Statistikcentralen.",
  "taxIceberg.netModeStat": "{net} i handen kräver {gross} brutto.",
  "taxIceberg.perMonthWord": "i månaden",
  "taxIceberg.perYearWord": "om året",
  "taxIceberg.popularNets": "Eller börja med vad du vill ha i handen",
  "taxIceberg.popularNets.link": "{amount} netto",
  "taxIceberg.popularSalaries": "Se isberget för andra löner",
  "taxIceberg.popularSalaries.link": "{amount} / mån",
  "taxIceberg.raise.employer": "För arbetsgivaren kostar höjningen {cost}.",
  "taxIceberg.raise.heading": "Vad blir kvar av en löneförhöjning?",
  "taxIceberg.raise.result": "En höjning på {raise} ger dig {gain} mer {period}: du behåller {kept} av den.",
  "taxIceberg.raise.sliderLabel": "Höjningens storlek",
  "taxIceberg.resetOptions": "Återställ valen",
  "taxIceberg.roles.all": "Alla yrken med lönedata",
  "taxIceberg.roles.heading": "Yrken som betalar cirka {amount} i månaden",
  "taxIceberg.roles.intro": "Nationella medianer från angivna löneintervall i aktuella annonser. Öppna ett yrke för intervall, städer och lediga tjänster.",
  "taxIceberg.roles.postings": "{count, plural, one {# annons} other {# annonser}}",
  "taxIceberg.share": "Dela",
  "taxIceberg.share.email": "Skicka via e-post",
  "taxIceberg.share.linkedin": "Dela på LinkedIn",
  "taxIceberg.share.menuLabel": "Dela det här isberget",
  "taxIceberg.share.whatsapp": "Dela på WhatsApp",
  "taxIceberg.share.x": "Dela på X",
  "taxIceberg.sources.heading": "Källor",
  "taxIceberg.summary.capital": "Dividender och kapitalvinster: {amount}",
  "taxIceberg.summary.delta": "jämfört med den första lönen: {deltaGross} brutto, {deltaKept} behållet",
  "taxIceberg.summary.gross": "Bruttolön: {amount}",
  "taxIceberg.summary.investmentsKeep": "Du behåller {amount} ({rate} av dem)",
  "taxIceberg.summary.investmentsTax": "Skatt på dem: {amount}",
  "taxIceberg.summary.keep": "Du behåller {amount} ({rate} av den verkliga kostnaden)",
  "taxIceberg.summary.trueCost": "Verklig kostnad för arbetsgivaren: {amount}",
  "taxIceberg.taxCard.backTax": "Med {card} håller kortet inne cirka {amountYear} för lite per år ({amountMonth} i månaden): räkna med kvarskatt.",
  "taxIceberg.taxCard.barCard": "Ditt skattekort",
  "taxIceberg.taxCard.barSalary": "Skatten på den här lönen",
  "taxIceberg.taxCard.extra": "Tilläggsprocent",
  "taxIceberg.taxCard.extraHint": "Över gränsen",
  "taxIceberg.taxCard.heading": "Stämmer procenten på ditt skattekort?",
  "taxIceberg.taxCard.intro": "Inkomstskatten på den här lönen är {actual} av bruttolönen. Jämför det med förskottsinnehållningsprocenten på ditt skattekort.",
  "taxIceberg.taxCard.limit": "Inkomstgräns",
  "taxIceberg.taxCard.limitHint": "€ per år, valfritt",
  "taxIceberg.taxCard.limitToggle": "Mitt skattekort har en inkomstgräns",
  "taxIceberg.taxCard.note": "Förskottsinnehållningen täcker bara skatterna; pensions- och arbetslöshetsavgifterna dras separat. Bara de automatiska avdragen räknas, så ett kort som innehåller egna avdrag kan medvetet vara lägre.",
  "taxIceberg.taxCard.onTarget": "Med {card} stämmer kortet med den här lönen: skillnaden är under 60 euro per år.",
  "taxIceberg.taxCard.rate": "Procenten på ditt skattekort",
  "taxIceberg.taxCard.refund": "Med {card} håller kortet inne cirka {amountYear} för mycket per år ({amountMonth} i månaden): du får skatteåterbäring.",
  "taxIceberg.taxCard.where": "I MinSkatt är det grundprocenten på ditt skattekort.",
  "taxIceberg.taxRateStat": "Din skatteprocent på den här lönen: {rate} (med pensions- och arbetslöshetsförsäkringsavgifter {total})",
  "taxIceberg.taxYearNote": "Beräknat med {year} års skatteuppgifter",
  "taxIceberg.title": "Skatteisberget: vad din lön verkligen kostar och vad du faktiskt får behålla",
  "taxIceberg.toolbar.employerSize": "Arbetsgivarens lönesumma",
  "taxIceberg.toolbar.municipality": "Kommun",
  "taxIceberg.vatField.label": "Moms",
  "taxIceberg.visual.ariaLabel": "Skatteisberg i havet utanför Helsingfors. Den synliga toppen är lönen du behåller; den mycket större massan under vattenytan är skatter och avgifter.",
  "test.greeting": "Hej",
  "tools.applicationKits.cvBadge": "CV klart",
  "tools.applicationKits.deleteKit": "Ta bort",
  "tools.applicationKits.downloadCv": "Ladda ner CV",
  "tools.applicationKits.downloadLetter": "Ladda ner brev",
  "tools.applicationKits.emptyBody": "Anpassa ett CV eller skriv ett personligt brev från vilken jobbsida som helst — det sparas här automatiskt.",
  "tools.applicationKits.emptyTitle": "Inga ansökningspaket än",
  "tools.applicationKits.kitReadyBadge": "Ansökningspaket klart",
  "tools.applicationKits.lead": "Dina anpassade CV:n och personliga brev, sparade per jobb — öppna igen, granska eller ladda ner när som helst.",
  "tools.applicationKits.letterBadge": "Brev klart",
  "tools.applicationKits.openJob": "Öppna jobbsidan",
  "tools.applicationKits.title": "Ansökningspaket",
  "tools.applicationKits.updatedOn": "Uppdaterad {date}",
  "tools.applicationState.applied": "Ansökt",
  "tools.applicationState.hidden": "Dold",
  "tools.applicationState.label": "Status:",
  "tools.applicationState.updated": "Status uppdaterad till {state}",
  "tools.empty.browseJobs": "Bläddra bland jobb →",
  "tools.exportApplied.button": "Exportera ansökningar för rapportering",
  "tools.exportApplied.buttonHint": "Få en lista över dina ansökningar – arbetsgivare, tjänst, datum – att använda när du rapporterar din jobbsökning, till exempel till TE-tjänster.",
  "tools.exportApplied.close": "Stäng",
  "tools.exportApplied.colDateApplied": "Ansökningsdatum",
  "tools.exportApplied.colEmployer": "Arbetsgivare",
  "tools.exportApplied.colLink": "Länk",
  "tools.exportApplied.colMethod": "Sätt",
  "tools.exportApplied.colPosition": "Tjänst",
  "tools.exportApplied.description": "En färdig, kopierbar lista över vad du har sökt och när – ha den öppen medan du fyller i din rapport, eller ladda ner den som ett kalkylblad.",
  "tools.exportApplied.downloadCsv": "Ladda ner CSV",
  "tools.exportApplied.empty": "Inga ansökningar under den här perioden än.",
  "tools.exportApplied.from": "Från",
  "tools.exportApplied.methodExternal": "Annan ansökan (egen länk)",
  "tools.exportApplied.methodListing": "Jobbannons",
  "tools.exportApplied.rowCount": "{count, plural, one {# ansökan} other {# ansökningar}}",
  "tools.exportApplied.title": "Exportera dina ansökningar",
  "tools.exportApplied.to": "Till",
  "tools.exportApplied.viewLink": "Öppna",
  "tools.externalApplication.add": "Lägg till som ansökt",
  "tools.externalApplication.adding": "Lägger till…",
  "tools.externalApplication.closeModal": "Stäng",
  "tools.externalApplication.error.disallowedScheme": "Endast http- och https-länkar är tillåtna.",
  "tools.externalApplication.error.empty": "Ange en länk till jobb- eller ansökningssidan.",
  "tools.externalApplication.error.invalid": "Det där ser inte ut som en giltig URL.",
  "tools.externalApplication.error.syncFailed": "Kunde inte spara. Kontrollera din anslutning eller försök logga in.",
  "tools.externalApplication.error.tooLong": "Den länken är för lång.",
  "tools.externalApplication.lead": "Klistra in en länk till ett jobb du har ansökt till på en annan sida. Den visas tillsammans med dina andra ansökningar på den här sidan.",
  "tools.externalApplication.title": "Håll koll på en ansökan på annan sida",
  "tools.externalApplication.titleLabel": "Titel (valfritt)",
  "tools.externalApplication.urlLabel": "Jobblänk",
  "tools.history.emptyHidden": "Du har inte dolt några jobb.",
  "tools.history.emptyViewed": "Du har inte visat några jobb ännu.",
  "tools.history.hiddenTab": "Dolda ({count})",
  "tools.history.resetViewed": "Återställ visade jobb",
  "tools.history.showMore": "Visa fler",
  "tools.history.viewedTab": "Visade ({count})",
  "tools.historySummary.counts": "Visade {viewedCount} · Dolda {hiddenCount}",
  "tools.historySummary.heading": "Historik",
  "tools.historySummary.openDrawer": "Visa",
  "tools.jobFlowSankey.activityChartHeading": "Aktivitet",
  "tools.jobFlowSankey.applied": "Ansökt",
  "tools.jobFlowSankey.browsed": "Tittat på",
  "tools.jobFlowSankey.conversionSummary": "{interviewRate}% nådde intervju · {offerRate}% fick ett erbjudande",
  "tools.jobFlowSankey.emptyState": "Inte tillräckligt med data för att visa din aktivitet än. Titta på, spara eller sök jobb för att se din resa visualiserad!",
  "tools.jobFlowSankey.hideActivityChart": "Dölj aktivitetsdiagram",
  "tools.jobFlowSankey.hired": "Anställd",
  "tools.jobFlowSankey.interviewing": "Intervjuar",
  "tools.jobFlowSankey.offer": "Erbjudande",
  "tools.jobFlowSankey.rejected": "Avslag",
  "tools.jobFlowSankey.saved": "Sparade",
  "tools.jobFlowSankey.showActivityChart": "Visa aktivitetsdiagram",
  "tools.jobFlowSankey.summary": "Tittat på {browsed} → Visade {viewed} → Sparade {saved} → Ansökt {applied}",
  "tools.jobFlowSankey.tooltip.hint.applied": "Du har ansökt om eller spårat dessa som inskickade ansökningar.",
  "tools.jobFlowSankey.tooltip.hint.browsed": "Roller som du öppnat via sökningen – början av din tratt.",
  "tools.jobFlowSankey.tooltip.hint.hired": "Markerad som anställd – ett fantastiskt resultat.",
  "tools.jobFlowSankey.tooltip.hint.interviewing": "För närvarande i intervjuprocessen.",
  "tools.jobFlowSankey.tooltip.hint.offer": "Erbjudandestadiet – dags för förhandling eller beslut.",
  "tools.jobFlowSankey.tooltip.hint.rejected": "Markerad som stängd eller går inte vidare.",
  "tools.jobFlowSankey.tooltip.hint.saved": "Sparad till senare – enkelt att komma tillbaka till och ansöka.",
  "tools.jobFlowSankey.tooltip.hint.viewed": "Du har öppnat dessa annonser men har inte sparat dem än.",
  "tools.jobFlowSankey.tooltip.link.pathCount": "{count, plural, one {# jobb} other {# jobb}} på denna väg",
  "tools.jobFlowSankey.tooltip.link.pctFrom": "{pct}% av flödet som lämnar {fromName}",
  "tools.jobFlowSankey.tooltip.link.pctTo": "{pct}% av flödet in till {toName}",
  "tools.jobFlowSankey.tooltip.link.splitBrowsedApplied": "{direct} direkt från sök utan att spara · {external} från andra källor",
  "tools.jobFlowSankey.tooltip.node.beyondBrowse": "Inkluderar ansökningar som inte räknats i sök (t.ex. externa sidor).",
  "tools.jobFlowSankey.tooltip.node.jobCount": "{count, plural, one {# jobb} other {# jobb}}",
  "tools.jobFlowSankey.tooltip.node.pctApplied": "{pct}% av dina ansökningar",
  "tools.jobFlowSankey.tooltip.node.pctBrowsed": "{pct}% av annonserna du tittat på",
  "tools.jobFlowSankey.viewed": "Visade",
  "tools.kanban.addExternalApplication": "Lägg till extern ansökan",
  "tools.kanban.cancelSelectMode": "Avbryt",
  "tools.kanban.chip.appliedAgo": "Ansökt {relativeAge}",
  "tools.kanban.column.applied": "Ansökt",
  "tools.kanban.column.collapse": "Fäll ihop kolumnen {column}",
  "tools.kanban.column.expand": "Expandera kolumnen {column}",
  "tools.kanban.column.hired": "Anställd",
  "tools.kanban.column.interviewing": "Intervjuer",
  "tools.kanban.column.offer": "Erbjudande",
  "tools.kanban.column.rejected": "Avslag",
  "tools.kanban.column.saved": "Sparade",
  "tools.kanban.companyFilterAll": "Alla företag",
  "tools.kanban.companyFilterLabel": "Filtrera efter företag",
  "tools.kanban.confirmRemove.appliedBody": "”{jobTitle}” kommer att tas bort från din ansökningsöversikt. Du kan ansöka igen via sökningen senare.",
  "tools.kanban.confirmRemove.appliedTitle": "Ta bort från ansökningar?",
  "tools.kanban.confirmRemove.cancel": "Avbryt",
  "tools.kanban.confirmRemove.close": "Stäng",
  "tools.kanban.confirmRemove.confirm": "Ta bort",
  "tools.kanban.confirmRemove.savedBody": "”{jobTitle}” kommer att tas bort från sparade jobb.",
  "tools.kanban.confirmRemove.savedTitle": "Ta bort från sparade?",
  "tools.kanban.confirmRemove.working": "Tar bort…",
  "tools.kanban.deadlineChip": "Stänger om {days, plural, one {# dag} other {# dagar}}",
  "tools.kanban.dragHandle": "Dra för att flytta till en annan kolumn eller position",
  "tools.kanban.dragHandleGroup": "Dra för att flytta hela gruppen till en annan kolumn eller position",
  "tools.kanban.emptyBoard": "Inga sparade jobb eller ansökningar än. Lägg till en extern ansökan med knappen ovan, eller spara och sök jobb via sökfunktionen.",
  "tools.kanban.emptyColumn": "Inga än",
  "tools.kanban.groupMixedHeading": "{count} ansökningar",
  "tools.kanban.groupMixedSavedHeading": "{count} sparade",
  "tools.kanban.hideInactive": "Dölj jobb som inte längre är aktiva",
  "tools.kanban.keepLooking": "Fortsätt leta →",
  "tools.kanban.loadingApplications": "Laddar dina ansökningar…",
  "tools.kanban.mobile.cancel": "Avbryt",
  "tools.kanban.mobile.close": "Stäng",
  "tools.kanban.mobile.companyFilterAll": "Alla företag",
  "tools.kanban.mobile.companyFilterLabel": "Filtrera efter företag",
  "tools.kanban.mobile.emptyTab": "Inga ansökningar i {stage}.",
  "tools.kanban.mobile.move": "Flytta",
  "tools.kanban.mobile.moveTo": "Flytta till",
  "tools.kanban.mobile.searchPlaceholder": "Sök företag eller roll",
  "tools.kanban.mobile.searchToggle": "Sök ansökningar",
  "tools.kanban.mobile.sortCompanyAsc": "Företag (A–Ö)",
  "tools.kanban.mobile.sortDateAsc": "Äldst först",
  "tools.kanban.mobile.sortDateDesc": "Nyast först",
  "tools.kanban.mobile.sortLabel": "Sortera efter",
  "tools.kanban.mobile.sortTitleAsc": "Jobbtitel (A–Ö)",
  "tools.kanban.mobile.tabAll": "Alla",
  "tools.kanban.mobile.viewJob": "Visa jobbannons",
  "tools.kanban.moveSelectedTo": "Flytta till…",
  "tools.kanban.removeFailed": "Kunde inte uppdatera. Försök igen.",
  "tools.kanban.removeFailed.retry": "Försök igen",
  "tools.kanban.removeIcon.applied": "Ta bort från ansökningar",
  "tools.kanban.removeIcon.saved": "Ta bort från sparade jobb",
  "tools.kanban.removeSelected": "Ta bort",
  "tools.kanban.savedJob.expired": "Inte längre aktiv",
  "tools.kanban.savedJob.findSimilar": "Hitta liknande →",
  "tools.kanban.searchLabel": "Sök",
  "tools.kanban.searchPlaceholder": "Sök företag eller roll",
  "tools.kanban.selectCard": "Markera {title}",
  "tools.kanban.selectMode": "Markera",
  "tools.kanban.selectedCount": "{count, plural, one {# markerad} other {# markerade}}",
  "tools.kanban.sortCompanyAsc": "Företag (A–Ö)",
  "tools.kanban.sortDateAsc": "Äldst först",
  "tools.kanban.sortDateDesc": "Nyaste först",
  "tools.kanban.sortLabel": "Sortera efter",
  "tools.kanban.sortTitleAsc": "Jobbtitel (A–Z)",
  "tools.kanban.staleChip": "Följa upp? {days, plural, one {# dag} other {# dagar}} sedan ansökan",
  "tools.kanban.title": "Ansökningar per steg",
  "tools.kanban.untitledJob": "Namnlöst jobb",
  "tools.savedJobs.tailorCvAction": "Anpassa CV",
  "tooltip.allFilters": "Öppna alla filter för att förfina din jobbsökning baserat på plats, lön, anställningsform och mer",
  "tooltip.view.list": "Byt till listvy för att se jobb i ett kompakt listformat",
  "tooltip.view.map": "Byt till kartvy för att se jobbens platser på en karta",
  "usermenu.account": "Konto",
  "usermenu.apiKeys": "AI-sökning",
  "usermenu.installPwa": "Installera app",
  "usermenu.logout": "Logga ut",
  "usermenu.profile": "Min profil",
  "usermenu.theme": "Tema",
  "usermenu.theme.auto": "Automatiskt",
  "usermenu.theme.dark": "Mörkt",
  "usermenu.theme.light": "Ljust",
  "usermenu.translationInspector": "Översättningsgranskning",
  "usermenu.translationInspectorGuide": "Så här använder du översättningsgranskningen",
  "view.list": "Listvy",
  "view.map": "Kartvy",
  "watchlist.company.closedRoles": "{count, plural, one {# roll du såg är inte längre öppen} other {# roller du såg är inte längre öppna}}",
  "watchlist.company.dataUnavailable": "Företagsdata är inte tillgänglig just nu.",
  "watchlist.company.employerScore": "arbetsgivarpoäng",
  "watchlist.company.hiringActivity": "Rekryteringsaktivitet",
  "watchlist.company.hiringPace": "Har publicerat {count} jobb den här månaden — cirka {multiple}× sin vanliga takt",
  "watchlist.company.hiringTrend.declining": "Minskar",
  "watchlist.company.hiringTrend.growing": "Ökar",
  "watchlist.company.hiringTrend.stable": "Stabil",
  "watchlist.company.newRolesBadge": "+{count} nya",
  "watchlist.company.newSinceLastVisit": "Nytt sedan ditt senaste besök",
  "watchlist.company.openRoles": "öppna tjänster",
  "watchlist.company.roleMatch": "{score} % matchning",
  "watchlist.company.scoreGradeDropped": "Arbetsgivarens betyg försämrades till {tier} sedan ditt senaste besök",
  "watchlist.company.scoreGradeImproved": "Arbetsgivarens betyg förbättrades till {tier} sedan ditt senaste besök",
  "watchlist.company.similarEmpty": "Hittade inga liknande företag just nu.",
  "watchlist.company.similarTrigger": "Liknande företag",
  "watchlist.company.sparklineLabel": "Jobbannonser per månad, senaste {months} månaderna",
  "watchlist.compare.company": "Företag",
  "watchlist.compare.exportCsv": "Exportera CSV",
  "watchlist.compare.flexibility": "Flexibilitet",
  "watchlist.compare.jobsPerMonth": "Jobb/mån",
  "watchlist.compare.newBadge": "+{count} nya",
  "watchlist.compare.openRoles": "Öppna roller",
  "watchlist.compare.pay": "Lön",
  "watchlist.compare.remote": "Distans",
  "watchlist.compare.salary": "Medianlön €/mån",
  "watchlist.compare.score": "Poäng",
  "watchlist.compare.share": "Dela",
  "watchlist.compare.shareCopied": "Länken kopierades. Alla som har länken kan se den här jämförelsen",
  "watchlist.compare.stability": "Stabilitet",
  "watchlist.compare.topRoles": "Rekryterar mest",
  "watchlist.empty.body": "Följ ett företag från dess profilsida för att spåra nya tjänster, arbetsgivarpoäng och rekryteringstrend här.",
  "watchlist.empty.browse": "Bläddra bland toppföretag →",
  "watchlist.empty.title": "Du följer inga företag än.",
  "watchlist.filter.all": "Alla",
  "watchlist.filter.noMatches": "Inga företag du följer har den här taggen än.",
  "watchlist.relationshipTag.inConversation": "I samtal",
  "watchlist.relationshipTag.interested": "Intresserad",
  "watchlist.relationshipTag.reachedOut": "Kontaktat",
  "watchlist.roles.heading": "Roller du bevakar",
  "watchlist.roles.newBadge": "+{count} nya",
  "watchlist.roles.newSinceLastVisit": "Nytt sedan ditt senaste besök",
  "watchlist.roles.openCount": "{count, plural, one {# öppet jobb} other {# öppna jobb}}",
  "watchlist.roles.unwatch": "Sluta bevaka",
  "watchlist.sharedCompare.banner": "Du tittar på en jämförelse som någon delade med dig — det här är inte din egen bevakningslista.",
  "watchlist.sharedCompare.cta": "Skapa din egen bevakningslista →",
  "watchlist.sharedCompare.empty": "Den här delade jämförelsen har inga företag att visa.",
  "watchlist.sharedCompare.loading": "Laddar den delade jämförelsen…",
  "watchlist.suggestions.heading": "Företag du kanske vill bevaka",
  "watchlist.suggestions.reasonIndustry": "Liknar företag du följer",
  "watchlist.suggestions.reasonIndustryScoreDiff": "{delta} poäng högre än genomsnittet för företagen du följer",
  "watchlist.suggestions.reasonSavedJobs": "{count, plural, one {Du sparade # av deras jobb} other {Du sparade # av deras jobb}}",
  "watchlist.suggestions.reasonTopRated": "En av Finlands bästa arbetsgivare",
  "watchlist.thresholdAlert.add": "Lägg till varning",
  "watchlist.thresholdAlert.cancel": "Avbryt",
  "watchlist.thresholdAlert.condition.above": "stiger över",
  "watchlist.thresholdAlert.condition.below": "sjunker under",
  "watchlist.thresholdAlert.metric.employerScore": "Arbetsgivarpoäng",
  "watchlist.thresholdAlert.metric.openRoles": "Öppna tjänster",
  "watchlist.thresholdAlert.remove": "Ta bort varning",
  "watchlist.thresholdAlert.save": "Spara varning",
  "watchlist.thresholdAlert.summaryAbove": "{metric} över {value}",
  "watchlist.thresholdAlert.summaryBelow": "{metric} under {value}",
  "watchlist.view.cards": "Kort",
  "watchlist.view.compare": "Jämför",
  "translation.test": "Översättningstest: Svenska"
};

const messages_fi = {
  ...messages_en, // Use English as fallback
  "aboutEmployerScore.backToRankings": "Takaisin Yrityksiin",
  "aboutEmployerScore.breadcrumb.current": "Työnantajan pistemäärä",
  "aboutEmployerScore.breadcrumb.parent": "Yritykset",
  "aboutEmployerScore.intro": "JobCrawlsin Employer Score antaa työnantajille kirjainarvosanan A:sta E:hen. Arvosana johdetaan asioista, joita voimme mitata työpaikkailmoituksista johdonmukaisesti. Sen on tarkoitus nostaa esiin työnantajia, jotka viestivät selkeästi, rakentavat palkitsemisen reilusti ja tarjoavat joustavia, hakijaystävällisiä tehtäviä. Se ei korvaa omia haastattelujasi ja taustaselvityksiäsi.",
  "aboutEmployerScore.limits.changes": "Painotukset ja signaalit voivat muuttua, kun tunnistus paranee. Pyrimme pitämään menetelmän pääpiirteissään ennallaan.",
  "aboutEmployerScore.limits.listings": "Pisteet perustuvat siihen, mitä työnantajat julkaisevat indeksoimissamme ilmoituksissa, eivät sisäisiin HR-käytäntöihin, joita emme näe.",
  "aboutEmployerScore.limits.notEndorsement": "Korkeampi pistemäärä ei ole suositus, tae laadusta eikä oikeudellinen tai taloudellinen neuvo.",
  "aboutEmployerScore.limits.title": "Tärkeitä rajoituksia",
  "aboutEmployerScore.pillar.benefits.body": "Laskemme, kuinka monta erilaista etua (esim. terveysvakuutus, eläkelisä, työvälinebudjetti) työnantaja mainitsee ilmoituksissaan, sekä Suomen lakisääteisen vähimmäismäärän ylittävät lomapäivät.",
  "aboutEmployerScore.pillar.benefits.title": "Edut ja henkilöstöedut",
  "aboutEmployerScore.pillar.flex.body": "Etä- ja hybridityö pisteytetään sen mukaan, kuinka johdonmukaisesti työnantaja tarjoaa joustavia työmalleja avoimissa tehtävissään.",
  "aboutEmployerScore.pillar.flex.title": "Joustavuus (etätyö / hybridi)",
  "aboutEmployerScore.pillar.growth.body": "Kun ilmoituksissa näkyy tehtävien vaativuustasoja ja vihjeitä urakehityksestä, tulkitsemme sen merkiksi vahvemmista sisäisistä kasvupoluista.",
  "aboutEmployerScore.pillar.growth.title": "Kasvusignaalit",
  "aboutEmployerScore.pillar.pay.body": "Kun jäsenneltyjä palkkahaarukoita on riittävästi, pisteytämme, kuinka kilpailukykyinen tyypillinen haarukka on Suomen työmarkkinoilla.",
  "aboutEmployerScore.pillar.pay.title": "Palkkaus (ilmoitetut palkkahaitarit)",
  "aboutEmployerScore.pillar.stability.body": "Tarkastelemme rekrytoinnin jatkuvuutta. Työnantaja, jonka rekrytointitahti on tasainen ja ennustettava, saa enemmän pisteitä kuin sellainen, jonka ilmoittelu on poukkoilevaa.",
  "aboutEmployerScore.pillar.stability.title": "Rekrytoinnin vakaus",
  "aboutEmployerScore.pillar.transparency.body": "Seuraamme, kuinka usein ilmoituksissa kerrotaan todellinen, ei-arvioitu palkka epämääräisen \"kilpailukykyinen palkka\" -maininnan sijaan, sekä kuinka usein niissä kuvataan hakijoille rekrytointiprosessin aikataulu.",
  "aboutEmployerScore.pillar.transparency.title": "Läpinäkyvyys",
  "aboutEmployerScore.pillars.title": "Mistä pistemäärä koostuu",
  "aboutEmployerScore.tierExplainer": "Näytämme tarkoituksella arvosanan emmekä tarkkaa lukua: lähekkäin olevat työnantajat eivät saa näyttää erilaisemmilta kuin taustalla oleva signaali oikeasti tukee. Arvosanat vahvimmasta heikoimpaan: A, B, C, D, E.",
  "aboutEmployerScore.title": "Näin työnantajapisteet (Employer Score) toimivat",
  "apiKeys.settings.alreadyConnectedBody": "Olet jo luonut yhteysavaimen. Näytämme koko avaimen vain kerran, joten jos tarvitset sen uudelleen näkyviin, esimerkiksi toista laitetta varten, luo alla uusi avain. Nykyinen yhteytesi toimii silti edelleen.",
  "apiKeys.settings.alreadyConnectedHeading": "Olet jo yhdistänyt",
  "apiKeys.settings.authHeaderLabel": "Authorization-otsikon arvo",
  "apiKeys.settings.autoKeyLabel": "Tekoälyagentti",
  "apiKeys.settings.breadcrumbSeeker": "Tekoälyhaku",
  "apiKeys.settings.claudeCodeBody": "Jos tilisi ei vielä käytä Request headers -ominaisuutta tai käytät mieluummin komentoriviä, aja tämä sen sijaan:",
  "apiKeys.settings.claudeCodeHeading": "Tai käytä Claude Codea",
  "apiKeys.settings.claudeHeading": "Yhdistä Claude",
  "apiKeys.settings.claudeStep1": "Avaa Claude ja siirry kohtaan Customize, sitten Connectors (Team- tai Enterprise-työtilassa käytä Customize-valikon sijaan Organization settings -valikkoa), sitten Add custom connector.",
  "apiKeys.settings.claudeStep2": "Liitä alla oleva palvelimen osoite yhdistimen URL-kenttään.",
  "apiKeys.settings.claudeStep3": "Aseta Authentication-asetukseksi None.",
  "apiKeys.settings.claudeStep4": "Lisää Request headers -kohtaan otsikko nimeltä Authorization ja anna sille alla oleva arvo. Anthropic ottaa tätä ominaisuutta käyttöön vaiheittain, joten se ei vielä näy kaikissa tileissä. Jos et näe sitä, käytä sen sijaan Claude Codea.",
  "apiKeys.settings.claudeStep5": "Tallenna ja kokeile sitten pyytää Claudelta esimerkiksi: \"Etsi etätyönä tehtäviä ohjelmistokehittäjän töitä Helsingissä.\"",
  "apiKeys.settings.claudeStep5Generic": "Tallenna ja pyydä sitten Claudea käyttämään jotakin tämän liittimen työkaluista.",
  "apiKeys.settings.copiedButton": "Kopioitu",
  "apiKeys.settings.copyButton": "Kopioi",
  "apiKeys.settings.createButton": "Luo avain",
  "apiKeys.settings.createHeading": "Luo uusi avain",
  "apiKeys.settings.createdLabel": "Luotu {date}",
  "apiKeys.settings.creatingButton": "Luodaan…",
  "apiKeys.settings.doneButton": "Valmis",
  "apiKeys.settings.emptyState": "Et ole vielä luonut yhtään avainta.",
  "apiKeys.settings.existingHeading": "Avaimesi",
  "apiKeys.settings.generateNewButton": "Luo uusi avain",
  "apiKeys.settings.generatingButton": "Luodaan…",
  "apiKeys.settings.labelFieldLabel": "Nimeä tämä avain",
  "apiKeys.settings.labelFieldPlaceholder": "esim. Claude Desktop",
  "apiKeys.settings.lastUsedLabel": "Viimeksi käytetty {date}",
  "apiKeys.settings.manageKeysToggle": "Hallitse avaimia",
  "apiKeys.settings.neverUsedLabel": "Ei koskaan käytetty",
  "apiKeys.settings.newKeyHeading": "Uusi avaimesi",
  "apiKeys.settings.newKeyWarning": "Kopioi tämä nyt. Et näe sitä enää uudelleen.",
  "apiKeys.settings.noEmployerAccess": "Tililläsi ei ole vielä työnantajaoikeuksia. Kirjoita osoitteeseen {email}, niin järjestämme sen.",
  "apiKeys.settings.otherAgentsBody": "Useimmat MCP:tä HTTP:n yli tukevat agentit kysyvät palvelimen osoitetta ja antavat lisätä oman pyyntöotsikon. Käytä samaa palvelimen osoitetta ja Authorization-otsikkoa kuin yllä. ChatGPT:n liitinasetukset eivät vielä tue tällaista avainta, joten siellä tämä ei toistaiseksi toimi.",
  "apiKeys.settings.otherAgentsHeading": "Muut tekoälyagentit",
  "apiKeys.settings.revokeButton": "Peruuta",
  "apiKeys.settings.revokeConfirm": "Peruutetaanko tämä avain? Kaikki sitä käyttävä lakkaa toimimasta välittömästi.",
  "apiKeys.settings.revokedLabel": "Peruutettu {date}",
  "apiKeys.settings.serverUrlLabel": "Palvelimen osoite",
  "apiKeys.settings.setupHint": "Luo avain alta, niin näytämme sen jälkeen vaihe vaiheelta, miten se otetaan käyttöön.",
  "apiKeys.settings.subtitleEmployer": "Yhdistä Claude tai muu MCP-asiakas hallitsemaan yrityksen {companyName} työpaikkoja ja urasivua.",
  "apiKeys.settings.subtitleInternal": "Yhdistä Claude tai muu MCP-asiakas JobCrawlsin sisäisiin datatyökaluihin.",
  "apiKeys.settings.subtitleSeeker": "Yhdistä JobCrawls Claudeen tai muuhun tekoälyagenttiin, jotta se voi hakea sinulle oikeita avoimia työpaikkoja Suomessa.",
  "apiKeys.settings.title": "API-avaimet",
  "apiKeys.settings.titleSeeker": "JobCrawls-haku tekoälyagentissasi",
  "applyAutofill.applyManually": "Hae sen sijaan työnantajan omalla sivustolla",
  "applyAutofill.coverLetterLabel": "Saatekirje (valinnainen)",
  "applyAutofill.email": "Sähköposti",
  "applyAutofill.failedGeneric": "Emme onnistuneet lähettämään tätä hakemusta automaattisesti loppuun asti.",
  "applyAutofill.firstName": "Etunimi",
  "applyAutofill.lastName": "Sukunimi",
  "applyAutofill.no": "Ei",
  "applyAutofill.nothingSentYet": "Mitään ei ole vielä lähetetty työnantajalle.",
  "applyAutofill.pageTitle": "Tarkista hakemuksesi",
  "applyAutofill.phone": "Puhelin",
  "applyAutofill.polling": "Lähetämme hakemustasi nyt, tämä voi kestää minuutin…",
  "applyAutofill.preparing": "Valmistelemme hakemustasi…",
  "applyAutofill.regenerate": "Luo uudelleen",
  "applyAutofill.resumeAttached": "resume.pdf liitetään mukaan",
  "applyAutofill.submitTo": "Lähetä yritykselle {company}",
  "applyAutofill.submitting": "Lähetetään…",
  "applyAutofill.success": "Hakemus lähetetty.",
  "applyAutofill.viewInTracker": "Näytä hakemusseurannassa",
  "applyAutofill.yes": "Kyllä",
  "auth.signInPrompt.closeLabel": "Sulje",
  "auth.signInPrompt.description": "Luo ilmainen tili, niin voit tallentaa työpaikkoja, pitää tilanteen ajan tasalla ja jatkaa hakua millä tahansa laitteella.",
  "auth.signInPrompt.primaryAction": "Luo tili",
  "auth.signInPrompt.secondaryAction": "Ehkä myöhemmin",
  "auth.signInPrompt.title": "Kirjaudu sisään tallentaaksesi työpaikkoja",
  "autocomplete.filters": "Suodattimen osumat",
  "autocomplete.noMatches": "Ei suodattimen osumia",
  "autocomplete.scrollHint": "Vieritä nähdäksesi lisää",
  "backoffice.architecture": "Arkkitehtuuri",
  "backoffice.dashboard": "Hallintapaneeli",
  "backoffice.dataExplorer.nav": "Tiedonhaku",
  "backoffice.dataExplorer.title": "Tiedonhaku",
  "backoffice.emailAlerts.nav": "Sähköpostihälytykset",
  "backoffice.hub.nav": "Kaikki työkalut",
  "backoffice.hub.open": "Avaa",
  "backoffice.hub.subtitle": "Valitse avattava työkalu. Pääsy on rajoitettu valtuutetuille tileille.",
  "backoffice.jobDataExplorer.nav": "Työpaikkadata-API",
  "backoffice.mcpKeys.nav": "API-avaimet",
  "backoffice.nav.jumpToTool": "Siirry backoffice-työkaluun",
  "backoffice.nav.jumpToToolPlaceholder": "Valitse työkalu…",
  "backoffice.testing": "Testaus",
  "backoffice.userAgents.description": "Yhden näytön seuranta: karttapainotteinen, päivittää viimeisen minuutin automaattisesti latauksessa. Säädä tarkastelujaksoa ja suodattimia, ja siirry sitten tarkastelemaan taulukkoa.",
  "backoffice.userAgents.hours": "Tarkastelujakso",
  "backoffice.userAgents.mapboxTokenMissing": "Karttanäkymä vaatii Mapbox-pääsytokenin (PUBLIC_ENV__MAPBOX_ACCESS_TOKEN).",
  "backoffice.userAgents.nav": "Käyttäjäagentit",
  "backoffice.userAgents.noData": "Tällä aikavälillä ei ole käyttäjäagenttimerkintöjä.",
  "backoffice.userAgents.run": "Päivitä",
  "backoffice.userAgents.title": "Kierto- ja liikennepaneeli",
  "bestCompanies.breadcrumb.current": "Työnantajat",
  "bestCompanies.breadcrumb.hub": "Yritykset",
  "bestCompanies.dimension.backToHub": "← Kaikki työnantajalistaukset",
  "bestCompanies.dimension.empty": "Tälle suodattimelle ei löytynyt vielä työnantajia. Kokeile uudelleen seuraavan indeksipäivityksen jälkeen.",
  "bestCompanies.dimension.introPrefix": "Aktiivisimmin rekrytoivat ensin. Jokaisella työnantajalla on myös",
  "bestCompanies.dimension.introSuffix": ", jotka lasketaan palkka-avoimuudesta, etätyön joustavuudesta, rekrytoinnin vakaudesta ja eduista Suomen työmarkkinoille suunnatuissa ilmoituksissa (myös monet etätyöt). Ei arvosteluja.",
  "bestCompanies.dimension.scoreName": "JobCrawls työnantajapisteet",
  "bestCompanies.dimension.title": "Rekrytoivat työnantajat: {label}",
  "bestCompanies.hub.agenciesHidden": "Rekrytointitoimistot piilotettu",
  "bestCompanies.hub.azHeading": "Kaikki työnantajat aakkosittain",
  "bestCompanies.hub.browseAzChip": "Kaikki työnantajat aakkosittain",
  "bestCompanies.hub.browseCity": "Työnantajat kaupungeittain",
  "bestCompanies.hub.browseLabel": "Selaa",
  "bestCompanies.hub.chip.all": "Kaikki",
  "bestCompanies.hub.chip.growing": "Kasvava",
  "bestCompanies.hub.chip.hiringMyRole": "Rekrytoi rooliini",
  "bestCompanies.hub.chip.nearHelsinki": "Lähellä Helsinkiä",
  "bestCompanies.hub.chip.pays5k": "Palkka €5 000+",
  "bestCompanies.hub.clearSearch": "Tyhjennä haku",
  "bestCompanies.hub.filteredCount": "{count, plural, one {# työnantaja vastaa hakua} other {# työnantajaa vastaa hakua}}",
  "bestCompanies.hub.heroLede": "Palkkahaarukat, etätyön osuus, rekrytointivauhti ja trendi jokaiselle työnantajalle, jota seuraamme. Seuraa yritystä, niin tarkistamme sen urasivun päivittäin ja kerromme, kun uusi paikka ilmestyy.",
  "bestCompanies.hub.hiringNowCount": "· {count} rekrytoi nyt",
  "bestCompanies.hub.loadingMoreMatches": "etsitään lisää osumia…",
  "bestCompanies.hub.matchCount": "{count, plural, one {# osuma} other {# osumaa}}",
  "bestCompanies.hub.moreWaysToBrowse": "Muita tapoja selata",
  "bestCompanies.hub.networkWorthyFilter": "Julkaisee harvoin",
  "bestCompanies.hub.noMatches": "Yksikään yritys ei vastaa suodattimiasi. Kokeile tyhjentää suodatin tai hakea eri nimellä.",
  "bestCompanies.hub.overallEmpty": "Työnantajia ei ole juuri nyt saatavilla. Yritä myöhemmin uudelleen.",
  "bestCompanies.hub.remoteFriendlyFilter": "Etätyöystävällinen",
  "bestCompanies.hub.resultsCount": "{count, plural, one {# työnantaja} other {# työnantajaa}}",
  "bestCompanies.hub.searchPlaceholder": "Hae työnantajia nimellä, toimialalla tai ammatilla…",
  "bestCompanies.hub.showMore": "Näytä lisää",
  "bestCompanies.hub.showingCount": "Näytetään {shown}",
  "bestCompanies.hub.showingOfTotal": "Näytetään {shown}/{total}",
  "bestCompanies.hub.sort.hiring": "Rekrytointivauhti",
  "bestCompanies.hub.sort.pay": "Palkka",
  "bestCompanies.hub.sort.score": "Työnantajapisteet",
  "bestCompanies.hub.sortLabel": "Lajittele",
  "bestCompanies.hub.title": "Työnantajat Suomessa",
  "bestCompanies.hub.watchlistStrip.following": "Seurataan <b>{count}</b>",
  "bestCompanies.hub.watchlistStrip.newThisWeek": "<b>{count} uutta</b> paikkaa tällä viikolla",
  "bestCompanies.hub.watchlistStrip.open": "Avaa Omat työpaikat →",
  "bestCompanies.row.hiringPace": "~{count} uutta roolia/kk",
  "bestCompanies.row.medianPrefix": "Mediaani",
  "bestCompanies.row.networkWorthy": "Verkostoitumisen arvoinen",
  "bestCompanies.row.perMonth": "{range}/kk",
  "bestCompanies.row.remoteHybridPercent": "{percent}% etä/hybridi",
  "bestCompanies.row.remotePercent": "{percent}% etätyö",
  "bestCompaniesCard.employees": "{range} työntekijää",
  "bestCompaniesCard.hiresLabel": "Palkkaa",
  "bestCompaniesCard.noOpenRoles": "ei avoimia paikkoja juuri nyt",
  "bestCompaniesCard.noPayBands": "Ei ilmoitettua palkkahaarukkaa",
  "bestCompaniesCard.openRoles": "{count, plural, one {# avoin paikka} other {# avointa paikkaa}}",
  "bestCompaniesCard.pace": "~{count} / kk",
  "bestCompaniesCard.payBandRange": "€{min}–{max}<small>/kk</small>",
  "bestCompaniesCard.payBandSingle": "€{amount}<small>/kk</small>",
  "bestCompaniesCard.rarelyPostsPublicly": "Julkaisee harvoin",
  "bestCompaniesCard.remoteOrHybridPercent": "{percent}% etä tai hybridi",
  "bestCompaniesCard.remotePercent": "{percent}% etätyö",
  "bestCompaniesCard.scoreCaption": "Työnantajapisteet",
  "bestCompaniesCard.trendDeclining": "Laskeva ↘",
  "bestCompaniesCard.trendGrowing": "Kasvava ↗",
  "bestCompaniesCard.trendStable": "Vakaa",
  "breadcrumb.benefits": "Edut",
  "breadcrumb.company": "Yritys",
  "breadcrumb.educationLevel": "Koulutus",
  "breadcrumb.industry": "Ala",
  "breadcrumb.isDriversLicenseRequired": "Ajokortti",
  "breadcrumb.isOpenApplication": "Avoin hakemus",
  "breadcrumb.jobType": "Työsuhteen tyyppi",
  "breadcrumb.jobs": "Työpaikat",
  "breadcrumb.language": "Kieli",
  "breadcrumb.level": "Taso",
  "breadcrumb.location": "Sijainti",
  "breadcrumb.navigation": "Murupolku-navigointi",
  "breadcrumb.peopleManagementTier": "Johtaminen",
  "breadcrumb.remote": "Etätyö",
  "breadcrumb.skillsAndTechnologies": "Taidot/Teknologiat",
  "checklist.field.addTrigger": "Lisää tarkistuslista",
  "checklist.field.placeholder": "Lisää tehtävä ja paina Enteriä…",
  "checklist.field.progressTrigger": "{done}/{total} valmis",
  "checklist.field.remove": "Poista tehtävä {text}",
  "collectiveAgreements.aiTranslatedBadge": "Tekoälyn kääntämä",
  "collectiveAgreements.bindingLegend": "Mitä \"ratkaisematon\" tarkoittaa:",
  "collectiveAgreements.bindingLegendBody": "Vahvistuslautakunta ei ole maininnut sopimusta yhdessäkään arkistoimistamme vuosikatsauksista. Kyse on siis aukosta tiedoissa, ei kieltävästä vastauksesta.",
  "collectiveAgreements.bindingNo": "Ei yleissitova",
  "collectiveAgreements.bindingUnknown": "Tuntematon",
  "collectiveAgreements.bindingYes": "Yleissitova",
  "collectiveAgreements.breadcrumb.current": "Työehtosopimukset",
  "collectiveAgreements.decisionNoPrefix": "Päätösnro",
  "collectiveAgreements.editorialStandardsLinkLabel": "toimitukselliset periaatteet",
  "collectiveAgreements.eyebrow": "Lähde · Finlex & Sosiaali- ja terveysministeriö",
  "collectiveAgreements.filterLabel": "Suodata työehtosopimuksia nimen perusteella",
  "collectiveAgreements.filterPlaceholder": "Hae sopimuksen nimellä…",
  "collectiveAgreements.intro": "Työehtosopimus määrittää työn vähimmäispalkan ja -ehdot. Se, mikä sopimus pätee, riippuu työnantajan toimialasta ja tehtävän luonteesta. Linkitämme työpaikkailmoitukset automaattisesti parhaaseen arvaukseemme; tässä on koko lähdeluettelo, josta voit tarkistaa arvauksen itse.",
  "collectiveAgreements.noResults": "Haku ei tuottanut tuloksia.",
  "collectiveAgreements.pdfFi": "PDF (suomi)",
  "collectiveAgreements.pdfSv": "PDF (ruotsi)",
  "collectiveAgreements.resultsCount": "Näytetään {shown} / {total} sopimusta, joista {binding} on vahvistettu yleissitovaksi",
  "collectiveAgreements.scopeHeading": "Soveltamisala",
  "collectiveAgreements.scopeUnavailable": "Tälle sopimukselle ei ole saatavilla soveltamisalatekstiä.",
  "collectiveAgreements.sourceLanguageDisclaimer": "Sopimusten nimet ja soveltamisalatekstit näytetään alla englanniksi tai ruotsiksi, jos tekoälykäännös on saatavilla, ja muuten alkuperäisellä suomen kielellä: Finlex ei julkaise niistä virallista käännöstä. Käännökset ovat epävirallisia ja voivat sisältää virheitä; Finlexin alkuperäinen suomenkielinen sanamuoto on ratkaiseva. Myös muu tämän sivun teksti voi olla konekäännettyä; katso {editorialStandardsLink}.",
  "collectiveAgreements.stat.binding": "Vahvistettu yleissitovaksi",
  "collectiveAgreements.stat.total": "Arkistoidut sopimukset",
  "collectiveAgreements.stat.unresolved": "Ratkaisematta",
  "collectiveAgreements.title": "Suomalaiset työehtosopimukset",
  "company.bulkFollow.cta": "{count, plural, one {Seuraa tätä yritystä} other {Seuraa kaikkia {count} yritystä}}",
  "company.bulkFollow.followedToast": "{count, plural, one {Seurataan yhtä yritystä. Seurantalista päivitetty} other {Seurataan {count} yritystä. Seurantalista päivitetty}}",
  "company.follow.createAccount": "Luo tili",
  "company.follow.cta": "Seuraa",
  "company.follow.emailPrompt.enabled": "Valmista. Seuraamiesi yritysten uudet työpaikat tulevat työpaikkavahtisi sähköposteihin.",
  "company.follow.emailPrompt.failed": "Sähköpostipäivitysten käyttöönotto epäonnistui. Voit ottaa ne käyttöön milloin tahansa Hälytykset-sivulta.",
  "company.follow.emailPrompt.offer": "Seuraat nyt yritystä {company}. Haluatko sähköpostin, kun se julkaisee uusia työpaikkoja?",
  "company.follow.emailPrompt.pendingConfirmation": "Melkein valmista: vahvista sähköpostiosoitteesi postilaatikostasi, niin päivitykset ovat käytössä.",
  "company.follow.emailPrompt.turnOn": "Ota käyttöön",
  "company.follow.followedToast": "Seurataan. Seurantalista päivitetty",
  "company.follow.following": "Seurataan",
  "company.follow.followingCheck": "Seurataan ✓",
  "company.follow.undo": "Kumoa",
  "company.follow.unfollow": "Lopeta seuranta",
  "company.follow.unfollowedToast": "Seuranta lopetettu. Et saa enää ilmoituksia sen uusista työpaikoista",
  "company.follow.viewWatchlist": "Näytä →",
  "company.logoAlt": "{company}-logo",
  "company.logoAltGeneric": "Työnantajan logo",
  "companyChart.caption.averaging": "keskiarvona {avg} työpaikkaa kuukaudessa",
  "companyChart.caption.hiringDeclining": "Yrityksen {companyName} rekrytointi on laskussa",
  "companyChart.caption.hiringGrowing": "Yrityksen {companyName} rekrytointi on kasvussa",
  "companyChart.caption.hiringRapidlyDeclining": "Yrityksen {companyName} rekrytointi laskee nopeasti",
  "companyChart.caption.hiringRapidlyGrowing": "Yrityksen {companyName} rekrytointi kasvaa nopeasti",
  "companyChart.caption.hiringStable": "Yrityksen {companyName} rekrytointi on vakaata",
  "companyChart.caption.levelDistributionDouble": "{companyName} rekrytoi pääasiassa tasoille {level1} ja {level2}.",
  "companyChart.caption.levelDistributionSingle": "{companyName} palkkaa pääasiassa {level}-tasolle.",
  "companyChart.caption.levelDistributionTriple": "{companyName} palkkaa pääasiassa {level1}-, {level2}- ja {level3}-tasoille.",
  "companyChart.caption.locationDistributionDouble": "{companyName} palkkaa pääasiassa paikkakunnilla {location1} ja {location2}.",
  "companyChart.caption.locationDistributionSingle": "{companyName} palkkaa pääasiassa paikkakunnalla {location}.",
  "companyChart.caption.locationDistributionTriple": "{companyName} palkkaa pääasiassa paikkakunnilla {location1}, {location2} ja {location3}.",
  "companyChart.caption.margin": "ja {margin} voittomarginaalilla",
  "companyChart.caption.marginOnly": "Yrityksen {companyName} voittomarginaali oli vuonna 2024 {margin}",
  "companyChart.caption.profitable": "{companyName} oli kannattava vuonna 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} palkkaa pääasiassa hybridirooleihin.",
  "companyChart.caption.remotenessOnsite": "{companyName} palkkaa pääasiassa paikan päällä tehtäviin rooleihin.",
  "companyChart.caption.remotenessRemote": "{companyName} palkkaa pääasiassa etätyöntekijöitä.",
  "companyChart.caption.revenue": "Yrityksen {companyName} liikevaihto oli vuonna 2024 {revenue}",
  "companyChart.caption.revenueWith": "liikevaihdolla {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} palkkaa pääasiassa {role1}- ja {role2}-rooleihin.",
  "companyChart.caption.roleDistributionSingle": "{companyName} palkkaa pääasiassa {role}-rooleihin.",
  "companyChart.caption.roleDistributionTriple": "{companyName} palkkaa pääasiassa {role1}-, {role2}- ja {role3}-rooleihin.",
  "companyChart.caption.unprofitable": "{companyName} oli tappiollinen vuonna 2024",
  "companyChart.caption.workforceRate": "({rate} % henkilöstöstä)",
  "companyChart.financialOverview": "Talouskatsaus (2024)",
  "companyChart.insufficientData": "Rajoitetusti tietoja saatavilla – trendien laskeminen edellyttää vähintään 3 kuukauden tietoja",
  "companyChart.monthlyHiringTrends": "Kuukausittaiset rekrytointitrendit",
  "companyChart.moreCategories": "+{count} lisää",
  "companyChart.profit": "Voitto",
  "companyChart.profitMargin": "Voittomarginaali",
  "companyChart.revenue": "Liikevaihto",
  "companyChart.trend.declining": "Laskeva",
  "companyChart.trend.growing": "Kasvava",
  "companyChart.trend.insufficientData": "Rajoitettu määrä tietoa",
  "companyChart.trend.rapidlyDeclining": "Nopeasti laskeva",
  "companyChart.trend.rapidlyGrowing": "Nopeasti kasvava",
  "companyChart.trend.stable": "Vakaa",
  "companyChart.trendDescription.declining": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyChart.trendDescription.growing": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyChart.trendDescription.rapidlyDeclining": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyChart.trendDescription.rapidlyGrowing": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyChart.trendDescription.simpleDeclining": "Rekrytointeja keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.simpleGrowing": "Rekrytointeja keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.simpleStable": "Rekrytointeja keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.stable": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyGroupingToggle.label": "Ryhmittele työpaikat yrityksittäin",
  "companyHeader.jobCount": "{count, plural, one {# avoinna oleva tehtävä} other {# avointa tehtävää}}",
  "companyHeader.locationCount": "{count, plural, one {# toimipiste} other {# toimipistettä}}",
  "companyInsight.bodyNoLocations": "esiintyy {count, plural, one {# indeksoidussa työpaikkailmoituksessa} other {# indeksoidussa työpaikkailmoituksessa}} JobCrawlsin Suomen aineistossa {sinceDate} lähtien. Luku perustuu indeksin historiaan, ei reaaliaikaiseen avoimien työpaikkojen määrään.",
  "companyInsight.bodyWithLocations": "esiintyy {count, plural, one {# indeksoidussa työpaikkailmoituksessa} other {# indeksoidussa työpaikkailmoituksessa}} JobCrawlsin Suomen aineistossa {sinceDate} lähtien. Indeksin historiassa tämän työnantajan vahvimmat sijaintisignaalit ovat {locationList}.",
  "companyInsight.englishRequirement": "{percent} % näistä indeksoiduista ilmoituksista mainitsee englannin kielen vaatimuksena.",
  "companyInsight.locationSegment": "{location} ({count, plural, one {# indeksoitu ilmoitus} other {# indeksoitua ilmoitusta}})",
  "companyProfile.commonBenefits.heading": "Yleisimmät edut",
  "companyProfile.communityInsights.consTitle": "Yleisimmät valitukset",
  "companyProfile.communityInsights.heading": "Mitä verkossa sanotaan",
  "companyProfile.communityInsights.prosTitle": "Mistä pidetään",
  "companyProfile.communityInsights.sentimentInsufficient": "Ei tarpeeksi tietoa",
  "companyProfile.communityInsights.sentimentMixed": "Sekalainen",
  "companyProfile.communityInsights.sentimentNegative": "Pääosin negatiivinen",
  "companyProfile.communityInsights.sentimentPositive": "Pääosin positiivinen",
  "companyProfile.communityInsights.sourcesTitle": "Lähteet",
  "companyProfile.communityInsights.subtitle": "Tiivistelmä julkisista Reddit-, Suomi24- ja foorumikeskusteluista",
  "companyProfile.companyFacts.benefitsLabel": "Edut",
  "companyProfile.companyFacts.contactLabel": "Yhteystiedot",
  "companyProfile.companyFacts.corporateHistoryLabel": "Omistus",
  "companyProfile.companyFacts.heading": "Hyvä tietää",
  "companyProfile.companyFacts.officeLocationsLabel": "Toimipisteet",
  "companyProfile.companyFacts.remotePolicyLabel": "Etätyö",
  "companyProfile.companyFacts.teamLabel": "Tiimi",
  "companyProfile.companyFacts.teamLinkText": "Tutustu tiimiin",
  "companyProfile.companyFacts.valuesLabel": "Arvot",
  "companyProfile.ownedBrands.heading": "Omat brändit",
  "companyProfile.siteSources.sourceLabel": "Lähde",
  "cookie.consent.accept": "Hyväksy analytiikka",
  "cookie.consent.analyticsBody": "Auttaa meitä huomaamaan haut, jotka eivät tuota tuloksia, ja sivut, joille käyttäjät jäävät jumiin, jotta voimme korjata ne. Valinnainen, eikä tietoja käytetä koskaan mainontaan.",
  "cookie.consent.analyticsTitle": "Analytiikka",
  "cookie.consent.banner": "Käytämme välttämättömiä evästeitä, jotta JobCrawls toimii. Luvallasi käytämme myös yksityisyyttä kunnioittavaa analytiikkaa: sen avulla huomaamme nopeammin tuloksettomat haut ja sivut, joille käyttäjät jäävät jumiin, ja voimme korjata ne. Ei koskaan mainontaan. Voit muuttaa valintaasi milloin tahansa.",
  "cookie.consent.cancel": "Peruuta",
  "cookie.consent.manage": "Hallitse asetuksia",
  "cookie.consent.modalTitle": "Evästeasetukset",
  "cookie.consent.necessaryNote": "Välttämättömiä evästeitä (istunto, asetukset, tietoturva) käytetään aina, jotta sivusto toimii.",
  "cookie.consent.nudge": "Voit ottaa yksityisyyttä kunnioittavan analytiikan käyttöön milloin tahansa. Se auttaa meitä huomaamaan rikkinäiset haut nopeammin.",
  "cookie.consent.privacyLink": "Tietosuojaseloste",
  "cookie.consent.reject": "Hylkää ei-välttämättömät",
  "cookie.consent.save": "Tallenna valinnat",
  "cookie.consent.title": "Evästeet ja tietosuoja",
  "dashboard.actions": "Toiminnot",
  "dashboard.addComment": "Lisää kommentti",
  "dashboard.addComment.placeholder": "Lisää kommentti…",
  "dashboard.addCompany.cancel": "Peruuta",
  "dashboard.addCompany.close": "Sulje",
  "dashboard.addCompany.doCrawl": "Ota haku käyttöön (doCrawl = TRUE)",
  "dashboard.addCompany.errorName": "Yrityksen nimi on pakollinen.",
  "dashboard.addCompany.fieldCareers": "Urasivun URL-osoite",
  "dashboard.addCompany.fieldEnqueue": "Jonotus-URL",
  "dashboard.addCompany.fieldLogo": "Logon URL-osoite",
  "dashboard.addCompany.fieldName": "Yrityksen nimi",
  "dashboard.addCompany.fieldWebsite": "Verkkosivusto",
  "dashboard.addCompany.hintId": "Tietokannan yritystunnus on yrityksen tarkka nimi (ilman tyhjiä välejä reunoilla). Jos rivi, jolla on sama nimi, on jo olemassa, luominen epäonnistuu.",
  "dashboard.addCompany.open": "Lisää yritys",
  "dashboard.addCompany.placeholderName": "esim. Acme Oy",
  "dashboard.addCompany.saving": "Luodaan…",
  "dashboard.addCompany.submit": "Luo yritys",
  "dashboard.addCompany.title": "Lisää yritys",
  "dashboard.adding": "Lisätään…",
  "dashboard.address": "Osoite",
  "dashboard.all": "Kaikki",
  "dashboard.allAts": "Kaikki ATS:t",
  "dashboard.allCompanies": "Kaikki yritykset",
  "dashboard.allStatus": "Kaikki tilat",
  "dashboard.atsSystem": "ATS-järjestelmä",
  "dashboard.businessId": "Y-tunnus",
  "dashboard.cancelEdit": "Peruuta",
  "dashboard.careersUrl": "Urasivun URL",
  "dashboard.charts.closeBackdrop": "Sulje",
  "dashboard.charts.closeButton": "Sulje kaaviot",
  "dashboard.charts.modalTitle": "Käyntien aktiivisuuskaaviot",
  "dashboard.charts.toolbarDisabledHint": "Lataa ensin käyntien vientitiedot",
  "dashboard.charts.toolbarHint": "Avaa käyntien aktiivisuuskaaviot",
  "dashboard.charts.toolbarLabel": "Kaaviot",
  "dashboard.check": "Merkitse tarkistetuksi",
  "dashboard.clearDlq": "Tyhjennä DLQ",
  "dashboard.clearFilters": "Tyhjennä suodattimet",
  "dashboard.clearLogoFailures": "Tyhjennä logovirheet ({count})",
  "dashboard.comments": "Kommentit",
  "dashboard.companiesHeader": "Yritykset ({count} / {total})",
  "dashboard.companyAttributes": "Yrityksen attribuutit",
  "dashboard.companyBasic": "Yrityksen perustiedot",
  "dashboard.companyBasic.short": "Perustiedot",
  "dashboard.companyBusiness": "Liiketoimintatiedot",
  "dashboard.companyContact": "Yhteystiedot",
  "dashboard.companyCrawl": "Hakuasetukset",
  "dashboard.companyCrawlRecordsPerPageLabel": "Rivejä sivulla",
  "dashboard.companyCrawlRecordsShowing": "Näytetään {from}-{to} / {total}",
  "dashboard.companyFinancial": "Talous",
  "dashboard.companyId": "Yrityksen ID",
  "dashboard.companyIndustry": "Toimiala",
  "dashboard.companyInformation": "Yritystiedot",
  "dashboard.companyLocation": "Sijainti",
  "dashboard.companyModal.close": "Sulje yritysikkuna",
  "dashboard.companyModal.closeBackdrop": "Sulje",
  "dashboard.companyModal.subtitle": "{crawls} hakuja · {ok} onnistunutta · {jobs} lähetetty prosessoijalle",
  "dashboard.companyModal.tabCrawls": "Hakuajot",
  "dashboard.companyModal.tabSettings": "Yrityksen ja haun asetukset",
  "dashboard.companyName": "Yrityksen nimi",
  "dashboard.companyRegistry": "Rekisteri",
  "dashboard.companyRow.jobs": "työt",
  "dashboard.companyRow.openBadge": "Avoinna",
  "dashboard.companyRow.paginationWarningShort": "Sivutus ⚠ {n}",
  "dashboard.companySocial": "Sosiaali media",
  "dashboard.companyUrl": "Yrityksen URL",
  "dashboard.coordinates": "Koordinaatit",
  "dashboard.crawlActions.companyColumnHint": "HTML · Live · Trace · Lokit",
  "dashboard.crawlActions.flatLogsColumnHint": "⋯ valikko",
  "dashboard.crawlActions.flatTraceColumnHint": "Modaali",
  "dashboard.crawlActions.legendHtml": "Silmä – HTML: S3-snapshottivarmuuskopio haetussa muodossa (sekä live-uutettu JSON, jos rivillä on URL-osoite).",
  "dashboard.crawlActions.legendLive": "Nuoli ulos – Live-sivusto: avaa julkinen työpaikkasivu JobCrawlsissa (vain objektitunnuksen omaavat yksityiskohtaiset rivit).",
  "dashboard.crawlActions.legendLogs": "⋯ – CloudWatch: siirry crawleriin, prosessoriin, enrichiin, Algoliaan jne. (suodattimet käyttävät tätä crawl-id:tä tai työpaikan URL-osoitetta).",
  "dashboard.crawlActions.legendRecrawlDetail": "Nuolet – Hae sivu uudelleen: lisää yksi yksityiskohtainen haku jonoon tälle URL-osoitteelle (ei koko yritysluetteloa).",
  "dashboard.crawlActions.legendTitle": "Mitä rivin painikkeet tekevät",
  "dashboard.crawlActions.legendTrace": "Suurennuslasi – Trace: yksi modaali, jossa on Raw/Final/Enriched-tilat sekä linkit DynamoDB:hen ja AWS-konsoliin.",
  "dashboard.crawlActions.liveJobAria": "Avaa julkinen työpaikkailmoitus JobCrawls-palvelussa",
  "dashboard.crawlActions.liveJobTooltip": "Avaa tämän työpaikan julkinen ilmoitussivu JobCrawls-palvelussa (sama URL, jonka vierailijat näkevät, kun työpaikka on indeksoitu).",
  "dashboard.crawlActions.logsMenuAria": "CloudWatch-putkilokien valikko tälle hakuprosessille",
  "dashboard.crawlActions.logsMenuTooltip": "CloudWatch-lokilinkit: tarkka haku-striimi (kun saatavilla), sekä suodatetut näkymät hakuohjelmalle (crawlId), prosessorille, rikastukselle, Algolialle, ylläpitäjälle ja prosessorille URL-osoitteen mukaan.",
  "dashboard.crawlActions.recrawlDetailAria": "Hae tämä työpaikkasivu uudelleen (vain yksityiskohtainen haku)",
  "dashboard.crawlActions.recrawlDetailTooltip": "Lisää jonoon vain tämän työpaikkasivun haku (yksityiskohdat). Ei aja koko yritysluettelosivujen hakua uudelleen. Käytä sitä varten yrityksen \"Recrawl\"-toimintoa.",
  "dashboard.crawlActions.traceAria": "Avaa koko putken trace tälle työpaikan URL-osoitteelle",
  "dashboard.crawlActions.traceTooltip": "Avaa putken trace: RawJobs / FinalJobs / Enriched -yhteenvedot, objektitunnukset sekä linkit DynamoDB:hen ja CloudWatchiin tälle työpaikan URL-osoitteelle.",
  "dashboard.crawlActions.viewHtmlAria": "Näytä tämän haun tallennettu HTML-snapshot",
  "dashboard.crawlActions.viewHtmlTooltip": "Avaa tälle hakuun tallennettu HTML-snapshot (S3). Näyttää renderöidyn tai raa'an merkinnän sekä sen vieressä live DynamoDB -työn JSON-tiedon.",
  "dashboard.crawlDataLoadedNoCompanies": "Crawl-data on ladattu ({count} tietuetta), mutta yritystietoja ei ole vielä ladattu tähän selaimeen, siksi alla ei näy ryhmiä. Lataa yritykset nähdäksesi ne.",
  "dashboard.crawlDlq": "Haku DLQ",
  "dashboard.crawlExportWindow": "Ladattuja hakuennätyksiä väliltä {from} – {to} (ylläpitäjän vienti-ikkuna).",
  "dashboard.crawlFailIconTooltip": "Tämä hakukerta epäonnistui tai palautti HTTP-virheen – avaa CloudWatch- / pipeline-lokit tälle crawlId:lle.",
  "dashboard.crawlHistory.hideOlder": "Piilota {n} vanhempaa hakua",
  "dashboard.crawlHistory.hint": "Uusin suoritus on yläpuolella olevalla rivillä. Jokaisella vanhemmalla suorituksella on oma crawlId:nsä ja CloudWatch-linkkinsä.",
  "dashboard.crawlHistory.showOlder": "Näytä {n} vanhempaa hakua: aika, lokit, HTML",
  "dashboard.crawlHourlyChart.ariaDuration": "Tuntikohtainen kaavio sivujen keskimääräisestä ajasta ja kokonaisvaltaisista hakuminuuteista",
  "dashboard.crawlHourlyChart.ariaPages": "Tuntikohtainen kaavio listaus- ja työsivujen hauista, tallennetuista työistä, listauslinkeistä ja tallentamattomista työsivuista",
  "dashboard.crawlHourlyChart.avgSecPhrase": "keskiarvo {seconds} s per sivu, josta raportoitiin ajoitus",
  "dashboard.crawlHourlyChart.axisAvgSec": "Keski-s / sivu",
  "dashboard.crawlHourlyChart.axisExtracted": "Työhön liittyvät määrät / h",
  "dashboard.crawlHourlyChart.axisPageFetches": "Sivuhaudonnot / h",
  "dashboard.crawlHourlyChart.axisTotalMin": "Yhteensä min / h",
  "dashboard.crawlHourlyChart.collapsedEmpty": "Ei rivejä ladatussa aikavälissä",
  "dashboard.crawlHourlyChart.collapsedSummary": "{hours} tuntia · {fetches} sivuhautonta",
  "dashboard.crawlHourlyChart.durationHms": "Yhteensä {hours}t {minutes}m {seconds}s (sivukohtaisten aikojen summa)",
  "dashboard.crawlHourlyChart.durationMs": "Yhteensä {minutes}m {seconds}s (sivukohtaisten aikojen summa)",
  "dashboard.crawlHourlyChart.durationSecOnly": "Yhteensä {seconds}s (sivukohtaisten aikojen summa)",
  "dashboard.crawlHourlyChart.durationZero": "Yhteensä 0s",
  "dashboard.crawlHourlyChart.empty": "Ladatussa aikavälissä ei ole crawl-rivejä – päivitä crawl-tiedot maintainer-viennin jälkeen.",
  "dashboard.crawlHourlyChart.helpCollapsibleLabel": "Selitykset ja aikavälin kokonaismäärät",
  "dashboard.crawlHourlyChart.hoverAllFetches": "Kaikki sivun haut",
  "dashboard.crawlHourlyChart.hoverAllFetchesValue": "{total} ({ok} ok / {fail} epäonnistunutta)",
  "dashboard.crawlHourlyChart.hoverAvgPageTime": "Sivun keskimääräinen aika (ajastetut rivit)",
  "dashboard.crawlHourlyChart.hoverDetailJobsCounted": "Yksittäisiltä työpaikkasivuilta (nähdyt ilmoitukset)",
  "dashboard.crawlHourlyChart.hoverDetailNotSaved": "Yksittäiset työpaikkasivut, joita emme tallentaneet",
  "dashboard.crawlHourlyChart.hoverFoundOtherPages": "Löytyi muilta sivutyypeiltä",
  "dashboard.crawlHourlyChart.hoverJobPages": "Työpaikkasivut (yksityiskohdat)",
  "dashboard.crawlHourlyChart.hoverJobPagesValue": "{ok} ok / {fail} epäonnistui",
  "dashboard.crawlHourlyChart.hoverJobsFound": "\"Löytyneiden\" kokonaismäärä (kaikki laskettuna yhteen)",
  "dashboard.crawlHourlyChart.hoverListPages": "Listasivut",
  "dashboard.crawlHourlyChart.hoverListPagesValue": "{ok} ok / {fail} epäonnistui",
  "dashboard.crawlHourlyChart.hoverListUrlsEnqueued": "Listasivuilta (laskettu työpaikkalinkit)",
  "dashboard.crawlHourlyChart.hoverNoTimingSamples": "–",
  "dashboard.crawlHourlyChart.hoverPipeline": "Tallennettu putkeen",
  "dashboard.crawlHourlyChart.hoverPipelineBreakdown": "{total} (Työmarkkinatori {tm}, muut {other})",
  "dashboard.crawlHourlyChart.hoverTotalReportedTime": "Ilmoitettu kokonaiskestoaika hakuun",
  "dashboard.crawlHourlyChart.noTiming": "tässä viennissä ei ole tallennettu sivukohtaisia kestoja",
  "dashboard.crawlHourlyChart.panelDuration": "Haku- eli crawl-kesto",
  "dashboard.crawlHourlyChart.panelPages": "Haudut ja työpaikkojen määrät tunneittain",
  "dashboard.crawlHourlyChart.plainGuide1": "\"Löytyneet\" (Found) on usein suuri luku, koska jokainen työpaikkalinkki listausivulla lasketaan mukaan. Nämä linkit tarkoittavat vain sitä, että \"jonotimme tämän URL-osoitteen\" – ne eivät ole vielä tallennettuja työpaikkoja.",
  "dashboard.crawlHourlyChart.plainGuide2": "\"Poimitut\" (Extracted) tarkoittaa, että tallensimme kyseisen työpaikan raakamuotoiseen tallennustilaan yksittäiseltä työpaikkasivulta. Listausrivit eivät koskaan kasvata poimittujen määrää (tämä on tietoinen valinta).",
  "dashboard.crawlHourlyChart.plainGuide3": "Käytä kaaviossa valintaruutuja: katkoviivainen violetti viiva = listasivuilla lasketut linkit; katkoviivainen ruskea viiva = vierailtavat työpaikkasivut, joita ei tallennettu; yhtenäinen kultainen viiva = putkeen tallennetut. Vie hiiri kaavion päälle nähdäksesi yhden tunnin lukemat.",
  "dashboard.crawlHourlyChart.plainGuideTitle": "Yksinkertaisesti selitettynä",
  "dashboard.crawlHourlyChart.subtitle": "Ylempi kaavio: haetut sivut ja työpaikkojen määrät tunnissa. Alempi kaavio: haun kesto. Aika-akseli vastaa viennin hakuikkunaa (usein noin viikko).",
  "dashboard.crawlHourlyChart.title": "Hakuaktiivisuus tunneittain (paikallinen aika)",
  "dashboard.crawlHourlyChart.totalDetailSkipped": "Vierailut työpaikkasivuilla, joita ei tallennettu",
  "dashboard.crawlHourlyChart.totalExtracted": "Työt tallennettu raakamuotoon (\"extracted\")",
  "dashboard.crawlHourlyChart.totalFoundRaw": "\"Löytyi\" (kaikki rivit laskettuna yhteen)",
  "dashboard.crawlHourlyChart.totalJobPages": "Käydyt yksittäiset työpaikkasivut",
  "dashboard.crawlHourlyChart.totalJobPagesValue": "{total} ({ok} onnistui, {fail} epäonnistui)",
  "dashboard.crawlHourlyChart.totalListLinks": "Näistä listausivuilla laskettujen linkkien määrä",
  "dashboard.crawlHourlyChart.totalListPages": "Käydyt listausivut",
  "dashboard.crawlHourlyChart.totalListPagesValue": "{total} ({ok} onnistui, {fail} epäonnistui)",
  "dashboard.crawlHourlyChart.totalTiming": "Crawlerin raportoima aika",
  "dashboard.crawlHourlyChart.totalsTitle": "Yhteensä yllä olevalla aikavälillä",
  "dashboard.crawlKey": "Crawl-avain",
  "dashboard.crawlMetricsExplainer.crawls": "Hakuja: yksi lokirivi joka kerta, kun avaamme listaus- tai yksittäisen työpaikkasivun.",
  "dashboard.crawlMetricsExplainer.extracted": "Poimittu: työpaikat, jotka tallensimme varsinaisesti työpaikkasivulta. Listaus-sivut eivät vaikuta tähän.",
  "dashboard.crawlMetricsExplainer.found": "Löytynyt: pääasiassa \"kuinka monta työpaikkalinkkiä laskimme listaus-sivuilla\", plus mitä näimme työpaikkasivuilla. Suuret luvut tässä ovat normaaleja.",
  "dashboard.crawlMetricsExplainer.foundVsExtracted": "Saadaksesi kokonaiskuvan, käytä alla olevaa tuntikohtaista kaaviota: siinä purppura, ruskea ja kultainen viiva on nimetty vastaamaan tätä kuvausta.",
  "dashboard.crawlMetricsExplainer.successFailed": "Onnistunut / epäonnistunut: latautuiko sivu ja valmistuiko se ilman hakuvirhettä?",
  "dashboard.crawlMetricsExplainer.title": "Mitä nämä luvut tarkoittavat",
  "dashboard.crawlMetricsExplainer.triggerAria": "Mitä nämä haun yhteenvetoluvut tarkoittavat",
  "dashboard.crawlOkIconTooltip": "Tämä haku onnistui (HTTP OK, ei hakuohjelmiston virhettä).",
  "dashboard.crawlOutliersFilter.all": "Kaikki hakurivit",
  "dashboard.crawlOutliersFilter.any": "Haettu, mutta ei lähetetty",
  "dashboard.crawlOutliersFilter.hint": "Käyttää vain IndexedDB-vienti-kenttiä. Listasivun rivit piilotetaan, kun tämä ei ole \"Kaikki\". Yhdistä tasaisiin \"Job / list pages\" -välilehtiin.",
  "dashboard.crawlOutliersFilter.label": "Pipeline- / indeksipoikkeamat (yksityiskohtaiset haku)",
  "dashboard.crawlOutliersFilter.notSent": "Haku onnistui, mutta jobsExtracted = 0 (ei ohitettu)",
  "dashboard.crawlRecords": "Hakuennätykset",
  "dashboard.crawlStatistics": "Hakutilastot",
  "dashboard.crawlType": "Hakutyyppi",
  "dashboard.crawlingInformation": "Hakutiedot",
  "dashboard.deleteComment": "Poista kommentti",
  "dashboard.deleteCompany": "Poista",
  "dashboard.deleteCompany.confirm": "Poistetaanko \"{name}\" Companies-taulukosta (DynamoDB)? Tätä toimintoa ei voi peruuttaa. Tähän yritykseen liittyvät paikallisen hallintapaneelin rivit poistetaan.",
  "dashboard.deleteCompany.done": "Yritys \"{name}\" poistettiin.",
  "dashboard.deleteCompany.failed": "Yrityksen poistaminen epäonnistui: {message}",
  "dashboard.deleteCompany.modalTooltip": "Poista tämä yritys Yritykset-taulukosta (DynamoDB)",
  "dashboard.deleteCompany.rowTooltip": "Poista yritys DynamoDB:stä ja poista paikallisesta hallintapaneelista",
  "dashboard.deleteCompany.virtualBlocked": "Työmarkkinatorin kooste-rivi ei ole Yritykset-taulukon tietue. Sitä ei voi poistaa tästä.",
  "dashboard.detailPages": "Yksityiskohtasivut",
  "dashboard.details": "Tiedot",
  "dashboard.dlqEmpty": "DLQ on tyhjä - ei epäonnistuneita viestejä",
  "dashboard.dlqMessageCount": "{count} {count, plural, one {viesti} other {viestiä}} DLQ:ssa",
  "dashboard.dlqViewer": "Dead Letter Queue -katselu",
  "dashboard.duration": "Kesto",
  "dashboard.editCompany": "Muokkaa",
  "dashboard.enqueueUrlPattern": "Jonotus-URL-malli",
  "dashboard.error": "Virhe",
  "dashboard.failed": "Epäonnistuneet",
  "dashboard.failedToLoadCompanySettings": "Yrityksen asetusten lataaminen epäonnistui: {error}",
  "dashboard.filterByField": "Suodata kentän mukaan",
  "dashboard.filterValue": "Suodatinarvo… (käytä __NOT_EMPTY__ tyhjien poistamiseen)",
  "dashboard.flatView.noCrawlRows": "Ei näytettäviä rivejä tasanäkymässä. Lataa ensin crawl-vienti-tiedot.",
  "dashboard.flatViews.colActions": "Toiminnot",
  "dashboard.flatViews.colActionsTooltip": "Sivuston live-listaus, S3-HTML-tilannekuva kun saatavilla.",
  "dashboard.flatViews.colCompany": "Yritys",
  "dashboard.flatViews.colCompanyTooltip": "Crawl-tietueeseen tallennettu yrityksen nimi.",
  "dashboard.flatViews.colDuration": "Kesto",
  "dashboard.flatViews.colDurationTooltip": "Tähän crawl-pyyntöön käytetty haku- ja käsittelyaika.",
  "dashboard.flatViews.colHttpTooltip": "Tämän pyynnön HTTP-vastaustila (esim. 200 = OK).",
  "dashboard.flatViews.colMetrics": "Löytyi / lähetetty",
  "dashboard.flatViews.colMetricsTooltip": "Lista: jonotetut työpaikat. Yksityiskohdat: lähetetty prosessoijalle vai ei. Muut sivutyypit: raakamäärät. Vie hiiri solun päälle nähdäksesi lisätietoja.",
  "dashboard.flatViews.colOkTooltip": "Vihreä: crawl onnistui. Punainen: epäonnistui tai virheellinen HTTP. Jos samalle URL-osoitteelle on useita ajoja, vie hiiri aikasarakeen päälle nähdäksesi tilan per ajo.",
  "dashboard.flatViews.colPage": "Sivu",
  "dashboard.flatViews.colPageTooltip": "Sivutyyppi (lista vs. yksityiskohdat) ja tunnisteet: TMT, Ohitettu, Y-tunnus-vihjeet jne.",
  "dashboard.flatViews.colPipelineLogsTooltip": "Linkit CloudWatch-lokivirtoihin crawlerille, prosessorille ja liittyville vaiheille.",
  "dashboard.flatViews.colTime": "Aika",
  "dashboard.flatViews.colTimeTooltip": "Milloin tämä haku alkoi. Jos sama URL on haettu useammin kuin kerran, tässä rivissä näytetään uusin haku.",
  "dashboard.flatViews.colTrace": "Pipeline-lokit",
  "dashboard.flatViews.colTraceFull": "Jälkitys",
  "dashboard.flatViews.colTraceFullTooltip": "Avaa koko työn pipeline-jälkitys (Raw/Final/Enriched, DynamoDB & CloudWatch).",
  "dashboard.flatViews.colUrlTooltip": "Crawlerin noutama URL.",
  "dashboard.flatViews.colYtunnusTooltip": "Vain Työmarkkinatori: onko HTML-koodista poimittu suomalaista Y-tunnusta ja täsmännytkö se yritystietokantaasi.",
  "dashboard.flatViews.crawlRunCount": "{n} hakua",
  "dashboard.flatViews.failure.algolia": "Algolia-virheet (metatiedot)",
  "dashboard.flatViews.failure.all": "Kaikki tulokset",
  "dashboard.flatViews.failure.cookie": "Eväste / peitekerros",
  "dashboard.flatViews.failure.nav": "Navigointi / aikakatkaisu",
  "dashboard.flatViews.failure.net": "Verkko",
  "dashboard.flatViews.failure.ok": "Haku onnistui",
  "dashboard.flatViews.failure.other": "Muu hakuvirhe",
  "dashboard.flatViews.failureFilterLabel": "Hakuun liittyvä tulos",
  "dashboard.flatViews.first": "Ensimmäinen",
  "dashboard.flatViews.hint": "Lajittelu, Lähde, Poikkeamat ja Crawl-tulos koskevat vain tätä taulukkoa. Rivit ryhmittelevät saman URL-osoitteen toistuvat haku-kerrat (uusin ensin; hakukertojen määrä aikasarakeessa). Poikkeamat käyttävät vain työn yksityiskohtien rivejä (Algolia-virheet metatiedoissa tai haku onnistui, mutta jobsExtracted on 0 eikä sitä ohitettu). Crawl-tulos käyttää IndexedDB-vienti-kenttiä (ei live Dynamoa). Käytä Trace-toimintoa rivillä ladataksesi Raw/Final/Enriched-tiedot sekä AWS-konsolin linkit. Rivijoukko käyttää samoja suodattimia (Työmarkkinatori, TMT Y-tunnus) kuin yllä.",
  "dashboard.flatViews.jobPages": "Kaikki työpaikkasivut",
  "dashboard.flatViews.last": "Viimeinen",
  "dashboard.flatViews.listPages": "Kaikki listasivut",
  "dashboard.flatViews.next": "Seuraava",
  "dashboard.flatViews.pageJumpLabel": "Siirry sivulle",
  "dashboard.flatViews.pageOf": "Sivu {p} / {t} ({n} riviä)",
  "dashboard.flatViews.prev": "Edellinen",
  "dashboard.flatViews.sort.companyAsc": "Yritys · A–Ö",
  "dashboard.flatViews.sort.companyDesc": "Yritys · Ö–A",
  "dashboard.flatViews.sort.failedFirst": "OK · epäonnistumiset ensin",
  "dashboard.flatViews.sort.jobsFoundAsc": "Löytyneet työt · pienestä → suureen",
  "dashboard.flatViews.sort.jobsFoundDesc": "Löytyneet työt · suuresta → pieneen",
  "dashboard.flatViews.sort.successFirst": "OK · onnistumiset ensin",
  "dashboard.flatViews.sort.timeAsc": "Aika · vanhimmat ensin",
  "dashboard.flatViews.sort.timeDesc": "Aika · uusimmat ensin",
  "dashboard.flatViews.sort.urlAsc": "URL · A–Ö",
  "dashboard.flatViews.sort.urlDesc": "URL · Ö–A",
  "dashboard.flatViews.sortLabel": "Lajittele",
  "dashboard.flatViews.source.all": "Kaikki crawlaukset",
  "dashboard.flatViews.source.nonTmt": "Poissulje Työmarkkinatori",
  "dashboard.flatViews.source.tmtOnly": "Vain Työmarkkinatori",
  "dashboard.flatViews.sourceLabel": "Lähde",
  "dashboard.flatViews.title": "Flat crawl -näkymät",
  "dashboard.flatViews.yt.legacy": "Vanhempi rivi: ei Y-tunnus-metadataa (uudelleenhaku luokittelua varten)",
  "dashboard.flatViews.yt.na": "Ei Työmarkkinatorin yksityiskohtainen rivi",
  "dashboard.flatViews.yt.nocompany": "Y-tunnus poimittu, mutta ei löytynyt CompaniesTable-taulukosta",
  "dashboard.flatViews.yt.none": "Y-tunnusta ei poimittu sivun HTML-koodista",
  "dashboard.flatViews.yt.ok": "Y-tunnus poimittu ja yritys täsmää",
  "dashboard.greenSuccess": "Vihreä (Onnistunut)",
  "dashboard.groupBy": "Ryhmittele",
  "dashboard.groupCrawlCount": "Haku-kerrat",
  "dashboard.groupJobsCount": "Työpaikkojen määrä",
  "dashboard.groupLogoFailed": "Logon tila",
  "dashboard.groupMetrics": "Mittarit",
  "dashboard.groupNone": "Ei mitään",
  "dashboard.groupPaginationIssue": "Sivutuspulmat",
  "dashboard.groupStatus": "Tila (Punainen/Keltainen/Vihreä)",
  "dashboard.groupStatusIssues": "Tilat ja ongelmat",
  "dashboard.groupSuccessRate": "Onnistumisprosentti",
  "dashboard.hasAnyFailedCrawl": "Mikä tahansa epäonnistunut haku (ikkunassa)",
  "dashboard.hasComments": "Sisältää kommentteja",
  "dashboard.hasCrawlData.label": "Haku-tiedot",
  "dashboard.hasCrawlData.option": "Sisältää tietoja",
  "dashboard.heroImage": "Sankarikuva",
  "dashboard.howToRunCrawl": "Kuinka suorittaa haku",
  "dashboard.htmlModal.liveExtractedHint": "Sama objektitunnus kuin hakuindeksissä. Pitkät tekstikentät on lyhennetty näkymää varten.",
  "dashboard.htmlModal.liveExtractedTitle": "Reaaliaikaisesti louhittu työpaikka (DynamoDB)",
  "dashboard.htmlModal.loadingLive": "Ladataan FinalJobs / Enriched…",
  "dashboard.htmlModal.noJobUrl": "Tällä hakurivillä ei ole URL-osoitetta – reaaliaikaisia työpaikkatiueita ei voida hakea.",
  "dashboard.httpStatusCellTooltip": "Tämän pyynnön HTTP-vastausstatus (esim. 200 = OK, 404 = ei löytynyt).",
  "dashboard.industry": "Toimiala",
  "dashboard.isChecked": "Tarkistettu",
  "dashboard.isSaved": "Tallennettu",
  "dashboard.issuesOnly": "Vain ongelmat",
  "dashboard.itemsPerPage": "Kohteita sivulla",
  "dashboard.jobLookup.activeHint": "Näytetään yksityiskohtaiset haku-tulokset työlle ID: {id}",
  "dashboard.jobLookup.clear": "Tyhjennä vientisuodatin",
  "dashboard.jobLookup.find": "Etsi viennistä",
  "dashboard.jobLookup.noMatchInExport": "Ladatussa ikkunassa ei ole yksityiskohtaista hakua tällä työ-ID:llä. Lataa hakudata uudelleen tai laajenna vienti-ikkunaa.",
  "dashboard.jobLookup.parseError": "Työpaikkatunnusta ei löytynyt. Liitä JobCrawls-työpaikkasivun koko URL-osoite (…/en/job/…/company/…) tai osoitepalkin objektitunnus.",
  "dashboard.jobLookup.placeholder": "Liitä työpaikkasivun URL-osoite tai objektitunnus…",
  "dashboard.jobLookup.resolvingIds": "yhdistetään työpaikkatunnuksia hakuun…",
  "dashboard.jobSearch.matchExportLabel": "Hae ladatusta crawl-viennistä",
  "dashboard.jobSearch.sectionHint": "Etsi rivejä ladatusta viennistä tai seuraa putken tilaa työpaikan URL-osoitteen avulla.",
  "dashboard.jobSearch.sectionTitle": "Työpaikkahaku",
  "dashboard.jobTrace.blurb": "Liitä täsmälleen se työpaikkailmoituksen URL-osoite, joka on tallennettu RawJobs-tietokantaan. Hallintapaneeli lataa RawJobs-, FinalJobs- ja EnrichedFinalJobs-tiedot, päättelee kuinka pitkälle työpaikka eteni ja linkittää DynamoDB-tauluihin sekä CloudWatch-lokisuodattimiin.",
  "dashboard.jobTrace.close": "Sulje",
  "dashboard.jobTrace.dynamo": "DynamoDB (konsoli)",
  "dashboard.jobTrace.failureCode": "Koodi: {code}",
  "dashboard.jobTrace.load": "Hae kaikki tiedot",
  "dashboard.jobTrace.loading": "Ladataan jäljitystä…",
  "dashboard.jobTrace.logs": "CloudWatch (suodatin)",
  "dashboard.jobTrace.modalTitle": "Putken jäljitys",
  "dashboard.jobTrace.noAwsLinks": "Konsolilinkit eivät ole käytettävissä (putken lokiympäristö on puutteellinen).",
  "dashboard.jobTrace.noLogContext": "Putken lokiympäristön muuttujat puuttuvat API:sta. Dynamon linkit toimivat edelleen; määritä PIPELINE_LOG_GROUP_* Dashboard Lambdassa, jotta CloudWatch-syvälinkit näkyvät API-vastauksessa.",
  "dashboard.jobTrace.rawJson": "Kohteiden yhteenvedot (JSON)",
  "dashboard.jobTrace.title": "Putken jäljitys (Dynamo & CloudWatch)",
  "dashboard.jobTrace.urlLabel": "Työn URL",
  "dashboard.jobTrace.visual": "Putken edistyminen",
  "dashboard.jobsEnqueued": "{count} tehtävää jonossa",
  "dashboard.jobsEnqueuedCellTooltip": "Listahaku: tällä sivulla löydetyt ja yksityiskohtaiseen hakuun jonotetut työpaikkojen URL-osoitteet. \"Listasivut\" sisältää myös muut jonotetut listaus-URL-osoitteet (esim. sivunumerointi).",
  "dashboard.jobsExtracted": "Poimitut tehtävät",
  "dashboard.jobsFound": "Löydetyt tehtävät",
  "dashboard.layout.company": "Yrityksittäin",
  "dashboard.layout.flat": "Yksittäiset haut",
  "dashboard.layout.label": "Asettelu",
  "dashboard.listPages": "Listasivut",
  "dashboard.listPagesEnqueued": "{count} listasivua",
  "dashboard.liveJobLink": "Live-työpaikka",
  "dashboard.loadAllCompanies": "Lataa kaikki yritykset (86k)",
  "dashboard.loadCompaniesButton": "Lataa yritykset",
  "dashboard.loadedCompanies": "Ladattu: {current} / {total} yritystä",
  "dashboard.loadedCompaniesUnknown": "Ladattu: {current} yritystä",
  "dashboard.loadingAllCompanies": "Ladataan kaikkia yrityksiä (hitaampi alkuvaiheen lataus)",
  "dashboard.loadingBatch": "Käsitellään erää {current} noin {total}:sta",
  "dashboard.loadingCompanies": "Ladataan yritystietoja",
  "dashboard.loadingCompaniesWithUrls": "Ladataan vain yritykset, joilla on verkkosivuosoite (nopeampi)",
  "dashboard.loadingNote": "Tämä voi kestää muutaman minuutin. Pidä tämä sivu auki.",
  "dashboard.logoFailed": "Logon lataus epäonnistui",
  "dashboard.logoFailedBadgeTitle": "Logon lataaminen hallintapaneeliin epäonnistui. Käytä alla olevia Logo Lambda -lokeja ProcessCompanyLogos-tulosten tarkistamiseen",
  "dashboard.logoProcessingFailedBadgeTitle": "ProcessCompanyLogos epäonnistui ({failedAt}): {error}",
  "dashboard.logoProcessingFailedUnknownDate": "tuntematon päivämäärä",
  "dashboard.logoUrlFailedLabel": "Epäonnistui",
  "dashboard.map": "Kartta",
  "dashboard.menu.overview": "Yleiskatsaus",
  "dashboard.menu.overview.metricsHelpDesc": "Vie hiiri (i)-kuvakkeen päälle nähdäksesi, mitä kukin lukema tarkoittaa.",
  "dashboard.menu.overview.metricsHelpTitle": "Mittarien määritelmät",
  "dashboard.menu.overview.noExport": "Lataa crawl-vientiä (Työkalut) nähdäksesi yhteenvetoluvut.",
  "dashboard.menu.overview.pipelineDesc": "Maintainer-snapshot vs. crawl-ikkuna.",
  "dashboard.menu.overview.summaryDesc": "Luvut tässä selaimessa ladatusta crawl-JSON-tiedostosta.",
  "dashboard.menu.overview.summaryTitle": "Viennin yhteenveto",
  "dashboard.menu.refine": "Tarkenna",
  "dashboard.metricsFoundExtractedTooltip": "Löytyneet työt vs. tämän sivutyypin kohdalta poimitut työt (ei vakioitu luettelo/yksityiskohtainen rivi).",
  "dashboard.mostRecent": "Viimeisin",
  "dashboard.next": "Seuraava",
  "dashboard.noCrawlData.message": "Hakuaineistoa ei ole vielä saatavilla. Laajenna yllä oleva \"Kuinka suorittaa haku\" -osio saadaksesi ohjeet haun suorittamiseen ja tietojen vientiin.",
  "dashboard.noCrawlData.option": "Ei tietoja",
  "dashboard.noCrawlData.withServerDetail": "Hakuviestiä ei ole saatavilla: {detail}. Jos käytät localhostia, varmista, että AWS-tunnuksilla on lukuoikeus crawl-data-bucketiin ja että Maintainer on kirjoittanut tiedoston crawl-exports/latest.json.",
  "dashboard.noFieldFilter": "Ei kenttäsuodatinta",
  "dashboard.noIssues": "Ei ongelmia",
  "dashboard.noLogoUrl": "Ei logo-URL-osoitetta",
  "dashboard.notSent": "Ei lähetetty",
  "dashboard.notSentTooltip": "Työpaikkadataa ei louhittu (jobsExtracted on 0). Tämä ei ole sama asia kuin \"Ohitettu\": Ohitettu tarkoittaa, että crawler ei tietoisesti suorittanut ajoa uudelleen, koska työpaikka löytyi jo RawJobs-taulusta.",
  "dashboard.pageInfo": "Sivu {current} / {total}",
  "dashboard.pageType": "Sivutyyppi",
  "dashboard.pageType.detailTooltip": "Yksityiskohtainen sivu: yksittäisen työpaikkailmoituksen URL. Crawler louhii jäsenneltyä dataa ja voi lähettää sen prosessoijalle.",
  "dashboard.pageType.genericTooltip": "Crawlerin sivutyyppi: {pageType}.",
  "dashboard.pageType.listTooltip": "Listasivu: etsii työpaikkalinkkejä listaus- tai hakusivulta ja lisää ne jonoon yksityiskohtaista louhintaa varten.",
  "dashboard.pagination.allRows": "Kaikki",
  "dashboard.pagination.first": "Ensimmäinen",
  "dashboard.pagination.last": "Viimeinen",
  "dashboard.pagination.navGroup": "Sivunavigointi",
  "dashboard.pagination.pageJumpAria": "Sivunumero, 1–{total}",
  "dashboard.pagination.pageJumpLabel": "Siirry sivulle",
  "dashboard.paginationIssueDescription": "Lähetetty tarkalleen {count} työpaikkaa – tämä voi viitata puutteelliseen sivutukseen.",
  "dashboard.pipelineHealth.active": "Aktiivinen",
  "dashboard.pipelineHealth.activeFinland": "Aktiivinen + Suomi",
  "dashboard.pipelineHealth.activeNotFinland": "Aktiivinen, ei Suomi",
  "dashboard.pipelineHealth.crawlCompare.body": "Työmarkkinatori-haun riveiltä poimitut työpaikat (jobsExtracted-summa): {count}. Vertaa yllä olevaan kohtaan \"Active Työmarkk. (URL)\". Suuret erot johtuvat usein vanhentuneesta lastSeen-merkinnästä (ei-aktiivinen), prosessointijonon ruuhkasta tai URL/companyId-ristiriidoista.",
  "dashboard.pipelineHealth.crawlCompare.title": "Haku-exportti (tämä ikkuna)",
  "dashboard.pipelineHealth.generatedAt": "Snapshot Maintainer-skannauksesta: {when}",
  "dashboard.pipelineHealth.inactive": "Epäaktiivinen",
  "dashboard.pipelineHealth.missingStats": "Ei vielä snapshotia. Lukumäärät ilmestyvät tähän seuraavan onnistuneen Maintainer-ajon (CRAWL_DATA_BUCKET asetettuna) jälkeen. Päivitä crawl-tiedot Maintainerin jälkeen.",
  "dashboard.pipelineHealth.title": "Pipelinen kunto (FinalJobs)",
  "dashboard.pipelineHealth.totalRows": "FinalJobs-rivit",
  "dashboard.pipelineHealth.tyoFlag": "Aktiivinen Työmarkk. (lippu)",
  "dashboard.pipelineHealth.tyoUrl": "Aktiivinen Työmarkk. (URL)",
  "dashboard.pipelineHealth.tyoUrlBadFinland": "Työmarkk. URL + ei Suomi",
  "dashboard.pipelineLogs.allGroups": "Lambda-lokiryhmät",
  "dashboard.pipelineLogs.aria": "CloudWatch-lokilinkit crawl → processor → enrich → Algolia → maintainer -polun mukaisesti",
  "dashboard.pipelineLogs.crawlSearch": "Haku (crawlId)",
  "dashboard.pipelineLogs.crawlStream": "Hakuvirta",
  "dashboard.pipelineLogs.enrich": "Rikastaminen",
  "dashboard.pipelineLogs.maintainer": "Ylläpitäjä",
  "dashboard.pipelineLogs.noObjectId": "ObjectID-linkit vain yksityiskohtaisilla riveillä",
  "dashboard.pipelineLogs.processor": "Prosessori",
  "dashboard.pipelineLogs.processorUrl": "Prosessori (URL)",
  "dashboard.pipelineLogs.unconfigured": "Aseta PIPELINE_LOG_GROUP_* Dashboard- tai API Lambdaan lokilinkkejä varten",
  "dashboard.potentialPaginationIssue": "Mahdollinen sivutusongelma",
  "dashboard.previous": "Edellinen",
  "dashboard.processCompanyLogoLogs.link": "Logo Lambda -lokit",
  "dashboard.processCompanyLogoLogs.tooltip": "Avaa ProcessCompanyLogos-lokiryhmä CloudWatchista (suodatettuna tämän yrityksen tunnuksen mukaan)",
  "dashboard.processDlq": "Käsittele DLQ",
  "dashboard.quickFilterUncrawled": "Ei haetut · korkein pistemäärä",
  "dashboard.quickFilterUncrawled.tooltip": "Näytä yritykset, joissa doCrawl ei ole TRUE, järjestettynä pistemäärän mukaan laskevasti. Hyödyllinen tärkeimpien ei-haettujen yritysten manuaaliseen käsittelyyn",
  "dashboard.recordCount": "{count} {count, plural, one {tietue} other {tietuetta}}",
  "dashboard.recrawl": "Hae uudelleen",
  "dashboard.recrawlDetailTriggered": "Yksityiskohtien uudelleenhaku jonotettu yritykselle {companyName}",
  "dashboard.recrawlTriggered": "Uudelleenhaku käynnistetty yritykselle {companyName}",
  "dashboard.recrawling": "Uudelleenhaku käynnissä…",
  "dashboard.redLastCrawlFailed": "[Punainen] – viimeisin haku epäonnistui",
  "dashboard.refine.quickOptionsTitle": "Pikavalinnat",
  "dashboard.refine.section.companyList": "Yritysluettelo",
  "dashboard.refine.section.companyListDesc": "Rajaa luettelossa näkyviä yrityksiä.",
  "dashboard.refine.section.fieldFilterDesc": "Hae tietyn yrityskentän (ja valinnaisen arvon) perusteella.",
  "dashboard.refine.section.pipelineIndex": "Pipeline & indeksi",
  "dashboard.refine.section.pipelineIndexDesc": "Ladatun viennin yksityiskohtaiset haku-signaalit.",
  "dashboard.refine.section.tyomarkkinatoriDesc": "Suodata Työmarkkinatori-tunnisteiset rivit ja Y-tunnus-metatiedot.",
  "dashboard.refreshCompanies": "Päivitä yritykset",
  "dashboard.refreshCrawlData": "Päivitä hakuaineisto",
  "dashboard.refreshCrawlData.title": "Päivitä hakuaineisto S3-tallennustilasta",
  "dashboard.refreshing": "Päivitetään…",
  "dashboard.registryInformation": "Rekisteritiedot",
  "dashboard.result": "Tulos",
  "dashboard.runMaintainer": "Aja ylläpitotyökalu",
  "dashboard.running": "Ajetaan…",
  "dashboard.saveError": "Virhe",
  "dashboard.saved": "Tallennettu",
  "dashboard.saving": "Tallennetaan…",
  "dashboard.scanningDatabase": "Skannataan tietokantaa ja ladataan yrityksiä…",
  "dashboard.searchCompanies": "Hae yrityksiä…",
  "dashboard.sentForProcessing": "✓ Lähetetty käsiteltäväksi",
  "dashboard.sentForProcessingTooltip": "Strukturoidut työpaikkatiedot on uutettu (jobsExtracted ≥ 1) ja lähetetty käsittelyputkeen (SQS / processor).",
  "dashboard.sentToProcessor": "Lähetetty prosessoriin",
  "dashboard.showing": "Näytetään {filtered} / {total} yritystä",
  "dashboard.skipped": "Ohitettu",
  "dashboard.skippedCrawlTooltip": "Ohitettu: crawler ei hakenut tätä URL-osoitetta uudelleen, koska työpaikka oli jo tallennettu RawJobs-tauluun (duplikaattien esto). Crawl-rivi on silti tallennettu näkyvyyden varmistamiseksi.",
  "dashboard.socialMedia": "Sosiaali media",
  "dashboard.sortAndGroup.sectionHint": "Muuta listan järjestystä ja valinnaista ryhmittelyä.",
  "dashboard.sortAndGroup.sectionTitle": "Lajittelu ja ryhmittely",
  "dashboard.sortAscending": "Nouseva",
  "dashboard.sortBasic": "Perus",
  "dashboard.sortBy": "Lajitteluperuste",
  "dashboard.sortCrawls": "Hakuajat",
  "dashboard.sortDescending": "Laskeva",
  "dashboard.sortDetailPages": "Yksityiskohtaiset sivut",
  "dashboard.sortDirection": "Lajittele {direction}",
  "dashboard.sortFailed": "Epäonnistuneet haku-kerrat",
  "dashboard.sortJobs": "Työt",
  "dashboard.sortJobsExtracted": "Kaikki poimitut työt",
  "dashboard.sortJobsFound": "Kaikki löydetyt työt",
  "dashboard.sortJobsSent": "Käsittelyyn lähetetyt työt",
  "dashboard.sortLastCrawl": "Viimeisin haku-päivämäärä",
  "dashboard.sortListPages": "Listasivut",
  "dashboard.sortMostRecentJobs": "Viimeisimmät löydetyt työt",
  "dashboard.sortName": "Yrityksen nimi",
  "dashboard.sortPages": "Sivut",
  "dashboard.sortStatus": "Tila",
  "dashboard.sortSuccessRate": "Onnistumisprosentti",
  "dashboard.sortSuccessful": "Onnistuneet hakuet",
  "dashboard.status": "Tila",
  "dashboard.successRate": "Onnistumisprosentti",
  "dashboard.successful": "Onnistuneet",
  "dashboard.summary.extractedLabel": "Poimitut tehtävät",
  "dashboard.summary.failedLabel": "Epäonnistuneet",
  "dashboard.summary.foundLabel": "Löytyneet tehtävät",
  "dashboard.summary.successLabel": "Onnistuneet",
  "dashboard.summary.totalCrawls": "Kierroksia yhteensä",
  "dashboard.summary.uniqueUrls": "Uniikit URL-osoitteet",
  "dashboard.syncingCompanySettings": "Synkronoidaan yrityksen asetuksia…",
  "dashboard.time": "Aika",
  "dashboard.title": "Kierrosten hallintapaneeli",
  "dashboard.tmtBadge.noYtunnus": "Työmarkkinatori-yksityiskohta: Y-tunnusta ei erotettu HTML-koodista",
  "dashboard.tmtBadge.noYtunnusShort": "Ei Y-tunnusta",
  "dashboard.tmtBadge.yTunnusNoCompany": "Y-tunnus erotettu, mutta vastaavaa yritystä ei löytynyt CompaniesTable-taulukosta",
  "dashboard.tmtBadge.yTunnusNoCompanyShort": "Y-tunnus / ei yritystä",
  "dashboard.tmtBadge.yTunnusUnknown": "Vanhempi kierrosrivi: Y-tunnuksen metadataa ei ole vielä tallennettu (luokittele uudelleen kierroksella)",
  "dashboard.tmtSourceTooltip": "Tämä työpaikka on haettu Työmarkkinatorilta (TE-palvelut / julkiset työpaikkailmoitukset).",
  "dashboard.tmtYtunnusFilter.all": "Kaikki",
  "dashboard.tmtYtunnusFilter.noCompany": "Y-tunnusta ei löydy yrityksistä",
  "dashboard.tmtYtunnusFilter.noExtract": "Y-tunnusta ei voitu hakea",
  "dashboard.toolsModal.actionsHeading": "Toiminnot",
  "dashboard.toolsModal.closeBackdrop": "Sulje",
  "dashboard.toolsModal.closeButton": "Sulje",
  "dashboard.toolsModal.openButton": "Työkalut ja asetukset",
  "dashboard.toolsModal.openButtonSr": "Avaa ylläpitäjän työkalut, päivitykset, DLQ ja hakuohjeet",
  "dashboard.toolsModal.title": "Työkalut ja asetukset",
  "dashboard.totalCrawls": "Kokonaislouhinnat",
  "dashboard.tyomarkkinatoriCrawlFilter.all": "Kaikki louhinnat",
  "dashboard.tyomarkkinatoriCrawlFilter.nonTmt": "Vain muut kuin TMT-rivit",
  "dashboard.tyomarkkinatoriCrawlFilter.tmtOnly": "Vain TMT-rivit",
  "dashboard.uncheck": "Poista valinta",
  "dashboard.unsave": "Poista tallennetuista",
  "dashboard.viewAttributes": "Näytä attribuutit",
  "dashboard.viewJobs": "Näytä",
  "dashboard.viewMessageBody": "Näytä viestin sisältö",
  "dashboard.viewOnGoogleMaps": "Näytä Google Mapsissa",
  "dashboard.yellowNoJobs": "Keltainen (ei työpaikkoja)",
  "employerPortal.nav": "Työnantajaportaali",
  "employerScoreCard.dimension.benefits": "edut",
  "employerScoreCard.dimension.flexibility": "joustavuus",
  "employerScoreCard.dimension.growth": "kasvu",
  "employerScoreCard.dimension.pay": "palkkaus",
  "employerScoreCard.dimension.stability": "vakaus",
  "employerScoreCard.dimension.transparency": "läpinäkyvyys",
  "employerScoreCard.disclaimer": "Laskettu työpaikkadatasta, ei arvosteluista",
  "employerScoreCard.howWeCalculate": "Näin laskemme tämän",
  "employerScoreCard.methodology": "Arvosana perustuu ilmoitettujen palkkahaarukoiden kilpailukykyyn (kun ilmoituksia on riittävästi), etä- ja hybridityön joustoon, rekrytoinnin vakauteen ajan mittaan, roolijakaumasta ja rekrytointimäärien trendeistä johdettuihin kasvusignaaleihin, ilmoituksissa mainittuihin etuihin sekä avoimuuteen (kuinka usein ilmoituksissa kerrotaan todellinen, ei arvioitu palkka ja rekrytointiprosessin aikataulu).",
  "employerScoreCard.strongestAt": "Vahvin osa-alue: {dimension}",
  "employerScoreCard.subscore.benefits": "Edut",
  "employerScoreCard.subscore.flexibility": "Joustavuus",
  "employerScoreCard.subscore.growth": "Kasvu",
  "employerScoreCard.subscore.pay": "Palkkaus",
  "employerScoreCard.subscore.stability": "Vakaus",
  "employerScoreCard.subscore.transparency": "Läpinäkyvyys",
  "employerScoreCard.title": "JobCrawls-työnantajapisteet",
  "engagement.nav.signIn": "Kirjaudu sisään",
  "engagement.trustpilotPrompt.leaveReview": "Jätä arvostelu",
  "engagement.trustpilotPrompt.offer": "Käytät Omat työpaikat -osiota ahkerasti. Jättäisitkö meille nopean arvostelun?",
  "facets.benefits": "Etu",
  "facets.company": "Yritys",
  "facets.companyIndustry": "Toimiala",
  "facets.education": "Koulutus",
  "facets.field": "Ala",
  "facets.jobType": "Työsuhteen tyyppi",
  "facets.language": "Kieli",
  "facets.location": "Sijainti",
  "facets.management": "Johtajuus",
  "facets.remoteness": "Työskentelymalli",
  "facets.role": "Rooli",
  "facets.roleLevel": "Roolitaso",
  "facets.skills": "Taito",
  "feedback.button.label": "Anna palautetta",
  "feedback.cancel": "Peruuta",
  "feedback.error": "Palautteen lähettäminen epäonnistui. Yritä uudelleen.",
  "feedback.label": "Palautteesi",
  "feedback.modal.close": "Sulje",
  "feedback.modal.description": "Haluamme kuulla mielipiteesi. Palautteesi auttaa meitä parantamaan palvelua.",
  "feedback.modal.title": "Lähetä palautetta",
  "feedback.page.anonymous": "Anonyymi",
  "feedback.page.attachmentDownloadError": "Liitteen lataaminen epäonnistui. Yritä uudelleen.",
  "feedback.page.attachmentDownloadTitle": "Lataa liite",
  "feedback.page.cannedReply.gdpr": "Kiitos yhteydenotostasi. Olemme vastaanottaneet tietosuojapyyntösi ja käsittelemme sen 30 päivän kuluessa GDPR:n mukaisesti. Palaamme asiaan tässä viestiketjussa, kun käsittely on valmis.",
  "feedback.page.category.abuse": "Väärinkäyttö",
  "feedback.page.category.accessibility": "Saavutettavuus",
  "feedback.page.category.all": "Kaikki kategoriat",
  "feedback.page.category.ashton": "Ashton (henkilökohtainen)",
  "feedback.page.category.corrections": "Oikaisut",
  "feedback.page.category.developers": "Kehittäjät",
  "feedback.page.category.dmarcReport": "DMARC-raportti",
  "feedback.page.category.employers": "Työnantajat",
  "feedback.page.category.jobAlerts": "Työpaikkavahti",
  "feedback.page.category.john": "John (henkilökohtainen)",
  "feedback.page.category.maria": "Maria (henkilökohtainen)",
  "feedback.page.category.other": "Muu",
  "feedback.page.category.partners": "Kumppanit",
  "feedback.page.category.privacy": "Tietosuoja",
  "feedback.page.category.security": "Tietoturva",
  "feedback.page.category.support": "Tuki",
  "feedback.page.channel.all": "Kaikki",
  "feedback.page.channel.email": "Sähköposti",
  "feedback.page.channel.form": "Lomake",
  "feedback.page.delete": "Poista palaute",
  "feedback.page.deleteConfirm": "Oletko varma, että haluat poistaa tämän palautteen?",
  "feedback.page.deleteError": "Palautteen poistaminen epäonnistui. Yritä uudelleen.",
  "feedback.page.description": "Tarkastele ja hallitse käyttäjäpalautteita",
  "feedback.page.emailReporterTooltip": "Avaa sähköpostiohjelmasi valmiiksi täytetyllä vastauksella tälle ilmoittajalle",
  "feedback.page.followUpEmailGreeting": "Hei{name},",
  "feedback.page.followUpEmailSubject": "Liittyen ilmoitukseesi JobCrawlsissa",
  "feedback.page.followUpEmailThanksLine": "Kiitos, että ilmoitit tästä JobCrawlsille:",
  "feedback.page.followUpEmailWhatWeDidLine": "Tässä mitä teimme asialle:",
  "feedback.page.identifyReporter": "Tunnista ilmoittaja",
  "feedback.page.listTitle": "Kaikki palautteet",
  "feedback.page.noFeedback": "Ei vielä palautteita",
  "feedback.page.refresh": "Päivitä",
  "feedback.page.replyError": "Vastauksen lähettäminen epäonnistui. Yritä uudelleen.",
  "feedback.page.replyPlaceholder": "Kirjoita vastaus…",
  "feedback.page.sendReply": "Lähetä vastaus",
  "feedback.page.signOffNameLabel": "Allekirjoita vastaukset nimellä",
  "feedback.page.signOffNamePlaceholder": "Nimesi",
  "feedback.page.signOffTitlePlaceholder": "Nimike",
  "feedback.page.signingAs": "Allekirjoitus",
  "feedback.page.submitTitle": "Lähetä palautetta",
  "feedback.page.threadStatus.closed": "Suljettu",
  "feedback.page.threadStatus.open": "Avoin",
  "feedback.page.threadStatus.replied": "Vastattu",
  "feedback.page.title": "Palaute",
  "feedback.page.useGdprTemplate": "Käytä GDPR-vastauspohjaa",
  "feedback.page.viewMetadata": "Näytä metatiedot",
  "feedback.page.viewReportedCompany": "Näytä yritys",
  "feedback.page.viewReportedJob": "Näytä ilmoitettu työpaikka",
  "feedback.page.viewReportedPage": "Näytä ilmoitettu sivu",
  "feedback.placeholder": "Kerro, mitä meidän pitäisi muuttaa tai lisätä…",
  "feedback.postSubmit.signInBody": "Luo ilmainen tili, jotta voimme vastata, jos meillä on kysyttävää palautteestasi.",
  "feedback.postSubmit.signInButton": "Kirjaudu sisään tai luo tili",
  "feedback.postSubmit.signInTitle": "Haluatko, että otamme yhteyttä?",
  "feedback.submit": "Lähetä",
  "feedback.submitting": "Lähetetään…",
  "feedback.success": "Kiitos! Palautteesi on lähetetty.",
  "filters.allFilters.navigation": "Kaikki suodatinvaihtoehdot",
  "filters.top.ariaLabel": "Suodatinluokat",
  "filters.top.clearAll": "Tyhjennä kaikki suodattimet",
  "footer.aboutJobcrawls": "Tietoa JobCrawlsista",
  "footer.accessibilityStatementLink": "Saavutettavuusseloste",
  "footer.aiTranslationDisclaimer": "Huom. Osa tämän sivuston sisällöstä on tekoälyllä konekäännettyä ja voi sisältää virheitä.",
  "footer.allLocations": "Kaikki sijainnit",
  "footer.bestEmployers": "Työnantajat",
  "footer.brandDescription": "JobCrawls on suomalaisten työpaikkojen hakukone. Indeksoimme avoimet työpaikat päivittäin suoraan tuhansilta työnantajien urasivuilta englanniksi, suomeksi ja ruotsiksi, läpinäkyvin palkkatiedoin ja ilman maksettuja sijoituksia.",
  "footer.browseAllPages": "Selaa kaikkia sivuja",
  "footer.businessIdLabel": "Y-tunnus",
  "footer.colCompany": "Yritys",
  "footer.colEmployersAndDevelopers": "Työnantajat ja kehittäjät",
  "footer.colFindJobs": "Etsi työpaikkoja",
  "footer.colJobSeekers": "Työnhakijat",
  "footer.collectiveAgreementsLink": "Työehtosopimukset",
  "footer.connectorPrivacy": "Connectorin tietosuojakäytäntö",
  "footer.contact": "Ota yhteyttä",
  "footer.cookieSettings": "Evästeasetukset",
  "footer.editorialStandards": "Toimitukselliset periaatteet",
  "footer.featuresLink": "Ominaisuudet",
  "footer.forDevelopers": "Kehittäjille",
  "footer.forEmployersLink": "Työnantajille",
  "footer.freeCareersPageLink": "Ilmainen urasivu",
  "footer.guidesAndArticles": "Oppaat ja artikkelit",
  "footer.howCrawlerWorks": "Miten indeksointimme toimii",
  "footer.jobsInEspoo": "Työpaikat Espoossa",
  "footer.jobsInHelsinki": "Työpaikat Helsingissä",
  "footer.jobsInOulu": "Työpaikat Oulussa",
  "footer.jobsInTampere": "Työpaikat Tampereella",
  "footer.jobsInTurku": "Työpaikat Turussa",
  "footer.openJobsInFinland": "Avoimet työpaikat Suomessa",
  "footer.partnerships": "Mediayhteistyö",
  "footer.privacy": "Tietosuojaseloste",
  "footer.remoteJobs": "Etätyöt",
  "footer.rolesIndex": "Työpaikat ammateittain",
  "footer.salariesByRole": "Palkat ammateittain",
  "footer.signIn": "Kirjaudu sisään",
  "footer.sitemap": "Sivukartta",
  "footer.terms": "Käyttöehdot",
  "forEmployers.contact.desc": "Kerro, mikä kiinnostaa, ja hieman tiimistänne. Luemme jokaisen viestin itse, myyntijonoa ei ole.",
  "forEmployers.contact.error": "Jokin meni pieleen. Yritä uudelleen.",
  "forEmployers.contact.interest.branding": "Työnantajabrändäystuki",
  "forEmployers.contact.interest.careers": "Ilmainen urasivu",
  "forEmployers.contact.interest.other": "Jotain muuta",
  "forEmployers.contact.interest.promoted": "Nostetut työpaikat",
  "forEmployers.contact.interestLabel": "Mistä olette kiinnostuneita?",
  "forEmployers.contact.learnMore": "Lue lisää meistä",
  "forEmployers.contact.placeholder": "Kerro rekrytointitarpeistanne…",
  "forEmployers.contact.submit": "Lähetä viesti",
  "forEmployers.contact.submitting": "Lähetetään…",
  "forEmployers.contact.success": "Kiitos! Palaamme asiaan pian.",
  "forEmployers.contact.title": "Ilmaise kiinnostuksesi",
  "forEmployers.cta.expressInterest": "Ilmaise kiinnostuksesi",
  "forEmployers.cta.seeScore": "Katso, miten työnantajapisteet lasketaan",
  "forEmployers.hero.body": "Indeksoimme urasivunne suoraan, joten työnhakijat löytävät oikeat ilmoituksenne oikean palkkatiedon rinnalta. Ei ilmoitusten jättämistä, ei hallintapaneelia, ei maksua näkyvyydestä. Nyt avaamme kaksi uutta tapaa erottua: nostetut työpaikat ja henkilökohtaisen tuen työnantajabrändäykseen.",
  "forEmployers.hero.point.automatic": "Automaattinen näkyvyys ilman rekisteröitymistä",
  "forEmployers.hero.point.real": "Aitoa indeksointidataa, ei maksettua sijoittelua",
  "forEmployers.hero.point.score": "Läpinäkyvät, julkaistut työnantajapisteet",
  "forEmployers.hero.point.trilingual": "Näkyvyys kolmella kielellä: EN, FI, SV",
  "forEmployers.new.branding.cta": "Keskustele kanssamme brändäyksestä",
  "forEmployers.new.branding.desc": "Terävöitämme yhdessä tiiminne kanssa yritysprofiilinne sisältöä (kulttuuri, arvot ja roolien selkeys), jotta se vastaa sitä, mitä työnantajapisteenne jo kertovat teistä.",
  "forEmployers.new.branding.title": "Työnantajabrändäystuki",
  "forEmployers.new.careers.cta": "Hanki ilmainen urasivu",
  "forEmployers.new.careers.desc": "Ei urasivua? Julkaisemme yrityksellenne brändätyn urasivun ilmaiseksi: te liitätte työpaikkailmoitusten linkit, me hoidamme loput. Verkkosivunne \"Avoimet työpaikat\" -painikkeelle on vihdoin oikea osoite.",
  "forEmployers.new.careers.learnMore": "Lue lisää",
  "forEmployers.new.careers.pilotNote": "Avaamme tämän aluksi pienelle joukolle työnantajia.",
  "forEmployers.new.careers.title": "Ilmainen urasivu",
  "forEmployers.new.promoted.cta": "Ilmaise kiinnostuksesi nostettuihin työpaikkoihin",
  "forEmployers.new.promoted.desc": "Avoimet paikkanne etusijalle osuvissa hauissa ja kategoriasivuilla, sekä huomiomerkki siellä, missä hakijat jo katsovat.",
  "forEmployers.new.promoted.title": "Nostetut työpaikat",
  "forEmployers.new.subtitle": "Avaamme nämä ensin pienelle joukolle työnantajia.",
  "forEmployers.new.title": "Uutta: tapoja erottua",
  "forEmployers.score.cta": "Lue koko menetelmä",
  "forEmployers.score.ctaBestCompanies": "Katso Yritykset-listaus",
  "forEmployers.score.desc": "Yksi kirjainarvosana, kuusi osa-aluetta, kokonaan julkinen menetelmä. Hyvin pisteytetyt yritykset nousevat esiin Yritykset-listauksessamme ilman erillistä ilmoittautumista.",
  "forEmployers.score.pillar.benefits": "Edut ja henkilöstöedut",
  "forEmployers.score.pillar.flex": "Joustavuus",
  "forEmployers.score.pillar.growth": "Kasvusignaalit",
  "forEmployers.score.pillar.pay": "Palkkaus",
  "forEmployers.score.pillar.stability": "Rekrytoinnin vakaus",
  "forEmployers.score.pillar.transparency": "Läpinäkyvyys",
  "forEmployers.score.title": "Työnantajapisteet",
  "forEmployers.subtitle": "Avoimet työpaikkanne näkyvät täällä jo nyt: automaattisesti, englanniksi, suomeksi ja ruotsiksi.",
  "forEmployers.title": "Työnantajille",
  "forEmployers.today.step1.desc": "Indeksoimme hakukoneen tavoin ne työpaikkailmoitukset, jotka ovat jo omalla sivustollanne. Ilmoituksia ei tarvitse jättää eikä integraatiota rakentaa.",
  "forEmployers.today.step1.title": "Indeksoimme urasivunne",
  "forEmployers.today.step2.desc": "Haun, palkkavertailujen ja Yritykset-listauksemme kautta. Kaikki kolmella kielellä ja hakukoneoptimoituna.",
  "forEmployers.today.step2.title": "Työnhakijat löytävät teidät",
  "forEmployers.today.step3.desc": "Palkka-avoimuuden, joustavuuden, rekrytoinnin vakauden ja kasvusignaalien perusteella. Sama julkaistu menetelmä jokaiselle yritykselle.",
  "forEmployers.today.step3.title": "Saatte pisteet läpinäkyvästi",
  "forEmployers.today.title": "Näin näytte jo nyt",
  "forEmployers.values.desc": "Haluamme olla hakijoidenne ajan arvoisia. Siksi nostamme esiin työnantajia, jotka maksavat reilusti, viestivät selkeästi ja kohtelevat hakijoita hyvin. Kaiken uuden, kuten nostetut työpaikat tai työnantajabrändäystuen, rakennamme tämän vaatimuksen päälle, emme sen ohi.",
  "forEmployers.values.title": "Arvomme",
  "freeCareersPage.breadcrumb": "Ilmainen urasivu",
  "freeCareersPage.cta": "Hanki ilmainen urasivusi",
  "freeCareersPage.cta.hint": "Kerro yrityksesi nimi, niin hoidamme loput.",
  "freeCareersPage.cta.pilotNote": "Avaamme nämä aluksi pienelle joukolle työnantajia, joten luemme ja käsittelemme jokaisen pyynnön itse.",
  "freeCareersPage.features.apply": "Hakijat hakevat alkuperäisen LinkedIn-ilmoituksesi kautta, joten uutta postilaatikkoa ei tarvitse vahtia",
  "freeCareersPage.features.branded": "Oma ilmeesi: logo, värit ja oma esittelyteksti",
  "freeCareersPage.features.fresh": "Ilmoitukset vanhenevat automaattisesti, kun haku päättyy",
  "freeCareersPage.features.languages": "Kolme kieltä: englanti, suomi ja ruotsi",
  "freeCareersPage.features.search": "Työpaikkasi näkyvät myös JobCrawls-haussa ja tavoittavat hakijoita koko Suomessa",
  "freeCareersPage.features.title": "Mitä sisältyy",
  "freeCareersPage.features.zero": "Ei ylläpitoa: ei lisäosia, ei julkaisujärjestelmää, ei hosting-laskuja",
  "freeCareersPage.hero.subtitle": "Rekrytoitko LinkedInissä, mutta omilla sivuillasi ei ole paikkaa avoimille työpaikoille? Julkaisemme yrityksellesi brändätyn urasivun (logosi, värisi ja avoimet paikkasi) täysin ilmaiseksi, ilman asennuksia tai ylläpitoa.",
  "freeCareersPage.hero.title": "Ilmainen urasivu yrityksellesi",
  "freeCareersPage.how.step1.desc": "Yksi sähköposti riittää alkuun. Luomme brändätyn sivusi (logo, brändiväri ja muokattava esittelyteksti) englanniksi, suomeksi ja ruotsiksi.",
  "freeCareersPage.how.step1.title": "Me perustamme sivusi",
  "freeCareersPage.how.step2.desc": "Julkaise LinkedInissä kuten ennenkin ja liitä ilmoituksen linkki portaaliin. Me haemme tiedot, käännämme ne ja pidämme listauksen ajan tasalla. Ilmoitus poistuu automaattisesti, kun haku päättyy.",
  "freeCareersPage.how.step2.title": "Liitä ilmoitusten linkit",
  "freeCareersPage.how.step3.desc": "Vaihda verkkosivusi \"Avoimet työpaikat\" -painike osoittamaan uudelle urasivullesi. Tuo yksi linkki on ainoa asia, jonka pyydämme: sillä ilmainen sivu maksaa itsensä.",
  "freeCareersPage.how.step3.title": "Ohjaa verkkosivusi sinne",
  "freeCareersPage.how.title": "Näin se toimii",
  "freeCareersPage.portalLink": "Onko sivusi jo olemassa? Avaa työnantajaportaali",
  "freeCareersPage.whyFree.desc": "JobCrawls on suomalaisten työpaikkojen hakukone. Kun urasivusi on meillä, avoimet työpaikkasi tulevat osaksi hakemistoamme (muuten ne olisivat vain LinkedInissä), ja linkki verkkosivuiltasi kertoo hakukoneille ja meille, että sivu on aidosti sinun. Siinä koko vaihtokauppa: ei maksuja, ei sitoutumista, ja voit lähteä milloin haluat.",
  "freeCareersPage.whyFree.title": "Miksi se on ilmainen?",
  "hit.applicationDeadline": "Haku päättyy: {date}",
  "hit.companyInsights.cue": "Yritystiedot",
  "hit.companyLinkTitle": "Avaa yritysprofiili: tiedot ja analyysit yrityksestä {company}",
  "hit.companyProfile.aria": "Näytä yritysprofiili, rekrytointitiedot ja analyysit yrityksestä {company}",
  "hit.driversLicenseRequired": "Ajokortti vaaditaan",
  "hit.hidden": "Piilotettu",
  "hit.hide.button": "Piilota",
  "hit.hide.menu": "Piilota",
  "hit.jobTitle": "Työpaikka",
  "hit.jobTypeLinkAria": "Hae {jobType}-työpaikkoja",
  "hit.jobTypeLinkTitle": "Hae {jobType}-työpaikkoja",
  "hit.linkCopied": "Linkki kopioitu leikepöydälle!",
  "hit.locationLinkAria": "Hae työpaikkoja paikasta {location}",
  "hit.locationLinkTitle": "Hae työpaikkoja paikasta {location}",
  "hit.locationNotAvailable": "Sijaintitietoja ei ole saatavilla",
  "hit.markAsApplied.menu": "Merkitse haetuksi",
  "hit.markAsState": "Merkitse tilaksi {state}",
  "hit.moreLocations": "+{count} lisää",
  "hit.moreOptions": "Lisää vaihtoehtoja",
  "hit.openApplication": "Avoin hakemus",
  "hit.postedDate": "Julkaistu: {date}",
  "hit.postedDate.detail": "Julkaistu: {date}",
  "hit.remotenessLinkAria": "Hae {remoteness} työpaikkoja",
  "hit.remotenessLinkTitle": "Hae {remoteness} työpaikkoja",
  "hit.removeApplied": "Poista haetuista",
  "hit.roleLevelLinkAria": "Hae {roleLevel} työpaikkoja",
  "hit.roleLevelLinkLabel": "{roleLevel} työpaikat",
  "hit.roleLevelLinkTitle": "Hae {roleLevel} työpaikkoja",
  "hit.salaryNotSpecified": "Palkkaa ei ilmoitettu",
  "hit.salaryNotSpecified.card": "Palkkaa ei ilmoitettu",
  "hit.save": "Tallenna",
  "hit.save.detail": "Tallenna",
  "hit.saved": "Tallennettu",
  "hit.saved.detail": "Tallennettu",
  "hit.seeAd": "Tiedot",
  "hit.share": "Jaa",
  "hit.share.detail": "Jaa",
  "hit.shareError": "Jotain meni vikaan, kun työpaikkaa yritettiin jakaa.",
  "hit.shareError.retry": "Yritä uudelleen",
  "hit.summerJob": "Kesätyö",
  "hit.toast.applied": "Merkitty haetuksi",
  "hit.toast.hidden": "Työpaikka piilotettu",
  "hit.toast.hidden.undo": "Kumoa",
  "hit.toast.savedWithCount": "Tallennettu Omat työpaikat -osioon: {count, plural, one {# työpaikka} other {# työpaikkaa}}",
  "hit.toast.unapplied": "Poistettu haetuista",
  "hit.toast.unhidden": "Työpaikka palautettu näkyviin",
  "hit.toast.unsaved": "Työpaikka poistettu tallennetuista",
  "hit.toast.viewMyJobs": "Näytä →",
  "hit.toast.viewed": "Merkitty katsotuksi",
  "hit.tooltip.details": "Näytä työpaikan täydelliset tiedot ja kuvaus",
  "hit.tooltip.filterByCompany": "Suodata työpaikat tämän yrityksen mukaan",
  "hit.tooltip.filterByJobType": "Suodata tyypin mukaan: {jobType}",
  "hit.tooltip.filterByLanguages": "Suodata vaadittujen kielten mukaan: {languages}",
  "hit.tooltip.filterByLevel": "Suodata tason mukaan: {level}",
  "hit.tooltip.filterByLocation": "Suodata sijainnin mukaan: {locations}",
  "hit.tooltip.filterByRemoteness": "Suodata etätyömahdollisuuden mukaan: {remoteness}",
  "hit.tooltip.moreOptions": "Lisää vaihtoehtoja",
  "hit.tooltip.save": "Tallenna tämä työpaikka vertailua varten",
  "hit.tooltip.saved": "Poista tallennetuista työpaikoista",
  "hit.tooltip.share": "Jaa tämä työpaikka",
  "hit.unhide": "Näytä työpaikka uudelleen",
  "hitGroup.openRoles": "{count, plural, one {# avoin työpaikka} other {# avointa työpaikkaa}}",
  "hitGroup.viewCompanyProfile": "Näytä yrityksen profiili",
  "hitV2.estMonthly": "Arvioitu kuukausipalkka",
  "hitV2.monthly": "Kuukausipalkka",
  "hitV2.viewJob": "Katso työpaikka",
  "hub.bottomNav.alerts": "Hälytykset",
  "hub.bottomNav.ariaLabel": "Työkalujen navigointi",
  "hub.bottomNav.profile": "Profiili",
  "hub.guestSyncNote": "Tallennettu tälle laitteelle: {signIn}, niin tiedot säilyvät kaikilla laitteillasi",
  "hub.guestSyncNote.signIn": "kirjaudu sisään",
  "hub.nav.myJobs": "Omat työpaikat",
  "hub.nav.myJobs.count": "{savedCount} tallennettua · {activeCount} aktiivista",
  "hub.nav.profile": "Profiili ja CV",
  "hub.nav.searchesAlerts": "Haut ja hälytykset",
  "hub.nav.searchesAlerts.newCount": "{count} uutta",
  "hub.nav.watchlist": "Seurantalista",
  "hub.nav.watchlist.newsCount": "{count} uutta",
  "hub.title": "Omat työpaikat",
  "instantsearch.searchBoxLink.placeholder": "Hae työpaikkoja",
  "instantsearch.searchbox.placeholder": "Hae työpaikkoja, kieltä tai kaupunkia",
  "job.copyCompanyName": "Kopioi yrityksen nimi",
  "jobAlerts.confirm.confirm": "Vahvista",
  "jobAlerts.confirm.errorBody": "Jotain meni vikaan. Yritä uudelleen hetken kuluttua.",
  "jobAlerts.confirm.explanation": "Vahvista sähköpostiosoitteesi, niin alat saada JobCrawlsin työpaikkahälytyksiä.",
  "jobAlerts.confirm.heading": "Vahvista työpaikkahälytyksesi",
  "jobAlerts.confirm.invalidLink": "Tämä vahvistuslinkki on virheellinen tai vanhentunut. Ota hälytykset uudelleen käyttöön tallennetuista hauistasi, niin saat uuden linkin.",
  "jobAlerts.confirm.successBody": "Kaikki valmista. Lähetämme sähköpostia, kun uusia työpaikkoja osuu tallennettuihin hakuihisi.",
  "jobAlerts.confirm.successHeading": "Sähköpostiosoitteesi on vahvistettu",
  "jobAlerts.confirm.working": "Vahvistetaan…",
  "jobAlerts.newMatches.errorBody": "Uusia osumia ei voitu ladata. Yritä uudelleen hetken kuluttua.",
  "jobAlerts.newMatches.summaryHeading": "{count, plural, one {# uusi työpaikka} other {# uutta työpaikkaa}} viime käyntisi jälkeen",
  "jobAlerts.newMatches.summaryMore": "+{count} lisää alla olevissa hauissasi",
  "jobAlerts.newMatches.viewAllInSection": "Näytä kaikki {count} uutta osumaa",
  "jobAlerts.panel.activeStatus.v2": "Ota hälytykset käyttöön hakukohtaisesti alta, niin alat saada niitä.",
  "jobAlerts.panel.detailCopy.v2": "Oletuksena viikoittain maanantaiaamuisin, tai päivittäin jos haluat. Lähetetään osoitteeseen {email}. Voit lopettaa milloin tahansa täältä tai jokaisen sähköpostin linkin kautta.",
  "jobAlerts.panel.disable": "Kytke sähköpostihälytykset pois päältä",
  "jobAlerts.panel.enable": "Ota sähköpostihälytykset käyttöön",
  "jobAlerts.panel.error": "Tallennus epäonnistui. Yritä uudelleen.",
  "jobAlerts.panel.frequencyDaily": "Päivittäin",
  "jobAlerts.panel.frequencyDailyHint": "Joka päivä",
  "jobAlerts.panel.frequencyLegend": "Kuinka usein",
  "jobAlerts.panel.frequencyWeekly.v2": "Viikoittain",
  "jobAlerts.panel.frequencyWeeklyHint": "Maanantaiaamuisin",
  "jobAlerts.panel.heading": "Sähköpostihälytykset",
  "jobAlerts.panel.languageLegend": "Sähköpostin kieli",
  "jobAlerts.panel.leadCopy": "Saat sähköpostia heti, kun tallennettuihin hakuihisi löytyy uusi työpaikka.",
  "jobAlerts.panel.noEmail": "Tililläsi ei ole sähköpostiosoitetta, joten hälytykset eivät ole käytettävissä.",
  "jobAlerts.panel.pendingStatus.v2": "Tarkista postilaatikkosi ja vahvista sähköpostiosoitteesi aktivoidaksesi hälytykset.",
  "jobAlerts.panel.privacyLink": "Tietosuojaseloste",
  "jobAlerts.panel.sectionHeading": "Sähköpostikooste",
  "jobAlerts.panel.seeNewMatches": "Katso uudet osumat nyt",
  "jobAlerts.panel.statusOff": "Pois päältä",
  "jobAlerts.panel.statusOn": "Käytössä",
  "jobAlerts.panel.statusPending": "Vahvistetaan",
  "jobAlerts.panel.update": "Tallenna muutokset",
  "jobAlerts.signInPrompt": "Älä missaa yhtään uutta osumaa: {signIn}, niin näet päivitykset reaaliajassa ja voit ottaa sähköpostihälytykset käyttöön hauillesi.",
  "jobAlerts.toggle.failed": "Tallennus epäonnistui. Yritä uudelleen",
  "jobAlerts.toggle.label": "Lähetä uudet osumat sähköpostitse",
  "jobAlerts.toggle.label.activate": "Ota hälytys käyttöön",
  "jobAlerts.toggle.needsSubscription": "Ota ensin käyttöön sähköpostihälytykset ylhäältä",
  "jobAlerts.unsubscribe.confirm": "Peruuta tilaus",
  "jobAlerts.unsubscribe.errorBody": "Jotain meni vikaan. Yritä uudelleen hetken kuluttua.",
  "jobAlerts.unsubscribe.explanation": "Tämä pysäyttää kaikki JobCrawls-palvelun työpaikkahälytykset sähköpostiisi. Tallennetut haut pysyvät ennallaan.",
  "jobAlerts.unsubscribe.heading": "Peruuta työpaikkahälytysten tilaus",
  "jobAlerts.unsubscribe.invalidLink": "Tämä peruutuslinkki on virheellinen tai puutteellinen. Käytä viimeisimmän hälytysviestin linkkiä tai hallitse hälytyksiä tallennettujen hakujen kautta kirjautuneena.",
  "jobAlerts.unsubscribe.successBody": "Et saa enää työpaikkahälytyksiä sähköpostiisi. Voit ottaa hälytykset uudelleen käyttöön milloin tahansa tallennettujen hakujen kautta kirjautuneena.",
  "jobAlerts.unsubscribe.successHeading": "Tilaus peruutettu",
  "jobAlerts.unsubscribe.working": "Peruutetaan tilausta…",
  "jobAlerts.watchlistDigest.combined": "Yhdistettynä tähän sähköpostiin",
  "jobAlerts.watchlistDigest.error.v2": "Tallennus epäonnistui. Yritä uudelleen.",
  "jobAlerts.watchlistDigest.frequencyLegend": "Seurantalistan sähköpostin tiheys",
  "jobAlerts.watchlistDigest.legend": "Seurantalistan päivitykset",
  "jobAlerts.watchlistDigest.saving": "Tallennetaan…",
  "jobAlerts.watchlistDigest.separate": "Lähetä erillisenä sähköpostina",
  "jobChart.popover.categoriesShown": "Näytetyt kategoriat",
  "jobChart.popover.companyContext": "Perustuu {companyName}-yrityksen ilmoituksiin tiedoissamme.",
  "jobChart.popover.count": "Työpaikkailmoitukset",
  "jobChart.popover.monthKey": "Jakso",
  "jobChart.popover.share": "Osuus kaaviosta",
  "jobChart.popover.totalInRing": "Yhteensä tässä renkaassa",
  "jobChart.segmentHint": "Napauta tai vie hiiri segmentin päälle nähdäksesi lisätiedot.",
  "jobDetail.lastSeen.daysAgo": "{value, plural, one {Nähty {value} päivä sitten} other {Nähty {value} päivää sitten}}",
  "jobDetail.lastSeen.hoursAgo": "{value, plural, one {Nähty {value} tunti sitten} other {Nähty {value} tuntia sitten}}",
  "jobDetail.lastSeen.minutesAgo": "{value, plural, one {Nähty {value} minuutti sitten} other {Nähty {value} minuuttia sitten}}",
  "jobDetail.relatedPages.intro": "Tämän ilmoituksen ammatti, kaupunki, työnantaja ja palkkatiedot omilla sivuillaan.",
  "jobDetail.relatedPages.title": "Selaa lisää",
  "jobDetail.roleHub.jobsInCity": "{role} työpaikat {city}",
  "jobDetail.roleHub.moreJobs": "Lisää {role} työpaikkoja",
  "jobDetail.save.alsoFollowAction": "Seuraa",
  "jobDetail.save.alsoFollowToast": "Työpaikka tallennettu. Haluatko seurata yritystä {company} ja kuulla sen seuraavista työpaikoista?",
  "jobDetail.save.nowFollowingToast": "Seuraat nyt yritystä {company}. Uudet työpaikat näkyvät seurantalistallasi.",
  "jobDetail.similarJobs.algoliaListTitle": "Samankaltaisia työpaikkoja",
  "jobDetail.similarJobs.description": "Lisää työpaikkoja, jotka sopivat kiinnostuksiisi ja osaamiseesi",
  "jobDetail.similarJobs.seeAll": "Katso kaikki",
  "jobDetail.similarJobs.sourceNote": "JobCrawls-haun tuloksia: sama tehtävänimike ja ensisijainen sijainti kuin tässä ilmoituksessa (tämä työpaikka on rajattu pois). Enintään 8 tulosta.",
  "jobDetail.similarJobs.title": "Vastaavia työpaikkoja",
  "jobDetail.viewOnMapCommute": "Katso kartalla ja tarkista työmatkasi",
  "jobDetailAlertCta.bannerText": "Älä missaa yhtään uutta vastaavaa {role}-työpaikkaa",
  "jobDetailAlertCta.bannerTextWithLocation": "Älä missaa yhtään uutta {role}-työpaikkaa alueella {location}",
  "jobDetailAlertCta.ctaButton": "Tilaa sähköposti-ilmoitukset",
  "jobDetailAlertCta.dismissLabel": "Sulje",
  "jobDetailAlertCta.errorText": "Jokin meni pieleen. Ilmoituksia ei saatu käyttöön. Yritä uudelleen.",
  "jobDetailAlertCta.manageLink": "Hallitse ilmoituksia",
  "jobDetailAlertCta.pendingText": "Melkein valmista: tarkista postilaatikkosi ja vahvista sähköpostiosoitteesi, niin ilmoitukset ovat käytössä.",
  "jobDetailAlertCta.subText": "Ilmainen viikoittainen tai päivittäinen kooste. Voit peruuttaa milloin vain.",
  "jobDetailAlertCta.successText": "Kaikki valmista – lähetämme sinulle sähköpostia vastaavista työpaikoista.",
  "jobDetailPage.404.backHome": "Takaisin etusivulle",
  "jobDetailPage.404.description": "Pahoittelut, emme löytäneet tätä työpaikkaa. Se on saatettu poistaa tai linkki on virheellinen.",
  "jobDetailPage.404.heading": "Sivua ei löytynyt",
  "jobDetailPage.aboutCompany": "Tietoa yrityksestä",
  "jobDetailPage.applicationDeadline": "Haku päättyy",
  "jobDetailPage.applied": "Haettu ✓",
  "jobDetailPage.applyMoreOptions": "Lisää vaihtoehtoja hakemiseen",
  "jobDetailPage.applyNavigation": "Hae työpaikkaa",
  "jobDetailPage.applyNow": "Hae työpaikkaa",
  "jobDetailPage.autofillApplyCta": "Täytä tämä hakemus automaattisesti",
  "jobDetailPage.availableLanguages": "Saatavilla kielillä:",
  "jobDetailPage.benefits": "Edut",
  "jobDetailPage.benefitsAndPerks": "Edut ja henkilöstöedut",
  "jobDetailPage.businessId": "Y-tunnus",
  "jobDetailPage.byRemoteness": "Etätyöasteen mukaan",
  "jobDetailPage.chartsDataRange": "Näytetyt tiedot perustuvat tietokantamme historiallisiin työpaikkailmoituksiin.",
  "jobDetailPage.collapseCompensation": "Piilota palkkatiedot",
  "jobDetailPage.companiesHiringInLocation": "Yritykset, jotka rekrytoivat alueella {location}",
  "jobDetailPage.companyCollapsedBody": "Laajenna nähdäksesi trendikaaviot, sijaintijakauman, kielikysynnän ja karttatiedot.",
  "jobDetailPage.companyDistributionDescription": "Näytetään {count} yritystä, joilla on eniten työpaikkailmoituksia",
  "jobDetailPage.companyInfoFromTradeRegister": "Sisältää tietoja kaupparekisteristä.",
  "jobDetailPage.compensation": "Palkkaus",
  "jobDetailPage.contact": "Yhteystiedot:",
  "jobDetailPage.coverLetter.basedOn": "Perustuu: {entries}",
  "jobDetailPage.coverLetter.copied": "Kopioitu!",
  "jobDetailPage.coverLetter.copy": "Kopioi teksti",
  "jobDetailPage.coverLetter.download": "Lataa hakemuskirje",
  "jobDetailPage.coverLetter.editHint": "Muokkaa alla olevaa tekstiä ennen kopiointia tai lataamista. Se on vapaasti muokattavissasi.",
  "jobDetailPage.coverLetter.failed": "Hakemuskirjettä ei voitu luoda. Yritä myöhemmin uudelleen.",
  "jobDetailPage.coverLetter.generateCta": "Laadi hakemuskirjeeni",
  "jobDetailPage.coverLetter.intro": "Laadi hakemuskirje profiilisi ja tämän työpaikan pohjalta. Voit muokata sitä ennen lataamista.",
  "jobDetailPage.coverLetter.loading": "Laaditaan hakemuskirjettäsi…",
  "jobDetailPage.coverLetter.networkError": "Verkkovirhe. Tarkista yhteytesi.",
  "jobDetailPage.coverLetter.notConfigured": "Hakemuskirjeen laatiminen ei ole käytössä tässä ympäristössä.",
  "jobDetailPage.coverLetter.overclaimWarning": "Emme löytäneet profiilistasi taitoa \"{skill}\". Varmista, että tämä pitää paikkansa.",
  "jobDetailPage.coverLetter.quotaExceeded": "Tämän päivän hakemuskirjeraja on tullut täyteen. Se vapautuu huomenna.",
  "jobDetailPage.coverLetter.sourceCompany": "Yrityksen tiedot",
  "jobDetailPage.coverLetter.sourceSkills": "Osaaminen",
  "jobDetailPage.coverLetter.ungroundedFlag": "{count, plural, one {Yksi kohta} other {# kohtaa}} tästä kirjeestä ei perustunut mihinkään profiilisi tiettyyn tietoon. Tarkista, että {count, plural, one {se pitää} other {ne pitävät}} paikkansa.",
  "jobDetailPage.description": "Työpaikkakuvaus",
  "jobDetailPage.estimatedExpiry": "Arvioitu päättymispäivä",
  "jobDetailPage.estimatedNetSalary.explanation": "Arvioitu {year} nettopalkka Suomen tuloveron, eläkevakuutusmaksun ja työttömyysvakuutusmaksun jälkeen. Laskelmassa käytetään koko maan keskimääräistä kunnallisveroprosenttia ({rate} %), ei kirkollisveroa ja vain vakiovähennyksiä. Todellinen nettopalkkasi riippuu kunnastasi, kirkon jäsenyydestäsi, iästäsi ja perhetilanteestasi.",
  "jobDetailPage.expandCompanyData": "Laajenna yritystiedot nähdäksesi trendit, jakaumat ja kartan",
  "jobDetailPage.expandCompensation": "Laajenna palkkatiedot",
  "jobDetailPage.expired.backToSearch": "Takaisin hakutuloksiin",
  "jobDetailPage.expired.toastMessage": "Tämä ilmoitus voi olla vanhentunut tai poistunut.",
  "jobDetailPage.headcount": "Henkilöstömäärä",
  "jobDetailPage.hideCharts": "Piilota kaaviot",
  "jobDetailPage.hiringSnapshotSeo.activeListings": "Aktiiviset ilmoitukset",
  "jobDetailPage.hiringSnapshotSeo.caption": "Yrityksen {company} avoimet työpaikat JobCrawlsissa juuri nyt",
  "jobDetailPage.hiringSnapshotSeo.location": "Sijainti",
  "jobDetailPage.languageNavigation": "Saatavilla olevat kielet",
  "jobDetailPage.languageRequirements": "Kielivaatimukset",
  "jobDetailPage.lastSeenAgoCompact": "{days, plural, =0 {tänään} one {# pv sitten} other {# pv sitten}}",
  "jobDetailPage.lastSeenDetail": "Viimeksi nähty: {date}{ago}",
  "jobDetailPage.listingCompanyIndustryLabel": "Ilmoitus",
  "jobDetailPage.loadingMap": "Ladataan karttaa…",
  "jobDetailPage.location": "Sijainti",
  "jobDetailPage.locationAndRemotenessDistribution": "Sijainnin ja etätyön jakautuminen",
  "jobDetailPage.locationDistribution": "Sijaintien jakautuminen",
  "jobDetailPage.mapError": "Karttaa ei voitu ladata",
  "jobDetailPage.markAppliedAction": "Merkitse haetuksi",
  "jobDetailPage.markAppliedPrompt": "Avasimme hakemuksen uuteen välilehteen. Merkitäänkö tämä työpaikka haetuksi?",
  "jobDetailPage.matchBreakdown.collapse": "Piilota osumapisteiden erittely",
  "jobDetailPage.matchBreakdown.expand": "Näytä osumapisteiden erittely",
  "jobDetailPage.matchBreakdown.title": "Näin tämä työ sopii profiiliisi",
  "jobDetailPage.noItems": "Ei näytettäviä kohteita.",
  "jobDetailPage.noLocation": "Ei sijaintia",
  "jobDetailPage.noRemoteness": "Ei määritelty",
  "jobDetailPage.officialRegisterName": "Rekisteröity nimi",
  "jobDetailPage.originalLanguage": "Alkuperäinen",
  "jobDetailPage.period.day": "päivä",
  "jobDetailPage.period.hour": "tunti",
  "jobDetailPage.period.month": "kuukausi",
  "jobDetailPage.period.year": "vuosi",
  "jobDetailPage.perks": "Edut",
  "jobDetailPage.postedAgo": "{days, plural, =0 {Julkaistu tänään} one {Julkaistu 1 päivä sitten} other {Julkaistu # päivää sitten}}",
  "jobDetailPage.recruitmentProcess": "Rekrytointiprosessi",
  "jobDetailPage.remoteness": "Etätyömahdollisuus",
  "jobDetailPage.remotenessDistribution": "Etätyön jakautuminen",
  "jobDetailPage.remotenessDistribution.short": "Etätyö",
  "jobDetailPage.requiredLanguages": "Vaaditut kielet",
  "jobDetailPage.requirements": "Vaatimukset",
  "jobDetailPage.responsibilities": "Vastuualueet",
  "jobDetailPage.roleAndRoleLevelDistribution": "Roolien ja tasojen jakautuminen",
  "jobDetailPage.roleDistribution": "Roolien jakautuminen",
  "jobDetailPage.roleLevelDistribution": "Roolitasojen jakautuma",
  "jobDetailPage.roleLevelSnapshotSeo.activeListings": "Aktiiviset ilmoitukset",
  "jobDetailPage.roleLevelSnapshotSeo.caption": "Nykyinen roolitasojen jakauma yrityksessä {company} JobCrawls-palvelussa",
  "jobDetailPage.roleLevelSnapshotSeo.level": "Roolitaso",
  "jobDetailPage.roleSnapshotSeo.activeListings": "Aktiiviset ilmoitukset",
  "jobDetailPage.roleSnapshotSeo.caption": "Nykyinen roolien jakauma yrityksessä {company} JobCrawls-palvelussa",
  "jobDetailPage.roleSnapshotSeo.role": "Roolityyppi",
  "jobDetailPage.salaryProvenance.employerQuote": "Palkkahaitari on poimittu työpaikkailmoituksen tekstistä.",
  "jobDetailPage.salaryProvenance.extractedNoQuote": "Tämä on juuri tämän työpaikan palkkahaarukka, ei markkinoiden keskiarvo. Sitä ei kuitenkaan löytynyt ilmoituksesta sanatarkasti, joten pidä sitä vahvistamattomana.",
  "jobDetailPage.salarySourceBadge.estimated": "Arvioitu",
  "jobDetailPage.salarySourceBadge.fromListing": "Ilmoitettu",
  "jobDetailPage.salarySourceBadge.unverified": "Vahvistamaton",
  "jobDetailPage.salaryStatistics": "Palkkatilastot",
  "jobDetailPage.section.company": "Yritystiedot",
  "jobDetailPage.section.jobDetails": "Työn tiedot",
  "jobDetailPage.seeLocation": "Katso sijainti",
  "jobDetailPage.seeOriginal": "Katso alkuperäinen",
  "jobDetailPage.showCharts": "Näytä kaaviot",
  "jobDetailPage.showCompanyContact": "Näytä yrityksen yhteystiedot",
  "jobDetailPage.showContact": "Näytä yhteysosoite",
  "jobDetailPage.showConverted": "Näytä EUR/kk",
  "jobDetailPage.showingItemsAboveThreshold": "Näytetään vain kohteet, jotka ylittävät {percentage} %",
  "jobDetailPage.skillsAndTechnologies": "Taidot ja teknologiat",
  "jobDetailPage.specialisations": "Erikoistumisalueet",
  "jobDetailPage.tailorCv.disclaimer": "Vain nykyistä kokemustasi on muotoiltu ja järjestetty uudelleen niin, että tämän työpaikan kannalta olennainen korostuu. Mitään ei ole keksitty. Tarkista teksti alta ennen lataamista.",
  "jobDetailPage.tailorCv.download": "Lataa räätälöity CV",
  "jobDetailPage.tailorCv.emptyProfile": "Täytä ensin profiilisi: tarvitsemme työkokemuksesi tai osaamisesi CV:n räätälöimiseksi.",
  "jobDetailPage.tailorCv.failed": "CV:n räätälöinti epäonnistui. Yritä myöhemmin uudelleen.",
  "jobDetailPage.tailorCv.goToProfile": "Siirry profiiliisi",
  "jobDetailPage.tailorCv.loading": "Muotoillaan nykyistä kokemustasi tätä työpaikkaa varten…",
  "jobDetailPage.tailorCv.networkError": "Verkkovirhe. Tarkista yhteytesi.",
  "jobDetailPage.tailorCv.notConfigured": "CV:n räätälöinti ei ole käytössä tässä ympäristössä.",
  "jobDetailPage.tailorCv.quotaExceeded": "Tämän päivän CV:n räätälöintiraja on tullut täyteen. Se vapautuu huomenna.",
  "jobDetailPage.tailorCv.tabCoverLetter": "Hakemuskirje",
  "jobDetailPage.tailorCv.title": "Räätälöi CV:ni tätä työpaikkaa varten",
  "jobDetailPage.tailorCvCta": "Räätälöi CV:ni tätä työpaikkaa varten",
  "jobDetailPage.tradeRegisterWebsite": "Kaupparekisterin verkkosivusto",
  "jobDetailPage.tyomarkkinatori.about": "<strong>Työmarkkinatori</strong> on Suomen virallinen julkisten työvoimapalvelujen portaali, jota ylläpitää työ- ja elinkeinoministeriö (TEM). Sieltä löytyvät avoimet työpaikat koko Suomen julkiselta sektorilta ja kunnilta sekä työnantajilta, jotka käyttävät valtion rekrytointi-infrastruktuuria.",
  "jobDetailPage.tyomarkkinatori.dataSourceAttribution": "Lähde: <link>Työmarkkinatorin asiakastietojärjestelmä</link>",
  "jobDetailPage.tyomarkkinatori.whyWeIndex": "Otamme Työmarkkinatorin ilmoitukset mukaan, jotta JobCrawls kattaa Suomen työmarkkinat kokonaan, myös tehtävät, jotka julkaistaan vain valtion virallisissa kanavissa ja jäisivät muuten huomaamatta.",
  "jobDetailPage.vacationWeeks": "Loma: {weeks} viikkoa",
  "jobDetailPage.viewBenefits": "Näytä edut",
  "jobDetailPage.watchCompanyVideo": "Katso yritysvideo",
  "jobDetailPageV2.awardsAndCertifications": "Palkinnot ja sertifikaatit",
  "jobDetailPageV2.collectiveAgreement.browseAll": "Selaa kaikkia Suomen työehtosopimuksia",
  "jobDetailPageV2.collectiveAgreement.confidence": "{percent} % luotettavuus",
  "jobDetailPageV2.collectiveAgreement.explicit": "Työnantaja ilmoittaa, että tehtävässä noudatetaan työehtosopimusta {agreementName}.",
  "jobDetailPageV2.collectiveAgreement.inferred": "Paras arvaus: työehtosopimus {agreementName}, pääteltynä työnantajan toimialasta ja tehtävästä. Sopimus voi olla myös jokin muu.",
  "jobDetailPageV2.coreValues": "Arvot",
  "jobDetailPageV2.daysAgo": "{days, plural, one {# päivä sitten} other {# päivää sitten}}",
  "jobDetailPageV2.daysLeft": "{days, plural, one {# päivä jäljellä} other {# päivää jäljellä}}",
  "jobDetailPageV2.daysOpen.longer": "Ollut auki {days, plural, one {# päivän} other {# päivää}}, pidempään kuin tässä roolissa yleensä ({typical} päivää)",
  "jobDetailPageV2.daysOpen.usual": "Ollut auki {days, plural, one {# päivän} other {# päivää}}. Tämä rooli on yleensä haussa noin {typical} päivää",
  "jobDetailPageV2.deadline": "Haku päättyy {date}",
  "jobDetailPageV2.descriptionDisclaimer": "Yllä oleva teksti on työnantajan alkuperäinen työpaikkakuvaus sellaisenaan poimittuna. Muut sivun tiedot, kuten palkka, vastuut ja vaatimukset, ovat järjestelmämme tulkintoja samasta tekstistä, eivät työnantajan erikseen vahvistamia. Pidä niitä siis parhaana tulkintanamme, ei varmistettuina tosiasioina.",
  "jobDetailPageV2.employerOverview": "Työnantajasta",
  "jobDetailPageV2.employerScore.aria": "Employer Score {tier}. Katso koko yritysprofiili",
  "jobDetailPageV2.estTakeHome": "Arvioitu nettopalkka {amount}",
  "jobDetailPageV2.estTakeHome.infoLabel": "Mihin oletuksiin tämä arvio perustuu?",
  "jobDetailPageV2.estimatedExpiry": "Arvioitu päättymispäivä {date}",
  "jobDetailPageV2.experienceYears": "{years} {years, plural, one {vuoden} other {vuoden}} kokemus",
  "jobDetailPageV2.financialOverview": "Talouskatsaus",
  "jobDetailPageV2.fitLedger.action.addLanguage": "Puhutko {list}? Lisää se profiiliisi",
  "jobDetailPageV2.fitLedger.action.fillProfile": "Täytä profiilisi, niin saat oikean vertailun",
  "jobDetailPageV2.fitLedger.action.tailorCv": "Räätälöi CV:si tähän rooliin",
  "jobDetailPageV2.fitLedger.action.weights": "Muuta, mikä on sinulle tärkeintä",
  "jobDetailPageV2.fitLedger.basis.current": "Vertailtu nykyiseen rooliisi. Aseta toivetyöpaikka profiiliisi, jos haluat verrata siihen, mitä oikeasti haluat.",
  "jobDetailPageV2.fitLedger.basis.desired": "Vertailtu profiilissasi ilmoittamaasi toivetyöhön. Kohdissa, jotka jätit tyhjäksi, käytetään sen sijaan nykyistä rooliasi.",
  "jobDetailPageV2.fitLedger.cell.benefitsNow": "{count, plural, one {# etu nyt} other {# etua nyt}}",
  "jobDetailPageV2.fitLedger.cell.more": "+{count} lisää",
  "jobDetailPageV2.fitLedger.cell.notSet": "Ei asetettu",
  "jobDetailPageV2.fitLedger.cell.notStated": "Ei ilmoitettu",
  "jobDetailPageV2.fitLedger.cell.weeks": "{weeks, plural, one {# viikko} other {# viikkoa}} / vuosi",
  "jobDetailPageV2.fitLedger.column.thisJob": "Tämä työpaikka",
  "jobDetailPageV2.fitLedger.column.you": "Sinä",
  "jobDetailPageV2.fitLedger.column.yourSearches": "Hakusi",
  "jobDetailPageV2.fitLedger.delta.benefitsFewer": "Vähemmän kuin sinulla nyt on",
  "jobDetailPageV2.fitLedger.delta.benefitsGain": "{count, plural, one {Yksi, jota sinulla ei nyt ole} other {#, joita sinulla ei nyt ole}}",
  "jobDetailPageV2.fitLedger.delta.benefitsSame": "Ei mitään, mitä sinulla ei jo olisi",
  "jobDetailPageV2.fitLedger.delta.contractDifferent": "Ei se sopimustyyppi, jota haluat",
  "jobDetailPageV2.fitLedger.delta.contractSame": "Sopimustyyppi, jota haluat",
  "jobDetailPageV2.fitLedger.delta.languagesAll": "Osaat kaikki vaaditut kielet",
  "jobDetailPageV2.fitLedger.delta.languagesMissing": "Puuttuu: {list}",
  "jobDetailPageV2.fitLedger.delta.languagesNone": "Ei kielivaatimusta",
  "jobDetailPageV2.fitLedger.delta.levelDifferent": "Eri taso",
  "jobDetailPageV2.fitLedger.delta.levelDown": "{steps, plural, one {Yksi taso alempana} other {# tasoa alempana}}",
  "jobDetailPageV2.fitLedger.delta.levelSame": "Taso, jota haluat",
  "jobDetailPageV2.fitLedger.delta.levelUp": "{steps, plural, one {Yksi taso ylempänä} other {# tasoa ylempänä}}",
  "jobDetailPageV2.fitLedger.delta.locationIn": "Alueellasi",
  "jobDetailPageV2.fitLedger.delta.locationOut": "Alueidesi ulkopuolella",
  "jobDetailPageV2.fitLedger.delta.notStated": "Ei ilmoitettu työpaikkailmoituksessa",
  "jobDetailPageV2.fitLedger.delta.salaryMeets": "Vastaa {basis, select, desired {vähimmäistoivettasi} other {nykyistä palkkaasi}}",
  "jobDetailPageV2.fitLedger.delta.salaryOver": "{amount} enemmän kuin {basis, select, desired {vähimmäistoiveesi} other {nykyinen palkkasi}}",
  "jobDetailPageV2.fitLedger.delta.salaryRangeCovers": "Haarukan yläpää kattaa {basis, select, desired {vähimmäistoiveesi} other {nykyisen palkkasi}}",
  "jobDetailPageV2.fitLedger.delta.salaryUnder": "{amount} vähemmän kuin {basis, select, desired {vähimmäistoiveesi} other {nykyinen palkkasi}}",
  "jobDetailPageV2.fitLedger.delta.styleExact": "Työmuoto, jota haluat",
  "jobDetailPageV2.fitLedger.delta.styleHybrid": "Hybridi, riittävän lähellä",
  "jobDetailPageV2.fitLedger.delta.styleMismatch": "Ei se työmuoto, jota haluat",
  "jobDetailPageV2.fitLedger.delta.titleClose": "Lähellä tavoitenimikettäsi",
  "jobDetailPageV2.fitLedger.delta.titleDifferent": "Erityyppinen rooli",
  "jobDetailPageV2.fitLedger.delta.titleExact": "Nimike, jota tavoittelet",
  "jobDetailPageV2.fitLedger.delta.titleOverlap": "Sisältää sanoja tavoitenimikkeestäsi",
  "jobDetailPageV2.fitLedger.delta.vacationLess": "{weeks, plural, one {Yksi viikko vähemmän} other {# viikkoa vähemmän}} kuin nyt",
  "jobDetailPageV2.fitLedger.delta.vacationMore": "{weeks, plural, one {Yksi viikko enemmän} other {# viikkoa enemmän}} kuin nyt",
  "jobDetailPageV2.fitLedger.delta.vacationSame": "Sama kuin nyt",
  "jobDetailPageV2.fitLedger.kicker": "Sopivuutesi",
  "jobDetailPageV2.fitLedger.kicker.searches": "Arvioitu hakujesi perusteella",
  "jobDetailPageV2.fitLedger.noun.benefits": "edut",
  "jobDetailPageV2.fitLedger.noun.jobType": "sopimustyyppi",
  "jobDetailPageV2.fitLedger.noun.languages": "kielet",
  "jobDetailPageV2.fitLedger.noun.location": "sijainti",
  "jobDetailPageV2.fitLedger.noun.remoteness": "työmuoto",
  "jobDetailPageV2.fitLedger.noun.roleLevel": "kokemustaso",
  "jobDetailPageV2.fitLedger.noun.salary": "palkka",
  "jobDetailPageV2.fitLedger.noun.title": "rooli",
  "jobDetailPageV2.fitLedger.noun.vacation": "lomat",
  "jobDetailPageV2.fitLedger.perMonth": "{amount} / kk",
  "jobDetailPageV2.fitLedger.row.benefits": "Edut",
  "jobDetailPageV2.fitLedger.row.jobType": "Sopimus",
  "jobDetailPageV2.fitLedger.row.keywords": "Hakusanat",
  "jobDetailPageV2.fitLedger.row.languages": "Kielet",
  "jobDetailPageV2.fitLedger.row.location": "Sijainti",
  "jobDetailPageV2.fitLedger.row.remoteness": "Työmuoto",
  "jobDetailPageV2.fitLedger.row.roleLevel": "Taso",
  "jobDetailPageV2.fitLedger.row.salary": "Palkka",
  "jobDetailPageV2.fitLedger.row.searchCompany": "Työnantaja",
  "jobDetailPageV2.fitLedger.row.searchRoles": "Rooli ja ala",
  "jobDetailPageV2.fitLedger.row.title": "Rooli",
  "jobDetailPageV2.fitLedger.row.vacation": "Lomat",
  "jobDetailPageV2.fitLedger.verdict.A": "Erinomainen sopivuus",
  "jobDetailPageV2.fitLedger.verdict.B": "Hyvä sopivuus",
  "jobDetailPageV2.fitLedger.verdict.C": "Osittainen sopivuus",
  "jobDetailPageV2.fitLedger.verdict.D": "Heikko sopivuus",
  "jobDetailPageV2.fitLedger.verdict.F": "Ei sopivuutta paperilla",
  "jobDetailPageV2.fitLedger.verdict.allMiddle": "Kaikki tekijät ovat jossain keskivaiheilla.",
  "jobDetailPageV2.fitLedger.verdict.gaps": "{count, plural, one {Puute: {list}.} other {Puutteet: {list}.}}",
  "jobDetailPageV2.fitLedger.verdict.noGaps": "Mikään ei erotu puutteena.",
  "jobDetailPageV2.fitLedger.verdict.strengths": "{list} {count, plural, one {vastaa} other {vastaavat}} sitä, mitä haluat.",
  "jobDetailPageV2.hideOriginalDescription": "Piilota alkuperäinen kuvaus",
  "jobDetailPageV2.homeCommute.addHome": "Lisää kotiosoitteesi kerran, niin näet työmatka-aikasi jokaisessa työpaikassa.",
  "jobDetailPageV2.homeCommute.addressLabel": "Kotiosoitteesi",
  "jobDetailPageV2.homeCommute.calculating": "Lasketaan matka-aikoja…",
  "jobDetailPageV2.homeCommute.cancelChange": "Säilytä nykyinen",
  "jobDetailPageV2.homeCommute.change": "Muuta",
  "jobDetailPageV2.homeCommute.changeHome": "Hae uusi kotiosoite.",
  "jobDetailPageV2.homeCommute.chip": "{time} kotoa",
  "jobDetailPageV2.homeCommute.fromHome": "Osoitteesta {home}",
  "jobDetailPageV2.homeCommute.noTransit": "Julkisen liikenteen aikoja ei ole vielä saatavilla.",
  "jobDetailPageV2.homeCommute.privacyNote": "Tallennetaan profiiliisi ja käytetään vain matka-aikoihin. Ei koskaan jaeta työnantajille.",
  "jobDetailPageV2.homeCommute.unavailable": "Matka-aikoja ei ole saatavilla tälle osoitteelle.",
  "jobDetailPageV2.includesVariablePay": "+ muuttuva palkanosa",
  "jobDetailPageV2.jobDescription": "Työpaikkakuvaus",
  "jobDetailPageV2.lastSeen": "Viimeksi nähty {date}",
  "jobDetailPageV2.locationModal.close": "Sulje kartta",
  "jobDetailPageV2.locationModal.headingWithCount": "{count, plural, one {Työpaikan sijainti} other {Työpaikan sijainnit · {count} toimipistettä}}",
  "jobDetailPageV2.locationModal.title": "Työpaikan sijainti",
  "jobDetailPageV2.mapChip": "Kartta",
  "jobDetailPageV2.mapChip.locationCount": "{count} sijaintia",
  "jobDetailPageV2.matchBreakdown.overallLabel": "kokonaisosuma",
  "jobDetailPageV2.mostHiredRoles": "Eniten rekrytoidut roolit",
  "jobDetailPageV2.numberOfPositions": "{count} avointa paikkaa",
  "jobDetailPageV2.officePhotos": "Toimistokuvat",
  "jobDetailPageV2.openRoles": "{count} avointa tehtävää",
  "jobDetailPageV2.originalDescription": "Alkuperäinen työpaikkakuvaus",
  "jobDetailPageV2.originallyListedAs": "Alun perin ilmoitettu: {amount}",
  "jobDetailPageV2.otherLocations": "+{count} muuta sijaintia",
  "jobDetailPageV2.postedOn": "Julkaistu {date}",
  "jobDetailPageV2.profit": "Voitto",
  "jobDetailPageV2.profitMargin": "Voittomarginaali",
  "jobDetailPageV2.readFullDescription": "Lue koko kuvaus",
  "jobDetailPageV2.realSalaryNote": "(todellinen palkka, työnantajan ilmoittama)",
  "jobDetailPageV2.revenue": "Liikevaihto",
  "jobDetailPageV2.roleLevelMix": "Roolitasojen jakautuma",
  "jobDetailPageV2.salaryCompares": "Näin palkka vertautuu muihin",
  "jobDetailPageV2.salaryEstimateSampleSize": "{count, plural, one {Arvioitu # vertailukelpoisen ilmoituksen perusteella} other {Arvioitu # vertailukelpoisen ilmoituksen perusteella}}",
  "jobDetailPageV2.salaryGauge.benchmark.companyLocation": "tämä yritys alueella {location}",
  "jobDetailPageV2.salaryGauge.benchmark.companySalaryStats": "tämä yritys",
  "jobDetailPageV2.salaryGauge.benchmark.locationMarket": "kaikki roolit alueella {location}",
  "jobDetailPageV2.salaryGauge.benchmark.title": "{title}-roolit",
  "jobDetailPageV2.salaryGauge.benchmark.titleLocation": "{title} alueella {location}",
  "jobDetailPageV2.salaryGauge.benchmark.titleRoleLevel": "{roleLevel}-tason roolit",
  "jobDetailPageV2.salaryGauge.headline": "{percent} % {direction, select, above {korkeampi} other {alempi}} kuin {benchmark}",
  "jobDetailPageV2.salaryGauge.headlineLevel": "Samalla tasolla kuin {benchmark}",
  "jobDetailPageV2.salaryGauge.headlineNoJobSalary": "Vertailukohta: {benchmark}",
  "jobDetailPageV2.salaryGauge.median": "mediaani",
  "jobDetailPageV2.salaryGauge.thisOffer": "Tämä tarjous",
  "jobDetailPageV2.taxIcebergLink": "Katso koko verojaottelu →",
  "jobDetailPageV2.tldr": "Lyhyesti",
  "jobDetailPageV2.topLocations": "Suosituimmat sijainnit:",
  "jobDetailPageV2.vacationWeeks": "{count, plural, one {# viikon loma} other {# viikon loma}}",
  "jobDetailPageV2.viewCompany": "Näytä yritysprofiili",
  "jobDetailPageV2.watchCompanyVideo": "Katso yritysvideo",
  "layoutErrorFallback.body": "Lataa sivu uudelleen. Jos ongelma jatkuu, olemme jo saaneet siitä tiedon.",
  "layoutErrorFallback.home": "Siirry etusivulle",
  "layoutErrorFallback.reload": "Lataa sivu uudelleen",
  "layoutErrorFallback.title": "Jotain meni vikaan",
  "locationHub.activeJobs": "Työpaikat",
  "locationHub.avgSalary": "Palkka",
  "locationHub.cityCard.languageDonut.englishPercent": "{percent} % EN",
  "locationHub.cityCard.qa.languageAnswer": "{percent} % työpaikoista vaatii englannin kielen taitoa.",
  "locationHub.cityCard.qa.languageQuestion": "Mitä kieliä kaupungissa {city} vaaditaan?",
  "locationHub.cityCard.qa.remoteAnswerFallback": "Etätyömahdollisuuksia on tarjolla.",
  "locationHub.cityCard.qa.remoteAnswerWithPercent": "Kyllä, {percent} % rooleista on etä- tai hybridityötä.",
  "locationHub.cityCard.qa.remoteQuestion": "Onko {city} etätyöystävällinen?",
  "locationHub.cityCard.qa.salaryAnswerFallback": "Palkkatietoja saatavilla.",
  "locationHub.cityCard.qa.salaryAnswerWithValue": "Keskipalkka on {salary}.",
  "locationHub.cityCard.qa.salaryQuestion": "Mikä on keskipalkka kaupungissa {city}?",
  "locationHub.cityCard.workModel.flexiblePercent": "{percent} % joustava",
  "locationHub.cityCard.workModel.hybridTooltip": "{percent} % hybridi",
  "locationHub.cityCard.workModel.onsiteTooltip": "{percent} % paikan päällä",
  "locationHub.cityCard.workModel.remoteTooltip": "{percent} % etätyötä",
  "locationHub.hero.description": "Tutustu Suomen suurimpiin kaupunkeihin: työpaikkamäärät, palkkatiedot ja säännöllisesti päivittyvä markkinadata. Löydä seuraava työpaikkasi Suomen työmarkkinoilta.",
  "locationHub.hero.subtitle": "Kaupunkioppaat ja työpaikkahaut ympäri Suomea",
  "locationHub.hero.title": "Suomen työmarkkinat",
  "locationHub.hero.title.breadcrumb": "Selaa työpaikkoja sijainnin mukaan",
  "locationHub.languages": "Kielet",
  "locationHub.metropolitan.seo": "Pääkaupunkiseutu, Espoo ja Vantaa mukaan lukien, on Suomen talouden veturi: siellä on tihein tarjonta englanninkielisiä ja etätyöpaikkoja sekä erinomaiset joukkoliikenneyhteydet (HSL).",
  "locationHub.overview.description": "Tutustu Suomen johtaviin teknologia- ja innovaatiokeskuksiin: reaaliaikaista työmarkkinadataa, palkkatietoja ja toimialatrendejä.",
  "locationHub.overview.title": "Tärkeimmät teknologiakeskittymät",
  "locationHub.popularRoles.heading": "Suositut ammatit",
  "locationHub.quickJump.overview": "Yleiskatsaus",
  "locationHub.resourcesLink": "Tutustu työmarkkinoiden näkymiin ja uravinkkeihin",
  "locationHub.structuredData.collectionPage.description": "Löydä työmahdollisuuksia Suomen suurimmista kaupungeista palkkatietojen ja markkinadatan avulla",
  "locationHub.structuredData.collectionPage.name": "Suomen paikkakunnat",
  "locationHub.structuredData.itemList.description": "Tutustu työmahdollisuuksiin Suomen suurimmissa kaupungeissa",
  "locationHub.structuredData.itemList.name": "Työpaikat Suomessa",
  "locationHub.table.activeJobs": "Aktiiviset työpaikat",
  "locationHub.table.avgSalary": "Keskipalkka",
  "locationHub.table.city": "Kaupunki",
  "locationHub.table.notAvailable": "Ei saatavilla",
  "locationHub.table.specialty": "Erikoisala",
  "locationHub.workModel": "Työmalli",
  "map.cappedResultsNotice": "Näytetään {shown} / {total}. Rajaa tuloksia lähentämällä karttaa.",
  "map.commute.addSecond": "Lisää toinen lähtöpiste",
  "map.commute.addressAriaLabel": "Hae lähtöpisteen osoitetta",
  "map.commute.addressPlaceholder": "Tai kirjoita osoite…",
  "map.commute.button": "Työmatkahaku",
  "map.commute.clear": "Poista työmatkasuodatin",
  "map.commute.customMinutesAriaLabel": "Mukautettu työmatka-aika minuutteina",
  "map.commute.customMinutesLabel": "Mukautettu",
  "map.commute.error": "Työmatka-aluetta ei voitu ladata. Yritä uudelleen.",
  "map.commute.loading": "Haetaan työmatka-aluetta…",
  "map.commute.panelHeading": "Työmatka-aika",
  "map.commute.profile.cycling": "Pyörällä",
  "map.commute.profile.driving": "Autolla",
  "map.commute.profile.transit": "Julkisilla",
  "map.commute.profile.walking": "Kävellen",
  "map.commute.prompt": "Napauta karttaa asettaaksesi lähtöpisteen",
  "map.commute.promptSecond": "Napauta karttaa asettaaksesi toisen lähtöpisteen",
  "map.commute.removeSecond": "Poista toinen lähtöpiste",
  "map.commute.transitApproxNote": "Joukkoliikennealue on likimääräinen",
  "map.companies.count": "{count, plural, one {# yritys} other {# yritystä}}",
  "map.companies.none": "Ei yrityksiä tällä alueella",
  "map.companies.openRoles": "{count, plural, one {# avoin työpaikka} other {# avointa työpaikkaa}}",
  "map.companiesInView": "Yritykset näkymässä",
  "map.companyLogoAlt": "Yrityksen logo",
  "map.densityBubble.perCapitaSuffix": "/1 000",
  "map.densityZoomPrompt": "Lähennä nähdäksesi yksittäiset työpaikat ja yritysten logot",
  "map.densityZoomPrompt.button": "Lähennä",
  "map.draw.button": "Piirrä alue",
  "map.draw.cancel": "Peruuta",
  "map.draw.clear": "Poista piirretty alue",
  "map.draw.finish": "Valmis ({count})",
  "map.draw.prompt": "Napauta karttaa rajataksesi alueen",
  "map.jobs": "työpaikkaa",
  "map.jobsInView": "Näkymän työpaikat",
  "map.loading": "Ladataan karttaa…",
  "map.newThisWeekToggle": "Uudet tällä viikolla",
  "map.noJobs": "Tällä alueella ei ole työpaikkoja",
  "map.noJobsInView": "Tällä alueella ei ole työpaikkoja",
  "map.noLocationsForPins": "Tässä näkymässä ei ole sijaintikoordinaatteja karttamerkkejä varten.",
  "map.panel.companiesTab": "Yritykset",
  "map.panel.jobsTab": "Työpaikat",
  "map.perCapitaToggle": "1 000 asukasta kohden",
  "map.popup.close": "Sulje",
  "map.popup.companyFallback": "Yritys",
  "map.popup.jobFallback": "Työpaikka",
  "map.popup.more": "+{count} lisää",
  "map.popup.titleMultiLocation": "{count, plural, one {# työpaikka} other {# työpaikkaa}} · {locationCount, plural, one {# sijainti} other {# sijaintia}}",
  "map.popup.titleSingleLocation": "{count, plural, one {# työpaikka} other {# työpaikkaa}} – {location}",
  "map.pulse.button": "Rekrytointipulssi",
  "map.pulse.error": "Rekrytointihistoriaa ei voitu ladata",
  "map.pulse.loading": "Ladataan rekrytointihistoriaa…",
  "map.pulse.pause": "Tauko",
  "map.pulse.play": "Toista",
  "map.pulse.scrubber": "Viikko",
  "map.pulse.weekOf": "Viikko alkaen {date}",
  "map.remoteCard.label": "{count, plural, one {# etätyöpaikka} other {# etätyöpaikkaa}}",
  "map.remoteCard.more": "+{count} lisää",
  "map.resetView": "Palauta kartta näyttämään koko Suomi",
  "map.tokenMissing": "Karttanäkymä vaatii Mapbox-pääsytokenin",
  "map.tools.hideLabels": "Piilota selitteet",
  "map.tools.showLabels": "Näytä selitteet",
  "map.unknownLocation": "Tuntematon sijainti",
  "map.workInEnglishToggle": "Työpaikat englanniksi",
  "marketHeader.language.english": "Englanti",
  "marketHeader.language.finlandComparison": "Suomi: {finlandEnglish}% englanti",
  "marketHeader.language.label": "Kielikysyntä",
  "marketHeader.language.mixed": "Sekoitettu",
  "marketHeader.languageSeo.caption": "Kielikysyntä alueella {location}",
  "marketHeader.languageSeo.english": "Englanti",
  "marketHeader.languageSeo.language": "Kielikategoria",
  "marketHeader.languageSeo.localLanguages": "Kotimaiset kielet",
  "marketHeader.languageSeo.share": "Ilmoitusten osuus",
  "marketHeader.nearbyMarkets": "Lähialueet",
  "marketHeader.qa.languageAnswer": "{percent} % työpaikoista vaatii englannin kielen taitoa.",
  "marketHeader.qa.languageAnswerFallback": "Kielivaatimukset vaihtelevat roolin mukaan.",
  "marketHeader.qa.languageQuestion": "Mitä kieliä alueella {location} vaaditaan?",
  "marketHeader.qa.remoteAnswer": "Kyllä, {answer}",
  "marketHeader.qa.remoteAnswerFallback": "Etätyömahdollisuuksia on tarjolla.",
  "marketHeader.qa.remoteAnswerWithPercent": "{percent} % rooleista on etä- tai hybridityötä.",
  "marketHeader.qa.remoteQuestion": "Onko {location} etätyöystävällinen?",
  "marketHeader.qa.salaryAnswerFallback": "Palkkatietoja saatavilla.",
  "marketHeader.qa.salaryAnswerWithValue": "Keskipalkka on {salary}.",
  "marketHeader.qa.salaryQuestion": "Mikä on keskipalkka alueella {location}?",
  "marketHeader.rail.samplesUpdatedDaily": "{count} avointa työpaikkaa · päivitetään päivittäin",
  "marketHeader.removeLocation": "Poista sijainti",
  "marketHeader.salary.finlandComparison": "Suomen keskiarvo: {finlandAvg}",
  "marketHeader.salary.label": "Palkkatrendit",
  "marketHeader.salary.range": "Palkkahaitari",
  "marketHeader.salary.rangePercentile": "25.–75. persentiilin vaihteluväli",
  "marketHeader.salaryPercentileSeo.caption": "Ilmoitettujen palkkojen jakauma alueella {location}, Suomi (kokoaikaiset tehtävät)",
  "marketHeader.salaryPercentileSeo.p25": "25. persentiili",
  "marketHeader.salaryPercentileSeo.p50": "Mediaani (50. persentiili)",
  "marketHeader.salaryPercentileSeo.p75": "75. persentiili",
  "marketHeader.salaryPercentileSeo.percentile": "Prosentiili",
  "marketHeader.salaryPercentileSeo.salary": "Kuukausipalkka (EUR)",
  "marketHeader.salaryPercentileSeo.sampleSize": "Perustuu {count} työpaikkailmoitukseen, joissa palkka on ilmoitettu (alue: {location}, Suomi).",
  "marketHeader.toggle": "Vaihda markkinanäkymän tila",
  "marketHeader.updated": "Päivitetty:",
  "marketHeader.workModel.finlandComparison": "Suomi: {finlandRemote}% etätyö/hybridi",
  "marketHeader.workModel.label": "Työmalli",
  "marketHeader.workModel.noData": "Joustava",
  "marketHeader.workModelSeo.caption": "Työmallien jakautuminen alueella {location}",
  "marketHeader.workModelSeo.hybrid": "Hybridi",
  "marketHeader.workModelSeo.model": "Työmalli",
  "marketHeader.workModelSeo.onsite": "Paikan päällä",
  "marketHeader.workModelSeo.remote": "Etätyö",
  "marketHeader.workModelSeo.share": "Ilmoitusten osuus",
  "marketingConsent.checkbox.description": "Valinnainen. Voit peruuttaa milloin vain.",
  "marketingConsent.checkbox.label": "Työmarkkinasähköposteja ja vinkkejä",
  "matchDonut.ariaLabel": "Osumapisteet: {score}%",
  "matchDonut.breakdown.benefits": "Edut",
  "matchDonut.breakdown.languages": "Kielet",
  "matchDonut.breakdown.remoteness": "Etätyömahdollisuus",
  "matchDonut.breakdown.salary": "Palkka",
  "matchDonut.breakdown.title": "Osumapisteiden erittely",
  "matchDonut.breakdown.vacation": "Lomat",
  "matchDonut.loginPrompt.createAccount": "Luo tili",
  "matchDonut.loginPrompt.description": "Luo profiili ja lisää nykyisen työsi tiedot, niin näet, kuinka hyvin työpaikat vastaavat toiveitasi",
  "matchDonut.loginPrompt.title": "Kirjaudu sisään, niin näet osumapisteesi",
  "matchDonut.loginPromptAria": "Kirjaudu sisään, niin näet osumapisteesi",
  "matchDonut.profilePrompt.description": "Lisää nykyisen työsi tiedot ja toiveesi profiiliisi, niin näet, kuinka hyvin työpaikat vastaavat niitä.",
  "matchDonut.profilePrompt.goToProfile": "Siirry profiiliin",
  "matchDonut.profilePrompt.title": "Täydennä profiilisi, niin näet osumapisteesi",
  "matchDonut.profilePromptAria": "Täydennä profiilisi, niin näet osumapisteesi",
  "matchDonut.searchBreakdown.employer": "Työnantaja ja toimiala",
  "matchDonut.searchBreakdown.keywords": "Hakusanat",
  "matchDonut.searchBreakdown.location": "Sijainti",
  "matchDonut.searchBreakdown.remoteness": "Etätyömahdollisuus",
  "matchDonut.searchBreakdown.roleFit": "Rooli ja ala",
  "matchDonut.searchInference.bullet.company": "Olet osoittanut kiinnostusta esimerkiksi yritystä {company} kohtaan. Otamme sen huomioon pisteytyksessä.",
  "matchDonut.searchInference.bullet.keywords": "Hauissasi on esiintynyt sanoja, kuten \"{terms}\". Vertasimme niitä tämän työpaikan nimikkeeseen ja rooliin.",
  "matchDonut.searchInference.bullet.locations": "Olet hakenut työpaikkoja alueilta, kuten {locations}. Tämän ilmoituksen sijaintia verrataan siihen.",
  "matchDonut.searchInference.bullet.remoteness": "Käytät usein etätyösuodattimia ({values}). Tämä työpaikka pisteytetään niiden perusteella.",
  "matchDonut.searchInference.bullet.roles": "Hauissasi on roolisuodattimia, kuten {hints}. Vertaamme vastaavia signaaleja tähän työpaikkaan.",
  "matchDonut.searchInference.intro": "Meillä ei ole vielä profiiliasi, joten tämä pistemäärä arvioi sopivuutta JobCrawlsissa tekemiesi hakujen suodattimien ja hakusanojen perusteella (tuoreet haut painavat enemmän).",
  "matchDonut.searchInference.title": "Osuma viimeisimpien hakujesi perusteella",
  "modal.close": "Sulje",
  "nav.index.employersHiring": "työnantajaa rekrytoi",
  "nav.index.newToday": "uutta tänään",
  "nav.index.openJobs": "avointa työpaikkaa",
  "nav.index.remote": "etätyötä",
  "nav.index.updatedAgo": "Päivitetty {minutes} min sitten",
  "nav.search.placeholder": "Hae työpaikkoja, taitoja tai kaupunkia",
  "nav.search.shortcutAria": "Pikanäppäin: / kohdistaa hakukenttään",
  "nav.sheet.alerts": "Uudet osumat sähköpostiin",
  "nav.sheet.alertsNote": "<em>{n}</em> uutta tänään, vain sinulle sopivat",
  "nav.sheet.alertsNoteLoading": "uutta tänään, vain sinulle sopivat",
  "nav.sheet.device": "Vain tällä laitteella. Kirjaudu, niin ne säilyvät kaikkialla ja saat hälytykset.",
  "nav.sheet.email": "tai käytä sähköpostia",
  "nav.sheet.fine": "Ilmainen. Ei koskaan mainoksia.",
  "nav.sheet.free": "Ilmainen tili",
  "nav.sheet.google": "Jatka Googlella",
  "nav.sheet.keep": "Säilytä se, mitä sinulla jo on",
  "nav.sheet.keepGoogle": "Pidä nämä, jatka Googlella",
  "nav.sheet.kit": "Räätälöity CV ja hakemuskirje",
  "nav.sheet.kitNote": "yhdellä klikkauksella per työpaikka",
  "nav.sheet.searches": "{n} viimeisintä hakua",
  "nav.sheet.track": "Seuraa jokaista hakemusta",
  "nav.sheet.trackNote": "tallennetut, haetut, haastattelut: yksi taulu",
  "nav.sheet.viewed": "Viimeksi katsottu",
  "nav.sheet.viewedCount": "{n, plural, one {# katsottu työpaikka} other {# katsottua työpaikkaa}}",
  "nav.tape.and": "ja",
  "nav.tape.clearAll": "Tyhjennä kaikki",
  "nav.tape.not": "ei",
  "nav.tape.only": "vain",
  "nav.tape.or": "tai",
  "nav.tape.results": "{count} tulosta",
  "nav.tape.sortNewest": "uusimmat ensin",
  "nav.tape.sortSalary": "paras palkka ensin",
  "nav.view.list": "Lista",
  "nav.view.map": "Kartta",
  "navigation.home.breadcrumb": "Etusivu",
  "navigation.language": "Kieli",
  "navigation.language.label": "Kieli",
  "navigation.menu": "Valikko",
  "navigation.menu.adminTools": "Ylläpidon työkalut",
  "navigation.menu.continue": "Jatka siitä, mihin jäit",
  "navigation.menu.explore": "Selaa",
  "navigation.menu.forYou": "Sinulle",
  "navigation.menu.heading": "Valikko",
  "navigation.menu.more": "Lisää",
  "navigation.menu.note.apiKeys": "avaimet tekoälyagentillesi",
  "navigation.menu.note.employerPortal": "omat työpaikkailmoituksesi",
  "navigation.menu.note.employers": "ketkä rekrytoivat nyt",
  "navigation.menu.note.feedback": "kerro, mitä puuttuu",
  "navigation.menu.note.followed": "{count} seurattua",
  "navigation.menu.note.install": "lisää aloitusnäytölle",
  "navigation.menu.note.jobs": "kaikki avoimet työpaikat",
  "navigation.menu.note.locations": "työpaikat kaupungeittain",
  "navigation.menu.note.myJobsEmpty": "ei vielä tallennuksia",
  "navigation.menu.note.profileEmpty": "kokoa CV:si",
  "navigation.menu.note.profilePct": "{pct} % valmis",
  "navigation.menu.note.remote": "työskentele mistä vain",
  "navigation.menu.note.reset": "takaisin kaikkiin työpaikkoihin",
  "navigation.menu.note.resources": "oppaat ja artikkelit",
  "navigation.menu.note.roles": "työpaikat ammateittain",
  "navigation.menu.note.salaries": "palkat ammateittain",
  "navigation.menu.note.searches": "tallennetut haut",
  "navigation.menu.note.watchlistEmpty": "seuraa työnantajia",
  "navigation.menu.open": "Avaa valikko",
  "navigation.menu.searchPrompt": "Hae {count} avoimesta työpaikasta",
  "navigation.menu.searchSubmit": "Hae",
  "navigation.menu.signInHint": "Pidä tallennetut työpaikat ja hälytykset ajan tasalla kaikilla laitteillasi.",
  "navigation.menu.translatorTools": "Kääntäjän työkalut",
  "navigation.menu.unit.hiring": "rekrytoi",
  "navigation.menu.unit.open": "avointa",
  "navigation.menu.unit.remote": "etätyötä",
  "navigation.mobileBottomBar.ariaLabel": "Mobiilinavigointi",
  "navigation.search.reset": "Nollaa haku",
  "notes.field.add": "Lisää muistiinpano",
  "notes.field.placeholder": "Lisää yksityinen muistiinpano…",
  "numberSelector.any": "Kaikki",
  "numberSelector.decrease": "Vähennä",
  "numberSelector.increase": "Lisää",
  "pagination.ariaLabel": "Työpaikkahakutulosten sivunavigointi",
  "pagination.first": "Ensimmäinen",
  "pagination.keyboardShortcuts": "Näppäimistön pikanäppäimet",
  "pagination.last": "Viimeinen",
  "pagination.next": "Seuraava",
  "pagination.previous": "Edellinen",
  "postSignup.alertNudge.enabled": "Valmista. Lähetämme sinulle sähköpostia uusista hakujasi vastaavista työpaikoista.",
  "postSignup.alertNudge.failed": "Työpaikkavahdin käyttöönotto epäonnistui. Voit ottaa sen käyttöön milloin tahansa Hälytykset-sivulta.",
  "postSignup.alertNudge.offer": "Tervetuloa JobCrawlsiin! Haluatko sähköpostin, kun tarjolle tulee uusia sinua kiinnostavia työpaikkoja?",
  "postSignup.alertNudge.pendingConfirmation": "Melkein valmista: vahvista sähköpostiosoitteesi postilaatikostasi, niin ilmoitukset ovat käytössä.",
  "postSignup.alertNudge.turnOn": "Ota käyttöön",
  "profile.account.delete.button": "Poista tili",
  "profile.account.delete.cancel": "Peruuta",
  "profile.account.delete.close": "Sulje",
  "profile.account.delete.confirm": "Poista tili",
  "profile.account.delete.confirmBody": "Tämä poistaa tilisi, tallennetut työpaikat, haut, hakemuspaketit ja CV:si pysyvästi. Tätä ei voi perua.",
  "profile.account.delete.confirmTitle": "Poistetaanko tilisi?",
  "profile.account.delete.done": "Tilisi on poistettu. Kirjaudutaan ulos…",
  "profile.account.delete.error": "Jokin meni pieleen. Yritä uudelleen.",
  "profile.account.delete.working": "Poistetaan…",
  "profile.account.title": "Tili",
  "profile.aiApply": "Käytä",
  "profile.aiLoading": "Ajatellaan…",
  "profile.aiSuggest": "Ehdotukset tekoälyllä",
  "profile.aiSuggestionsDisclaimer": "Nämä ovat tekoälyn luonnostelemia lähtökohtia, jotka perustuvat vain työnimikkeisiisi ja tutkintoihisi. Ne eivät ole vahvistettuja faktoja sinusta. Lue jokainen ja korjaa se vastaamaan totuutta, ennen kuin käytät sitä.",
  "profile.aiSuggestionsEmpty": "Profiilisi näyttää valmiilta. Lisää kokemusta tai jätä joitakin kenttiä tyhjiksi ja yritä uudelleen.",
  "profile.aiSuggestionsTitle": "Tekoälyehdotukset",
  "profile.applicationDetails.emailPlaceholder": "Sähköposti",
  "profile.applicationDetails.firstNamePlaceholder": "Etunimi",
  "profile.applicationDetails.hint": "Käytetään työhakemuslomakkeiden täyttämiseen puolestasi. Lähetetään vain työnantajan omaan hakulomakkeeseen ja vasta, kun olet tarkistanut ja vahvistanut sen.",
  "profile.applicationDetails.lastNamePlaceholder": "Sukunimi",
  "profile.applicationDetails.phonePlaceholder": "Puhelin",
  "profile.applicationDetails.salaryExpectationPlaceholder": "Palkkatoive (vuosittainen)",
  "profile.applicationDetails.sectionTitle": "Hakemustiedot",
  "profile.applicationDetails.workAuthorization.euEeaCitizen": "EU/ETA-kansalainen",
  "profile.applicationDetails.workAuthorization.finnishCitizen": "Suomen kansalainen",
  "profile.applicationDetails.workAuthorization.notAuthorized": "Ei tällä hetkellä oikeutta työskennellä täällä",
  "profile.applicationDetails.workAuthorization.permanentResident": "Pysyvä oleskelulupa",
  "profile.applicationDetails.workAuthorization.placeholder": "Työskentelyoikeus (valinnainen)",
  "profile.applicationDetails.workAuthorization.requiresSponsorship": "Tarvitsen työluvan/viisumin",
  "profile.applicationDetails.workAuthorization.validWorkPermit": "Voimassa oleva työlupa",
  "profile.applicationKits.link": "Hakemuspaketit",
  "profile.benefits.label": "Nykyiset edut (osumapisteitä varten)",
  "profile.benefitsWeight": "Etujen painotus: {weight} %",
  "profile.closePreview": "Sulje esikatselu",
  "profile.closeSuggestions": "Sulje",
  "profile.commuteMode.label": "Kuljen yleensä",
  "profile.completion.allDone": "Profiilisi on valmis hyvän CV:n pohjaksi.",
  "profile.completion.fix": "Korjaa",
  "profile.completion.itemBasic": "Lisää titteli tai viimeisin roolisi",
  "profile.completion.itemCurrentRole": "Lisää nykyisen roolisi tiedot (osumapisteitä varten)",
  "profile.completion.itemEducation": "Lisää koulutuksesi",
  "profile.completion.itemExperience": "Lisää työkokemuksesi",
  "profile.completion.itemSkills": "Lisää vähintään 3 taitoa",
  "profile.completion.label": "profiili täytetty",
  "profile.currentJob.label": "Nykyinen rooli (osumapisteitä varten)",
  "profile.currentSalary.label": "Nykyinen kuukausipalkka (osumapisteitä varten)",
  "profile.currentSalary.placeholder": "esim. 3500",
  "profile.currentSalary.privacyShort": "Yksityinen. Käytetään vain osumapisteidesi laskemiseen.",
  "profile.currentSalary.unit": "€/kk",
  "profile.currentSalary.workPercent": "työ %",
  "profile.currentWorkModel.label": "Nykyinen työmalli (osumapisteitä varten)",
  "profile.cvDownloadFailed": "CV:n lataaminen epäonnistui. Yritä uudelleen.",
  "profile.cvDownloadFailed.retry": "Yritä uudelleen",
  "profile.cvExportPdfFailed": "PDF:n vieminen epäonnistui. Yritä uudelleen.",
  "profile.cvExportPdfFailed.retry": "Yritä uudelleen",
  "profile.cvImport.notConfigured": "CV:n tuonti ei ole käytössä tässä ympäristössä.",
  "profile.cvUploadError": "Lataa PDF-tiedosto",
  "profile.cvUploadFailed": "CV:n lataaminen epäonnistui. Yritä uudelleen.",
  "profile.cvUploadSizeError": "Tiedoston koon on oltava alle 5 Mt",
  "profile.cvUploading": "Tuodaan…",
  "profile.desiredBenefits": "Toivottuja etuja",
  "profile.desiredIndustries": "Yritysten toimialat",
  "profile.desiredJob": "Mitä etsit",
  "profile.desiredJobDescription": "Kerro, mitä etsit. Nämä toiveet ohittavat nykyisen roolisi, kun pisteytämme, kuinka hyvin työpaikka sopii sinulle.",
  "profile.desiredJobTypes": "Työsuhteen tyypit",
  "profile.desiredLocations": "Sijainnit",
  "profile.desiredRemoteness": "Etätyömahdollisuudet",
  "profile.desiredRoleLevels": "Roolitasot",
  "profile.desiredSalaryMin": "Vähimmäispalkka, kuukausittain",
  "profile.desiredTitles": "Työnimikkeet",
  "profile.desiredVacationWeeks": "Vähimmäislomaviikot",
  "profile.downloadCV": "Lataa CV:ni",
  "profile.europass.additionalInfo": "Lisätiedot",
  "profile.europass.basedOn": "Perustuu Europass CV -rakenteeseen (europass.europa.eu)",
  "profile.europass.educationAndTraining": "Koulutus ja tutkinto",
  "profile.europass.noEducation": "Koulutusta ei ole lisätty.",
  "profile.europass.noSkills": "Taitoja ei ole lisätty.",
  "profile.europass.noWorkExperience": "Työkokemusta ei ole lisätty.",
  "profile.europass.personalSkills": "Henkilökohtaiset taidot",
  "profile.europass.workExperience": "Työkokemus",
  "profile.exportCV": "Vie CV",
  "profile.homeAddress.hint": "Asettaa kartan työmatkahaulle oletuslähtöpisteen, jotta karttaa ei tarvitse napauttaa joka kerta. Valinnainen ja näkyy vain sinulle. Osoite lähetetään vain Mapboxille koordinaattien hakua varten, ei koskaan työnantajille.",
  "profile.homeAddress.placeholder": "Hae osoitetta…",
  "profile.homeAddress.remove": "Poista",
  "profile.homeAddress.sectionTitle": "Kotiosoite",
  "profile.jobType": "Työsuhteen tyyppi",
  "profile.jobTypeWeight": "Työsuhteen tyypin painotus: {weight} %",
  "profile.languageSwitcher.hint": "Tuonti, lataus ja tekoälyehdotukset täyttävät sen kieliversion, joka on valittuna. Versiot ovat toisistaan riippumattomia; mitään ei käännetä automaattisesti.",
  "profile.languages.label": "Kielet (ammatillinen taso)",
  "profile.languagesWeight": "Kielten painotus: {weight} %",
  "profile.linkedInImport.button": "Tuo LinkedInistä",
  "profile.linkedInImport.failed": "Profiilia ei voitu tuoda. Yritä myöhemmin uudelleen.",
  "profile.linkedInImport.hint": "Liitä julkisen profiilisi osoite (linkedin.com/in/…) ja tuo tiedot. Tiedot haetaan Proxycurlin (kolmas osapuoli) kautta, eikä mukana ole välttämättä kaikkea, mitä sivullasi on. Ne täyttävät alla olevan lomakkeen, eivät tallennettua profiiliasi. Tarkista ja korjaa tarvittaessa ennen tallennusta.",
  "profile.linkedInImport.invalidProfileUrl": "Käytä henkilökohtaisen profiilisi linkkiä (linkedin.com/in/…).",
  "profile.linkedInImport.invalidUrl": "Anna kelvollinen LinkedIn-osoite.",
  "profile.linkedInImport.loading": "Tuodaan…",
  "profile.linkedInImport.networkError": "Verkkovirhe. Tarkista yhteytesi.",
  "profile.linkedInImport.notConfigured": "LinkedIn-tuonti ei ole käytössä tässä ympäristössä.",
  "profile.linkedInImport.ownProfileOnlyWarning": "Käytä tätä vain omaan LinkedIn-profiiliisi. Jos syötät jonkun toisen profiilin osoitteen, hänen henkilötietonsa haetaan ja näytetään hänen tietämättään.",
  "profile.linkedInImport.placeholder": "https://www.linkedin.com/in/profiilisi/",
  "profile.linkedInImport.sectionTitle": "LinkedIn-profiili",
  "profile.loading": "Ladataan…",
  "profile.locationWeight": "Sijainnin painotus: {weight} %",
  "profile.locations": "Sijainnit",
  "profile.matchPreferences": "Osumapisteiden painotukset",
  "profile.matchPreferencesDescription": "Säädä, kuinka paljon eri tekijät painavat osumapisteissäsi. Summan on oltava 100 %.",
  "profile.prefillFromSearches.banner": "Täytimme joitakin kenttiä viimeisimpien työhakujesi perusteella. Tarkista tiedot ja korjaa mahdolliset virheet.",
  "profile.prefillFromSearches.dismiss": "Sulje",
  "profile.preview": "Esikatselu",
  "profile.previewEuropass": "CV-esikatselu (Europass-muoto)",
  "profile.profilePhoto.errorCompressedTooLarge": "Kuva on edelleen liian suuri pakkaamisen jälkeen. Kokeile pienempää alkuperäiskuvaa.",
  "profile.profilePhoto.errorProcess": "Kuvaa ei voitu käsitellä. Kokeile toista tiedostoa.",
  "profile.profilePhoto.errorTooLarge": "Kuva on liian suuri (enintään 5 Mt).",
  "profile.profilePhoto.errorType": "Käytä JPEG-, PNG-, WebP- tai GIF-kuvaa.",
  "profile.profilePhoto.remove": "Poista ladattu kuva",
  "profile.profilePhoto.uploadAria": "Lataa tai vaihda profiilikuva",
  "profile.quickActions.title": "CV:si",
  "profile.remotenessWeight": "Etätyön painotus: {weight} %",
  "profile.roleLevel": "Roolitaso",
  "profile.roleLevelWeight": "Roolitason painotus: {weight} %",
  "profile.salaryWeight": "Palkan painotus: {weight} %",
  "profile.selectJobType": "Valitse työsuhteen tyyppi",
  "profile.selectLocations": "Valitse sijainnit",
  "profile.selectMultipleIndustries": "Valitse yksi tai useampi toimiala",
  "profile.selectMultipleJobTypes": "Valitse yksi tai useampi työsuhteen tyyppi",
  "profile.selectMultipleLocations": "Valitse yksi tai useampi sijainti",
  "profile.selectMultipleRemoteness": "Valitse yksi tai useampi etätyövaihtoehto",
  "profile.selectMultipleRoleLevels": "Valitse yksi tai useampi roolitaso",
  "profile.selectMultipleTitles": "Valitse yksi tai useampi työnimike",
  "profile.selectRoleLevel": "Valitse roolitasosi",
  "profile.title": "Työnimike",
  "profile.titlePlaceholder": "esim. ohjelmistokehittäjä",
  "profile.titleWeight": "Nimikkeen painotus: {weight} %",
  "profile.totalWeight": "Yhteensä",
  "profile.uploadCV": "Lataa CV esitäyttöä varten",
  "profile.uploadCV.disclaimer": "Tekoäly poimii tiedot PDF-tiedostostasi. Ne täyttävät alla olevan lomakkeen, eivät tallennettua profiiliasi. Tarkista ja korjaa tarvittaessa ennen tallennusta.",
  "profile.vacationWeeks.label": "Lomaviikot vuodessa",
  "profile.vacationWeeks.unit": "viikkoa/vuosi",
  "profile.vacationWeight": "Loman painotus: {weight} %",
  "recentSearches.delete": "Poista",
  "recentSearches.noSearches": "Et ole vielä tallentanut yhtään hakua.",
  "role.follow.createAccount": "Luo tili",
  "role.follow.cta": "Seuraa roolia",
  "role.follow.emailPrompt.enabled": "Valmista. Seuraamiesi roolien uudet työpaikat tulevat työpaikkavahtisi sähköposteihin.",
  "role.follow.emailPrompt.failed": "Sähköpostipäivitysten käyttöönotto epäonnistui. Voit ottaa ne käyttöön milloin tahansa Hälytykset-sivulta.",
  "role.follow.emailPrompt.offer": "Seuraat nyt roolia {role}. Haluatko sähköpostin, kun uusia työpaikkoja julkaistaan?",
  "role.follow.emailPrompt.pendingConfirmation": "Melkein valmista: vahvista sähköpostiosoitteesi postilaatikostasi, niin päivitykset ovat käytössä.",
  "role.follow.emailPrompt.turnOn": "Ota käyttöön",
  "role.follow.undo": "Kumoa",
  "role.follow.unwatchedToast": "Seuranta lopetettu. Et saa enää ilmoituksia tämän roolin uusista työpaikoista",
  "role.follow.watchedToast": "Seuraat roolia {role}. Uudet ilmoitukset näkyvät seurantalistallasi",
  "role.follow.watching": "Seurataan",
  "rolesIndex.breadcrumb": "Ammatit",
  "rolesIndex.floorNote": "Ammatit, joissa on vain muutama avoin ilmoitus, näytetään ilman linkkiä, kunnes paikkoja avautuu lisää.",
  "rolesIndex.lede": "{roles} ammattia suoraan työnantajien omilta sivuilta ja Työmarkkinatorilta. Jokaisella ammatilla on oma sivu, jolla ovat avoimet ilmoitukset, palkkatiedot ja eniten rekrytoivat kaupungit.",
  "rolesIndex.ledeWithCount": "{roles} ammattia ja {jobs} avointa työpaikkaa suoraan työnantajien omilta sivuilta ja Työmarkkinatorilta. Jokaisella ammatilla on oma sivu, jolla ovat avoimet ilmoitukset, palkkatiedot ja eniten rekrytoivat kaupungit.",
  "rolesIndex.title": "Avoimet työpaikat ammateittain",
  "salary.period.day": "/pv",
  "salary.period.hour": "/t",
  "salary.period.month": "/kk",
  "salary.period.year": "/v",
  "salaryChart.allRolesInLocation": "Kaikki roolit alueella {location}",
  "salaryChart.analysisTitle": "Palkka-analyysi",
  "salaryChart.companyLocation": "Yritys alueella {location}",
  "salaryChart.estimatedFromMarket": "Arvioitu markkinatiedon perusteella (ei palkkatietoa ilmoituksessa)",
  "salaryChart.fromJobAd": "Työpaikkailmoituksesta",
  "salaryChart.fromJobAdWithLevel": "Työpaikkailmoituksesta ({roleLevel})",
  "salaryChart.locationAverage": "Alueella {location}: {title}",
  "salaryChart.marketAverage": "Markkinoiden keskiarvo: {title}",
  "salaryChart.marketAverageRoleLevel": "Markkinoiden keskiarvo: {roleLevel}-taso",
  "salaryChart.payInDataNotInAd": "Tämän työpaikan palkkahaarukka (ei mainittu ilmoituksessa)",
  "salaryChart.payInDataNotInAdWithLevel": "Tämän työpaikan palkkahaarukka, ei mainittu ilmoituksessa ({roleLevel})",
  "salaryChart.popover.average": "Keskimääräinen palkkahaitari",
  "salaryChart.popover.benchmarkEstimateNote": "Ei työnantajalta, vaan mallinnettu vertailutiedoista",
  "salaryChart.popover.dimension": "Ulottuvuus",
  "salaryChart.popover.extractedNoQuoteNote": "Numeerinen palkka ilman tarkentavaa tekstiä ilmoituksessa",
  "salaryChart.popover.fromAdText": "Perustuu ilmoituksen palkkatekstiin",
  "salaryChart.popover.jobEstimatedRange": "Arvioitu palkkahaarukka",
  "salaryChart.popover.jobListedRange": "Ilmoitettu palkkahaarukka",
  "salaryChart.popover.max": "Enimmäisarvo",
  "salaryChart.popover.median": "Mediaanihaitari",
  "salaryChart.popover.min": "Minimi",
  "salaryChart.popover.monthlyNote": "Kaikki summat on esitetty euroina kuukaudessa, jotta niitä voi vertailla tässä kaaviossa.",
  "salaryChart.popover.p25": "25. persentiili",
  "salaryChart.popover.p75": "75. persentiili",
  "salaryChart.popover.p90": "90. persentiili",
  "salaryChart.popover.sample": "Otoskoko",
  "salaryChart.popover.seeFullSalaryPage": "Katso koko palkkasivu: {title} →",
  "salaryChart.rangeAria": "Palkkahaarukka {min}–{max} kuukaudessa, mediaani noin {median}",
  "salaryChart.salaryContext": "Palkkayhteys: {title}",
  "salaryChart.segmentHint": "Vie hiiri rivin päälle tai napauta riviä, niin näet kaikki tilastot (tässä kaaviossa EUR/kk).",
  "salaryChart.seoTable.caption": "Kuukausipalkkavertailu nimikkeelle {title}",
  "salaryChart.seoTable.lowerBound": "Alaraja (25. persentiili)",
  "salaryChart.seoTable.market": "Markkinat",
  "salaryChart.seoTable.median": "Mediaani",
  "salaryChart.seoTable.upperBound": "Yläraja (75. persentiili)",
  "salaryChart.thisRole": "tämä rooli",
  "salaryChart.thisRoleLevel": "tämä roolitaso",
  "salaryChart.verifiedPayBanner": "Työnantajan ilmoittama todellinen palkka, ei arvio",
  "salaryDisplayToggle.label": "Näytä alkuperäinen valuutta",
  "salaryIndexPage.allRolesHeading": "Selaa kaikkia rooleja",
  "salaryIndexPage.empty": "Palkkatietoja ei ole juuri nyt saatavilla. Käy myöhemmin uudelleen.",
  "salaryIndexPage.eyebrow": "{count} seurattua roolia",
  "salaryIndexPage.heading": "Palkkatiedot ammateittain Suomessa",
  "salaryIndexPage.intro": "Todellista palkkatietoa suomalaisista työpaikkailmoituksista ammateittain. Valitse ammatti, niin näet mediaanipalkan, vaihteluvälin ja kaupunkien väliset erot.",
  "salaryIndexPage.methodologyLink": "Näin laskemme nämä luvut",
  "salaryIndexPage.postingsSuffix": "ilmoitusta",
  "salaryIndexPage.search.clear": "Tyhjennä haku",
  "salaryIndexPage.search.label": "Hae rooleja",
  "salaryIndexPage.search.noResults": "Yksikään rooli ei vastaa hakua \"{query}\". Kokeile toista hakusanaa.",
  "salaryIndexPage.search.placeholder": "Hae rooleja, esim. \"sairaanhoitaja\" tai \"kirvesmies\"…",
  "salaryIndexPage.search.resultsCount": "{shown, plural, one {# rooli} other {# roolia}} löytyi",
  "salaryIndexPage.searchResultsHeading": "Hakutulokset",
  "salaryIndexPage.stat.postings": "analysoitua ilmoitusta",
  "salaryIndexPage.stat.roles": "seurattu rooli",
  "salaryIndexPage.stat.topRole": "eniten analysoitu rooli",
  "salaryIndexPage.taxIcebergLink": "Verojäävuorilaskuri",
  "salaryIndexPage.topRolesHeading": "Kysytyimmät roolit",
  "salaryIndexPage.topRolesSub": "Järjestetty palkka-arvion taustalla olevien ilmoitusten määrän mukaan – mitä enemmän ilmoituksia, sitä luotettavampia luvut ovat.",
  "salaryInsight.above": "Tämän roolin palkka <strong>{salary}</strong> on <strong>{percent} %</strong> korkeampi kuin {benchmark}.",
  "salaryInsight.below": "Tämän roolin palkka <strong>{salary}</strong> on <strong>{percent} %</strong> alempi kuin {benchmark}.",
  "salaryInsight.benchmark.finlandOnly": "koko Suomen mediaani palkkatiedoissamme",
  "salaryInsight.benchmark.finlandWithRole": "koko Suomen mediaani {role}-rooleissa",
  "salaryInsight.benchmark.locationOnly": "mediaanipalkka alueella {location}",
  "salaryInsight.benchmark.locationWithRole": "{role}-roolien mediaani alueella {location}",
  "salaryMethodology.backToSalary": "Takaisin palkkaoppaaseen",
  "salaryMethodology.breadcrumb.current": "Palkkatietojen menetelmä",
  "salaryMethodology.breadcrumb.parent": "Palkkaopas",
  "salaryMethodology.byline": "Kirjoittanut {author}",
  "salaryMethodology.intro": "Jokainen JobCrawlsin palkkaluku, olipa kyse mediaanista, vaihteluvälistä tai rooli- ja kaupunkikohtaisista tilastoista, käy läpi saman putken. Tässä on tarkalleen, mitä se putki tekee.",
  "salaryMethodology.limits.confidence": "Alle 10 ilmoituksesta lasketut tilastot merkitään epävarmoiksi. Pidä niitä suuntaa-antavina, ei tarkkoina lukuina.",
  "salaryMethodology.limits.disclaimer": "Palkkatiedot perustuvat julkaistuihin työpaikkailmoituksiin, eivätkä ne välttämättä kuvaa kokonaiskorvausta. Luvut ovat euroa/kk ja voivat sisältää työnantajan arvioita silloin, kun ilmoitettua palkkahaarukkaa ei ole julkisesti kerrottu.",
  "salaryMethodology.limits.notVerified": "Emme tarkista erikseen, mitä työnantajat julkaisevat. Luvut kuvaavat ilmoitusten sisältöä, eivät tarkastettuja palkkatietoja.",
  "salaryMethodology.limits.title": "Tärkeitä rajoituksia",
  "salaryMethodology.step1.body": "Poimintavaihe hakee palkkaluvut suoraan ilmoituksen tekstistä. Sitä on erikseen ohjeistettu olemaan arvaamatta lukua epämääräisistä ilmauksista, kuten \"kilpailukykyinen palkka\". Jos ilmoituksessa ei ole lukua, emme keksi sitä tässä vaiheessa.",
  "salaryMethodology.step1.title": "Keräämme ilmoituksessa mainitut palkat",
  "salaryMethodology.step2.body": "Kun ilmoituksessa ei ole palkkaa, arvioimme sen vertailukelpoisista ilmoituksista, joilla on sama nimike, sijainti, roolitaso ja yritys. Ilmoitukset painotetaan luotettavuuden mukaan, ja kun suppea otos on ohut, painoa siirretään laajempaan, suurempaan otokseen. Arvioidut luvut merkitään arvioiksi aina, kun ne näkyvät työpaikkailmoituksen yhteydessä, joten ilmoitetun palkan erottaa pääteltystä aina.",
  "salaryMethodology.step2.title": "Arvioimme, kun palkkaa ei ole ilmoitettu, ja merkitsemme arvion",
  "salaryMethodology.step3.body": "Ilmoitukset kertovat palkan eri tavoin (tunti-, kuukausi- tai vuosipalkkana), ja jakso on joskus merkitty väärin. Muunnamme jokaisen luvun euroiksi kuukaudessa ja teemme uskottavuustarkistuksen (karkeasti 500–30 000 €/kk, ja vaihteluvälin yläraja enintään 5-kertainen alarajaan nähden), jotta paikkamerkit ja sotkeutuneet tiedot jäävät kiinni ennen kuin ne päätyvät mihinkään tilastoon.",
  "salaryMethodology.step3.title": "Normalisoimme jokaisen luvun euroa/kk-muotoon",
  "salaryMethodology.step4.body": "Alle 5 ilmoituksen otoksista emme karsi mitään: dataa ei ole tarpeeksi, jotta jotain voisi turvallisesti pudottaa pois. 5–24 ilmoituksen otoksissa karsimme kvartiilivälin perusteella. Vähintään 25 ilmoituksen otoksissa käytämme tiukempaa karsintaa 10.–90. persentiiliin ennen mediaanin, keskiarvon ja persentiilien laskemista.",
  "salaryMethodology.step4.title": "Karsimme poikkeamat otoskoon mukaan",
  "salaryMethodology.step5.body": "Yksi poikkeava ilmoitus voisi muuten määrätä koko julkaistun vaihteluvälin. Näyttämämme ala- ja yläraja ovat otoksen minimien 10. persentiili ja maksimien 90. persentiili, eivät yksittäinen alin tai ylin näkemämme luku.",
  "salaryMethodology.step5.title": "Näytetty vaihteluväli ei ole raaka minimi ja maksimi",
  "salaryMethodology.steps.heading": "Putki vaihe vaiheelta",
  "salaryMethodology.title": "Miten laskemme palkkatilastot",
  "salaryRolePage.alsoKnownAs": "Löytyy myös nimillä: {titles}",
  "salaryRolePage.breadcrumb.salaryData": "Palkkatiedot",
  "salaryRolePage.cityTable.footnote": "Palkki näyttää P25–P75-vaihteluvälin. Pystyviiva = mediaani. Kaikki arvot ovat euroa/kk.",
  "salaryRolePage.cityTable.title": "{roleTitle}: palkka kaupungeittain",
  "salaryRolePage.ctaBanner": "Etsitkö {roleTitle}-työpaikkoja? {link}",
  "salaryRolePage.ctaBanner.link": "Selaa avoimia työpaikkoja JobCrawlsissa →",
  "salaryRolePage.disclaimer": "Palkkatiedot perustuvat julkaistuihin työpaikkailmoituksiin, eivätkä ne välttämättä kuvaa kokonaiskorvausta. Luvut ovat euroa/kk ja voivat sisältää työnantajan arvioita silloin, kun ilmoitettua palkkahaarukkaa ei ole julkisesti kerrottu.",
  "salaryRolePage.examplePostings.inactiveBadge": "Ei enää voimassa",
  "salaryRolePage.examplePostings.title": "Perustuu näihin ilmoituksiin",
  "salaryRolePage.heading": "{roleTitle} palkka Suomessa",
  "salaryRolePage.hero.perMonthNational": "/ kk, koko maan mediaani",
  "salaryRolePage.hero.sampleEyebrow": "Perustuu {count} ilmoitukseen",
  "salaryRolePage.hiringCompanies.browseAll": "Selaa Suomen parhaita työnantajia →",
  "salaryRolePage.hiringCompanies.empty": "Selaa kaikkia listattuja työnantajia ja etsi niistä tähän rooliin rekrytoivia.",
  "salaryRolePage.hiringCompanies.sub": "Poimittu työnantajalistauksestamme. Joihinkin kannattaa ottaa yhteyttä suoraan, vaikka avointa paikkaa ei olisi ilmoitettu.",
  "salaryRolePage.hiringCompanies.title": "Yritykset, jotka rekrytoivat {roleTitle}-ammattilaisia",
  "salaryRolePage.intro": "Perustuu suomalaisten työnantajien työpaikkailmoituksiin. Päivitetään säännöllisesti.",
  "salaryRolePage.methodologyLink": "Näin laskemme nämä luvut",
  "salaryRolePage.overallPanel.footnote": "EUR/kk · P25–P75-väli mediaanimerkinnällä · perustuu {count} työpaikkailmoitukseen",
  "salaryRolePage.overallPanel.title": "{roleTitle}: Suomen keskiarvo",
  "salaryRolePage.rangeBar.hint": "Napauta tai vie hiiri päälle nähdäksesi tiedot.",
  "salaryRolePage.rangeBar.popoverListings": "{count, plural, one {Perustuu # työpaikkailmoitukseen} other {Perustuu # työpaikkailmoitukseen}}",
  "salaryRolePage.remotePanel.title": "{roleTitle}: etätyö Suomessa",
  "salaryRolePage.seeOpenJobs": "Katso avoimet {roleTitle}-työpaikat →",
  "salaryRolePage.stat.average": "Keskiarvo",
  "salaryRolePage.stat.median": "Mediaani",
  "salaryRolePage.stat.middle50": "Keskimmäinen 50 %",
  "salaryRolePage.stat.range": "Koko vaihteluväli",
  "salaryRolePage.stat.sampleSize": "Otoskoko",
  "salaryRolePage.trend.down": "▼ {percent} % edelliseen kuukauteen verrattuna",
  "salaryRolePage.trend.flat": "Ei muutosta edelliseen kuukauteen verrattuna",
  "salaryRolePage.trend.up": "▲ {percent} % edelliseen kuukauteen verrattuna",
  "salaryStats.aboveMarket": "Tämä palkka on markkinoiden mediaania korkeampi",
  "salaryStats.accuracy.exact": "Perustuu saman yrityksen vastaaviin tehtäviin",
  "salaryStats.accuracy.general": "Perustuu markkinatietoihin",
  "salaryStats.accuracy.location": "Perustuu palkkoihin paikassa {location}",
  "salaryStats.atMarket": "Tämä palkka on markkinoiden mediaanin tasolla",
  "salaryStats.average": "Keskiarvo",
  "salaryStats.belowMarket": "Tämä palkka on markkinoiden mediaania matalampi",
  "salaryStats.jobSalary": "Tämä työpaikka",
  "salaryStats.marketRange": "Markkinahaarukka: {min}–{max} (mediaani: {median})",
  "salaryStats.median": "Mediaani",
  "salaryStats.noJobSalary": "Tälle työpaikalle ei ole annettu palkkahaitaria. Kaavio näyttää markkinajakauman.",
  "salaryStats.noValidValues": "Palkkatilastoja on saatavilla ({sampleSize} {samples}), mutta kaikki arvot ovat nollia. Tämä voi tarkoittaa, että tiedot on päivitettävä.",
  "salaryStats.perDay": "päivässä",
  "salaryStats.perHour": "tunnissa",
  "salaryStats.perMonth": "kuukaudessa",
  "salaryStats.perYear": "vuodessa",
  "salaryStats.percentiles": "25.–75. persentiili",
  "salaryStats.samples": "ilmoitusta",
  "salaryStats.smallSampleWarning": "Huom: Perustuu pieneen otoskokoon ({sampleSize} {samples}). Tulokset eivät välttämättä ole edustavia.",
  "savedSearches.card.continue": "Jatka",
  "savedSearches.card.dragAria": "Järjestä uudelleen vetämällä \"{title}\"",
  "savedSearches.card.moveDownAria": "Siirrä \"{title}\" alaspäin",
  "savedSearches.card.moveUpAria": "Siirrä \"{title}\" ylöspäin",
  "savedSearches.card.selectAria": "Valitse \"{title}\"",
  "savedSearches.confirmRemove.bulkBody": "{count} tallennettua hakua ja niiden hälytysasetukset poistetaan.",
  "savedSearches.confirmRemove.bulkTitle": "Poistetaanko {count} hakua?",
  "savedSearches.confirmRemove.cancel": "Peruuta",
  "savedSearches.confirmRemove.close": "Sulje",
  "savedSearches.confirmRemove.confirm": "Poista",
  "savedSearches.confirmRemove.singleBody": "\"{title}\" ja sen hälytysasetukset poistetaan.",
  "savedSearches.confirmRemove.singleTitle": "Poistetaanko tämä haku?",
  "savedSearches.confirmRemove.working": "Poistetaan…",
  "savedSearches.emptyHint": "Tee haku avainsanoilla tai suodattimilla työpaikkasivulla, niin se ilmestyy tänne automaattisesti. Voit myös kiinnittää haun \"Tallenna haku\" -toiminnolla.",
  "savedSearches.folder.collapseToggle": "Näytä tai piilota kansio",
  "savedSearches.folder.count": "{count, plural, one {# haku} other {# hakua}}",
  "savedSearches.folder.delete": "Poista kansio",
  "savedSearches.folder.menuAria": "Kansion asetukset",
  "savedSearches.folder.moveDown": "Siirrä alaspäin",
  "savedSearches.folder.moveUp": "Siirrä ylöspäin",
  "savedSearches.folder.rename": "Nimeä uudelleen",
  "savedSearches.folder.renameSave": "Tallenna",
  "savedSearches.folder.sheetCancel": "Peruuta",
  "savedSearches.folder.sheetClose": "Sulje",
  "savedSearches.folder.unsorted": "Lajittelemattomat",
  "savedSearches.newMatchesBadge": "{count} uutta",
  "savedSearches.noFilterResults": "Yksikään tallennettu haku ei vastaa hakua \"{filterText}\".",
  "savedSearches.openSearchAria": "Avaa haku: {title}",
  "savedSearches.rename.action": "Nimeä tämä haku",
  "savedSearches.rename.placeholder": "esim. Backend-työt Helsingissä",
  "savedSearches.rename.save": "Tallenna",
  "savedSearches.summary.filtered": "Suodatettu haku",
  "savedSearches.summary.location": "Sijainti: {values}",
  "savedSearches.summary.page": "Sivu {page}",
  "savedSearches.summary.sortDate": "Lajittelu: uusimmat",
  "savedSearches.summary.sortSalary": "Lajittelu: palkka",
  "savedSearches.summary.worldwide": "Kaikki maat",
  "savedSearches.toolbar.cancelSelect": "Peruuta",
  "savedSearches.toolbar.deleteSelected": "Poista",
  "savedSearches.toolbar.filterAria": "Suodata tallennettuja hakuja",
  "savedSearches.toolbar.filterPlaceholder": "Suodata hakujasi…",
  "savedSearches.toolbar.moveToFolder": "Siirrä kansioon",
  "savedSearches.toolbar.moveToNewFolder": "Uusi kansio…",
  "savedSearches.toolbar.moveToUnsorted": "Lajittelemattomat",
  "savedSearches.toolbar.newFolderButton": "Uusi kansio",
  "savedSearches.toolbar.newFolderPrompt": "Kansion nimi",
  "savedSearches.toolbar.newFolderSave": "Luo",
  "savedSearches.toolbar.selectAll": "Valitse kaikki",
  "savedSearches.toolbar.selectButton": "Valitse",
  "savedSearches.toolbar.selectedCount": "{count, plural, one {# valittu} other {# valittua}}",
  "savedSearches.toolbar.sortAlphabetical": "A–Ö",
  "savedSearches.toolbar.sortAria": "Järjestä tallennetut haut",
  "savedSearches.toolbar.sortCustom": "Mukautettu järjestys",
  "savedSearches.toolbar.sortNewest": "Uusimmat",
  "savedSearches.toolbar.sortSuggested": "Ehdotettu",
  "search.bestCompaniesStrip.hubCta": "Suomessa rekrytoivat yritykset →",
  "search.bestCompaniesStrip.label": "Huipputyönantajat",
  "search.controls.navigation": "Haun ohjaimet ja suodattimet",
  "search.jobCount": "{count, number} työpaikkaa",
  "search.noresults.clearAllParameters": "Tyhjennä kaikki hakuehdot",
  "search.noresults.description": "Kokeile muuttaa hakua tai suodattimia, niin löydät enemmän työpaikkoja.",
  "search.noresults.filtersLabel": "Suodattimet:",
  "search.noresults.goToFirstPage": "Siirry sivulle 1",
  "search.noresults.hybridJobs": "Hybridityöt",
  "search.noresults.pageLabel": "Sivu:",
  "search.noresults.popularSearches": "Suositut haut",
  "search.noresults.queryLabel": "Haku:",
  "search.noresults.removeQuery": "Poista",
  "search.noresults.searchParameters": "Hakuehtosi",
  "search.noresults.searchTips": "Hakuohjeita",
  "search.noresults.tip1": "Kokeile laajempia hakusanoja tai poista joitakin suodattimia",
  "search.noresults.tip2": "Tarkista oikeinkirjoitus tai kokeile vaihtoehtoisia avainsanoja",
  "search.noresults.tip3": "Selaa yllä olevia suosittuja kategorioita, niin löydät uusia työpaikkoja",
  "search.noresults.title": "Tuloksia ei löytynyt",
  "search.noresults.unavailable.description": "Työpaikkahaku ei ole juuri nyt käytettävissä. Yritä päivittää sivu tai tutustu näihin sivuihin sillä välin.",
  "search.noresults.unavailable.exploreResources": "Oppaat ja artikkelit",
  "search.noresults.unavailable.exploreSalary": "Palkat ammateittain",
  "search.noresults.unavailable.linksLabel": "Sillä välin",
  "search.noresults.unavailable.retry": "Yritä uudelleen",
  "search.noresults.unavailable.title": "Haku ei toimi juuri nyt",
  "search.refinements.advancedFilters": "Tarkennetut suodattimet",
  "search.refinements.advancedFilters.aria": "Tarkennetut suodattimet",
  "search.refinements.allFilters.aria": "Kaikki suodattimet",
  "search.refinements.benefits.label": "Edut",
  "search.refinements.clearAll": "Tyhjennä kaikki ({count})",
  "search.refinements.company": "Yritys",
  "search.refinements.company.label": "Yritys",
  "search.refinements.company.openProfileAria": "Avaa yritysprofiili {company}{count, plural, =0 {} other {, {count} avointa työpaikkaa JobCrawlsissa}}",
  "search.refinements.company.searchPlaceholder": "Hae yrityksiä…",
  "search.refinements.educationLevel.detail": "Koulutustaso",
  "search.refinements.educationLevel.label": "Koulutustaso",
  "search.refinements.excludeApplied.label": "Piilota haetut työpaikat",
  "search.refinements.excludeConsultingCompany.filter": "Piilota konsulttiyritysten ilmoitukset",
  "search.refinements.excludeFreelance.filter": "Piilota keikkatyöilmoitukset",
  "search.refinements.excludeJobs": "Piilota työpaikkoja",
  "search.refinements.excludeRecruitmentCompany.filter": "Piilota rekrytointitoimistojen ilmoitukset",
  "search.refinements.excludeSaved.label": "Piilota tallennetut työpaikat",
  "search.refinements.excludeViewed.label": "Piilota katsotut työpaikat",
  "search.refinements.field.label": "Ala",
  "search.refinements.headcount.chip": "Enintään {count} työntekijää",
  "search.refinements.headcount.max": "Enimmäishenkilöstömäärä",
  "search.refinements.industry.label": "Toimiala",
  "search.refinements.isDriversLicenseRequired.filter": "Ajokorttivaatimus",
  "search.refinements.isOpenApplication.filter": "Avoin hakemus",
  "search.refinements.job": "Työpaikka",
  "search.refinements.jobTitle": "Työnimike",
  "search.refinements.jobType.label": "Työsuhteen tyyppi",
  "search.refinements.languages.label": "Kielet",
  "search.refinements.lastSeen.all": "Kaikki",
  "search.refinements.lastSeen.aria": "Julkaisupäivämäärä",
  "search.refinements.lastSeen.past1Month": "Viimeinen kuukausi",
  "search.refinements.lastSeen.past1Week": "Viimeinen viikko",
  "search.refinements.lastSeen.past24Hours": "Viimeiset 24 tuntia",
  "search.refinements.lastSeen.past2Weeks": "Viimeiset 2 viikkoa",
  "search.refinements.lastSeen.past3Days": "Viimeiset 3 päivää",
  "search.refinements.lastSeen.past6Hours": "Viimeiset 6 tuntia",
  "search.refinements.location": "Sijainti",
  "search.refinements.location.searchPlaceholder": "Hae sijainteja…",
  "search.refinements.peopleManagementTier.label": "Esihenkilötaso",
  "search.refinements.posted.section": "Julkaistu",
  "search.refinements.quickFilter.salary": "{amount} €+",
  "search.refinements.quickFilter.thisWeek": "Tällä viikolla",
  "search.refinements.quickFilters.heading": "Pikasuodattimet",
  "search.refinements.regionTags.breadcrumb.root": "Kaikki sijainnit",
  "search.refinements.regionTags.drillIn": "Selaa aluetta {value}",
  "search.refinements.regionTags.finlandQuickChip": "Suomi",
  "search.refinements.regionTags.group.continent": "Maanosat",
  "search.refinements.regionTags.group.country": "Maat",
  "search.refinements.regionTags.group.finland": "Suomi",
  "search.refinements.regionTags.group.recruitingRegion": "Alueet",
  "search.refinements.regionTags.label": "Alue",
  "search.refinements.regionTags.remoteCountLabel": "{value} etätyö",
  "search.refinements.regionTags.showBeyondFinland": "Näytä sijainnit Suomen ulkopuolella",
  "search.refinements.remoteness.heading": "Työmuoto",
  "search.refinements.roleLevel.label": "Roolitaso",
  "search.refinements.salary": "Palkka",
  "search.refinements.salary.min": "Minimipalkka",
  "search.refinements.search.placeholder": "Hae…",
  "search.refinements.showJobsInFinlandOnly": "Näytä vain Suomessa olevat työpaikat",
  "search.refinements.showLess": "Näytä vähemmän",
  "search.refinements.showMore": "Näytä lisää",
  "search.refinements.showResults": "Näytä {count} tulosta",
  "search.refinements.showResultsNoCount": "Näytä tulokset",
  "search.refinements.skillsAndTechnologies.label": "Taidot ja teknologiat",
  "search.refinements.sort.section": "Lajittelu",
  "search.refinements.vacationWeeks": "Lomaviikot",
  "search.refinements.vacationWeeks.chip": "{count}+ lomaviikkoa",
  "search.results.title": "Työnhakutulokset",
  "search.resultsPerPage.aria": "Tuloksia sivua kohden",
  "search.resultsPerPage.optionLabel": "{count} / sivu",
  "search.signInCta.benefit1": "Tallenna työpaikkoja myöhempää varten",
  "search.signInCta.benefit2": "Seuraa kaikkia hakemuksiasi yhdellä taululla",
  "search.signInCta.benefit3": "Saat ilmoituksen heti, kun uusi työpaikka sopii sinulle",
  "search.signInCta.button": "Luo ilmainen tili",
  "search.signInCta.secondaryText": "Onko sinulla jo tili? Kirjaudu sisään",
  "search.signInCta.title": "Pidä työnhakusi hallinnassa",
  "search.topRolesStrip.hubCta": "Palkat ammateittain Suomessa →",
  "search.topRolesStrip.label": "Kysytyimmät roolit",
  "search.view.ariaLabel": "Näkymä",
  "sort.ariaLabel": "Lajittele tulokset",
  "sort.newest": "Uusimmat",
  "sort.relevance": "Osuvuus",
  "sort.salary": "Palkka",
  "srpAlertCta.bannerText": "Ei enää turhaa tarkistelua. Lähetämme sähköpostia, kun uusia vastaavia työpaikkoja julkaistaan.",
  "srpAlertCta.ctaButton": "Tilaa sähköposti-ilmoitukset",
  "srpAlertCta.dismissLabel": "Sulje",
  "srpAlertCta.errorText": "Jokin meni pieleen. Ilmoituksia ei saatu käyttöön. Yritä uudelleen.",
  "srpAlertCta.manageLink": "Hallitse ilmoituksia",
  "srpAlertCta.pendingText": "Melkein valmista: tarkista postilaatikkosi ja vahvista sähköpostiosoitteesi, niin ilmoitukset ovat käytössä.",
  "srpAlertCta.subText": "Ilmainen viikoittainen tai päivittäinen kooste. Voit peruuttaa milloin vain.",
  "srpAlertCta.successText": "Kaikki valmista – lähetämme sinulle sähköpostia vastaavista työpaikoista.",
  "stats.appliedJobs": "{count} haettua työpaikkaa",
  "stats.finlandJobsSubtitle": "Työpaikkoja suomeksi tai etänä Suomessa asuville",
  "stats.newThisWeekInline": "· {count, number} uutta tällä viikolla",
  "stats.savedJobs": "{count} tallennettua työpaikkaa",
  "stats.viewedJobs": "{count} katsottua työpaikkaa",
  "tags.field.addTrigger": "Lisää tunniste",
  "tags.field.placeholder": "Kirjoita tunniste ja paina Enteriä…",
  "tags.field.remove": "Poista tunniste {tag}",
  "taxIceberg.accuracyNote": "Tarkistettu Veronmaksajien vuoden {year} palkansaajataulukkoa vastaan: euron tarkkuudella 15 tulotasolla 20 000 eurosta 200 000 euroon.",
  "taxIceberg.advanced.group.deductions": "Vähennykset",
  "taxIceberg.advanced.group.employer": "Työnantaja",
  "taxIceberg.advanced.group.otherIncome": "Muut tulot",
  "taxIceberg.advanced.group.person": "Sinusta",
  "taxIceberg.advanced.group.picture": "Kuva",
  "taxIceberg.advanced.toggle": "Lisäasetukset: vähennykset, muut tulot, työnantaja, perhe",
  "taxIceberg.agents.body": "Jokaisella palkalla on oma sivunsa: {urlTemplate}, ja yllä olevat valinnat kulkevat osoitteen parametreina (municipality, employer, vat, church, age, children, sole, union, commuting, dividends, gains, own, assets). Sama tulos JSON-muodossa: {apiUrl}. Tekoälyavustajat voivat kutsua JobCrawlsin MCP-liittimen työkalua {tool} ({connectorUrl}).",
  "taxIceberg.agents.heading": "Tekoälyavustajille ja kehittäjille",
  "taxIceberg.amounts.perMonth": "Kaikki summat kuukaudessa",
  "taxIceberg.amounts.perYear": "Kaikki summat vuodessa",
  "taxIceberg.backToSalary": "Takaisin palkkaoppaaseen",
  "taxIceberg.breadcrumb.current": "Verojäävuori",
  "taxIceberg.breadcrumb.parent": "Palkkaopas",
  "taxIceberg.breakdown.capitalGross": "Osingot ja luovutusvoitot",
  "taxIceberg.breakdown.capitalTax": "Pääomatulovero",
  "taxIceberg.breakdown.gross": "Bruttopalkka",
  "taxIceberg.breakdown.heading": "Täydellinen erittely",
  "taxIceberg.breakdown.investmentsKeep": "Sinulle jää osingoista ja voitoista",
  "taxIceberg.breakdown.investmentsTax": "Vero osingoista ja voitoista",
  "taxIceberg.breakdown.netPay": "Nettopalkka",
  "taxIceberg.breakdown.totalIn": "Kaikki tulot ennen veroja",
  "taxIceberg.breakdown.trueCost": "Todellinen kustannus työnantajalle (bruttopalkka + työnantajamaksut)",
  "taxIceberg.byline": "Kirjoittanut {author}",
  "taxIceberg.compare.add": "Vertaa toiseen palkkaan",
  "taxIceberg.compare.hint": "Jäävuoret on piirretty samaan mittakaavaan, joten voit vertailla niitä suoraan.",
  "taxIceberg.compare.remove": "Poista tämä palkka vertailusta",
  "taxIceberg.copyLink": "Kopioi linkki",
  "taxIceberg.copyLink.copied": "Kopioitu",
  "taxIceberg.destinations.averageMunicipality": "keskimääräinen kunta",
  "taxIceberg.destinations.employmentFund": "Työllisyysrahasto",
  "taxIceberg.destinations.employmentFund.desc": "Työttömyysvakuutusmaksut: ansiosidonnainen työttömyyspäiväraha, aikuiskoulutustuki ja eläkkeen karttuminen työttömyysajalta.",
  "taxIceberg.destinations.heading": "Minne rahat menevät",
  "taxIceberg.destinations.insurers": "Vakuutusyhtiöt",
  "taxIceberg.destinations.insurers.desc": "Työnantajan tapaturma- ja ryhmähenkivakuutusmaksut.",
  "taxIceberg.destinations.intro": "Jokaisella pinnan alla olevalla eurolla on lain mukaan yksi saaja. Avaa kunta ja valtio nähdäksesi, mihin ne käyttävät rahat.",
  "taxIceberg.destinations.kela": "Kelan sairausvakuutus",
  "taxIceberg.destinations.kela.desc": "Sairaanhoito- ja päivärahamaksut sekä työnantajan sairausvakuutusmaksu: sairaus- ja vanhempainpäivärahat, lääke- ja lääkärikorvaukset.",
  "taxIceberg.destinations.legend": "Palkin tumma osa: pidätetty palkastasi. Vaalea osa: työnantajasi maksaa päälle. Kunnan ja valtion jaot seuraavat niiden julkaistuja menoja (kuntien tilinpäätökset 2025, valtion talousarvio 2026); jaot ovat suhteellisia, eivät korvamerkittyjä.",
  "taxIceberg.destinations.muni.administrationOther": "Hallinto ja muut",
  "taxIceberg.destinations.muni.basicEducation": "Perusopetus",
  "taxIceberg.destinations.muni.cultureSport": "Kulttuuri, kirjastot, liikunta ja nuoriso",
  "taxIceberg.destinations.muni.earlyChildhood": "Varhaiskasvatus ja esiopetus",
  "taxIceberg.destinations.muni.employmentBusiness": "Työllisyyspalvelut ja elinkeinojen edistäminen",
  "taxIceberg.destinations.muni.streetsParksPlanning": "Kadut, puistot, kaavoitus, asuminen ja pelastustoimi",
  "taxIceberg.destinations.muni.upperSecondary": "Lukio- ja ammatillinen koulutus",
  "taxIceberg.destinations.municipality": "Kuntasi ({name})",
  "taxIceberg.destinations.municipality.desc": "Kunnallisvero, jonka {name} käyttää omiin palveluihinsa.",
  "taxIceberg.destinations.parish": "Seurakuntasi",
  "taxIceberg.destinations.parish.desc": "Kirkollisvero kuntasi evankelis-luterilaiselle seurakunnalle.",
  "taxIceberg.destinations.pensions": "Työeläkkeet",
  "taxIceberg.destinations.pensions.desc": "Sinun ja työnantajasi TyEL-maksut eläkevakuuttajille: niillä maksetaan nykyisiä eläkkeitä ja kartutetaan omaa eläkettäsi.",
  "taxIceberg.destinations.state": "Valtio",
  "taxIceberg.destinations.state.administrationOther": "Hallinto ja muut",
  "taxIceberg.destinations.state.agriculture": "Maa- ja metsätalous",
  "taxIceberg.destinations.state.debtInterest": "Valtionvelan korot",
  "taxIceberg.destinations.state.defence": "Puolustus",
  "taxIceberg.destinations.state.desc": "Valtion tulovero{vat}, joka käytetään vuoden {year} talousarvion kautta.",
  "taxIceberg.destinations.state.education": "Koulutus, tiede ja kulttuuri",
  "taxIceberg.destinations.state.employmentEconomy": "Työllisyys ja elinkeinot",
  "taxIceberg.destinations.state.environment": "Ympäristö",
  "taxIceberg.destinations.state.eu": "EU-jäsenmaksut",
  "taxIceberg.destinations.state.foreignAffairs": "Ulkoasiat ja kehitysyhteistyö",
  "taxIceberg.destinations.state.healthSocialCounties": "Sosiaali- ja terveydenhuolto (hyvinvointialueet)",
  "taxIceberg.destinations.state.municipalGrants": "Valtionosuudet kunnille",
  "taxIceberg.destinations.state.securityJustice": "Poliisi, pelastus, raja ja oikeuslaitos",
  "taxIceberg.destinations.state.socialSecurity": "Sosiaaliturva: Kelan etuudet ja valtion eläkkeet",
  "taxIceberg.destinations.state.transport": "Liikenne ja viestintä",
  "taxIceberg.destinations.state.vat": " ja arvonlisävero",
  "taxIceberg.destinations.total": "{total} {period} veroja ja maksuja",
  "taxIceberg.destinations.yle.desc": "Yle-verolla rahoitetaan Yleisradio.",
  "taxIceberg.detail.capital.unlistedLight": "Oman yhtiön osinko 8 %:n tuoton rajoissa: {light}, josta veronalaista 25 %",
  "taxIceberg.detail.capital.unlistedSplit": "Oman yhtiön osinko: {light} kevyesti verotettua (25 %), {heavy} 85-prosenttisesti veronalaista",
  "taxIceberg.detail.employee.capitalTax": "Pääomatulovero osingoista ja voitoista: {amount}",
  "taxIceberg.detail.employee.church": "Kirkollisvero: {amount}",
  "taxIceberg.detail.employee.commutingDeducted": "Matkakuluvähennys: {amount}",
  "taxIceberg.detail.employee.credit": "Työtulovähennys: {amount}",
  "taxIceberg.detail.employee.dailyAllowance": "Päivärahamaksu: {amount}",
  "taxIceberg.detail.employee.medical": "Sairaanhoitomaksu: {amount}",
  "taxIceberg.detail.employee.municipal": "Kunnallisvero ({rate}): {amount}",
  "taxIceberg.detail.employee.pension": "Työeläkemaksusi: {amount}",
  "taxIceberg.detail.employee.state": "Valtion tulovero: {amount}",
  "taxIceberg.detail.employee.unemployment": "Työttömyysvakuutusmaksusi: {amount}",
  "taxIceberg.detail.employee.unionDeducted": "Jäsenmaksut vähennetty verotettavasta tulosta: {amount}",
  "taxIceberg.detail.employee.unlistedEarned": "Oman yhtiön osinko yli 8 %:n tuoton, verotettu ansiotulona: {amount}",
  "taxIceberg.detail.employee.yle": "Yle-vero: {amount}",
  "taxIceberg.detail.employer.accident": "Tapaturma- ja ryhmähenkivakuutus: {amount}",
  "taxIceberg.detail.employer.health": "Työnantajan sairausvakuutusmaksu: {amount}",
  "taxIceberg.detail.employer.tyel": "Työeläkemaksu (TyEL) {rate}: {amount}",
  "taxIceberg.detail.employer.unemployment": "Työttömyysvakuutusmaksu: {amount}",
  "taxIceberg.detail.investments.gains": "Luovutusvoitot: {amount} (kokonaan veronalaista)",
  "taxIceberg.detail.investments.gross": "Osingot ja voitot ennen veroja: {amount}",
  "taxIceberg.detail.investments.listed": "Osingot pörssiyhtiöistä: {amount} (85 % veronalaista)",
  "taxIceberg.detail.investments.minusTax": "miinus niiden verot: {amount}",
  "taxIceberg.detail.investments.own": "Osingot omasta yhtiöstä: {amount}",
  "taxIceberg.detail.net.minusVat": "miinus kulutuksen arvonlisävero: {amount}",
  "taxIceberg.detail.net.payslip": "Nettopalkka palkkalaskelmassa: {amount}",
  "taxIceberg.detail.net.shareOfGross": "{share} bruttopalkastasi",
  "taxIceberg.detail.share": "{share} siitä, mitä palkkaamisesi maksaa",
  "taxIceberg.detail.share.investments": "{share} osingoistasi ja voitoistasi",
  "taxIceberg.detail.vat.assumption": "Oletus: {share} nettopalkasta kulutetaan, keskimääräinen alv-kanta {rate}",
  "taxIceberg.detail.vat.basis": "Kulutusrakenne Tilastokeskuksen tulotasoittain",
  "taxIceberg.genericEstimateNote.both": "Käytössä koko maan keskimääräinen kunnallisveroprosentti ({rate}) ja työttömyysvakuutusmaksun keskiarvo. Valitse kuntasi ja työnantajan palkkasumma yllä, niin saat tarkemman luvun.",
  "taxIceberg.genericEstimateNote.employerSize": "Käytössä työttömyysvakuutusmaksun keskiarvo. Valitse työnantajasi palkkasumma yllä, niin saat tarkemman luvun.",
  "taxIceberg.genericEstimateNote.municipal": "Käytössä koko maan keskimääräinen kunnallisveroprosentti ({rate}). Valitse kuntasi yllä, niin saat tarkemman luvun.",
  "taxIceberg.headlineStat": "Sinun palkkaamisesi maksaa työnantajalle {trueEmployerCost}, mutta sinulle jää käteen vain {netAfterVat}, kun sekä verot että arvonlisävero on laskettu mukaan.",
  "taxIceberg.headlineStat.noVat": "Palkkaamisesi maksaa {trueEmployerCost}, mutta sinulle jää siitä verojen jälkeen vain {netAfterVat}.",
  "taxIceberg.headlineStat.withCapital": "Palkkasi ja sijoituksesi ovat yhteensä {total} ennen veroja, mutta sinulle jää vain {netAfterVat}, kun verot ja arvonlisävero on laskettu.",
  "taxIceberg.headlineStat.withCapital.noVat": "Palkkasi ja sijoituksesi ovat yhteensä {total} ennen veroja, mutta sinulle jää verojen jälkeen vain {netAfterVat}.",
  "taxIceberg.iceberg.title.month": "{amount} / kk",
  "taxIceberg.iceberg.title.year": "{amount} / vuosi",
  "taxIceberg.input.advancedOptions.toggle": "Lisäasetukset (kunta, työnantajan koko)",
  "taxIceberg.input.age.hint": "Vaikuttaa eläke- ja työttömyysvakuutusmaksuihin",
  "taxIceberg.input.age.label": "Ikä (vaikuttaa eläke- ja työttömyysvakuutusmaksuihin)",
  "taxIceberg.input.age.placeholder": "Työikäinen",
  "taxIceberg.input.age.short": "Ikä",
  "taxIceberg.input.capitalGains.hint": "Kokonaan veronalaista pääomatuloa",
  "taxIceberg.input.capitalGains.label": "Luovutusvoitot (hankintahinnan jälkeen)",
  "taxIceberg.input.children.hint": "Korottaa työtulovähennystä",
  "taxIceberg.input.children.label": "Alaikäiset lapset (korottaa työtulovähennystä)",
  "taxIceberg.input.children.short": "Alaikäiset lapset",
  "taxIceberg.input.church.hint": "Lisää noin {rate} kirkollisveroa",
  "taxIceberg.input.church.label": "Kirkon jäsen (kirkollisvero noin {rate})",
  "taxIceberg.input.church.short": "Kirkon jäsen",
  "taxIceberg.input.commuting.hint": "Vähennyskelpoista {ownLiability} omavastuun yli, enintään {max} vuodessa",
  "taxIceberg.input.commuting.label": "Matkakulut (vähennyskelpoista {ownLiability} omavastuun yli, enintään {max} vuodessa)",
  "taxIceberg.input.commuting.short": "Matkakulut",
  "taxIceberg.input.detail.full": "Jokainen vero",
  "taxIceberg.input.detail.hint": "Näytä oma kerros jokaiselle verolle ja maksulle",
  "taxIceberg.input.detail.label": "Jäävuoren kerrokset",
  "taxIceberg.input.detail.simple": "Neljä kerrosta",
  "taxIceberg.input.dividends.hint": "85 % veronalaista pääomatuloa",
  "taxIceberg.input.dividends.label": "Osingot pörssiyhtiöistä",
  "taxIceberg.input.employerSize.hint": "Määrää työttömyysvakuutusmaksun tason",
  "taxIceberg.input.employerSize.label": "Työnantajan palkkasumma (vaikuttaa työttömyysvakuutusmaksuun)",
  "taxIceberg.input.employerSize.large": "Yli 2,5 M€/v",
  "taxIceberg.input.employerSize.short": "Työnantajan palkkasumma",
  "taxIceberg.input.employerSize.small": "Alle 2,5 M€/v",
  "taxIceberg.input.employerSize.unknown": "En tiedä",
  "taxIceberg.input.municipality.label": "Kunta (kunnallisveroa varten)",
  "taxIceberg.input.municipality.placeholder": "Koko maan keskiarvo",
  "taxIceberg.input.netAssets.hint": "Valinnainen; tyhjänä osingon oletetaan pysyvän 8 %:n tuoton rajoissa",
  "taxIceberg.input.netAssets.label": "Osuutesi yhtiön nettovarallisuudesta",
  "taxIceberg.input.option.no": "Ei",
  "taxIceberg.input.option.yes": "Kyllä",
  "taxIceberg.input.otherIncome.hint": "Verotetaan pääomatulona: {lower} {threshold} asti ja {upper} sen yli; ei työnantajan sivukuluja. Oma yhtiösi maksaa ensin 20 %:n yhteisöveron, jota ei näytetä tässä.",
  "taxIceberg.input.period.month": "Kuukausi",
  "taxIceberg.input.period.year": "Vuosi",
  "taxIceberg.input.salary.label": "Bruttopalkka",
  "taxIceberg.input.salary.modeLabel": "Syötä bruttopalkka tai tavoiteltu nettopalkka",
  "taxIceberg.input.salary.modeNet": "Nettopalkka (tavoite)",
  "taxIceberg.input.salary.presetGross": "{amount} brutto",
  "taxIceberg.input.salary.presetNet": "{amount} netto",
  "taxIceberg.input.salary.presets": "Valitse yleinen palkka",
  "taxIceberg.input.soleGuardian.hint": "Kaksinkertaistaa lapsikorotuksen",
  "taxIceberg.input.soleGuardian.label": "Yksinhuoltaja",
  "taxIceberg.input.unionFees.hint": "Vähennetään kokonaan ansiotulosta",
  "taxIceberg.input.unionFees.label": "Ammattiliiton ja työttömyyskassan jäsenmaksut",
  "taxIceberg.input.unit.month": "/ kk",
  "taxIceberg.input.unit.year": "/ vuosi",
  "taxIceberg.input.unlistedDividends.hint": "Listaamaton yhtiö: 25 % veronalaista {cap} asti vuodessa 8 %:n tuoton rajoissa",
  "taxIceberg.input.unlistedDividends.label": "Osingot omasta yhtiöstäsi",
  "taxIceberg.input.vat.hint": "Lisää arvonlisäveron, jonka maksat kuluttaessasi nettopalkkasi",
  "taxIceberg.input.vat.label": "Laske mukaan kulutuksen arvonlisävero",
  "taxIceberg.intro": "Palkkakuittisi näyttää yhden luvun. Se, mitä palkkaamisesi todella maksaa, ja se, mitä sinulle jää verojen ja maksujen jälkeen, ovat pinnan alla. Syötä bruttopalkkasi ja katso oma jäävuoresi.",
  "taxIceberg.investments.stat": "Osinkosi ja luovutusvoittosi tuovat {gross}, josta sinulle jää {net}.",
  "taxIceberg.investments.title": "Osingot ja luovutusvoitot",
  "taxIceberg.keepRateStat": "Sinulle jää {rate} siitä, mitä palkkaamisesi todella maksaa.",
  "taxIceberg.keepRateStat.total": "Sinulle jää {rate} kaikista tuloistasi.",
  "taxIceberg.layer.capitalTax": "Pääomatulovero",
  "taxIceberg.layer.church": "Kirkollisvero",
  "taxIceberg.layer.employeeDailyAllowance": "Päivärahamaksu",
  "taxIceberg.layer.employeePension": "Työeläkemaksusi",
  "taxIceberg.layer.employeeTax": "Tuloverosi ja maksusi",
  "taxIceberg.layer.employeeUnemployment": "Työttömyysvakuutusmaksusi",
  "taxIceberg.layer.employerAccident": "Tapaturma- ja ryhmähenkivakuutus",
  "taxIceberg.layer.employerContributions": "Työnantajamaksut",
  "taxIceberg.layer.employerHealth": "Työnantajan sairausvakuutusmaksu",
  "taxIceberg.layer.employerTyel": "Työnantajan työeläkemaksu (TyEL)",
  "taxIceberg.layer.employerUnemployment": "Työnantajan työttömyysvakuutusmaksu",
  "taxIceberg.layer.investmentEarnedTax": "Tulovero oman yhtiön osingosta",
  "taxIceberg.layer.investmentTax": "Vero osingoista ja voitoista",
  "taxIceberg.layer.medicalCare": "Sairaanhoitomaksu",
  "taxIceberg.layer.municipalTax": "Kunnallisvero",
  "taxIceberg.layer.netAfterVat": "Mitä sinulle oikeasti jää",
  "taxIceberg.layer.stateTax": "Valtion tulovero",
  "taxIceberg.layer.vat": "Arvonlisävero, kun käytät rahaa",
  "taxIceberg.layer.yle": "Yle-vero",
  "taxIceberg.methodology.capital": "Osingot ja luovutusvoitot: verotetaan pääomatulona {lower} {threshold} asti ja {upper} sen yli (Verohallinto, 2026). Pörssiyhtiön osingoista 85 % on veronalaista ja 15 % verovapaata. Oman listaamattoman yhtiön osingot: osakkeiden matemaattiselle arvolle lasketun 8 %:n tuoton rajoissa 25 % on veronalaista pääomatuloa {cap} asti vuodessa ja 85 % sen yli; 8 %:n tuoton ylittävästä osasta 75 % on veronalaista ansiotuloa. Yhtiön oma 20 %:n yhteisövero, pääomatulojen vähennykset ja tappioiden vähentäminen eivät ole mukana.",
  "taxIceberg.methodology.deductions": "Vähennykset: ammattiliiton ja työttömyyskassan jäsenmaksut vähennetään kokonaan ansiotulosta; matkakulut ovat vähennyskelpoisia {ownLiability} omavastuun ylittävältä osalta enintään {max} vuodessa (Verohallinto, 2026). Kirkollisverona käytetään valitun kunnan evankelis-luterilaisen seurakunnan veroprosenttia (Verohallinnon päätös 2026) tai valtakunnallista keskiarvoa {churchRate}, kun kuntaa ei ole valittu.",
  "taxIceberg.methodology.destinations": "Minne rahat menevät: jokainen maksu ja vero kohdistetaan lain mukaiselle saajalleen (eläkevakuuttajat, Työllisyysrahasto, Kela, kunta, valtio, seurakunta, Yle, vakuutusyhtiöt). Kunnan euro jaetaan sen mukaan, mihin valittu kunta käytti rahansa tehtävittäin vuonna 2025 (nettokäyttökustannukset, Kuntaliitto Valtiokonttorin aineistosta; koko maan keskiarvo, kun kuntaa ei ole valittu), ja valtion euro vuoden 2026 talousarvion mukaan käyttötarkoituksittain ryhmiteltynä, jossa hyvinvointialueet, kuntien valtionosuudet, EU-maksut ja valtion eläkkeet on eroteltu valtiovarainministeriön pääluokasta. Jaot ovat suhteellisia kohdistuksia, eivät korvamerkintöjä.",
  "taxIceberg.methodology.employeeTax": "Tulovero, kunnallisvero, kirkollisvero, Yle-vero, palkansaajan eläke- ja työttömyysvakuutusmaksut sekä työtulovähennys: laskettu Verohallinnon vuoden 2026 ennakonpidätysperusteiden ja Finlexin vuoden 2026 tuloveroasteikkolain mukaan.",
  "taxIceberg.methodology.employerAccident": "Työtapaturma- ja ryhmähenkivakuutus ({accidentRate} yhteensä, toimialan keskiarvo): Tapaturmavakuutuskeskuksen (TVK) vuosittainen ennuste. Todelliset työnantajakohtaiset maksut vaihtelevat toimialan riskiluokan mukaan, eikä niitä voi yksilöidä tietämättä työnantajaa.",
  "taxIceberg.methodology.employerOther": "Työnantajan työttömyysvakuutusmaksu ({unemploymentLow}–{unemploymentHigh}, porrastettu palkkasumman mukaan) ja sairausvakuutusmaksu ({healthInsurance}): Työllisyysrahaston ja Verohallinnon vuoden 2026 maksut.",
  "taxIceberg.methodology.employerTyel": "Työnantajan eläkevakuutusmaksu (TyEL), {tyelRate}: Eläketurvakeskuksen vuoden 2026 maksuprosentit. Maksu muuttui saman suuruiseksi kaikenikäisille vuoden 2026 uudistuksessa; ennen sitä maksu porrastettiin työntekijän iän mukaan.",
  "taxIceberg.methodology.heading": "Lähteet ja menetelmä",
  "taxIceberg.methodology.intro": "Jokainen alla oleva luku perustuu nimettyyn, tarkistettavissa olevaan lähteeseen. Mitään ei arvioida kertomatta siitä.",
  "taxIceberg.methodology.limitations": "Tämä on arvio, ei veroneuvontaa: laskelma olettaa vakiovähennykset, koko vuoden asumisen Suomessa eikä luontoisetuja, ja arvonlisäverolukema perustuu tulotasollesi tyypilliseen kulutukseen, ei todellisiin kuitteihisi.",
  "taxIceberg.methodology.municipal": "Kunnallisveroprosentit kaikille 308 ilmoittaneelle kunnalle: Suomen Kuntaliiton virallinen vuoden 2026 veroprosenttitaulukko, lähteenä Verohallinto.",
  "taxIceberg.methodology.vat": "Arvonlisäverokannat: Verohallinto (25,5 % yleinen verokanta, 13,5 % alennettu verokanta ruoalle, ravintoloille, kirjoille, lääkkeille, liikenteelle ja majoitukselle vuodesta 2026 alkaen). Kuinka suuri osa tuloista eri tulotasoilla todella kulutetaan eikä säästetä: Tilastokeskuksen kulutustutkimus vuodelta 2022, tuorein tehty, tuloviidenneksittäin jaoteltuna. Tarkempaa jaottelua Tilastokeskus ei julkaise.",
  "taxIceberg.methodology.vatInterpolation": "Viisi tuloviidennespistettä ovat oikeaa tutkimusdataa; niiden välinen tasainen käyrä on omaa interpolointiamme, ei Tilastokeskuksen lukuja.",
  "taxIceberg.netModeStat": "{net} käteen vaatii {gross} bruttopalkan.",
  "taxIceberg.perMonthWord": "kuukaudessa",
  "taxIceberg.perYearWord": "vuodessa",
  "taxIceberg.popularNets": "Tai aloita siitä, mitä haluat käteen",
  "taxIceberg.popularNets.link": "{amount} netto",
  "taxIceberg.popularSalaries": "Katso jäävuori muille palkoille",
  "taxIceberg.popularSalaries.link": "{amount} / kk",
  "taxIceberg.raise.employer": "Työnantajalle korotus maksaa {cost}.",
  "taxIceberg.raise.heading": "Mitä palkankorotuksesta jää käteen?",
  "taxIceberg.raise.result": "{raise} korotuksesta jää käteen {gain} lisää {period}: sinulle jää siitä {kept}.",
  "taxIceberg.raise.sliderLabel": "Korotuksen määrä",
  "taxIceberg.resetOptions": "Palauta oletukset",
  "taxIceberg.roles.all": "Kaikki ammatit, joista on palkkatietoa",
  "taxIceberg.roles.heading": "Ammatteja, joissa palkka on noin {amount} kuukaudessa",
  "taxIceberg.roles.intro": "Koko maan mediaanit avoimien ilmoitusten ilmoitetuista palkkahaarukoista. Avaa ammatti nähdäksesi haarukan, kaupungit ja avoimet paikat.",
  "taxIceberg.roles.postings": "{count, plural, one {# ilmoitus} other {# ilmoitusta}}",
  "taxIceberg.share": "Jaa",
  "taxIceberg.share.email": "Lähetä sähköpostilla",
  "taxIceberg.share.linkedin": "Jaa LinkedInissä",
  "taxIceberg.share.menuLabel": "Jaa tämä jäävuori",
  "taxIceberg.share.whatsapp": "Jaa WhatsAppissa",
  "taxIceberg.share.x": "Jaa X:ssä",
  "taxIceberg.sources.heading": "Lähteet",
  "taxIceberg.summary.capital": "Osingot ja luovutusvoitot: {amount}",
  "taxIceberg.summary.delta": "vs. ensimmäinen palkka: {deltaGross} brutto, {deltaKept} käteen",
  "taxIceberg.summary.gross": "Bruttopalkka: {amount}",
  "taxIceberg.summary.investmentsKeep": "Sinulle jää {amount} ({rate} niistä)",
  "taxIceberg.summary.investmentsTax": "Vero niistä: {amount}",
  "taxIceberg.summary.keep": "Sinulle jää {amount} ({rate} todellisesta kustannuksesta)",
  "taxIceberg.summary.trueCost": "Todellinen kustannus työnantajalle: {amount}",
  "taxIceberg.taxCard.backTax": "{card}:n kortilla pidätetään noin {amountYear} liian vähän vuodessa ({amountMonth} kuukaudessa): odotettavissa jäännösveroa.",
  "taxIceberg.taxCard.barCard": "Verokorttisi",
  "taxIceberg.taxCard.barSalary": "Tämän palkan verot",
  "taxIceberg.taxCard.extra": "Lisäprosentti",
  "taxIceberg.taxCard.extraHint": "Tulorajan ylittävältä osalta",
  "taxIceberg.taxCard.heading": "Onko verokorttisi prosentti oikea?",
  "taxIceberg.taxCard.intro": "Tämän palkan tuloverot ovat {actual} bruttopalkasta. Vertaa sitä verokorttiisi painettuun ennakonpidätysprosenttiin.",
  "taxIceberg.taxCard.limit": "Tuloraja",
  "taxIceberg.taxCard.limitHint": "€ vuodessa, valinnainen",
  "taxIceberg.taxCard.limitToggle": "Verokortissani on tuloraja",
  "taxIceberg.taxCard.note": "Ennakonpidätys kattaa vain verot; eläke- ja työttömyysvakuutusmaksut peritään erikseen. Laskuri huomioi vain automaattiset vähennykset, joten omat vähennyksesi sisältävä kortti voi olla tarkoituksella matalampi.",
  "taxIceberg.taxCard.onTarget": "{card}:n kortti vastaa tätä palkkaa: ero on alle 60 euroa vuodessa.",
  "taxIceberg.taxCard.rate": "Verokorttisi prosentti",
  "taxIceberg.taxCard.refund": "{card}:n kortilla pidätetään noin {amountYear} liikaa vuodessa ({amountMonth} kuukaudessa): odotettavissa veronpalautusta.",
  "taxIceberg.taxCard.where": "OmaVerossa se on verokorttisi perusprosentti.",
  "taxIceberg.taxRateStat": "Veroprosenttisi tästä palkasta: {rate} (eläke- ja työttömyysvakuutusmaksujen kanssa {total})",
  "taxIceberg.taxYearNote": "Laskettu vuoden {year} verotiedoilla",
  "taxIceberg.title": "Verojäävuori: mitä palkkasi todella maksaa ja mitä siitä oikeasti jää käteen",
  "taxIceberg.toolbar.employerSize": "Työnantajan palkkasumma",
  "taxIceberg.toolbar.municipality": "Kunta",
  "taxIceberg.vatField.label": "ALV",
  "taxIceberg.visual.ariaLabel": "Verojäävuoria meressä Helsingin edustalla. Näkyvä huippu on palkka, joka jää sinulle; paljon suurempi osa vedenpinnan alla on veroja ja maksuja.",
  "test.greeting": "Hei",
  "tools.applicationKits.cvBadge": "CV valmis",
  "tools.applicationKits.deleteKit": "Poista",
  "tools.applicationKits.downloadCv": "Lataa CV",
  "tools.applicationKits.downloadLetter": "Lataa kirje",
  "tools.applicationKits.emptyBody": "Räätälöi CV tai laadi hakemuskirje miltä tahansa työpaikkasivulta, niin se tallentuu tänne automaattisesti.",
  "tools.applicationKits.emptyTitle": "Ei vielä hakemuspaketteja",
  "tools.applicationKits.kitReadyBadge": "Hakemuspaketti valmis",
  "tools.applicationKits.lead": "Räätälöidyt CV:t ja hakemuskirjeet tallennettuna työpaikoittain. Avaa, tarkista tai lataa milloin tahansa.",
  "tools.applicationKits.letterBadge": "Kirje valmis",
  "tools.applicationKits.openJob": "Avaa työpaikkasivu",
  "tools.applicationKits.title": "Hakemuspaketit",
  "tools.applicationKits.updatedOn": "Päivitetty {date}",
  "tools.applicationState.applied": "Haettu",
  "tools.applicationState.hidden": "Piilotettu",
  "tools.applicationState.label": "Tila:",
  "tools.applicationState.updated": "Tila päivitetty muotoon {state}",
  "tools.empty.browseJobs": "Selaa työpaikkoja →",
  "tools.exportApplied.button": "Vie hakemukset raportointia varten",
  "tools.exportApplied.buttonHint": "Saat listan hakemuksistasi – työnantaja, tehtävä, päivämäärä – käytettäväksi työnhaun raportoinnissa, esimerkiksi TE-palveluille.",
  "tools.exportApplied.close": "Sulje",
  "tools.exportApplied.colDateApplied": "Hakupäivä",
  "tools.exportApplied.colEmployer": "Työnantaja",
  "tools.exportApplied.colLink": "Linkki",
  "tools.exportApplied.colMethod": "Tapa",
  "tools.exportApplied.colPosition": "Tehtävä",
  "tools.exportApplied.description": "Valmis, kopioitavissa oleva lista siitä, mihin ja milloin olet hakenut – pidä tämä auki täyttäessäsi raporttia, tai lataa se taulukkona.",
  "tools.exportApplied.downloadCsv": "Lataa CSV",
  "tools.exportApplied.empty": "Ei hakemuksia tällä aikavälillä.",
  "tools.exportApplied.from": "Alkaen",
  "tools.exportApplied.methodExternal": "Muu hakemus (oma linkki)",
  "tools.exportApplied.methodListing": "Työpaikkailmoitus",
  "tools.exportApplied.rowCount": "{count, plural, one {# hakemus} other {# hakemusta}}",
  "tools.exportApplied.title": "Vie hakemuksesi",
  "tools.exportApplied.to": "Päättyen",
  "tools.exportApplied.viewLink": "Avaa",
  "tools.externalApplication.add": "Lisää haettuihin",
  "tools.externalApplication.adding": "Lisätään…",
  "tools.externalApplication.closeModal": "Sulje",
  "tools.externalApplication.error.disallowedScheme": "Vain http- ja https-linkit ovat sallittuja.",
  "tools.externalApplication.error.empty": "Syötä linkki työpaikka- tai hakemusivulle.",
  "tools.externalApplication.error.invalid": "Tämä ei vaikuta olevan voimassa oleva URL-osoite.",
  "tools.externalApplication.error.syncFailed": "Tallennus epäonnistui. Tarkista yhteys tai yritä kirjautua sisään.",
  "tools.externalApplication.error.tooLong": "Linkki on liian pitkä.",
  "tools.externalApplication.lead": "Liitä linkki työpaikkaan, johon hait muualla. Se näkyy tällä sivulla muiden hakemustesi joukossa.",
  "tools.externalApplication.title": "Seuraa muualla tehtyä hakemusta",
  "tools.externalApplication.titleLabel": "Nimike (valinnainen)",
  "tools.externalApplication.urlLabel": "Työpaikkalinkki",
  "tools.history.emptyHidden": "Et ole piilottanut yhtään työpaikkaa.",
  "tools.history.emptyViewed": "Et ole vielä katsonut yhtään työpaikkaa.",
  "tools.history.hiddenTab": "Piilotetut ({count})",
  "tools.history.resetViewed": "Nollaa katsotut työpaikat",
  "tools.history.showMore": "Näytä lisää",
  "tools.history.viewedTab": "Katsotut ({count})",
  "tools.historySummary.counts": "Katsotut {viewedCount} · Piilotetut {hiddenCount}",
  "tools.historySummary.heading": "Historia",
  "tools.historySummary.openDrawer": "Näytä",
  "tools.jobFlowSankey.activityChartHeading": "Aktiivisuus",
  "tools.jobFlowSankey.applied": "Haettu",
  "tools.jobFlowSankey.browsed": "Selaillut",
  "tools.jobFlowSankey.conversionSummary": "{interviewRate}% pääsi haastatteluun · {offerRate}% sai tarjouksen",
  "tools.jobFlowSankey.emptyState": "Aktiivisuudestasi ei ole vielä tarpeeksi tietoa. Katso, tallenna tai hae työpaikkoja, niin näet polkusi kaaviona.",
  "tools.jobFlowSankey.hideActivityChart": "Piilota aktiivisuuskaavio",
  "tools.jobFlowSankey.hired": "Palkattu",
  "tools.jobFlowSankey.interviewing": "Haastatteluvaiheessa",
  "tools.jobFlowSankey.offer": "Tarjous",
  "tools.jobFlowSankey.rejected": "Hylätty",
  "tools.jobFlowSankey.saved": "Tallennetut",
  "tools.jobFlowSankey.showActivityChart": "Näytä aktiviteettikaavio",
  "tools.jobFlowSankey.summary": "Selaillut {browsed} → Katsotut {viewed} → Tallennetut {saved} → Haettu {applied}",
  "tools.jobFlowSankey.tooltip.hint.applied": "Olet hakenut näitä tai seurannut niitä lähetettyinä hakemuksina.",
  "tools.jobFlowSankey.tooltip.hint.browsed": "Hakuista avaamasi roolit – suppilosi alku.",
  "tools.jobFlowSankey.tooltip.hint.hired": "Merkitty palkatuksi – hieno lopputulos.",
  "tools.jobFlowSankey.tooltip.hint.interviewing": "Tällä hetkellä haastatteluprosessissa.",
  "tools.jobFlowSankey.tooltip.hint.offer": "Tarjousvaihe – neuvottelujen tai päätöksen aika.",
  "tools.jobFlowSankey.tooltip.hint.rejected": "Merkitty suljetuksi tai haku ei edennyt.",
  "tools.jobFlowSankey.tooltip.hint.saved": "Tallennettu myöhemmäksi – helppo palata ja hakea.",
  "tools.jobFlowSankey.tooltip.hint.viewed": "Olet avannut nämä ilmoitukset, mutta et ole vielä tallentanut niitä.",
  "tools.jobFlowSankey.tooltip.link.pathCount": "{count, plural, one {# työpaikka} other {# työpaikkaa}} tällä polulla",
  "tools.jobFlowSankey.tooltip.link.pctFrom": "{pct} % virtauksesta poistuu kohteesta {fromName}",
  "tools.jobFlowSankey.tooltip.link.pctTo": "{pct} % virtauksesta tulee kohteeseen {toName}",
  "tools.jobFlowSankey.tooltip.link.splitBrowsedApplied": "{direct} suoraan selaamisesta ilman tallennusta · {external} muualta",
  "tools.jobFlowSankey.tooltip.node.beyondBrowse": "Sisältää hakemukset, joita ei ole laskettu selaamisiin (esim. sivuston ulkopuolella).",
  "tools.jobFlowSankey.tooltip.node.jobCount": "{count, plural, one {# työpaikka} other {# työpaikkaa}}",
  "tools.jobFlowSankey.tooltip.node.pctApplied": "{pct} % hakemuksistasi",
  "tools.jobFlowSankey.tooltip.node.pctBrowsed": "{pct} % selaamistasi ilmoituksista",
  "tools.jobFlowSankey.viewed": "Katsotut",
  "tools.kanban.addExternalApplication": "Lisää muualla tehty hakemus",
  "tools.kanban.cancelSelectMode": "Peruuta",
  "tools.kanban.chip.appliedAgo": "Haettu {relativeAge}",
  "tools.kanban.column.applied": "Haettu",
  "tools.kanban.column.collapse": "Pienennä sarake {column}",
  "tools.kanban.column.expand": "Laajenna sarake {column}",
  "tools.kanban.column.hired": "Palkattu",
  "tools.kanban.column.interviewing": "Haastattelut",
  "tools.kanban.column.offer": "Tarjous",
  "tools.kanban.column.rejected": "Hylätty",
  "tools.kanban.column.saved": "Tallennetut",
  "tools.kanban.companyFilterAll": "Kaikki yritykset",
  "tools.kanban.companyFilterLabel": "Suodata yrityksen mukaan",
  "tools.kanban.confirmRemove.appliedBody": "\"{jobTitle}\" poistetaan hakemustaulultasi. Voit hakea paikkaa myöhemmin uudelleen haun kautta.",
  "tools.kanban.confirmRemove.appliedTitle": "Poistetaanko hakemuksista?",
  "tools.kanban.confirmRemove.cancel": "Peruuta",
  "tools.kanban.confirmRemove.close": "Sulje",
  "tools.kanban.confirmRemove.confirm": "Poista",
  "tools.kanban.confirmRemove.savedBody": "\"{jobTitle}\" poistetaan tallennetuista työpaikoista.",
  "tools.kanban.confirmRemove.savedTitle": "Poistetaanko tallennetuista?",
  "tools.kanban.confirmRemove.working": "Poistetaan…",
  "tools.kanban.deadlineChip": "Sulkeutuu {days, plural, one {# päivässä} other {# päivässä}}",
  "tools.kanban.dragHandle": "Raahaa siirtääksesi toiseen sarakkeeseen tai kohtaan",
  "tools.kanban.dragHandleGroup": "Raahaa siirtääksesi koko ryhmän toiseen sarakkeeseen tai kohtaan",
  "tools.kanban.emptyBoard": "Ei vielä tallennettuja tai haettuja työpaikkoja. Lisää muualla tehty hakemus yllä olevalla painikkeella tai tallenna ja hae työpaikkoja haun kautta.",
  "tools.kanban.emptyColumn": "Ei vielä yhtään",
  "tools.kanban.groupMixedHeading": "{count} hakemusta",
  "tools.kanban.groupMixedSavedHeading": "{count} tallennettua",
  "tools.kanban.hideInactive": "Piilota vanhentuneet työpaikat",
  "tools.kanban.keepLooking": "Jatka etsimistä →",
  "tools.kanban.loadingApplications": "Ladataan hakemuksiasi…",
  "tools.kanban.mobile.cancel": "Peruuta",
  "tools.kanban.mobile.close": "Sulje",
  "tools.kanban.mobile.companyFilterAll": "Kaikki yritykset",
  "tools.kanban.mobile.companyFilterLabel": "Suodata yrityksen mukaan",
  "tools.kanban.mobile.emptyTab": "Ei hakemuksia vaiheessa {stage}.",
  "tools.kanban.mobile.move": "Siirrä",
  "tools.kanban.mobile.moveTo": "Siirrä vaiheeseen",
  "tools.kanban.mobile.searchPlaceholder": "Hae yritystä tai roolia",
  "tools.kanban.mobile.searchToggle": "Hae hakemuksia",
  "tools.kanban.mobile.sortCompanyAsc": "Yritys (A–Z)",
  "tools.kanban.mobile.sortDateAsc": "Vanhimmat ensin",
  "tools.kanban.mobile.sortDateDesc": "Uusimmat ensin",
  "tools.kanban.mobile.sortLabel": "Lajitteluperuste",
  "tools.kanban.mobile.sortTitleAsc": "Työnimike (A–Z)",
  "tools.kanban.mobile.tabAll": "Kaikki",
  "tools.kanban.mobile.viewJob": "Näytä työpaikkailmoitus",
  "tools.kanban.moveSelectedTo": "Siirrä vaiheeseen…",
  "tools.kanban.removeFailed": "Päivitys epäonnistui. Yritä uudelleen.",
  "tools.kanban.removeFailed.retry": "Yritä uudelleen",
  "tools.kanban.removeIcon.applied": "Poista hakemuksista",
  "tools.kanban.removeIcon.saved": "Poista tallennetuista työpaikoista",
  "tools.kanban.removeSelected": "Poista",
  "tools.kanban.savedJob.expired": "Ei enää voimassa",
  "tools.kanban.savedJob.findSimilar": "Etsi vastaavia →",
  "tools.kanban.searchLabel": "Hae",
  "tools.kanban.searchPlaceholder": "Hae yritystä tai roolia",
  "tools.kanban.selectCard": "Valitse {title}",
  "tools.kanban.selectMode": "Valitse",
  "tools.kanban.selectedCount": "{count, plural, one {# valittu} other {# valittua}}",
  "tools.kanban.sortCompanyAsc": "Yritys (A–Z)",
  "tools.kanban.sortDateAsc": "Vanhimmat ensin",
  "tools.kanban.sortDateDesc": "Uusimmat ensin",
  "tools.kanban.sortLabel": "Lajitteluperuste",
  "tools.kanban.sortTitleAsc": "Työnimike (A–Z)",
  "tools.kanban.staleChip": "Kysy perään? {days, plural, one {# päivä} other {# päivää}} hakemuksesta",
  "tools.kanban.title": "Hakemukset vaiheittain",
  "tools.kanban.untitledJob": "Nimetön työpaikka",
  "tools.savedJobs.tailorCvAction": "Räätälöi CV",
  "tooltip.allFilters": "Avaa kaikki suodattimet ja rajaa hakua sijainnin, palkan, työmuodon ja muiden ehtojen mukaan",
  "tooltip.view.list": "Vaihda luettelonäkymään nähdäksesi työpaikat tiiviissä luettelomuodossa",
  "tooltip.view.map": "Vaihda karttanäkymään nähdäksesi työpaikkojen sijainnit kartalla",
  "usermenu.account": "Tili",
  "usermenu.apiKeys": "Tekoälyhaku",
  "usermenu.installPwa": "Asenna sovellus",
  "usermenu.logout": "Kirjaudu ulos",
  "usermenu.profile": "Oma profiili",
  "usermenu.theme": "Teema",
  "usermenu.theme.auto": "Automaattinen",
  "usermenu.theme.dark": "Tumma",
  "usermenu.theme.light": "Vaalea",
  "usermenu.translationInspector": "Käännösten tarkastelu",
  "usermenu.translationInspectorGuide": "Näin käytät käännösten tarkastelua",
  "view.list": "Luettelonäkymä",
  "view.map": "Karttanäkymä",
  "watchlist.company.closedRoles": "{count, plural, one {# näkemäsi työpaikka ei ole enää avoinna} other {# näkemääsi työpaikkaa ei ole enää avoinna}}",
  "watchlist.company.dataUnavailable": "Yritystiedot eivät ole juuri nyt saatavilla.",
  "watchlist.company.employerScore": "työnantajapisteet",
  "watchlist.company.hiringActivity": "Rekrytointiaktiivisuus",
  "watchlist.company.hiringPace": "Julkaissut {count} työpaikkaa tässä kuussa, noin {multiple}× tavallista tahtia",
  "watchlist.company.hiringTrend.declining": "Laskussa",
  "watchlist.company.hiringTrend.growing": "Kasvussa",
  "watchlist.company.hiringTrend.stable": "Vakaa",
  "watchlist.company.newRolesBadge": "+{count} uutta",
  "watchlist.company.newSinceLastVisit": "Uutta edellisen käyntisi jälkeen",
  "watchlist.company.openRoles": "avointa paikkaa",
  "watchlist.company.roleMatch": "{score} % osuma",
  "watchlist.company.scoreGradeDropped": "Työnantajan arvosana laski tasolle {tier} viime käyntisi jälkeen",
  "watchlist.company.scoreGradeImproved": "Työnantajan arvosana parani tasolle {tier} viime käyntisi jälkeen",
  "watchlist.company.similarEmpty": "Samankaltaisia yrityksiä ei löytynyt juuri nyt.",
  "watchlist.company.similarTrigger": "Samankaltaiset yritykset",
  "watchlist.company.sparklineLabel": "Työpaikkailmoituksia kuukaudessa, viimeiset {months} kuukautta",
  "watchlist.compare.company": "Yritys",
  "watchlist.compare.exportCsv": "Vie CSV",
  "watchlist.compare.flexibility": "Joustavuus",
  "watchlist.compare.jobsPerMonth": "Työpaikkoja/kk",
  "watchlist.compare.newBadge": "+{count} uutta",
  "watchlist.compare.openRoles": "Avoimet paikat",
  "watchlist.compare.pay": "Palkka",
  "watchlist.compare.remote": "Etätyö",
  "watchlist.compare.salary": "Mediaanipalkka €/kk",
  "watchlist.compare.score": "Pisteet",
  "watchlist.compare.share": "Jaa",
  "watchlist.compare.shareCopied": "Linkki kopioitu. Kuka tahansa linkin saanut voi katsoa tätä vertailua",
  "watchlist.compare.stability": "Vakaus",
  "watchlist.compare.topRoles": "Rekrytoi eniten",
  "watchlist.empty.body": "Seuraa yritystä sen profiilisivulta, niin näet täällä uudet paikat, työnantajapisteet ja rekrytointitrendin.",
  "watchlist.empty.browse": "Selaa parhaita yrityksiä →",
  "watchlist.empty.title": "Et seuraa vielä yhtään yritystä.",
  "watchlist.filter.all": "Kaikki",
  "watchlist.filter.noMatches": "Yhdelläkään seuratulla yrityksellä ei ole vielä tätä tunnistetta.",
  "watchlist.relationshipTag.inConversation": "Keskustelussa",
  "watchlist.relationshipTag.interested": "Kiinnostunut",
  "watchlist.relationshipTag.reachedOut": "Otettu yhteyttä",
  "watchlist.roles.heading": "Seuraamasi roolit",
  "watchlist.roles.newBadge": "+{count} uutta",
  "watchlist.roles.newSinceLastVisit": "Uutta edellisen käyntisi jälkeen",
  "watchlist.roles.openCount": "{count, plural, one {# avoin työpaikka} other {# avointa työpaikkaa}}",
  "watchlist.roles.unwatch": "Lopeta seuraaminen",
  "watchlist.sharedCompare.banner": "Katselet vertailua, jonka joku jakoi kanssasi. Tämä ei ole oma seurantalistasi.",
  "watchlist.sharedCompare.cta": "Aloita oma seurantalistasi →",
  "watchlist.sharedCompare.empty": "Tässä jaetussa vertailussa ei ole yrityksiä näytettäväksi.",
  "watchlist.sharedCompare.loading": "Ladataan jaettua vertailua…",
  "watchlist.suggestions.heading": "Yrityksiä, joita saatat haluta seurata",
  "watchlist.suggestions.reasonIndustry": "Samankaltainen kuin seuraamasi yritykset",
  "watchlist.suggestions.reasonIndustryScoreDiff": "{delta} pistettä korkeampi kuin seuraamiesi yritysten keskiarvo",
  "watchlist.suggestions.reasonSavedJobs": "{count, plural, one {Tallensit # sen työpaikoista} other {Tallensit # sen työpaikoista}}",
  "watchlist.suggestions.reasonTopRated": "Yksi Suomen parhaista työnantajista",
  "watchlist.thresholdAlert.add": "Lisää hälytys",
  "watchlist.thresholdAlert.cancel": "Peruuta",
  "watchlist.thresholdAlert.condition.above": "nousee yli",
  "watchlist.thresholdAlert.condition.below": "laskee alle",
  "watchlist.thresholdAlert.metric.employerScore": "Työnantajapisteet",
  "watchlist.thresholdAlert.metric.openRoles": "Avoimet paikat",
  "watchlist.thresholdAlert.remove": "Poista hälytys",
  "watchlist.thresholdAlert.save": "Tallenna hälytys",
  "watchlist.thresholdAlert.summaryAbove": "{metric} yli {value}",
  "watchlist.thresholdAlert.summaryBelow": "{metric} alle {value}",
  "watchlist.view.cards": "Kortit",
  "watchlist.view.compare": "Vertaile",
  "translation.test": "Käännöstesti: Suomi"
};

export const messages = {
  en: messages_en,
  sv: messages_sv,
  fi: messages_fi,
};

// Option 1: Hardcode the list of locales
export const supportedLocales = ['en', 'fi', 'sv'];

// Option 2: Dynamically derive from messages keys
// (uncomment if you prefer dynamic retrieval)
// export const supportedLocales = Object.keys(messages);

export const defaultLocale = 'en';
